
/**
 * 
 * @export
 * @interface AccessSource
 */
export interface AccessSource {
    /**
     * 
     * @type {string}
     * @memberof AccessSource
     */
    source: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccessSource
     */
    isBlocked: boolean;
    /**
     * 
     * @type {string}
     * @memberof AccessSource
     */
    blockedId?: string;
}

/**
 * 
 * @export
 * @interface AccessSourcePageRows
 */
export interface AccessSourcePageRows {
    /**
     * 
     * @type {Array<BlockedAccessSourceItem>}
     * @memberof AccessSourcePageRows
     */
    rows: Array<BlockedAccessSourceItem>;
}

/**
 * 
 * @export
 * @interface AccessSourceResponse
 */
export interface AccessSourceResponse {
    /**
     * 
     * @type {Array<AccessSource>}
     * @memberof AccessSourceResponse
     */
    ips: Array<AccessSource>;
    /**
     * 
     * @type {Array<AccessSource>}
     * @memberof AccessSourceResponse
     */
    devices: Array<AccessSource>;
}

/**
 * 
 * @export
 * @interface AccessSourceSearchResponse
 */
export interface AccessSourceSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof AccessSourceSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof AccessSourceSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {AccessSourcePageRows}
     * @memberof AccessSourceSearchResponse
     */
    data: AccessSourcePageRows;
}

/**
 * 
 * @export
 * @interface AccountItem
 */
export interface AccountItem {
    /**
     * 
     * @type {string}
     * @memberof AccountItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AccountItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof AccountItem
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountItem
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AccountItem
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountItem
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountItem
     */
    userType?: AccountItemUserTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum AccountItemUserTypeEnum {
    Guest = 'guest',
    Normal = 'normal',
    Seller = 'seller',
    VerifiedSeller = 'verifiedSeller'
}

/**
 * 
 * @export
 * @interface AccountsPageRows
 */
export interface AccountsPageRows {
    /**
     * 
     * @type {Array<AccountItem>}
     * @memberof AccountsPageRows
     */
    rows: Array<AccountItem>;
}

/**
 * 
 * @export
 * @interface ActiveFeaturedShowsRequest
 */
export interface ActiveFeaturedShowsRequest {
    /**
     * 
     * @type {string}
     * @memberof ActiveFeaturedShowsRequest
     */
    eventId?: string;
}

/**
 * 
 * @export
 * @interface AddAgencyDto
 */
export interface AddAgencyDto {
    /**
     * 
     * @type {string}
     * @memberof AddAgencyDto
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof AddAgencyDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AddAgencyDto
     */
    email: string;
    /**
     * 
     * @type {AgencyAddressDto}
     * @memberof AddAgencyDto
     */
    address: AgencyAddressDto;
}

/**
 * 
 * @export
 * @interface AddAgencyUserDto
 */
export interface AddAgencyUserDto {
    /**
     * 
     * @type {string}
     * @memberof AddAgencyUserDto
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof AddAgencyUserDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AddAgencyUserDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AddAgencyUserDto
     */
    role: AddAgencyUserDtoRoleEnum;
}

/**
* @export
* @enum {string}
*/
export enum AddAgencyUserDtoRoleEnum {
    Admin = 'agency-admin',
    User = 'agency-user'
}

/**
 * 
 * @export
 * @interface AddContentSubscriberRequest
 */
export interface AddContentSubscriberRequest {
    /**
     * 
     * @type {string}
     * @memberof AddContentSubscriberRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AddContentSubscriberRequest
     */
    phone?: string;
}

/**
 * 
 * @export
 * @interface AddFeaturedListingRequest
 */
export interface AddFeaturedListingRequest {
    /**
     * 
     * @type {string}
     * @memberof AddFeaturedListingRequest
     */
    listingId: string;
    /**
     * 
     * @type {string}
     * @memberof AddFeaturedListingRequest
     */
    sellerId: string;
}

/**
 * 
 * @export
 * @interface AddFeaturedTagRequest
 */
export interface AddFeaturedTagRequest {
    /**
     * 
     * @type {string}
     * @memberof AddFeaturedTagRequest
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddFeaturedTagRequest
     */
    sellerTags: Array<string>;
}

/**
 * 
 * @export
 * @interface AddListingsToLiveStreamInBatchDto
 */
export interface AddListingsToLiveStreamInBatchDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddListingsToLiveStreamInBatchDto
     */
    listingIds: Array<string>;
}

/**
 * 
 * @export
 * @interface AddListingsToLiveStreamInBatchResponse
 */
export interface AddListingsToLiveStreamInBatchResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddListingsToLiveStreamInBatchResponse
     */
    successfulListingIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddListingsToLiveStreamInBatchResponse
     */
    nonexistentListingIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddListingsToLiveStreamInBatchResponse
     */
    autoRemovedListingIdsOnSoldOut: Array<string>;
}

/**
 * 
 * @export
 * @interface AddLiveStreamListingRequest
 */
export interface AddLiveStreamListingRequest {
    /**
     * 
     * @type {string}
     * @memberof AddLiveStreamListingRequest
     */
    listingId: string;
}

/**
 * 
 * @export
 * @interface AddOnboardingPushRequest
 */
export interface AddOnboardingPushRequest {
    /**
     * 
     * @type {string}
     * @memberof AddOnboardingPushRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AddOnboardingPushRequest
     */
    summary: string;
    /**
     * 
     * @type {string}
     * @memberof AddOnboardingPushRequest
     */
    subtitle: string;
    /**
     * 
     * @type {string}
     * @memberof AddOnboardingPushRequest
     */
    subjectLine: string;
    /**
     * 
     * @type {string}
     * @memberof AddOnboardingPushRequest
     */
    editor: string;
    /**
     * 
     * @type {string}
     * @memberof AddOnboardingPushRequest
     */
    embedCode: string;
    /**
     * 
     * @type {string}
     * @memberof AddOnboardingPushRequest
     */
    contentType: AddOnboardingPushRequestContentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AddOnboardingPushRequest
     */
    cover?: string;
    /**
     * 
     * @type {string}
     * @memberof AddOnboardingPushRequest
     */
    videoUrl?: string;
    /**
     * 
     * @type {VideoSizeRequest}
     * @memberof AddOnboardingPushRequest
     */
    videoSize?: VideoSizeRequest;
    /**
     * 
     * @type {boolean}
     * @memberof AddOnboardingPushRequest
     */
    appearOnAllScreens?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddOnboardingPushRequest
     */
    appearOnSpecificPages?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddOnboardingPushRequest
     */
    visibleTo: Array<AddOnboardingPushRequestVisibleToEnum>;
    /**
     * 
     * @type {number}
     * @memberof AddOnboardingPushRequest
     */
    buttonDelayInSeconds: number;
    /**
     * 
     * @type {string}
     * @memberof AddOnboardingPushRequest
     */
    startTime: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddOnboardingPushRequest
     */
    disabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddOnboardingPushRequest
     */
    published: boolean;
    /**
     * 
     * @type {OnboardingPushCtaRequest}
     * @memberof AddOnboardingPushRequest
     */
    cta?: OnboardingPushCtaRequest;
    /**
     * 
     * @type {OnboardingPushNotificationRequest}
     * @memberof AddOnboardingPushRequest
     */
    notification?: OnboardingPushNotificationRequest;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddOnboardingPushRequest
     */
    sellerIds?: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum AddOnboardingPushRequestContentTypeEnum {
    Video = 'video',
    RichText = 'richText'
}/**
* @export
* @enum {string}
*/
export enum AddOnboardingPushRequestVisibleToEnum {
    Business = 'Business',
    Creator = 'Creator',
    CommentChat = 'CommentChat',
    Vfs = 'VFS'
}

/**
 * 
 * @export
 * @interface AddPaymentMethodRequest
 */
export interface AddPaymentMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof AddPaymentMethodRequest
     */
    nonce: string;
    /**
     * 
     * @type {string}
     * @memberof AddPaymentMethodRequest
     */
    name: string;
}

/**
 * 
 * @export
 * @interface AddPaymentMethodRequestV2
 */
export interface AddPaymentMethodRequestV2 {
    /**
     * 
     * @type {BillingAddressDto}
     * @memberof AddPaymentMethodRequestV2
     */
    billingAddress: BillingAddressDto;
    /**
     * 
     * @type {string}
     * @memberof AddPaymentMethodRequestV2
     */
    stripeToken?: string;
    /**
     * 
     * @type {string}
     * @memberof AddPaymentMethodRequestV2
     */
    nonce?: string;
    /**
     * 
     * @type {string}
     * @memberof AddPaymentMethodRequestV2
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddPaymentMethodRequestV2
     */
    isSubscriptionPayment?: boolean;
}

/**
 * 
 * @export
 * @interface AddPaymentMethodResponse
 */
export interface AddPaymentMethodResponse {
    /**
     * 
     * @type {string}
     * @memberof AddPaymentMethodResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AddPaymentMethodResponse
     */
    paymentMethodId: string;
}

/**
 * 
 * @export
 * @interface AddPaymentMethodResponseV3
 */
export interface AddPaymentMethodResponseV3 {
    /**
     * 
     * @type {string}
     * @memberof AddPaymentMethodResponseV3
     */
    clientSecret: string;
}

/**
 * 
 * @export
 * @interface AddPayoutRequest
 */
export interface AddPayoutRequest {
    /**
     * 
     * @type {string}
     * @memberof AddPayoutRequest
     */
    note?: string;
    /**
     * 
     * @type {number}
     * @memberof AddPayoutRequest
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof AddPayoutRequest
     */
    status: AddPayoutRequestStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum AddPayoutRequestStatusEnum {
    Pending = 'Pending',
    Processed = 'Processed',
    Completed = 'Completed',
    Failed = 'Failed'
}

/**
 * 
 * @export
 * @interface AddSeriesPopClipDto
 */
export interface AddSeriesPopClipDto {
    /**
     * 
     * @type {string}
     * @memberof AddSeriesPopClipDto
     */
    popClipId: string;
    /**
     * 
     * @type {string}
     * @memberof AddSeriesPopClipDto
     */
    contentType?: AddSeriesPopClipDtoContentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AddSeriesPopClipDto
     */
    sort?: number;
}

/**
* @export
* @enum {string}
*/
export enum AddSeriesPopClipDtoContentTypeEnum {
    Feed = 'FEED',
    Episode = 'EPISODE',
    Teaser = 'TEASER',
    Promo = 'PROMO',
    Sponsored = 'SPONSORED'
}

/**
 * 
 * @export
 * @interface AddShipmentTrackingRecordRequest
 */
export interface AddShipmentTrackingRecordRequest {
    /**
     * 
     * @type {string}
     * @memberof AddShipmentTrackingRecordRequest
     */
    trackingNumber: string;
    /**
     * 
     * @type {string}
     * @memberof AddShipmentTrackingRecordRequest
     */
    trackingUrlProvider?: string;
    /**
     * 
     * @type {string}
     * @memberof AddShipmentTrackingRecordRequest
     */
    carrier?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddShipmentTrackingRecordRequest
     */
    isRemoved?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AddShipmentTrackingRecordRequest
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof AddShipmentTrackingRecordRequest
     */
    transactionId?: string;
}

/**
 * 
 * @export
 * @interface AddShippingTrackingInfoRequest
 */
export interface AddShippingTrackingInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof AddShippingTrackingInfoRequest
     */
    carrier: string;
    /**
     * 
     * @type {string}
     * @memberof AddShippingTrackingInfoRequest
     */
    trackingNumber: string;
    /**
     * 
     * @type {string}
     * @memberof AddShippingTrackingInfoRequest
     */
    trackingUrl?: string;
}

/**
 * 
 * @export
 * @interface AddUserToGroupRequest
 */
export interface AddUserToGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof AddUserToGroupRequest
     */
    userId: string;
}

/**
 * 
 * @export
 * @interface AddUserToLiveStreamCommentDenylist
 */
export interface AddUserToLiveStreamCommentDenylist {
    /**
     * 
     * @type {string}
     * @memberof AddUserToLiveStreamCommentDenylist
     */
    reason: AddUserToLiveStreamCommentDenylistReasonEnum;
}

/**
* @export
* @enum {string}
*/
export enum AddUserToLiveStreamCommentDenylistReasonEnum {
    Spam = 'spam',
    Inappropriate = 'inappropriate',
    Aggressive = 'aggressive'
}

/**
 * 
 * @export
 * @interface AddUserToOrderDenylistRequest
 */
export interface AddUserToOrderDenylistRequest {
    /**
     * 
     * @type {string}
     * @memberof AddUserToOrderDenylistRequest
     */
    userId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddUserToOrderDenylistRequest
     */
    sellerIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AddUserToOrderDenylistRequest
     */
    reason: AddUserToOrderDenylistRequestReasonEnum;
}

/**
* @export
* @enum {string}
*/
export enum AddUserToOrderDenylistRequestReasonEnum {
    Fraud = 'fraud',
    Chargebacks = 'chargebacks',
    MultipleAccounts = 'multipleAccounts',
    InappropriateBehavior = 'inappropriateBehavior'
}

/**
 * 
 * @export
 * @interface AddUserToShowEventCommentDenylist
 */
export interface AddUserToShowEventCommentDenylist {
    /**
     * 
     * @type {string}
     * @memberof AddUserToShowEventCommentDenylist
     */
    reason: AddUserToShowEventCommentDenylistReasonEnum;
}

/**
* @export
* @enum {string}
*/
export enum AddUserToShowEventCommentDenylistReasonEnum {
    Spam = 'spam',
    Inappropriate = 'inappropriate',
    Aggressive = 'aggressive'
}

/**
 * 
 * @export
 * @interface AddUserToUpcomingShowCommentDenylist
 */
export interface AddUserToUpcomingShowCommentDenylist {
    /**
     * 
     * @type {string}
     * @memberof AddUserToUpcomingShowCommentDenylist
     */
    reason: AddUserToUpcomingShowCommentDenylistReasonEnum;
}

/**
* @export
* @enum {string}
*/
export enum AddUserToUpcomingShowCommentDenylistReasonEnum {
    Spam = 'spam',
    Inappropriate = 'inappropriate',
    Aggressive = 'aggressive'
}

/**
 * 
 * @export
 * @interface AddViewedOnboardingPushRequest
 */
export interface AddViewedOnboardingPushRequest {
    /**
     * 
     * @type {string}
     * @memberof AddViewedOnboardingPushRequest
     */
    onboardingPushId: string;
}

/**
 * 
 * @export
 * @interface AddVisitedFeedRequest
 */
export interface AddVisitedFeedRequest {
    /**
     * 
     * @type {string}
     * @memberof AddVisitedFeedRequest
     */
    feedId: string;
    /**
     * 
     * @type {string}
     * @memberof AddVisitedFeedRequest
     */
    feedType: AddVisitedFeedRequestFeedTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AddVisitedFeedRequest
     */
    sessionId?: string;
}

/**
* @export
* @enum {string}
*/
export enum AddVisitedFeedRequestFeedTypeEnum {
    Live = 'LIVE',
    Replay = 'REPLAY',
    Preview = 'PREVIEW',
    Review = 'REVIEW',
    PopClip = 'POP_CLIP'
}

/**
 * 
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    primaryPhone: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    compareHash?: string;
}

/**
 * 
 * @export
 * @interface AddressItem
 */
export interface AddressItem {
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    primaryPhone: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof AddressItem
     */
    compareHash?: string;
}

/**
 * 
 * @export
 * @interface AddressRequest
 */
export interface AddressRequest {
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    primaryPhone: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    postalCode: string;
}

/**
 * 
 * @export
 * @interface AdminPromoteRequest
 */
export interface AdminPromoteRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminPromoteRequest
     */
    password: string;
}

/**
 * 
 * @export
 * @interface AgenciesPageRows
 */
export interface AgenciesPageRows {
    /**
     * 
     * @type {Array<AgencyItemWithId>}
     * @memberof AgenciesPageRows
     */
    rows: Array<AgencyItemWithId>;
}

/**
 * 
 * @export
 * @interface AgenciesSearchResponse
 */
export interface AgenciesSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof AgenciesSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof AgenciesSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {AgenciesPageRows}
     * @memberof AgenciesSearchResponse
     */
    data: AgenciesPageRows;
}

/**
 * 
 * @export
 * @interface AgencyAddressDto
 */
export interface AgencyAddressDto {
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressDto
     */
    primaryPhone: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressDto
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressDto
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressDto
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressDto
     */
    postalCode: string;
}

/**
 * 
 * @export
 * @interface AgencyAddressItem
 */
export interface AgencyAddressItem {
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    primaryPhone: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyAddressItem
     */
    postalCode: string;
}

/**
 * 
 * @export
 * @interface AgencyItemWithId
 */
export interface AgencyItemWithId {
    /**
     * 
     * @type {string}
     * @memberof AgencyItemWithId
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyItemWithId
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyItemWithId
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyItemWithId
     */
    status: AgencyItemWithIdStatusEnum;
    /**
     * 
     * @type {AgencyAddressItem}
     * @memberof AgencyItemWithId
     */
    address: AgencyAddressItem;
    /**
     * 
     * @type {string}
     * @memberof AgencyItemWithId
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyItemWithId
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyItemWithId
     */
    id: string;
}

/**
* @export
* @enum {string}
*/
export enum AgencyItemWithIdStatusEnum {
    Active = 'active',
    Disabled = 'disabled'
}

/**
 * 
 * @export
 * @interface AgencyUserItemWithId
 */
export interface AgencyUserItemWithId {
    /**
     * 
     * @type {string}
     * @memberof AgencyUserItemWithId
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyUserItemWithId
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyUserItemWithId
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyUserItemWithId
     */
    role: AgencyUserItemWithIdRoleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyUserItemWithId
     */
    isDefault: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyUserItemWithId
     */
    disabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof AgencyUserItemWithId
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyUserItemWithId
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyUserItemWithId
     */
    id: string;
}

/**
* @export
* @enum {string}
*/
export enum AgencyUserItemWithIdRoleEnum {
    Admin = 'agency-admin',
    User = 'agency-user'
}

/**
 * 
 * @export
 * @interface AgencyUsersPageRows
 */
export interface AgencyUsersPageRows {
    /**
     * 
     * @type {Array<AgencyUserItemWithId>}
     * @memberof AgencyUsersPageRows
     */
    rows: Array<AgencyUserItemWithId>;
}

/**
 * 
 * @export
 * @interface AgencyUsersSearchResponse
 */
export interface AgencyUsersSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof AgencyUsersSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof AgencyUsersSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {AgencyUsersPageRows}
     * @memberof AgencyUsersSearchResponse
     */
    data: AgencyUsersPageRows;
}

/**
 * 
 * @export
 * @interface AggregateSellerLiveStreamsStatsItem
 */
export interface AggregateSellerLiveStreamsStatsItem {
    /**
     * 
     * @type {number}
     * @memberof AggregateSellerLiveStreamsStatsItem
     */
    totalGmv: number;
}

/**
 * 
 * @export
 * @interface AggregateSellerLiveStreamsStatsResponse
 */
export interface AggregateSellerLiveStreamsStatsResponse {
    /**
     * 
     * @type {AggregateSellerLiveStreamsStatsItem}
     * @memberof AggregateSellerLiveStreamsStatsResponse
     */
    data: AggregateSellerLiveStreamsStatsItem;
}

/**
 * 
 * @export
 * @interface AggregateSellerPeriodStatsItem
 */
export interface AggregateSellerPeriodStatsItem {
    /**
     * 
     * @type {number}
     * @memberof AggregateSellerPeriodStatsItem
     */
    totalGmv: number;
}

/**
 * 
 * @export
 * @interface AggregateSellerPeriodStatsResponse
 */
export interface AggregateSellerPeriodStatsResponse {
    /**
     * 
     * @type {AggregateSellerPeriodStatsItem}
     * @memberof AggregateSellerPeriodStatsResponse
     */
    data: AggregateSellerPeriodStatsItem;
}

/**
 * 
 * @export
 * @interface AggregateSellerUnshippedOrdersItem
 */
export interface AggregateSellerUnshippedOrdersItem {
    /**
     * 
     * @type {string}
     * @memberof AggregateSellerUnshippedOrdersItem
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof AggregateSellerUnshippedOrdersItem
     */
    storeFrontName: string;
    /**
     * The number of unshipped order
     * @type {number}
     * @memberof AggregateSellerUnshippedOrdersItem
     */
    count: number;
}

/**
 * 
 * @export
 * @interface AggregateSellerUnshippedOrdersResponse
 */
export interface AggregateSellerUnshippedOrdersResponse {
    /**
     * 
     * @type {Array<AggregateSellerUnshippedOrdersItem>}
     * @memberof AggregateSellerUnshippedOrdersResponse
     */
    data: Array<AggregateSellerUnshippedOrdersItem>;
}

/**
 * 
 * @export
 * @interface AiModerationResultItem
 */
export interface AiModerationResultItem {
    /**
     * 
     * @type {string}
     * @memberof AiModerationResultItem
     */
    video_path: string;
    /**
     * 
     * @type {number}
     * @memberof AiModerationResultItem
     */
    total_frames_analyzed: number;
    /**
     * 
     * @type {number}
     * @memberof AiModerationResultItem
     */
    exposed_frames_count: number;
    /**
     * 
     * @type {number}
     * @memberof AiModerationResultItem
     */
    processing_time: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AiModerationResultItem
     */
    all_labels: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AiModerationResultItem
     */
    exposed_labels: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AiModerationResultItem
     */
    frames_with_kids: number;
    /**
     * 
     * @type {number}
     * @memberof AiModerationResultItem
     */
    critical_frames: number;
    /**
     * 
     * @type {number}
     * @memberof AiModerationResultItem
     */
    count_critical_g: number;
    /**
     * 
     * @type {number}
     * @memberof AiModerationResultItem
     */
    count_critical_a: number;
    /**
     * 
     * @type {number}
     * @memberof AiModerationResultItem
     */
    count_critical_b: number;
    /**
     * 
     * @type {number}
     * @memberof AiModerationResultItem
     */
    highest_confidence_fg: number;
}

/**
 * 
 * @export
 * @interface Analytics
 */
export interface Analytics {
    /**
     * 
     * @type {GooglePlayAnalytics}
     * @memberof Analytics
     */
    googlePlay?: GooglePlayAnalytics;
    /**
     * 
     * @type {ItunesConnectAnalytics}
     * @memberof Analytics
     */
    itunesConnect?: ItunesConnectAnalytics;
}

/**
 * 
 * @export
 * @interface AndroidConfig
 */
export interface AndroidConfig {
    /**
     * 
     * @type {string}
     * @memberof AndroidConfig
     */
    afl?: string;
    /**
     * 
     * @type {string}
     * @memberof AndroidConfig
     */
    amv?: string;
}

/**
 * 
 * @export
 * @interface AnlsSellerItem
 */
export interface AnlsSellerItem {
    /**
     * 
     * @type {string}
     * @memberof AnlsSellerItem
     */
    sellerId: string;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    customerCount: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    viewerCount: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    followerCount: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    referralCount: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    gmv: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    initializedShowCount: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    totalNewShippingRevenue?: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    totalNewShippingCost?: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    maxNewShippingCost?: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    minNewShippingCost?: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    averageShippingCostT60d?: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerItem
     */
    averageNewShippingCost?: number;
}

/**
 * 
 * @export
 * @interface AnlsSellerMainOrderItem
 */
export interface AnlsSellerMainOrderItem {
    /**
     * 
     * @type {string}
     * @memberof AnlsSellerMainOrderItem
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof AnlsSellerMainOrderItem
     */
    orderNumber: string;
    /**
     * 
     * @type {string}
     * @memberof AnlsSellerMainOrderItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof AnlsSellerMainOrderItem
     */
    updatedAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof AnlsSellerMainOrderItem
     */
    isDeleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof AnlsSellerMainOrderItem
     */
    status: AnlsSellerMainOrderItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AnlsSellerMainOrderItem
     */
    mainOrderStatus: AnlsSellerMainOrderItemMainOrderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AnlsSellerMainOrderItem
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof AnlsSellerMainOrderItem
     */
    sellerName: string;
    /**
     * 
     * @type {string}
     * @memberof AnlsSellerMainOrderItem
     */
    sellerEmail: string;
    /**
     * 
     * @type {string}
     * @memberof AnlsSellerMainOrderItem
     */
    storeName: string;
    /**
     * 
     * @type {string}
     * @memberof AnlsSellerMainOrderItem
     */
    buyerId: string;
    /**
     * 
     * @type {string}
     * @memberof AnlsSellerMainOrderItem
     */
    buyerName: string;
    /**
     * 
     * @type {string}
     * @memberof AnlsSellerMainOrderItem
     */
    buyerEmail: string;
    /**
     * 
     * @type {string}
     * @memberof AnlsSellerMainOrderItem
     */
    liveStreamId: string;
    /**
     * 
     * @type {boolean}
     * @memberof AnlsSellerMainOrderItem
     */
    orderShipmentGroupStatusMaster: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnlsSellerMainOrderItem
     */
    orderShipmentGroupStatusCustomer: boolean;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerMainOrderItem
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerMainOrderItem
     */
    itemCnt: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerMainOrderItem
     */
    purchaseCnt: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerMainOrderItem
     */
    unshippedPurchaseCnt: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerMainOrderItem
     */
    shippedPurchaseCnt: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerMainOrderItem
     */
    completedPurchaseCnt: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerMainOrderItem
     */
    canceledPurchaseCnt: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerMainOrderItem
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerMainOrderItem
     */
    refund: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerMainOrderItem
     */
    buyerPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerMainOrderItem
     */
    taxRate: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsSellerMainOrderItem
     */
    taxAmount: number;
}

/**
* @export
* @enum {string}
*/
export enum AnlsSellerMainOrderItemStatusEnum {
    Created = 'created',
    Completed = 'completed',
    Canceled = 'canceled',
    PendingPayment = 'pendingPayment',
    ProcessingPayment = 'processingPayment',
    Closed = 'closed'
}/**
* @export
* @enum {string}
*/
export enum AnlsSellerMainOrderItemMainOrderStatusEnum {
    Created = 'created',
    Completed = 'completed',
    Canceled = 'canceled',
    PendingPayment = 'pendingPayment',
    ProcessingPayment = 'processingPayment',
    Closed = 'closed'
}

/**
 * 
 * @export
 * @interface AnlsUserItem
 */
export interface AnlsUserItem {
    /**
     * 
     * @type {string}
     * @memberof AnlsUserItem
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof AnlsUserItem
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof AnlsUserItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof AnlsUserItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof AnlsUserItem
     */
    userEmail: string;
    /**
     * 
     * @type {number}
     * @memberof AnlsUserItem
     */
    purchaseCnt: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsUserItem
     */
    buyerPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsUserItem
     */
    watchSec: number;
    /**
     * 
     * @type {string}
     * @memberof AnlsUserItem
     */
    watchFormatted: string;
    /**
     * 
     * @type {number}
     * @memberof AnlsUserItem
     */
    watchShowCnt: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsUserItem
     */
    followingCnt: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsUserItem
     */
    showLikeCnt: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsUserItem
     */
    showCommentCnt: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsUserItem
     */
    showShareCnt: number;
    /**
     * 
     * @type {number}
     * @memberof AnlsUserItem
     */
    followerCount: number;
}

/**
 * 
 * @export
 * @interface AppSellerApplicationItem
 */
export interface AppSellerApplicationItem {
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    whereOnline?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    whatSell?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    whatExperienceProducts?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    whatLiveStream?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    howHearUs?: string;
    /**
     * 
     * @type {AddressItem}
     * @memberof AppSellerApplicationItem
     */
    sellerAddress?: AddressItem;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    storeName?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    storeDesc?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    website?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    social?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    sellerDesc?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    sellerHasPhysicalStore?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    status: AppSellerApplicationItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    userId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof AppSellerApplicationItem
     */
    profile: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    rejectedReason?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    rejectedAt: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppSellerApplicationItem
     */
    categoryIds?: Array<string>;
    /**
     * Host Or Seller Application
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    applicationType?: AppSellerApplicationItemApplicationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    country?: string;
    /**
     * 
     * @type {SocialAccountDto}
     * @memberof AppSellerApplicationItem
     */
    socialAccounts?: SocialAccountDto;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    additionalNotes?: string;
    /**
     * Name of the category
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    category?: string;
    /**
     * What is your total community reach?
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    totalCommunityReach?: string;
    /**
     * How would you best describe the type of products you plan to sell?
     * @type {Array<string>}
     * @memberof AppSellerApplicationItem
     */
    productTypes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    annualSalesRevenue?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    liveStreamExperienceRate?: AppSellerApplicationItemLiveStreamExperienceRateEnum;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    liveStreamExperience?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    whenSell?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    businessName?: string;
    /**
     * Who will be hosting your shows?
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    hostingOperator?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppSellerApplicationItem
     */
    experienceInRetailSales?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AppSellerApplicationItem
     */
    interestedInPromoting?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    openQuestion?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    monthlySalesRevenue?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationItem
     */
    storeType?: AppSellerApplicationItemStoreTypeEnum;
    /**
     * 
     * @type {BaseAppSellerApplicationItem}
     * @memberof AppSellerApplicationItem
     */
    lastRejectedApplication?: BaseAppSellerApplicationItem;
}

/**
* @export
* @enum {string}
*/
export enum AppSellerApplicationItemStatusEnum {
    Submitted = 'submitted',
    Approved = 'approved',
    Rejected = 'rejected'
}/**
* @export
* @enum {string}
*/
export enum AppSellerApplicationItemApplicationTypeEnum {
    Host = 'HOST',
    Seller = 'SELLER'
}/**
* @export
* @enum {string}
*/
export enum AppSellerApplicationItemLiveStreamExperienceRateEnum {
    Beginner = 'BEGINNER',
    Intermediate = 'INTERMEDIATE',
    Pro = 'PRO'
}/**
* @export
* @enum {string}
*/
export enum AppSellerApplicationItemStoreTypeEnum {
    Business = 'Business',
    Creator = 'Creator',
    CommentChat = 'CommentChat',
    Vfs = 'VFS'
}

/**
 * 
 * @export
 * @interface AppSellerApplicationPageRows
 */
export interface AppSellerApplicationPageRows {
    /**
     * 
     * @type {Array<AppSellerApplicationItem>}
     * @memberof AppSellerApplicationPageRows
     */
    rows: Array<AppSellerApplicationItem>;
}

/**
 * 
 * @export
 * @interface AppSellerApplicationResponse
 */
export interface AppSellerApplicationResponse {
    /**
     * 
     * @type {AppSellerApplicationResponseData}
     * @memberof AppSellerApplicationResponse
     */
    data?: AppSellerApplicationResponseData;
}

/**
 * 
 * @export
 * @interface AppSellerApplicationResponseData
 */
export interface AppSellerApplicationResponseData {
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationResponseData
     */
    status: AppSellerApplicationResponseDataStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationResponseData
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof AppSellerApplicationResponseData
     */
    rejectedReason?: string;
}

/**
* @export
* @enum {string}
*/
export enum AppSellerApplicationResponseDataStatusEnum {
    Submitted = 'submitted',
    Approved = 'approved',
    Rejected = 'rejected'
}

/**
 * 
 * @export
 * @interface AppSellerApplicationsSearchResponse
 */
export interface AppSellerApplicationsSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof AppSellerApplicationsSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof AppSellerApplicationsSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {AppSellerApplicationPageRows}
     * @memberof AppSellerApplicationsSearchResponse
     */
    data: AppSellerApplicationPageRows;
}

/**
 * 
 * @export
 * @interface ApplyChangePayoutMethodDto
 */
export interface ApplyChangePayoutMethodDto {
    /**
     * 
     * @type {PayoutBankDto}
     * @memberof ApplyChangePayoutMethodDto
     */
    payoutMethodBank: PayoutBankDto;
}

/**
 * 
 * @export
 * @interface ApplyPopStoreThemeRequest
 */
export interface ApplyPopStoreThemeRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplyPopStoreThemeRequest
     */
    themeId: string;
}

/**
 * 
 * @export
 * @interface ApplyStripePayoutMethodRequest
 */
export interface ApplyStripePayoutMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplyStripePayoutMethodRequest
     */
    accountNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyStripePayoutMethodRequest
     */
    routingNumber: string;
}

/**
 * 
 * @export
 * @interface ApproveWithdrawTransactionDto
 */
export interface ApproveWithdrawTransactionDto {
    /**
     * 
     * @type {string}
     * @memberof ApproveWithdrawTransactionDto
     */
    note?: string;
}

/**
 * 
 * @export
 * @interface AssignAgencyRequest
 */
export interface AssignAgencyRequest {
    /**
     * 
     * @type {string}
     * @memberof AssignAgencyRequest
     */
    agencyId?: string;
}

/**
 * 
 * @export
 * @interface AssignBadgeRequest
 */
export interface AssignBadgeRequest {
    /**
     * 
     * @type {string}
     * @memberof AssignBadgeRequest
     */
    sourceType?: AssignBadgeRequestSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AssignBadgeRequest
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignBadgeRequest
     */
    upcomingShowId?: string;
}

/**
* @export
* @enum {string}
*/
export enum AssignBadgeRequestSourceTypeEnum {
    LiveStream = 'liveStream',
    UpcomingShow = 'upcomingShow'
}

/**
 * 
 * @export
 * @interface AssignCouponsToUserRequest
 */
export interface AssignCouponsToUserRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignCouponsToUserRequest
     */
    userIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignCouponsToUserRequest
     */
    couponIds: Array<string>;
}

/**
 * 
 * @export
 * @interface AuctionTimer
 */
export interface AuctionTimer {
    /**
     * 
     * @type {number}
     * @memberof AuctionTimer
     */
    durationSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof AuctionTimer
     */
    countdownSeconds: number;
}

/**
 * 
 * @export
 * @interface AuditBadgeRequest
 */
export interface AuditBadgeRequest {
    /**
     * 
     * @type {string}
     * @memberof AuditBadgeRequest
     */
    status: AuditBadgeRequestStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum AuditBadgeRequestStatusEnum {
    Approved = 'APPROVED',
    EditRequire = 'EDIT_REQUIRE'
}

/**
 * 
 * @export
 * @interface AuditChangePayoutMethodDto
 */
export interface AuditChangePayoutMethodDto {
    /**
     * 
     * @type {string}
     * @memberof AuditChangePayoutMethodDto
     */
    payoutHistoryId: string;
}

/**
 * 
 * @export
 * @interface AuditDropshipApplicationRequest
 */
export interface AuditDropshipApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof AuditDropshipApplicationRequest
     */
    action: AuditDropshipApplicationRequestActionEnum;
    /**
     * 
     * @type {string}
     * @memberof AuditDropshipApplicationRequest
     */
    reason?: string;
}

/**
* @export
* @enum {string}
*/
export enum AuditDropshipApplicationRequestActionEnum {
    Approve = 'approve',
    Reject = 'reject'
}

/**
 * 
 * @export
 * @interface AuthTokenResponse
 */
export interface AuthTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthTokenResponse
     */
    token: string;
}

/**
 * 
 * @export
 * @interface AuthUrlResponse
 */
export interface AuthUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthUrlResponse
     */
    authUrl: string;
}

/**
 * 
 * @export
 * @interface AuthUserItem
 */
export interface AuthUserItem {
    /**
     * 
     * @type {string}
     * @memberof AuthUserItem
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof AuthUserItem
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AuthUserItem
     */
    emailVerified: boolean;
    /**
     * 
     * @type {string}
     * @memberof AuthUserItem
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthUserItem
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthUserItem
     */
    photoURL?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AuthUserItem
     */
    disabled: boolean;
    /**
     * 
     * @type {Array<ProviderUser>}
     * @memberof AuthUserItem
     */
    providerData?: Array<ProviderUser>;
    /**
     * 
     * @type {CustomUserClaim}
     * @memberof AuthUserItem
     */
    customClaims?: CustomUserClaim;
    /**
     * 
     * @type {UserMetadata}
     * @memberof AuthUserItem
     */
    metadata: UserMetadata;
}

/**
 * 
 * @export
 * @interface AvailableAssignToUserCouponsItem
 */
export interface AvailableAssignToUserCouponsItem {
    /**
     * 
     * @type {string}
     * @memberof AvailableAssignToUserCouponsItem
     */
    couponId: string;
    /**
     * 
     * @type {CouponItem}
     * @memberof AvailableAssignToUserCouponsItem
     */
    coupon: CouponItem;
}

/**
 * 
 * @export
 * @interface AvailableAssignToUserCouponsResponse
 */
export interface AvailableAssignToUserCouponsResponse {
    /**
     * 
     * @type {Array<AvailableAssignToUserCouponsItem>}
     * @memberof AvailableAssignToUserCouponsResponse
     */
    coupons: Array<AvailableAssignToUserCouponsItem>;
}

/**
 * 
 * @export
 * @interface AvailableCouponDto
 */
export interface AvailableCouponDto {
    /**
     * 
     * @type {string}
     * @memberof AvailableCouponDto
     */
    couponId: string;
    /**
     * not null if coupon is redeemed and not used
     * @type {string}
     * @memberof AvailableCouponDto
     */
    redeemedCouponId?: string;
    /**
     * 
     * @type {CouponItem}
     * @memberof AvailableCouponDto
     */
    coupon: CouponItem;
    /**
     * 
     * @type {string}
     * @memberof AvailableCouponDto
     */
    redeemStatus: AvailableCouponDtoRedeemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AvailableCouponDto
     */
    reason?: string;
}

/**
* @export
* @enum {string}
*/
export enum AvailableCouponDtoRedeemStatusEnum {
    Redeemed = 'redeemed',
    Redeemable = 'redeemable',
    Nonredeemable = 'nonredeemable'
}

/**
 * 
 * @export
 * @interface AvailableCouponsResponseDto
 */
export interface AvailableCouponsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AvailableCouponsResponseDto
     */
    total: number;
    /**
     * 
     * @type {boolean}
     * @memberof AvailableCouponsResponseDto
     */
    isFirstPurchaseUser: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AvailableCouponsResponseDto
     */
    isNewUser: boolean;
    /**
     * 
     * @type {Array<AvailableCouponDto>}
     * @memberof AvailableCouponsResponseDto
     */
    coupons: Array<AvailableCouponDto>;
}

/**
 * 
 * @export
 * @interface BadgeItem
 */
export interface BadgeItem {
    /**
     * 
     * @type {string}
     * @memberof BadgeItem
     */
    status: BadgeItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BadgeItem
     */
    approvedById?: string;
    /**
     * 
     * @type {string}
     * @memberof BadgeItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BadgeItem
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof BadgeItem
     */
    currentStep: BadgeItemCurrentStepEnum;
    /**
     * 
     * @type {string}
     * @memberof BadgeItem
     */
    generatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof BadgeItem
     */
    storeId: string;
    /**
     * 
     * @type {StoreFrontItem}
     * @memberof BadgeItem
     */
    store: StoreFrontItem;
    /**
     * 
     * @type {number}
     * @memberof BadgeItem
     */
    assignedCount: number;
    /**
     * 
     * @type {number}
     * @memberof BadgeItem
     */
    limitCount: number;
    /**
     * 
     * @type {string}
     * @memberof BadgeItem
     */
    limit: BadgeItemLimitEnum;
    /**
     * 
     * @type {string}
     * @memberof BadgeItem
     */
    url?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BadgeItem
     */
    editionNoGaps?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof BadgeItem
     */
    nextEditionNo: number;
    /**
     * 
     * @type {string}
     * @memberof BadgeItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof BadgeItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof BadgeItem
     */
    approvedAt?: string;
}

/**
* @export
* @enum {string}
*/
export enum BadgeItemStatusEnum {
    Draft = 'DRAFT',
    Pending = 'PENDING',
    Approved = 'APPROVED',
    EditRequire = 'EDIT_REQUIRE'
}/**
* @export
* @enum {string}
*/
export enum BadgeItemCurrentStepEnum {
    FillBaseInfo = 'FILL_BASE_INFO',
    UploadBadge = 'UPLOAD_BADGE',
    ConfirmBadge = 'CONFIRM_BADGE',
    ReviewBadge = 'REVIEW_BADGE'
}/**
* @export
* @enum {string}
*/
export enum BadgeItemLimitEnum {
    BadgeLimit5 = 'Badge_LIMIT_5',
    BadgeLimit25 = 'Badge_LIMIT_25',
    BadgeLimit100 = 'Badge_LIMIT_100',
    BadgeLimit250 = 'Badge_LIMIT_250',
    BadgeLimit500 = 'Badge_LIMIT_500',
    BadgeLimit1000 = 'Badge_LIMIT_1000',
    Unlimited = 'Unlimited'
}

/**
 * 
 * @export
 * @interface BannerLiveStreamRow
 */
export interface BannerLiveStreamRow {
    /**
     * 
     * @type {string}
     * @memberof BannerLiveStreamRow
     */
    listingId: string;
    /**
     * 
     * @type {ProductsListing}
     * @memberof BannerLiveStreamRow
     */
    listing: ProductsListing;
    /**
     * 
     * @type {string}
     * @memberof BannerLiveStreamRow
     */
    type: BannerLiveStreamRowTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BannerLiveStreamRow
     */
    liveStreamId: string;
}

/**
* @export
* @enum {string}
*/
export enum BannerLiveStreamRowTypeEnum {
    LiveStream = 'liveStream'
}

/**
 * 
 * @export
 * @interface BannerProductsResponse
 */
export interface BannerProductsResponse {
    /**
     * 
     * @type {Array<BannerLiveStreamRow | BannerUpcomingShowRow>}
     * @memberof BannerProductsResponse
     */
    data: Array<BannerLiveStreamRow | BannerUpcomingShowRow>;
}

/**
 * 
 * @export
 * @interface BannerUpcomingShowRow
 */
export interface BannerUpcomingShowRow {
    /**
     * 
     * @type {string}
     * @memberof BannerUpcomingShowRow
     */
    listingId: string;
    /**
     * 
     * @type {ProductsListing}
     * @memberof BannerUpcomingShowRow
     */
    listing: ProductsListing;
    /**
     * 
     * @type {string}
     * @memberof BannerUpcomingShowRow
     */
    type: BannerUpcomingShowRowTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BannerUpcomingShowRow
     */
    upcomingShowId: string;
}

/**
* @export
* @enum {string}
*/
export enum BannerUpcomingShowRowTypeEnum {
    UpcomingShow = 'upcomingShow'
}

/**
 * 
 * @export
 * @interface BaseAppSellerApplicationItem
 */
export interface BaseAppSellerApplicationItem {
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    whereOnline?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    whatSell?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    whatExperienceProducts?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    whatLiveStream?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    howHearUs?: string;
    /**
     * 
     * @type {AddressItem}
     * @memberof BaseAppSellerApplicationItem
     */
    sellerAddress?: AddressItem;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    storeName?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    storeDesc?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    website?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    social?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    sellerDesc?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    sellerHasPhysicalStore?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    status: BaseAppSellerApplicationItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    userId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof BaseAppSellerApplicationItem
     */
    profile: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    rejectedReason?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    rejectedAt: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseAppSellerApplicationItem
     */
    categoryIds?: Array<string>;
    /**
     * Host Or Seller Application
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    applicationType?: BaseAppSellerApplicationItemApplicationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    country?: string;
    /**
     * 
     * @type {SocialAccountDto}
     * @memberof BaseAppSellerApplicationItem
     */
    socialAccounts?: SocialAccountDto;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    additionalNotes?: string;
    /**
     * Name of the category
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    category?: string;
    /**
     * What is your total community reach?
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    totalCommunityReach?: string;
    /**
     * How would you best describe the type of products you plan to sell?
     * @type {Array<string>}
     * @memberof BaseAppSellerApplicationItem
     */
    productTypes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    annualSalesRevenue?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    liveStreamExperienceRate?: BaseAppSellerApplicationItemLiveStreamExperienceRateEnum;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    liveStreamExperience?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    whenSell?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    businessName?: string;
    /**
     * Who will be hosting your shows?
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    hostingOperator?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseAppSellerApplicationItem
     */
    experienceInRetailSales?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof BaseAppSellerApplicationItem
     */
    interestedInPromoting?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    openQuestion?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    monthlySalesRevenue?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAppSellerApplicationItem
     */
    storeType?: BaseAppSellerApplicationItemStoreTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum BaseAppSellerApplicationItemStatusEnum {
    Submitted = 'submitted',
    Approved = 'approved',
    Rejected = 'rejected'
}/**
* @export
* @enum {string}
*/
export enum BaseAppSellerApplicationItemApplicationTypeEnum {
    Host = 'HOST',
    Seller = 'SELLER'
}/**
* @export
* @enum {string}
*/
export enum BaseAppSellerApplicationItemLiveStreamExperienceRateEnum {
    Beginner = 'BEGINNER',
    Intermediate = 'INTERMEDIATE',
    Pro = 'PRO'
}/**
* @export
* @enum {string}
*/
export enum BaseAppSellerApplicationItemStoreTypeEnum {
    Business = 'Business',
    Creator = 'Creator',
    CommentChat = 'CommentChat',
    Vfs = 'VFS'
}

/**
 * 
 * @export
 * @interface BaseProfileItem
 */
export interface BaseProfileItem {
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     */
    createdAt?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BaseProfileItem
     */
    hashtags?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     */
    userType?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     */
    storeType?: BaseProfileItemStoreTypeEnum;
    /**
     * 
     * @type {ProfileAppsItem}
     * @memberof BaseProfileItem
     */
    apps?: ProfileAppsItem;
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     */
    popStoreDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     */
    urlCode?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseProfileItem
     */
    username?: string;
    /**
     * 
     * @type {ProfileBadges}
     * @memberof BaseProfileItem
     */
    badges?: ProfileBadges;
}

/**
* @export
* @enum {string}
*/
export enum BaseProfileItemStoreTypeEnum {
    Business = 'Business',
    Creator = 'Creator',
    CommentChat = 'CommentChat',
    Vfs = 'VFS'
}

/**
 * 
 * @export
 * @interface BasePromotionPageItem
 */
export interface BasePromotionPageItem {
    /**
     * 
     * @type {string}
     * @memberof BasePromotionPageItem
     */
    avatar: string;
    /**
     * 
     * @type {string}
     * @memberof BasePromotionPageItem
     */
    coverImage: string;
    /**
     * 
     * @type {boolean}
     * @memberof BasePromotionPageItem
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof BasePromotionPageItem
     */
    thumbnailNickName: string;
    /**
     * 
     * @type {string}
     * @memberof BasePromotionPageItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof BasePromotionPageItem
     */
    video: string;
}

/**
 * 
 * @export
 * @interface BaseShowEventWithMetadataItem
 */
export interface BaseShowEventWithMetadataItem {
    /**
     * 
     * @type {string}
     * @memberof BaseShowEventWithMetadataItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BaseShowEventWithMetadataItem
     */
    urlCode: string;
    /**
     * 
     * @type {string}
     * @memberof BaseShowEventWithMetadataItem
     */
    previewVideoURL?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseShowEventWithMetadataItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseShowEventWithMetadataItem
     */
    backgroundURL?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseShowEventWithMetadataItem
     */
    active: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseShowEventWithMetadataItem
     */
    sellerUserGroupIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseShowEventWithMetadataItem
     */
    userGroupIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BaseShowEventWithMetadataItem
     */
    createdAt: string;
    /**
     * 
     * @type {number}
     * @memberof BaseShowEventWithMetadataItem
     */
    salesTaxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof BaseShowEventWithMetadataItem
     */
    maximumPurchaseQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseShowEventWithMetadataItem
     */
    startedAfter?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseShowEventWithMetadataItem
     */
    endedBefore?: string;
    /**
     * 
     * @type {number}
     * @memberof BaseShowEventWithMetadataItem
     */
    shippingFee?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BaseShowEventWithMetadataItem
     */
    isClosed?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseShowEventWithMetadataItem
     */
    visibilityGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BaseShowEventWithMetadataItem
     */
    sortedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof BaseShowEventWithMetadataItem
     */
    commissionFeeRate?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseShowEventWithMetadataItem
     */
    featuredStoreStackName?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseShowEventWithMetadataItem
     */
    sellerApplicationDisclosure?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseShowEventWithMetadataItem
     */
    sellerApplicationDisclosureUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseShowEventWithMetadataItem
     */
    unBundleOnDiscovery?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaseShowEventWithMetadataItem
     */
    visibilityOnDiscoveryBanner?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaseShowEventWithMetadataItem
     */
    visibleOnCategoryBanner?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseShowEventWithMetadataItem
     */
    id: string;
    /**
     * 
     * @type {Metadata}
     * @memberof BaseShowEventWithMetadataItem
     */
    metadata: Metadata;
}

/**
 * 
 * @export
 * @interface BaseStoreListingItem
 */
export interface BaseStoreListingItem {
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof BaseStoreListingItem
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof BaseStoreListingItem
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    defaultImage: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseStoreListingItem
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof BaseStoreListingItem
     */
    quantity: number;
    /**
     * 
     * @type {Array<StoreListingVariant>}
     * @memberof BaseStoreListingItem
     */
    variants?: Array<StoreListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof BaseStoreListingItem
     */
    maximumPurchaseQuantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BaseStoreListingItem
     */
    shippingFee?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseStoreListingItem
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    status?: BaseStoreListingItemStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof BaseStoreListingItem
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {StoreListingOriginalInfo}
     * @memberof BaseStoreListingItem
     */
    originalInfo?: StoreListingOriginalInfo;
    /**
     * 
     * @type {DimsInfo}
     * @memberof BaseStoreListingItem
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {SingleUnitWeightInfo | PoundWithOunceWeightInfo}
     * @memberof BaseStoreListingItem
     */
    weight?: SingleUnitWeightInfo | PoundWithOunceWeightInfo;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof BaseStoreListingItem
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    taxCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseStoreListingItem
     */
    nontaxable?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BaseStoreListingItem
     */
    soldQuantityLast7Days?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    storeCoverImage?: string;
    /**
     * 
     * @type {ListingDropshipDetailsItem}
     * @memberof BaseStoreListingItem
     */
    dropshipDetails?: ListingDropshipDetailsItem;
    /**
     * 
     * @type {boolean}
     * @memberof BaseStoreListingItem
     */
    useLocalPrice?: boolean;
    /**
     * 
     * @type {ListingProductCategoryItem}
     * @memberof BaseStoreListingItem
     */
    category?: ListingProductCategoryItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseStoreListingItem
     */
    collectionIds?: Array<string>;
    /**
     * 
     * @type {ListingRatingType}
     * @memberof BaseStoreListingItem
     */
    rating?: ListingRatingType;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    sizingGuideImage?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    defaultSizingGuideImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseStoreListingItem
     */
    eligibleForModelMe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaseStoreListingItem
     */
    shopModelMe?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseStoreListingItem
     */
    categoryIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    type?: BaseStoreListingItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseStoreListingItem
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    discountEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {UploadedFileItem}
     * @memberof BaseStoreListingItem
     */
    uploadedFile?: UploadedFileItem;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    moderationStatus?: BaseStoreListingItemModerationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    moderatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    moderatorUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    adminModerationReason?: string;
    /**
     * 
     * @type {ModeratorProfileItem}
     * @memberof BaseStoreListingItem
     */
    moderatorProfile?: ModeratorProfileItem;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    externalCheckoutUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    externalBrandName?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseStoreListingItem
     */
    externalBrandImage?: string;
    /**
     * 
     * @type {ListingMeetingItem}
     * @memberof BaseStoreListingItem
     */
    meeting?: ListingMeetingItem;
}

/**
* @export
* @enum {string}
*/
export enum BaseStoreListingItemStatusEnum {
    Active = 'active',
    Archived = 'archived'
}/**
* @export
* @enum {string}
*/
export enum BaseStoreListingItemTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}/**
* @export
* @enum {string}
*/
export enum BaseStoreListingItemModerationStatusEnum {
    Pending = 'Pending',
    Accepted = 'Accepted',
    Rejected = 'Rejected',
    ReviewRequired = 'ReviewRequired'
}

/**
 * 
 * @export
 * @interface BaseUpcomingShowItem
 */
export interface BaseUpcomingShowItem {
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseUpcomingShowItem
     */
    badges: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    title: string;
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof BaseUpcomingShowItem
     */
    user: BaseProfileItem;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    originalCoverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    previewVideoURL: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    shareVideo?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    startsAt: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    createdAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseUpcomingShowItem
     */
    available: boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    visibility?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    permission?: BaseUpcomingShowItemPermissionEnum;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    eventId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseUpcomingShowItem
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    eventTemplateId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseUpcomingShowItem
     */
    disableComments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaseUpcomingShowItem
     */
    notificationSent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    liveStreamId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseUpcomingShowItem
     */
    historyLiveStreamIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    transcodeStatus?: BaseUpcomingShowItemTranscodeStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BaseUpcomingShowItem
     */
    accessLevel?: BaseUpcomingShowItemAccessLevelEnum;
}

/**
* @export
* @enum {string}
*/
export enum BaseUpcomingShowItemPermissionEnum {
    All = 'all',
    Follower = 'follower',
    Subscriber = 'subscriber',
    NoOne = 'no-one'
}/**
* @export
* @enum {string}
*/
export enum BaseUpcomingShowItemTranscodeStatusEnum {
    Initial = 'initial',
    Processing = 'processing',
    TranscodeOriginal = 'transcode-original',
    TranscodeOriginalShare = 'transcode-original-share',
    RequestRetranscode = 'request-retranscode'
}/**
* @export
* @enum {string}
*/
export enum BaseUpcomingShowItemAccessLevelEnum {
    All = 'all',
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface BasicCommentItem
 */
export interface BasicCommentItem {
    /**
     * 
     * @type {string}
     * @memberof BasicCommentItem
     */
    type: BasicCommentItemTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum BasicCommentItemTypeEnum {
    Comment = 'comment',
    UserEnter = 'userEnter',
    UserFollow = 'userFollow',
    Purchase = 'purchase',
    Share = 'share',
    Gifting = 'gifting',
    Wave = 'wave',
    WavedToUserEnter = 'wavedToUserEnter'
}

/**
 * 
 * @export
 * @interface BasicGoogleCategoryItem
 */
export interface BasicGoogleCategoryItem {
    /**
     * 
     * @type {string}
     * @memberof BasicGoogleCategoryItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BasicGoogleCategoryItem
     */
    name: string;
}

/**
 * 
 * @export
 * @interface BasicProductCategoryItem
 */
export interface BasicProductCategoryItem {
    /**
     * 
     * @type {string}
     * @memberof BasicProductCategoryItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BasicProductCategoryItem
     */
    name: string;
}

/**
 * 
 * @export
 * @interface BasicProfileDto
 */
export interface BasicProfileDto {
    /**
     * First name
     * @type {string}
     * @memberof BasicProfileDto
     */
    firstName: string;
    /**
     * Last name
     * @type {string}
     * @memberof BasicProfileDto
     */
    lastName: string;
    /**
     * Username
     * @type {string}
     * @memberof BasicProfileDto
     */
    username: string;
    /**
     * Avatar URL
     * @type {string}
     * @memberof BasicProfileDto
     */
    avatar: string;
}

/**
 * 
 * @export
 * @interface BatchAddShipmentTrackingRecordRequest
 */
export interface BatchAddShipmentTrackingRecordRequest {
    /**
     * 
     * @type {Array<BatchAddShipmentTrackingRecordRequestItem>}
     * @memberof BatchAddShipmentTrackingRecordRequest
     */
    data: Array<BatchAddShipmentTrackingRecordRequestItem>;
}

/**
 * 
 * @export
 * @interface BatchAddShipmentTrackingRecordRequestItem
 */
export interface BatchAddShipmentTrackingRecordRequestItem {
    /**
     * 
     * @type {string}
     * @memberof BatchAddShipmentTrackingRecordRequestItem
     */
    trackingNumber: string;
    /**
     * 
     * @type {string}
     * @memberof BatchAddShipmentTrackingRecordRequestItem
     */
    trackingUrlProvider?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchAddShipmentTrackingRecordRequestItem
     */
    carrier?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BatchAddShipmentTrackingRecordRequestItem
     */
    isRemoved?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BatchAddShipmentTrackingRecordRequestItem
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchAddShipmentTrackingRecordRequestItem
     */
    transactionId?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchAddShipmentTrackingRecordRequestItem
     */
    orderId: string;
}

/**
 * 
 * @export
 * @interface BatchAddShipmentTrackingRecordResponse
 */
export interface BatchAddShipmentTrackingRecordResponse {
    /**
     * 
     * @type {Array<BatchAddShipmentTrackingRecordResponseInfo>}
     * @memberof BatchAddShipmentTrackingRecordResponse
     */
    successful: Array<BatchAddShipmentTrackingRecordResponseInfo>;
    /**
     * 
     * @type {Array<BatchAddShipmentTrackingRecordResponseInfo>}
     * @memberof BatchAddShipmentTrackingRecordResponse
     */
    fail: Array<BatchAddShipmentTrackingRecordResponseInfo>;
}

/**
 * 
 * @export
 * @interface BatchAddShipmentTrackingRecordResponseInfo
 */
export interface BatchAddShipmentTrackingRecordResponseInfo {
    /**
     * 
     * @type {string}
     * @memberof BatchAddShipmentTrackingRecordResponseInfo
     */
    orderId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchAddShipmentTrackingRecordResponseInfo
     */
    trackingNumbers: Array<string>;
}

/**
 * 
 * @export
 * @interface BatchAddStorePublicListingRequest
 */
export interface BatchAddStorePublicListingRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchAddStorePublicListingRequest
     */
    listingIds: Array<string>;
}

/**
 * 
 * @export
 * @interface BatchApproveWithdrawTransactionDto
 */
export interface BatchApproveWithdrawTransactionDto {
    /**
     * 
     * @type {string}
     * @memberof BatchApproveWithdrawTransactionDto
     */
    withdrawTransactionId: string;
    /**
     * 
     * @type {string}
     * @memberof BatchApproveWithdrawTransactionDto
     */
    note?: string;
}

/**
 * 
 * @export
 * @interface BatchApproveWithdrawTransactionErrorDto
 */
export interface BatchApproveWithdrawTransactionErrorDto {
    /**
     * 
     * @type {string}
     * @memberof BatchApproveWithdrawTransactionErrorDto
     */
    withdrawTransactionId: string;
    /**
     * 
     * @type {string}
     * @memberof BatchApproveWithdrawTransactionErrorDto
     */
    message: string;
}

/**
 * 
 * @export
 * @interface BatchApproveWithdrawTransactionResponse
 */
export interface BatchApproveWithdrawTransactionResponse {
    /**
     * 
     * @type {number}
     * @memberof BatchApproveWithdrawTransactionResponse
     */
    succeeded: number;
    /**
     * 
     * @type {number}
     * @memberof BatchApproveWithdrawTransactionResponse
     */
    failed: number;
    /**
     * 
     * @type {Array<BatchApproveWithdrawTransactionErrorDto>}
     * @memberof BatchApproveWithdrawTransactionResponse
     */
    errors: Array<BatchApproveWithdrawTransactionErrorDto>;
}

/**
 * 
 * @export
 * @interface BatchApproveWithdrawTransactionsDto
 */
export interface BatchApproveWithdrawTransactionsDto {
    /**
     * 
     * @type {Array<BatchApproveWithdrawTransactionDto>}
     * @memberof BatchApproveWithdrawTransactionsDto
     */
    withdrawTransactions: Array<BatchApproveWithdrawTransactionDto>;
}

/**
 * 
 * @export
 * @interface BatchAssignBadgeRequest
 */
export interface BatchAssignBadgeRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchAssignBadgeRequest
     */
    badgeIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchAssignBadgeRequest
     */
    userIds: Array<string>;
}

/**
 * 
 * @export
 * @interface BatchAssignBadgeResponse
 */
export interface BatchAssignBadgeResponse {
    /**
     * 
     * @type {Array<BatchAssignBadgeResponseInfo>}
     * @memberof BatchAssignBadgeResponse
     */
    successful: Array<BatchAssignBadgeResponseInfo>;
    /**
     * 
     * @type {Array<BatchAssignBadgeResponseInfo>}
     * @memberof BatchAssignBadgeResponse
     */
    failed: Array<BatchAssignBadgeResponseInfo>;
}

/**
 * 
 * @export
 * @interface BatchAssignBadgeResponseInfo
 */
export interface BatchAssignBadgeResponseInfo {
    /**
     * 
     * @type {string}
     * @memberof BatchAssignBadgeResponseInfo
     */
    badgeId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchAssignBadgeResponseInfo
     */
    userIds: Array<string>;
}

/**
 * 
 * @export
 * @interface BatchCategoryRowFeaturedStoreRequest
 */
export interface BatchCategoryRowFeaturedStoreRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchCategoryRowFeaturedStoreRequest
     */
    originalFeaturedStoreIds: Array<string>;
    /**
     * 
     * @type {Array<CategoryRowFeaturedStoreRequestDto>}
     * @memberof BatchCategoryRowFeaturedStoreRequest
     */
    latestFeaturedStores: Array<CategoryRowFeaturedStoreRequestDto>;
}

/**
 * 
 * @export
 * @interface BatchCreateThankYouMessageRequest
 */
export interface BatchCreateThankYouMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof BatchCreateThankYouMessageRequest
     */
    videoURL: string;
    /**
     * 
     * @type {string}
     * @memberof BatchCreateThankYouMessageRequest
     */
    emoji?: BatchCreateThankYouMessageRequestEmojiEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchCreateThankYouMessageRequest
     */
    orderIds: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum BatchCreateThankYouMessageRequestEmojiEnum {
    RollingEyesFace = 'rolling_eyes_face',
    Sweat = 'sweat',
    Blush = 'blush',
    Smile = 'smile',
    HeartEyes = 'heart_eyes'
}

/**
 * 
 * @export
 * @interface BatchDeletePackageTemplateRequest
 */
export interface BatchDeletePackageTemplateRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchDeletePackageTemplateRequest
     */
    packageTemplateIds: Array<string>;
}

/**
 * 
 * @export
 * @interface BatchDeletePackageTemplateResponse
 */
export interface BatchDeletePackageTemplateResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchDeletePackageTemplateResponse
     */
    successful: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchDeletePackageTemplateResponse
     */
    failed: Array<string>;
}

/**
 * 
 * @export
 * @interface BatchDeleteStorePublicListingRequest
 */
export interface BatchDeleteStorePublicListingRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchDeleteStorePublicListingRequest
     */
    listingIds: Array<string>;
}

/**
 * 
 * @export
 * @interface BatchFeaturedStoreRequest
 */
export interface BatchFeaturedStoreRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchFeaturedStoreRequest
     */
    originalFeaturedStoreIds: Array<string>;
    /**
     * 
     * @type {Array<FeaturedStoreRequestDto>}
     * @memberof BatchFeaturedStoreRequest
     */
    latestFeaturedStores: Array<FeaturedStoreRequestDto>;
}

/**
 * 
 * @export
 * @interface BatchGetShippingCostRequest
 */
export interface BatchGetShippingCostRequest {
    /**
     * 
     * @type {string}
     * @memberof BatchGetShippingCostRequest
     */
    packageTemplateId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchGetShippingCostRequest
     */
    orderIds: Array<string>;
}

/**
 * 
 * @export
 * @interface BatchGetShippingLabelResponse
 */
export interface BatchGetShippingLabelResponse {
    /**
     * an array of order ID
     * @type {Array<string>}
     * @memberof BatchGetShippingLabelResponse
     */
    success: Array<string>;
    /**
     * 
     * @type {Array<FailedOrder>}
     * @memberof BatchGetShippingLabelResponse
     */
    failed: Array<FailedOrder>;
}

/**
 * 
 * @export
 * @interface BatchPreviewRefundItem
 */
export interface BatchPreviewRefundItem {
    /**
     * 
     * @type {number}
     * @memberof BatchPreviewRefundItem
     */
    quantity?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchPreviewRefundItem
     */
    refundTypes: Array<BatchPreviewRefundItemRefundTypesEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof BatchPreviewRefundItem
     */
    shouldRestock?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BatchPreviewRefundItem
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof BatchPreviewRefundItem
     */
    orderId: string;
}

/**
* @export
* @enum {string}
*/
export enum BatchPreviewRefundItemRefundTypesEnum {
    All = 'all',
    ShippingFee = 'shippingFee',
    Listing = 'listing',
    CustomAmount = 'customAmount',
    Cancel = 'cancel',
    CancelListing = 'cancelListing'
}

/**
 * 
 * @export
 * @interface BatchPreviewShippingCostResponse
 */
export interface BatchPreviewShippingCostResponse {
    /**
     * 
     * @type {Array<PreviewShippingCostResponse>}
     * @memberof BatchPreviewShippingCostResponse
     */
    success: Array<PreviewShippingCostResponse>;
    /**
     * 
     * @type {Array<FailedOrder>}
     * @memberof BatchPreviewShippingCostResponse
     */
    failed: Array<FailedOrder>;
}

/**
 * 
 * @export
 * @interface BatchRefundOrderRequest
 */
export interface BatchRefundOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof BatchRefundOrderRequest
     */
    reason?: string;
    /**
     * only admin can use
     * @type {string}
     * @memberof BatchRefundOrderRequest
     */
    processingFeePayer?: BatchRefundOrderRequestProcessingFeePayerEnum;
    /**
     * 
     * @type {Array<BatchPreviewRefundItem>}
     * @memberof BatchRefundOrderRequest
     */
    refundItems: Array<BatchPreviewRefundItem>;
    /**
     * choose who to email
     * @type {string}
     * @memberof BatchRefundOrderRequest
     */
    whoToMail?: BatchRefundOrderRequestWhoToMailEnum;
}

/**
* @export
* @enum {string}
*/
export enum BatchRefundOrderRequestProcessingFeePayerEnum {
    Seller = 'SELLER',
    Popshop = 'POPSHOP'
}/**
* @export
* @enum {string}
*/
export enum BatchRefundOrderRequestWhoToMailEnum {
    Both = 'both',
    OnlySeller = 'only_seller',
    OnlyBuyer = 'only_buyer',
    Neither = 'neither'
}

/**
 * 
 * @export
 * @interface BatchRemoveListingDiscountPriceRequestV2
 */
export interface BatchRemoveListingDiscountPriceRequestV2 {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchRemoveListingDiscountPriceRequestV2
     */
    listingIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof BatchRemoveListingDiscountPriceRequestV2
     */
    skipIfDiscountPriceExists?: boolean;
}

/**
 * 
 * @export
 * @interface BatchRemoveLiveStreamListingDiscountPriceRequest
 */
export interface BatchRemoveLiveStreamListingDiscountPriceRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchRemoveLiveStreamListingDiscountPriceRequest
     */
    listingIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof BatchRemoveLiveStreamListingDiscountPriceRequest
     */
    skipIfDiscountPriceExists?: boolean;
}

/**
 * 
 * @export
 * @interface BatchSaveBlockedSellersRequest
 */
export interface BatchSaveBlockedSellersRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchSaveBlockedSellersRequest
     */
    blockedSellerIds: Array<string>;
}

/**
 * 
 * @export
 * @interface BatchSaveCategoryRowFeaturedStoreResponse
 */
export interface BatchSaveCategoryRowFeaturedStoreResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchSaveCategoryRowFeaturedStoreResponse
     */
    notExistsStoreIds: Array<string>;
}

/**
 * 
 * @export
 * @interface BatchSaveFeaturedStoreResponse
 */
export interface BatchSaveFeaturedStoreResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchSaveFeaturedStoreResponse
     */
    notExistsStoreIds: Array<string>;
}

/**
 * 
 * @export
 * @interface BatchSaveShowEventFeaturedStoreResponse
 */
export interface BatchSaveShowEventFeaturedStoreResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchSaveShowEventFeaturedStoreResponse
     */
    notExistsStoreIds: Array<string>;
}

/**
 * 
 * @export
 * @interface BatchShowEventFeaturedStoreRequest
 */
export interface BatchShowEventFeaturedStoreRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchShowEventFeaturedStoreRequest
     */
    originalFeaturedStoreIds: Array<string>;
    /**
     * 
     * @type {Array<ShowEventFeaturedStoreRequestDto>}
     * @memberof BatchShowEventFeaturedStoreRequest
     */
    latestFeaturedStores: Array<ShowEventFeaturedStoreRequestDto>;
}

/**
 * 
 * @export
 * @interface BatchSortCategorizedResourceRequest
 */
export interface BatchSortCategorizedResourceRequest {
    /**
     * 
     * @type {BatchSortStoreCategorizedResourceRequest | BatchSortUserCategorizedResourceRequest}
     * @memberof BatchSortCategorizedResourceRequest
     */
    data: BatchSortStoreCategorizedResourceRequest | BatchSortUserCategorizedResourceRequest;
}

/**
 * 
 * @export
 * @interface BatchSortCategoryDiscoveryRowsRequest
 */
export interface BatchSortCategoryDiscoveryRowsRequest {
    /**
     * 
     * @type {Array<SortCategoryDiscoveryRows>}
     * @memberof BatchSortCategoryDiscoveryRowsRequest
     */
    categoryDiscoveryRows: Array<SortCategoryDiscoveryRows>;
}

/**
 * 
 * @export
 * @interface BatchSortFeaturedShows
 */
export interface BatchSortFeaturedShows {
    /**
     * 
     * @type {Array<SortFeaturedShow>}
     * @memberof BatchSortFeaturedShows
     */
    featuredShows: Array<SortFeaturedShow>;
}

/**
 * 
 * @export
 * @interface BatchSortReferralGifts
 */
export interface BatchSortReferralGifts {
    /**
     * 
     * @type {Array<SortReferralGift>}
     * @memberof BatchSortReferralGifts
     */
    referralGifts: Array<SortReferralGift>;
}

/**
 * 
 * @export
 * @interface BatchSortShowEventFeaturedShows
 */
export interface BatchSortShowEventFeaturedShows {
    /**
     * 
     * @type {Array<SortShowEventFeaturedShow>}
     * @memberof BatchSortShowEventFeaturedShows
     */
    featuredShows: Array<SortShowEventFeaturedShow>;
}

/**
 * 
 * @export
 * @interface BatchSortShowEventsRequest
 */
export interface BatchSortShowEventsRequest {
    /**
     * 
     * @type {Array<SortShowEventItem>}
     * @memberof BatchSortShowEventsRequest
     */
    showEvents: Array<SortShowEventItem>;
}

/**
 * 
 * @export
 * @interface BatchSortShowTicketsRequest
 */
export interface BatchSortShowTicketsRequest {
    /**
     * 
     * @type {Array<SortShowTickets>}
     * @memberof BatchSortShowTicketsRequest
     */
    showTickets: Array<SortShowTickets>;
}

/**
 * 
 * @export
 * @interface BatchSortStoreCategorizedResourceRequest
 */
export interface BatchSortStoreCategorizedResourceRequest {
    /**
     * 
     * @type {string}
     * @memberof BatchSortStoreCategorizedResourceRequest
     */
    resourceType: BatchSortStoreCategorizedResourceRequestResourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BatchSortStoreCategorizedResourceRequest
     */
    storeId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchSortStoreCategorizedResourceRequest
     */
    resourceIds: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum BatchSortStoreCategorizedResourceRequestResourceTypeEnum {
    Store = 'STORE'
}

/**
 * 
 * @export
 * @interface BatchSortStorePublicListingRequest
 */
export interface BatchSortStorePublicListingRequest {
    /**
     * 
     * @type {Array<SortedPublicListingsDto>}
     * @memberof BatchSortStorePublicListingRequest
     */
    sortedListings: Array<SortedPublicListingsDto>;
}

/**
 * 
 * @export
 * @interface BatchSortUserCategorizedResourceRequest
 */
export interface BatchSortUserCategorizedResourceRequest {
    /**
     * 
     * @type {string}
     * @memberof BatchSortUserCategorizedResourceRequest
     */
    resourceType: BatchSortUserCategorizedResourceRequestResourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BatchSortUserCategorizedResourceRequest
     */
    userId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchSortUserCategorizedResourceRequest
     */
    resourceIds: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum BatchSortUserCategorizedResourceRequestResourceTypeEnum {
    User = 'USER'
}

/**
 * 
 * @export
 * @interface BatchUpdateListingDiscountPriceRequest
 */
export interface BatchUpdateListingDiscountPriceRequest {
    /**
     * 
     * @type {number}
     * @memberof BatchUpdateListingDiscountPriceRequest
     */
    discountPercent: number;
}

/**
 * 
 * @export
 * @interface BatchUpdateListingDiscountPriceRequestV2
 */
export interface BatchUpdateListingDiscountPriceRequestV2 {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchUpdateListingDiscountPriceRequestV2
     */
    listingIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof BatchUpdateListingDiscountPriceRequestV2
     */
    skipIfDiscountPriceExists?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BatchUpdateListingDiscountPriceRequestV2
     */
    discountPercent: number;
}

/**
 * 
 * @export
 * @interface BatchUpdateLiveStreamListingDiscountPriceRequest
 */
export interface BatchUpdateLiveStreamListingDiscountPriceRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchUpdateLiveStreamListingDiscountPriceRequest
     */
    listingIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof BatchUpdateLiveStreamListingDiscountPriceRequest
     */
    skipIfDiscountPriceExists?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BatchUpdateLiveStreamListingDiscountPriceRequest
     */
    discountPercent: number;
}

/**
 * 
 * @export
 * @interface BatchUpdatePackageTemplateRequest
 */
export interface BatchUpdatePackageTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof BatchUpdatePackageTemplateRequest
     */
    packageTemplateId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BatchUpdatePackageTemplateRequest
     */
    orderIds: Array<string>;
}

/**
 * 
 * @export
 * @interface BatchUpdatePackageTemplateResponse
 */
export interface BatchUpdatePackageTemplateResponse {
    /**
     * an array of order ID
     * @type {Array<string>}
     * @memberof BatchUpdatePackageTemplateResponse
     */
    success: Array<string>;
    /**
     * 
     * @type {Array<FailedOrder>}
     * @memberof BatchUpdatePackageTemplateResponse
     */
    failed: Array<FailedOrder>;
}

/**
 * 
 * @export
 * @interface BidRequest
 */
export interface BidRequest {
    /**
     * 
     * @type {number}
     * @memberof BidRequest
     */
    bidPrice: number;
}

/**
 * 
 * @export
 * @interface BillingAddressDto
 */
export interface BillingAddressDto {
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    postalCode: string;
}

/**
 * 
 * @export
 * @interface BillingAddressItem
 */
export interface BillingAddressItem {
    /**
     * For shipping addresses, id will be undefined while for billing addresses, id will be defined
     * @type {string}
     * @memberof BillingAddressItem
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    postalCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof BillingAddressItem
     */
    isDefault: boolean;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    compareHash?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressItem
     */
    email?: string;
}

/**
 * 
 * @export
 * @interface BillingCountryCodeItem
 */
export interface BillingCountryCodeItem {
    /**
     * 
     * @type {string}
     * @memberof BillingCountryCodeItem
     */
    code: string;
}

/**
 * 
 * @export
 * @interface BlockAccessSource
 */
export interface BlockAccessSource {
    /**
     * 
     * @type {string}
     * @memberof BlockAccessSource
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof BlockAccessSource
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof BlockAccessSource
     */
    type: BlockAccessSourceTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum BlockAccessSourceTypeEnum {
    Ip = 'ip',
    Device = 'device'
}

/**
 * 
 * @export
 * @interface BlockAccessSourceResponse
 */
export interface BlockAccessSourceResponse {
    /**
     * 
     * @type {object}
     * @memberof BlockAccessSourceResponse
     */
    blockedId: object;
}

/**
 * 
 * @export
 * @interface BlockUserCommentRequest
 */
export interface BlockUserCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof BlockUserCommentRequest
     */
    reason: BlockUserCommentRequestReasonEnum;
}

/**
* @export
* @enum {string}
*/
export enum BlockUserCommentRequestReasonEnum {
    Spam = 'spam',
    Inappropriate = 'inappropriate',
    Aggressive = 'aggressive'
}

/**
 * 
 * @export
 * @interface BlockUserRequest
 */
export interface BlockUserRequest {
    /**
     * 
     * @type {string}
     * @memberof BlockUserRequest
     */
    userId: string;
}

/**
 * 
 * @export
 * @interface BlockedAccessSourceItem
 */
export interface BlockedAccessSourceItem {
    /**
     * 
     * @type {string}
     * @memberof BlockedAccessSourceItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BlockedAccessSourceItem
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof BlockedAccessSourceItem
     */
    type: BlockedAccessSourceItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BlockedAccessSourceItem
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof BlockedAccessSourceItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof BlockedAccessSourceItem
     */
    blockedAt: string;
    /**
     * 
     * @type {Metadata}
     * @memberof BlockedAccessSourceItem
     */
    metadata: Metadata;
}

/**
* @export
* @enum {string}
*/
export enum BlockedAccessSourceItemTypeEnum {
    Ip = 'ip',
    Device = 'device'
}

/**
 * 
 * @export
 * @interface BraintreeDisbursementDetailsItem
 */
export interface BraintreeDisbursementDetailsItem {
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisbursementDetailsItem
     */
    disbursementDate: string;
    /**
     * 
     * @type {boolean}
     * @memberof BraintreeDisbursementDetailsItem
     */
    fundsHeld: boolean;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisbursementDetailsItem
     */
    settlementAmount: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisbursementDetailsItem
     */
    settlementCurrencyExchangeRate: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisbursementDetailsItem
     */
    settlementCurrencyIsoCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof BraintreeDisbursementDetailsItem
     */
    success: boolean;
}

/**
 * 
 * @export
 * @interface BraintreeDisputeItem
 */
export interface BraintreeDisputeItem {
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    amountDisputed: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    amountWon: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    caseNumber: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    currencyIsoCode: string;
    /**
     * 
     * @type {EvidenceItem}
     * @memberof BraintreeDisputeItem
     */
    evidence: EvidenceItem;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    kind: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    merchantAccountId: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    originalDisputeId: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    processorComments: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    reasonCode: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    reasonDescription: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    receivedDate: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    referenceNumber: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    replyByDate: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    status: BraintreeDisputeItemStatusEnum;
    /**
     * 
     * @type {Array<DisputeStatusHistoryItem>}
     * @memberof BraintreeDisputeItem
     */
    statusHistory: Array<DisputeStatusHistoryItem>;
    /**
     * 
     * @type {string}
     * @memberof BraintreeDisputeItem
     */
    updatedAt: string;
}

/**
* @export
* @enum {string}
*/
export enum BraintreeDisputeItemStatusEnum {
    Accepted = 'Accepted',
    Disputed = 'Disputed',
    Expired = 'Expired',
    Lost = 'Lost',
    Won = 'Won',
    Open = 'Open'
}

/**
 * 
 * @export
 * @interface BraintreeTokenResponse
 */
export interface BraintreeTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof BraintreeTokenResponse
     */
    clientToken: string;
}

/**
 * 
 * @export
 * @interface BraintreeTransactionItem
 */
export interface BraintreeTransactionItem {
    /**
     * 
     * @type {string}
     * @memberof BraintreeTransactionItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeTransactionItem
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeTransactionItem
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeTransactionItem
     */
    amount: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BraintreeTransactionItem
     */
    refundIds: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof BraintreeTransactionItem
     */
    refundedTransactionId?: object;
    /**
     * 
     * @type {string}
     * @memberof BraintreeTransactionItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof BraintreeTransactionItem
     */
    updatedAt: string;
    /**
     * 
     * @type {Array<BraintreeDisputeItem>}
     * @memberof BraintreeTransactionItem
     */
    disputes?: Array<BraintreeDisputeItem>;
    /**
     * 
     * @type {BraintreeDisbursementDetailsItem}
     * @memberof BraintreeTransactionItem
     */
    disbursementDetails?: BraintreeDisbursementDetailsItem;
}

/**
 * 
 * @export
 * @interface BuyerStats
 */
export interface BuyerStats {
    /**
     * 
     * @type {number}
     * @memberof BuyerStats
     */
    orders: number;
    /**
     * 
     * @type {number}
     * @memberof BuyerStats
     */
    badges: number;
    /**
     * 
     * @type {number}
     * @memberof BuyerStats
     */
    viewedShows: number;
}

/**
 * 
 * @export
 * @interface CalculateSaasSubscriptionActualChargeRequest
 */
export interface CalculateSaasSubscriptionActualChargeRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CalculateSaasSubscriptionActualChargeRequest
     */
    priceIds: Array<string>;
}

/**
 * 
 * @export
 * @interface CalculateSaasSubscriptionActualChargeResponse
 */
export interface CalculateSaasSubscriptionActualChargeResponse {
    /**
     * 
     * @type {number}
     * @memberof CalculateSaasSubscriptionActualChargeResponse
     */
    totalAmount: number;
    /**
     * 
     * @type {number}
     * @memberof CalculateSaasSubscriptionActualChargeResponse
     */
    taxAmount: number;
}

/**
 * 
 * @export
 * @interface CampaignActionsItem
 */
export interface CampaignActionsItem {
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignActionsItem
     */
    usersToFollow?: Array<string>;
}

/**
 * 
 * @export
 * @interface CampaignItem
 */
export interface CampaignItem {
    /**
     * 
     * @type {string}
     * @memberof CampaignItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignItem
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignItem
     */
    isWebOnly?: boolean;
    /**
     * 
     * @type {CampaignActionsItem}
     * @memberof CampaignItem
     */
    actions?: CampaignActionsItem;
    /**
     * 
     * @type {string}
     * @memberof CampaignItem
     */
    showEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignItem
     */
    profileId?: string;
    /**
     * 
     * @type {ContentFDLSocialItem}
     * @memberof CampaignItem
     */
    social?: ContentFDLSocialItem;
    /**
     * 
     * @type {string}
     * @memberof CampaignItem
     */
    shortLinkFDL: string;
    /**
     * 
     * @type {object}
     * @memberof CampaignItem
     */
    contentFDL: object;
    /**
     * 
     * @type {object}
     * @memberof CampaignItem
     */
    queryParams?: object;
    /**
     * 
     * @type {string}
     * @memberof CampaignItem
     */
    targetUserId?: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof CampaignItem
     */
    targetUserProfileSnapshot?: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof CampaignItem
     */
    targetEventId?: string;
    /**
     * 
     * @type {ShowEventItem}
     * @memberof CampaignItem
     */
    targetEventSnapshot?: ShowEventItem;
    /**
     * 
     * @type {string}
     * @memberof CampaignItem
     */
    createdAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignItem
     */
    isActive: boolean;
    /**
     * 
     * @type {CreateShareTargetRequest}
     * @memberof CampaignItem
     */
    shareTarget: CreateShareTargetRequest;
    /**
     * 
     * @type {object}
     * @memberof CampaignItem
     */
    updatedAt: object;
}

/**
 * 
 * @export
 * @interface CampaignPageRows
 */
export interface CampaignPageRows {
    /**
     * 
     * @type {Array<CampaignItem>}
     * @memberof CampaignPageRows
     */
    rows: Array<CampaignItem>;
}

/**
 * 
 * @export
 * @interface CampaignsSearchResponse
 */
export interface CampaignsSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof CampaignsSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof CampaignsSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {CampaignPageRows}
     * @memberof CampaignsSearchResponse
     */
    data: CampaignPageRows;
}

/**
 * 
 * @export
 * @interface CancelOrderRequest
 */
export interface CancelOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof CancelOrderRequest
     */
    reason?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CancelOrderRequest
     */
    shouldRestock?: boolean;
    /**
     * only admin can use
     * @type {string}
     * @memberof CancelOrderRequest
     */
    processingFeePayer?: CancelOrderRequestProcessingFeePayerEnum;
}

/**
* @export
* @enum {string}
*/
export enum CancelOrderRequestProcessingFeePayerEnum {
    Seller = 'SELLER',
    Popshop = 'POPSHOP'
}

/**
 * 
 * @export
 * @interface CardThreeDSecureUsage
 */
export interface CardThreeDSecureUsage {
    /**
     * 
     * @type {boolean}
     * @memberof CardThreeDSecureUsage
     */
    supported: boolean;
}

/**
 * 
 * @export
 * @interface CardWallet
 */
export interface CardWallet {
    /**
     * 
     * @type {string}
     * @memberof CardWallet
     */
    type: CardWalletTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum CardWalletTypeEnum {
    AmexExpressCheckout = 'amex_express_checkout',
    ApplePay = 'apple_pay',
    GooglePay = 'google_pay',
    Masterpass = 'masterpass',
    SamsungPay = 'samsung_pay',
    VisaCheckout = 'visa_checkout'
}

/**
 * 
 * @export
 * @interface CategoriesSearchResponse
 */
export interface CategoriesSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof CategoriesSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof CategoriesSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {CategoryPageRows}
     * @memberof CategoriesSearchResponse
     */
    data: CategoryPageRows;
}

/**
 * 
 * @export
 * @interface CategorizedResourceItem
 */
export interface CategorizedResourceItem {
    /**
     * 
     * @type {string}
     * @memberof CategorizedResourceItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CategorizedResourceItem
     */
    categoryId: string;
    /**
     * 
     * @type {CategoryItem}
     * @memberof CategorizedResourceItem
     */
    category: CategoryItem;
    /**
     * 
     * @type {number}
     * @memberof CategorizedResourceItem
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof CategorizedResourceItem
     */
    resourceType: CategorizedResourceItemResourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CategorizedResourceItem
     */
    storeId?: string;
    /**
     * 
     * @type {StoreFrontItem}
     * @memberof CategorizedResourceItem
     */
    store?: StoreFrontItem;
    /**
     * 
     * @type {string}
     * @memberof CategorizedResourceItem
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {UpcomingShowItem}
     * @memberof CategorizedResourceItem
     */
    upcomingShow?: UpcomingShowItem;
    /**
     * 
     * @type {string}
     * @memberof CategorizedResourceItem
     */
    liveStreamId?: string;
    /**
     * 
     * @type {LiveStreamItem}
     * @memberof CategorizedResourceItem
     */
    liveStream?: LiveStreamItem;
    /**
     * 
     * @type {string}
     * @memberof CategorizedResourceItem
     */
    userId?: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof CategorizedResourceItem
     */
    user?: ProfileItem;
    /**
     * 
     * @type {number}
     * @memberof CategorizedResourceItem
     */
    sequenceNo?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CategorizedResourceItem
     */
    isPrimary?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CategorizedResourceItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof CategorizedResourceItem
     */
    updatedAt: string;
}

/**
* @export
* @enum {string}
*/
export enum CategorizedResourceItemResourceTypeEnum {
    Store = 'STORE',
    UpcomingShow = 'UPCOMING_SHOW',
    LiveStream = 'LIVE_STREAM',
    User = 'USER'
}

/**
 * 
 * @export
 * @interface CategorizedResourcePageRows
 */
export interface CategorizedResourcePageRows {
    /**
     * 
     * @type {Array<CategorizedResourceItem>}
     * @memberof CategorizedResourcePageRows
     */
    rows: Array<CategorizedResourceItem>;
}

/**
 * 
 * @export
 * @interface CategorizedResourcesSearchResponse
 */
export interface CategorizedResourcesSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof CategorizedResourcesSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof CategorizedResourcesSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {CategorizedResourcePageRows}
     * @memberof CategorizedResourcesSearchResponse
     */
    data: CategorizedResourcePageRows;
}

/**
 * 
 * @export
 * @interface CategoryBatchImportResponse
 */
export interface CategoryBatchImportResponse {
    /**
     * 
     * @type {number}
     * @memberof CategoryBatchImportResponse
     */
    success: number;
    /**
     * 
     * @type {number}
     * @memberof CategoryBatchImportResponse
     */
    failed: number;
    /**
     * 
     * @type {Array<CategoryImportError>}
     * @memberof CategoryBatchImportResponse
     */
    errors: Array<CategoryImportError>;
}

/**
 * 
 * @export
 * @interface CategoryDiscoveryRowSellerIdsResponse
 */
export interface CategoryDiscoveryRowSellerIdsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof CategoryDiscoveryRowSellerIdsResponse
     */
    sellerIds: Array<string>;
}

/**
 * 
 * @export
 * @interface CategoryImportError
 */
export interface CategoryImportError {
    /**
     * 
     * @type {string}
     * @memberof CategoryImportError
     */
    storeId: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryImportError
     */
    message: string;
}

/**
 * 
 * @export
 * @interface CategoryItem
 */
export interface CategoryItem {
    /**
     * 
     * @type {string}
     * @memberof CategoryItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryItem
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryItem
     */
    parentId?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryItem
     */
    parentName?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryItem
     */
    rootCategory: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryItem
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof CategoryItem
     */
    sort: number;
    /**
     * 
     * @type {boolean}
     * @memberof CategoryItem
     */
    enabled: boolean;
    /**
     * 
     * @type {Metadata}
     * @memberof CategoryItem
     */
    metadata: Metadata;
    /**
     * 
     * @type {string}
     * @memberof CategoryItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryItem
     */
    updatedAt: string;
}

/**
 * 
 * @export
 * @interface CategoryPageRows
 */
export interface CategoryPageRows {
    /**
     * 
     * @type {Array<CategoryItem>}
     * @memberof CategoryPageRows
     */
    rows: Array<CategoryItem>;
}

/**
 * 
 * @export
 * @interface CategoryRowDetailCountItem
 */
export interface CategoryRowDetailCountItem {
    /**
     * 
     * @type {string}
     * @memberof CategoryRowDetailCountItem
     */
    categoryRowId: string;
    /**
     * 
     * @type {number}
     * @memberof CategoryRowDetailCountItem
     */
    liveStreamsCount: number;
    /**
     * 
     * @type {number}
     * @memberof CategoryRowDetailCountItem
     */
    upcomingShowsCount: number;
    /**
     * 
     * @type {number}
     * @memberof CategoryRowDetailCountItem
     */
    sellersCount: number;
}

/**
 * 
 * @export
 * @interface CategoryRowFeaturedStoreRequestDto
 */
export interface CategoryRowFeaturedStoreRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CategoryRowFeaturedStoreRequestDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryRowFeaturedStoreRequestDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryRowFeaturedStoreRequestDto
     */
    sortedAt: string;
}

/**
 * 
 * @export
 * @interface CategoryRowItem
 */
export interface CategoryRowItem {
    /**
     * 
     * @type {string}
     * @memberof CategoryRowItem
     */
    categoryRowId: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryRowItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryRowItem
     */
    urlCode?: string;
}

/**
 * 
 * @export
 * @interface CategoryRowLiveStreamsResponse
 */
export interface CategoryRowLiveStreamsResponse {
    /**
     * 
     * @type {Array<DiscoveryShowLiveStreamItem>}
     * @memberof CategoryRowLiveStreamsResponse
     */
    liveStreams: Array<DiscoveryShowLiveStreamItem>;
}

/**
 * 
 * @export
 * @interface CategoryRowSellerItem
 */
export interface CategoryRowSellerItem {
    /**
     * 
     * @type {string}
     * @memberof CategoryRowSellerItem
     */
    type: CategoryRowSellerItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CategoryRowSellerItem
     */
    sellerId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof CategoryRowSellerItem
     */
    profile: ProfileItem;
    /**
     * 
     * @type {StoreFrontItemWithBaseProfile}
     * @memberof CategoryRowSellerItem
     */
    store: StoreFrontItemWithBaseProfile;
}

/**
* @export
* @enum {string}
*/
export enum CategoryRowSellerItemTypeEnum {
    Seller = 'seller'
}

/**
 * 
 * @export
 * @interface CategoryRowSellersResponse
 */
export interface CategoryRowSellersResponse {
    /**
     * 
     * @type {Array<CategoryRowSellerItem>}
     * @memberof CategoryRowSellersResponse
     */
    sellers: Array<CategoryRowSellerItem>;
}

/**
 * 
 * @export
 * @interface CategoryRowShowsResponse
 */
export interface CategoryRowShowsResponse {
    /**
     * 
     * @type {Array<DiscoveryShowLiveStreamItem | DiscoveryShowUpcomingShowItem>}
     * @memberof CategoryRowShowsResponse
     */
    data: Array<DiscoveryShowLiveStreamItem | DiscoveryShowUpcomingShowItem>;
}

/**
 * 
 * @export
 * @interface CategoryRowUpcomingShowsResponse
 */
export interface CategoryRowUpcomingShowsResponse {
    /**
     * 
     * @type {Array<DiscoveryShowUpcomingShowItem>}
     * @memberof CategoryRowUpcomingShowsResponse
     */
    upcomingShows: Array<DiscoveryShowUpcomingShowItem>;
}

/**
 * 
 * @export
 * @interface CategoryRowsDetailCountResponse
 */
export interface CategoryRowsDetailCountResponse {
    /**
     * 
     * @type {Array<CategoryRowDetailCountItem>}
     * @memberof CategoryRowsDetailCountResponse
     */
    data: Array<CategoryRowDetailCountItem>;
}

/**
 * 
 * @export
 * @interface CategoryRowsResponse
 */
export interface CategoryRowsResponse {
    /**
     * 
     * @type {Array<CategoryRowItem>}
     * @memberof CategoryRowsResponse
     */
    data: Array<CategoryRowItem>;
}

/**
 * 
 * @export
 * @interface ChatMentionDto
 */
export interface ChatMentionDto {
    /**
     * 
     * @type {number}
     * @memberof ChatMentionDto
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMentionDto
     */
    length: number;
    /**
     * 
     * @type {string}
     * @memberof ChatMentionDto
     */
    userId: string;
}

/**
 * 
 * @export
 * @interface ChatMentionProfileItem
 */
export interface ChatMentionProfileItem {
    /**
     * 
     * @type {string}
     * @memberof ChatMentionProfileItem
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMentionProfileItem
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMentionProfileItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMentionProfileItem
     */
    lastNameInitial: string;
}

/**
 * 
 * @export
 * @interface ChatMessageData
 */
export interface ChatMessageData {
    /**
     * 
     * @type {number}
     * @memberof ChatMessageData
     */
    messageId: number;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    clientId: string;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageData
     */
    messageType: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageData
     */
    chatSessionId: number;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    sessionId: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    fromUserId: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    fromAvatar: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    fromNickname: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    toUserId: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    toAvatar: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    toNickname: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    ext: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageData
     */
    quoteMsg: string;
    /**
     * 
     * @type {Date}
     * @memberof ChatMessageData
     */
    createdAt: Date;
}

/**
 * 
 * @export
 * @interface ChatMessageDto
 */
export interface ChatMessageDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    chatSessionId: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    fromUserId: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    toUserId: string;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageDto
     */
    messageType: ChatMessageDtoMessageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    ext: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    pictureUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    quoteMsg: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    updatedAt: string;
}

/**
* @export
* @enum {string}
*/
export enum ChatMessageDtoMessageTypeEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5,
    NUMBER_6 = 6,
    NUMBER_7 = 7
}

/**
 * 
 * @export
 * @interface CheckDropshipEligibilityResponse
 */
export interface CheckDropshipEligibilityResponse {
    /**
     * status of eligibility: undefined, approved, rejected
     * @type {string}
     * @memberof CheckDropshipEligibilityResponse
     */
    status?: string;
}

/**
 * 
 * @export
 * @interface CheckFeedUpvoteStatusResponse
 */
export interface CheckFeedUpvoteStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CheckFeedUpvoteStatusResponse
     */
    isUpvote: boolean;
}

/**
 * 
 * @export
 * @interface CheckFreeShippingResponse
 */
export interface CheckFreeShippingResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CheckFreeShippingResponse
     */
    freeShipping: boolean;
}

/**
 * 
 * @export
 * @interface CheckPayoutMethodUpdateStatusResponse
 */
export interface CheckPayoutMethodUpdateStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CheckPayoutMethodUpdateStatusResponse
     */
    canWithdraw: boolean;
    /**
     * it means status is approved or reject.
     * @type {boolean}
     * @memberof CheckPayoutMethodUpdateStatusResponse
     */
    hasCompleteApply: boolean;
    /**
     * it means status is pending. can not withdraw.
     * @type {boolean}
     * @memberof CheckPayoutMethodUpdateStatusResponse
     */
    hasPendingApply: boolean;
    /**
     * it means whether the last request is within 24 hours. if hasCompleteApply && isInLimitHours && !firstCreate, can not withdraw 
     * @type {boolean}
     * @memberof CheckPayoutMethodUpdateStatusResponse
     */
    isInLimitHours?: boolean;
    /**
     * no status means seller never submits update request
     * @type {string}
     * @memberof CheckPayoutMethodUpdateStatusResponse
     */
    status?: CheckPayoutMethodUpdateStatusResponseStatusEnum;
    /**
     * first create payout method can be withdraw
     * @type {boolean}
     * @memberof CheckPayoutMethodUpdateStatusResponse
     */
    firstCreate?: boolean;
    /**
     * The last four digits of latest update bank account number when status is pending
     * @type {string}
     * @memberof CheckPayoutMethodUpdateStatusResponse
     */
    latestAccountNumber?: string;
}

/**
* @export
* @enum {string}
*/
export enum CheckPayoutMethodUpdateStatusResponseStatusEnum {
    Approved = 'approved',
    Pending = 'pending',
    Rejected = 'rejected',
    Canceled = 'canceled'
}

/**
 * 
 * @export
 * @interface CheckReviewMessageUpvoteStatusResponse
 */
export interface CheckReviewMessageUpvoteStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CheckReviewMessageUpvoteStatusResponse
     */
    isUpvote: boolean;
}

/**
 * 
 * @export
 * @interface ChooseServiceLevelRequest
 */
export interface ChooseServiceLevelRequest {
    /**
     * 
     * @type {string}
     * @memberof ChooseServiceLevelRequest
     */
    shippingServiceLevel: ChooseServiceLevelRequestShippingServiceLevelEnum;
}

/**
* @export
* @enum {string}
*/
export enum ChooseServiceLevelRequestShippingServiceLevelEnum {
    CheapestAvailable = 'CHEAPEST_AVAILABLE',
    FastestAvailable = 'FASTEST_AVAILABLE',
    UspsParcelSelect = 'USPS_PARCEL_SELECT',
    UspsFirstClass = 'USPS_FIRST_CLASS',
    UspsPriority = 'USPS_PRIORITY',
    UspsPriorityExpress = 'USPS_PRIORITY_EXPRESS'
}

/**
 * 
 * @export
 * @interface CloseSendItemRequest
 */
export interface CloseSendItemRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CloseSendItemRequest
     */
    noNeedNotification?: boolean;
}

/**
 * 
 * @export
 * @interface CommentChatAuthorizationItem
 */
export interface CommentChatAuthorizationItem {
    /**
     * 
     * @type {string}
     * @memberof CommentChatAuthorizationItem
     */
    lastAuthorizedAt: string;
    /**
     * 
     * @type {FacebookAuthResponseItem}
     * @memberof CommentChatAuthorizationItem
     */
    authResponse: FacebookAuthResponseItem;
}

/**
 * 
 * @export
 * @interface CommentChatConnectionItem
 */
export interface CommentChatConnectionItem {
    /**
     * 
     * @type {string}
     * @memberof CommentChatConnectionItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CommentChatConnectionItem
     */
    extId: string;
    /**
     * 
     * @type {string}
     * @memberof CommentChatConnectionItem
     */
    platform: CommentChatConnectionItemPlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof CommentChatConnectionItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CommentChatConnectionItem
     */
    accessToken: string;
    /**
     * 
     * @type {string}
     * @memberof CommentChatConnectionItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof CommentChatConnectionItem
     */
    updatedAt: string;
}

/**
* @export
* @enum {string}
*/
export enum CommentChatConnectionItemPlatformEnum {
    Fb = 'fb',
    Ig = 'ig'
}

/**
 * 
 * @export
 * @interface CommentChatItem
 */
export interface CommentChatItem {
    /**
     * 
     * @type {string}
     * @memberof CommentChatItem
     */
    connectionStatus?: CommentChatItemConnectionStatusEnum;
    /**
     * 
     * @type {CommentChatAuthorizationItem}
     * @memberof CommentChatItem
     */
    authorization?: CommentChatAuthorizationItem;
    /**
     * 
     * @type {Array<CommentChatConnectionItem>}
     * @memberof CommentChatItem
     */
    connections?: Array<CommentChatConnectionItem>;
    /**
     * 
     * @type {boolean}
     * @memberof CommentChatItem
     */
    onboardingFinished?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommentChatItem
     */
    onboardingFinishedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommentChatItem
     */
    waitingForAppSetup?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommentChatItem
     */
    appSetupFinished?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum CommentChatItemConnectionStatusEnum {
    Connecting = 'connecting',
    Authorized = 'authorized',
    Success = 'success',
    Error = 'error'
}

/**
 * 
 * @export
 * @interface CommentChatSource
 */
export interface CommentChatSource {
    /**
     * 
     * @type {string}
     * @memberof CommentChatSource
     */
    type: CommentChatSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CommentChatSource
     */
    storeId: string;
    /**
     * 
     * @type {string}
     * @memberof CommentChatSource
     */
    postLinkId: string;
}

/**
* @export
* @enum {string}
*/
export enum CommentChatSourceTypeEnum {
    CommentChat = 'COMMENT_CHAT'
}

/**
 * 
 * @export
 * @interface CommentItem
 */
export interface CommentItem {
    /**
     * 
     * @type {string}
     * @memberof CommentItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CommentItem
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof CommentItem
     */
    type: CommentItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CommentItem
     */
    createdAt: string;
}

/**
* @export
* @enum {string}
*/
export enum CommentItemTypeEnum {
    Comment = 'comment',
    UserEnter = 'userEnter',
    UserFollow = 'userFollow',
    Purchase = 'purchase',
    Share = 'share',
    Gifting = 'gifting',
    Wave = 'wave',
    WavedToUserEnter = 'wavedToUserEnter'
}

/**
 * 
 * @export
 * @interface CommentSoldOrderItem
 */
export interface CommentSoldOrderItem {
    /**
     * 
     * @type {string}
     * @memberof CommentSoldOrderItem
     */
    shopId?: string;
    /**
     * 
     * @type {number}
     * @memberof CommentSoldOrderItem
     */
    orderId?: number;
    /**
     * 
     * @type {string}
     * @memberof CommentSoldOrderItem
     */
    syncAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommentSoldOrderItem
     */
    success?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommentSoldOrderItem
     */
    subtotalAdjusted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommentSoldOrderItem
     */
    error?: string;
}

/**
 * 
 * @export
 * @interface CommentUpvoteItem
 */
export interface CommentUpvoteItem {
    /**
     * 
     * @type {string}
     * @memberof CommentUpvoteItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CommentUpvoteItem
     */
    commentId: string;
    /**
     * 
     * @type {number}
     * @memberof CommentUpvoteItem
     */
    totalUpvotes: number;
    /**
     * 
     * @type {Array<ChatMentionProfileItem>}
     * @memberof CommentUpvoteItem
     */
    latestUpvoters: Array<ChatMentionProfileItem>;
    /**
     * 
     * @type {string}
     * @memberof CommentUpvoteItem
     */
    userId: string;
    /**
     * 
     * @type {ChatMentionProfileItem}
     * @memberof CommentUpvoteItem
     */
    profile: ChatMentionProfileItem;
    /**
     * 
     * @type {string}
     * @memberof CommentUpvoteItem
     */
    createdAt: string;
}

/**
 * 
 * @export
 * @interface CommentUpvoterItem
 */
export interface CommentUpvoterItem {
    /**
     * 
     * @type {string}
     * @memberof CommentUpvoterItem
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentUpvoterItem
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentUpvoterItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CommentUpvoterItem
     */
    lastNameInitial: string;
    /**
     * 
     * @type {string}
     * @memberof CommentUpvoterItem
     */
    userId: string;
}

/**
 * 
 * @export
 * @interface CommentUpvotersResponse
 */
export interface CommentUpvotersResponse {
    /**
     * 
     * @type {string}
     * @memberof CommentUpvotersResponse
     */
    commentId: string;
    /**
     * 
     * @type {number}
     * @memberof CommentUpvotersResponse
     */
    total: number;
    /**
     * 
     * @type {Array<CommentUpvoterItem>}
     * @memberof CommentUpvotersResponse
     */
    upvoters: Array<CommentUpvoterItem>;
}

/**
 * 
 * @export
 * @interface CommunityWaitlistUserItem
 */
export interface CommunityWaitlistUserItem {
    /**
     * 
     * @type {string}
     * @memberof CommunityWaitlistUserItem
     */
    id: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof CommunityWaitlistUserItem
     */
    profile: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof CommunityWaitlistUserItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityWaitlistUserItem
     */
    updatedAt: string;
}

/**
 * 
 * @export
 * @interface ConfirmCategoryRequest
 */
export interface ConfirmCategoryRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ConfirmCategoryRequest
     */
    categoryIds: Array<string>;
}

/**
 * 
 * @export
 * @interface ConfirmSetupCreatorSubscriptionPaymentMethodRequest
 */
export interface ConfirmSetupCreatorSubscriptionPaymentMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupCreatorSubscriptionPaymentMethodRequest
     */
    stripeConfirmationToken: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupCreatorSubscriptionPaymentMethodRequest
     */
    returnUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupCreatorSubscriptionPaymentMethodRequest
     */
    description?: string;
}

/**
 * 
 * @export
 * @interface ConfirmSetupCreatorSubscriptionPaymentMethodResponse
 */
export interface ConfirmSetupCreatorSubscriptionPaymentMethodResponse {
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupCreatorSubscriptionPaymentMethodResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupCreatorSubscriptionPaymentMethodResponse
     */
    paymentMethodId: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupCreatorSubscriptionPaymentMethodResponse
     */
    clientSecret: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupCreatorSubscriptionPaymentMethodResponse
     */
    status: string;
    /**
     * 
     * @type {object}
     * @memberof ConfirmSetupCreatorSubscriptionPaymentMethodResponse
     */
    nextAction?: object;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupCreatorSubscriptionPaymentMethodResponse
     */
    addressId?: string;
}

/**
 * 
 * @export
 * @interface ConfirmSetupSaasSubscriptionPaymentMethodRequest
 */
export interface ConfirmSetupSaasSubscriptionPaymentMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodRequest
     */
    stripeConfirmationToken: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodRequest
     */
    returnUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodRequest
     */
    description?: string;
}

/**
 * 
 * @export
 * @interface ConfirmSetupSaasSubscriptionPaymentMethodResponse
 */
export interface ConfirmSetupSaasSubscriptionPaymentMethodResponse {
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodResponse
     */
    paymentMethodId: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodResponse
     */
    clientSecret: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodResponse
     */
    status: string;
    /**
     * 
     * @type {object}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodResponse
     */
    nextAction?: object;
    /**
     * 
     * @type {string}
     * @memberof ConfirmSetupSaasSubscriptionPaymentMethodResponse
     */
    addressId?: string;
}

/**
 * 
 * @export
 * @interface ConfirmTicketRequest
 */
export interface ConfirmTicketRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfirmTicketRequest
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmTicketRequest
     */
    uid: string;
    /**
     * 
     * @type {number}
     * @memberof ConfirmTicketRequest
     */
    purchaseAt: number;
    /**
     * 
     * @type {string}
     * @memberof ConfirmTicketRequest
     */
    fromType: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmTicketRequest
     */
    ticketType: string;
    /**
     * 
     * @type {object}
     * @memberof ConfirmTicketRequest
     */
    extra?: object;
}

/**
 * 
 * @export
 * @interface ConfirmTicketResponse
 */
export interface ConfirmTicketResponse {
    /**
     * 
     * @type {string}
     * @memberof ConfirmTicketResponse
     */
    response: string;
}

/**
 * 
 * @export
 * @interface ConnectTwoWayStreamRequest
 */
export interface ConnectTwoWayStreamRequest {
    /**
     * 
     * @type {string}
     * @memberof ConnectTwoWayStreamRequest
     */
    device: string;
}

/**
 * 
 * @export
 * @interface ContentFDLSocial
 */
export interface ContentFDLSocial {
    /**
     * 
     * @type {string}
     * @memberof ContentFDLSocial
     */
    st: string;
    /**
     * 
     * @type {string}
     * @memberof ContentFDLSocial
     */
    sd: string;
    /**
     * 
     * @type {string}
     * @memberof ContentFDLSocial
     */
    si: string;
}

/**
 * 
 * @export
 * @interface ContentFDLSocialItem
 */
export interface ContentFDLSocialItem {
    /**
     * 
     * @type {string}
     * @memberof ContentFDLSocialItem
     */
    st: string;
    /**
     * 
     * @type {string}
     * @memberof ContentFDLSocialItem
     */
    sd: string;
    /**
     * 
     * @type {string}
     * @memberof ContentFDLSocialItem
     */
    si: string;
}

/**
 * 
 * @export
 * @interface ContentModerationInfoItem
 */
export interface ContentModerationInfoItem {
    /**
     * 
     * @type {ModerationStatusEnumItem}
     * @memberof ContentModerationInfoItem
     */
    moderationStatus?: ModerationStatusEnumItem;
    /**
     * 
     * @type {string}
     * @memberof ContentModerationInfoItem
     */
    moderatedAt?: string;
    /**
     * 
     * @type {ModeratorProfileItem}
     * @memberof ContentModerationInfoItem
     */
    moderatorProfile?: ModeratorProfileItem;
    /**
     * 
     * @type {string}
     * @memberof ContentModerationInfoItem
     */
    moderatorUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentModerationInfoItem
     */
    adminModerationReason?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentModerationInfoItem
     */
    aiModerationReason?: string;
}

/**
 * 
 * @export
 * @interface CountResponse
 */
export interface CountResponse {
    /**
     * 
     * @type {number}
     * @memberof CountResponse
     */
    count: number;
}

/**
 * 
 * @export
 * @interface CouponCreatedByItem
 */
export interface CouponCreatedByItem {
    /**
     * 
     * @type {string}
     * @memberof CouponCreatedByItem
     */
    profileId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof CouponCreatedByItem
     */
    profile?: ProfileItem;
}

/**
 * 
 * @export
 * @interface CouponDetailDto
 */
export interface CouponDetailDto {
    /**
     * 
     * @type {string}
     * @memberof CouponDetailDto
     */
    couponId: string;
    /**
     * not null if coupon is redeemed and not used
     * @type {string}
     * @memberof CouponDetailDto
     */
    redeemedCouponId?: string;
    /**
     * 
     * @type {CouponItem}
     * @memberof CouponDetailDto
     */
    coupon: CouponItem;
    /**
     * 
     * @type {string}
     * @memberof CouponDetailDto
     */
    redeemStatus: CouponDetailDtoRedeemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CouponDetailDto
     */
    reason?: string;
    /**
     * 
     * @type {RedeemedCouponDetailItem}
     * @memberof CouponDetailDto
     */
    redeemedCoupon?: RedeemedCouponDetailItem;
}

/**
* @export
* @enum {string}
*/
export enum CouponDetailDtoRedeemStatusEnum {
    Redeemed = 'redeemed',
    Redeemable = 'redeemable',
    Nonredeemable = 'nonredeemable'
}

/**
 * 
 * @export
 * @interface CouponDetailResponse
 */
export interface CouponDetailResponse {
    /**
     * 
     * @type {CouponDetailDto}
     * @memberof CouponDetailResponse
     */
    data?: CouponDetailDto | null;
}

/**
 * 
 * @export
 * @interface CouponItem
 */
export interface CouponItem {
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    pagUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    visible: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    exclusive: boolean;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    createdAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    quantityLimit: boolean;
    /**
     * 
     * @type {number}
     * @memberof CouponItem
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof CouponItem
     */
    redeemedQuantity: number;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    startedAt: string;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    expiredAt: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CouponItem
     */
    storeIds?: Array<string>;
    /**
     * 
     * @type {StoreItem}
     * @memberof CouponItem
     */
    store?: StoreItem;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    couponCreateMethod?: CouponItemCouponCreateMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    type: CouponItemTypeEnum;
    /**
     * belong to type discountPercent and non-nullable.
     * @type {number}
     * @memberof CouponItem
     */
    discountPercent?: number;
    /**
     * belong to type discountPercent and nullable.
     * @type {number}
     * @memberof CouponItem
     */
    maximumDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof CouponItem
     */
    maximumFreeShippingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CouponItem
     */
    sellerShippingPriceSubsidy?: number;
    /**
     * belong to type discountAmount and non-nullable.
     * @type {number}
     * @memberof CouponItem
     */
    discountAmount?: number;
    /**
     * belong to type discountAmount and nullable.
     * @type {number}
     * @memberof CouponItem
     */
    minimalPurchase?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    onlyPurchasedUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    onlyNewUserPerStore?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    onlyReactivatedUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    onlyNewUser?: boolean;
    /**
     * 
     * @type {OnlyAssignToUserItem}
     * @memberof CouponItem
     */
    onlyAssignToUser?: OnlyAssignToUserItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof CouponItem
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    oncePerStore?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CouponItem
     */
    sellerGroupIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    followSelectedSellers?: boolean;
    /**
     * 
     * @type {CouponCreatedByItem}
     * @memberof CouponItem
     */
    createdBy?: CouponCreatedByItem;
    /**
     * 
     * @type {CouponCreatedByItem}
     * @memberof CouponItem
     */
    lastUpdatedBy?: CouponCreatedByItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof CouponItem
     */
    liveStreamIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    onlyFollower?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItem
     */
    onlyPopshopShipping?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof CouponItem
     */
    excludedDropshipPartnerIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof CouponItem
     */
    applicableOrderType?: CouponItemApplicableOrderTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum CouponItemCouponCreateMethodEnum {
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide'
}/**
* @export
* @enum {string}
*/
export enum CouponItemTypeEnum {
    DiscountPercent = 'discountPercent',
    DiscountAmount = 'discountAmount',
    FreeShipping = 'freeShipping'
}/**
* @export
* @enum {string}
*/
export enum CouponItemApplicableOrderTypeEnum {
    OrderGroup = 'OrderGroup',
    ChildOrder = 'ChildOrder'
}

/**
 * 
 * @export
 * @interface CouponItemWithId
 */
export interface CouponItemWithId {
    /**
     * 
     * @type {string}
     * @memberof CouponItemWithId
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof CouponItemWithId
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CouponItemWithId
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CouponItemWithId
     */
    pagUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CouponItemWithId
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItemWithId
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItemWithId
     */
    visible: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItemWithId
     */
    exclusive: boolean;
    /**
     * 
     * @type {string}
     * @memberof CouponItemWithId
     */
    createdAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItemWithId
     */
    quantityLimit: boolean;
    /**
     * 
     * @type {number}
     * @memberof CouponItemWithId
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof CouponItemWithId
     */
    redeemedQuantity: number;
    /**
     * 
     * @type {string}
     * @memberof CouponItemWithId
     */
    startedAt: string;
    /**
     * 
     * @type {string}
     * @memberof CouponItemWithId
     */
    expiredAt: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CouponItemWithId
     */
    storeIds?: Array<string>;
    /**
     * 
     * @type {StoreItem}
     * @memberof CouponItemWithId
     */
    store?: StoreItem;
    /**
     * 
     * @type {string}
     * @memberof CouponItemWithId
     */
    couponCreateMethod?: CouponItemWithIdCouponCreateMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof CouponItemWithId
     */
    type: CouponItemWithIdTypeEnum;
    /**
     * belong to type discountPercent and non-nullable.
     * @type {number}
     * @memberof CouponItemWithId
     */
    discountPercent?: number;
    /**
     * belong to type discountPercent and nullable.
     * @type {number}
     * @memberof CouponItemWithId
     */
    maximumDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof CouponItemWithId
     */
    maximumFreeShippingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CouponItemWithId
     */
    sellerShippingPriceSubsidy?: number;
    /**
     * belong to type discountAmount and non-nullable.
     * @type {number}
     * @memberof CouponItemWithId
     */
    discountAmount?: number;
    /**
     * belong to type discountAmount and nullable.
     * @type {number}
     * @memberof CouponItemWithId
     */
    minimalPurchase?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItemWithId
     */
    onlyPurchasedUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItemWithId
     */
    onlyNewUserPerStore?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItemWithId
     */
    onlyReactivatedUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItemWithId
     */
    onlyNewUser?: boolean;
    /**
     * 
     * @type {OnlyAssignToUserItem}
     * @memberof CouponItemWithId
     */
    onlyAssignToUser?: OnlyAssignToUserItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof CouponItemWithId
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItemWithId
     */
    oncePerStore?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CouponItemWithId
     */
    sellerGroupIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItemWithId
     */
    followSelectedSellers?: boolean;
    /**
     * 
     * @type {CouponCreatedByItem}
     * @memberof CouponItemWithId
     */
    createdBy?: CouponCreatedByItem;
    /**
     * 
     * @type {CouponCreatedByItem}
     * @memberof CouponItemWithId
     */
    lastUpdatedBy?: CouponCreatedByItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof CouponItemWithId
     */
    liveStreamIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItemWithId
     */
    onlyFollower?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponItemWithId
     */
    onlyPopshopShipping?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof CouponItemWithId
     */
    excludedDropshipPartnerIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof CouponItemWithId
     */
    applicableOrderType?: CouponItemWithIdApplicableOrderTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CouponItemWithId
     */
    id: string;
    /**
     * 
     * @type {Metadata}
     * @memberof CouponItemWithId
     */
    metadata: Metadata;
}

/**
* @export
* @enum {string}
*/
export enum CouponItemWithIdCouponCreateMethodEnum {
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide'
}/**
* @export
* @enum {string}
*/
export enum CouponItemWithIdTypeEnum {
    DiscountPercent = 'discountPercent',
    DiscountAmount = 'discountAmount',
    FreeShipping = 'freeShipping'
}/**
* @export
* @enum {string}
*/
export enum CouponItemWithIdApplicableOrderTypeEnum {
    OrderGroup = 'OrderGroup',
    ChildOrder = 'ChildOrder'
}

/**
 * 
 * @export
 * @interface CouponPageRows
 */
export interface CouponPageRows {
    /**
     * 
     * @type {Array<CouponItemWithId>}
     * @memberof CouponPageRows
     */
    rows: Array<CouponItemWithId>;
}

/**
 * 
 * @export
 * @interface CouponsSearchResponse
 */
export interface CouponsSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof CouponsSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof CouponsSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {CouponPageRows}
     * @memberof CouponsSearchResponse
     */
    data: CouponPageRows;
}

/**
 * 
 * @export
 * @interface CreateAccountLinkRequest
 */
export interface CreateAccountLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAccountLinkRequest
     */
    returnUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountLinkRequest
     */
    refreshUrl: string;
}

/**
 * 
 * @export
 * @interface CreateAccountLinkResponse
 */
export interface CreateAccountLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateAccountLinkResponse
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountLinkResponse
     */
    expiredAt: string;
}

/**
 * 
 * @export
 * @interface CreateAccountSessionRequest
 */
export interface CreateAccountSessionRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CreateAccountSessionRequest
     */
    enableExternalAccountCollection?: boolean;
}

/**
 * 
 * @export
 * @interface CreateAccountSessionResponse
 */
export interface CreateAccountSessionResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateAccountSessionResponse
     */
    clientSecret: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountSessionResponse
     */
    expireAt: string;
    /**
     * 
     * @type {object}
     * @memberof CreateAccountSessionResponse
     */
    account?: object;
}

/**
 * 
 * @export
 * @interface CreateAppSellerApplicationRequest
 */
export interface CreateAppSellerApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequest
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequest
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequest
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequest
     */
    whereOnline?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequest
     */
    whatSell?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequest
     */
    whatExperienceProducts?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequest
     */
    whatLiveStream?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequest
     */
    howHearUs?: string;
    /**
     * 
     * @type {SellerAddress}
     * @memberof CreateAppSellerApplicationRequest
     */
    sellerAddress?: SellerAddress;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequest
     */
    storeName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequest
     */
    storeDesc?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequest
     */
    website?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequest
     */
    social?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequest
     */
    sellerDesc?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequest
     */
    sellerHasPhysicalStore?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAppSellerApplicationRequest
     */
    categoryIds?: Array<string>;
}

/**
 * 
 * @export
 * @interface CreateAppSellerApplicationRequestV2
 */
export interface CreateAppSellerApplicationRequestV2 {
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    whereOnline?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    whatSell?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    whatExperienceProducts?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    whatLiveStream?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    howHearUs?: string;
    /**
     * 
     * @type {SellerAddress}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    sellerAddress?: SellerAddress;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    storeName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    storeDesc?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    website?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    social?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    sellerDesc?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    sellerHasPhysicalStore?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    categoryIds?: Array<string>;
    /**
     * Host Or Seller Application
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    applicationType: CreateAppSellerApplicationRequestV2ApplicationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    country: string;
    /**
     * 
     * @type {SocialAccountDto}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    socialAccounts?: SocialAccountDto;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    additionalNotes?: string;
    /**
     * Name of the category
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    category?: string;
    /**
     * What is your total community reach?
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    totalCommunityReach?: string;
    /**
     * How would you best describe the type of products you plan to sell?
     * @type {Array<string>}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    productTypes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    annualSalesRevenue?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    liveStreamExperienceRate?: CreateAppSellerApplicationRequestV2LiveStreamExperienceRateEnum;
    /**
     * Who will be hosting your shows?
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    hostingOperator?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    experienceInRetailSales?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    interestedInPromoting?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV2
     */
    openQuestion?: string;
}

/**
* @export
* @enum {string}
*/
export enum CreateAppSellerApplicationRequestV2ApplicationTypeEnum {
    Host = 'HOST',
    Seller = 'SELLER'
}/**
* @export
* @enum {string}
*/
export enum CreateAppSellerApplicationRequestV2LiveStreamExperienceRateEnum {
    Beginner = 'BEGINNER',
    Intermediate = 'INTERMEDIATE',
    Pro = 'PRO'
}

/**
 * 
 * @export
 * @interface CreateAppSellerApplicationRequestV3
 */
export interface CreateAppSellerApplicationRequestV3 {
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    whereOnline?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    whatSell?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    whatExperienceProducts?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    whatLiveStream?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    howHearUs?: string;
    /**
     * 
     * @type {SellerAddress}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    sellerAddress?: SellerAddress;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    storeName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    storeDesc?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    website?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    social?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    sellerDesc?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    sellerHasPhysicalStore?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    categoryIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    birthday?: string;
    /**
     * 
     * @type {object}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    utmParameters?: object;
    /**
     * Business Or Creator Application
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    storeType: CreateAppSellerApplicationRequestV3StoreTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    popStore?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    billingCountryCode?: string;
    /**
     * store url
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    sellerCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    country: string;
    /**
     * 
     * @type {SocialAccountDto}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    socialAccounts?: SocialAccountDto;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    additionalNotes?: string;
    /**
     * Name of the category
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    category?: string;
    /**
     * What is your total community reach?
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    totalCommunityReach?: string;
    /**
     * How would you best describe the type of products you plan to sell?
     * @type {Array<string>}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    productTypes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    annualSalesRevenue?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    liveStreamExperienceRate?: CreateAppSellerApplicationRequestV3LiveStreamExperienceRateEnum;
    /**
     * Who will be hosting your shows?
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    hostingOperator?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    experienceInRetailSales?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    interestedInPromoting?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    openQuestion?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    liveStreamExperience?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    businessName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    whenSell?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    monthlySalesRevenue?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    allowSMS?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateAppSellerApplicationRequestV3
     */
    productSource?: string;
}

/**
* @export
* @enum {string}
*/
export enum CreateAppSellerApplicationRequestV3StoreTypeEnum {
    Business = 'Business',
    Creator = 'Creator',
    CommentChat = 'CommentChat',
    Vfs = 'VFS'
}/**
* @export
* @enum {string}
*/
export enum CreateAppSellerApplicationRequestV3LiveStreamExperienceRateEnum {
    Beginner = 'BEGINNER',
    Intermediate = 'INTERMEDIATE',
    Pro = 'PRO'
}

/**
 * 
 * @export
 * @interface CreateBadgeRequest
 */
export interface CreateBadgeRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateBadgeRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBadgeRequest
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBadgeRequest
     */
    limit: CreateBadgeRequestLimitEnum;
}

/**
* @export
* @enum {string}
*/
export enum CreateBadgeRequestLimitEnum {
    BadgeLimit5 = 'Badge_LIMIT_5',
    BadgeLimit25 = 'Badge_LIMIT_25',
    BadgeLimit100 = 'Badge_LIMIT_100',
    BadgeLimit250 = 'Badge_LIMIT_250',
    BadgeLimit500 = 'Badge_LIMIT_500',
    BadgeLimit1000 = 'Badge_LIMIT_1000',
    Unlimited = 'Unlimited'
}

/**
 * 
 * @export
 * @interface CreateBillingAddressRequest
 */
export interface CreateBillingAddressRequest {
    /**
     * 
     * @type {BillingAddressDto}
     * @memberof CreateBillingAddressRequest
     */
    billingAddress: BillingAddressDto;
}

/**
 * 
 * @export
 * @interface CreateBulkUploadHistoryRecordeRequest
 */
export interface CreateBulkUploadHistoryRecordeRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateBulkUploadHistoryRecordeRequest
     */
    csvUrl: string;
    /**
     * 
     * @type {number}
     * @memberof CreateBulkUploadHistoryRecordeRequest
     */
    listingsCount: number;
}

/**
 * 
 * @export
 * @interface CreateCategorizedResourceRequest
 */
export interface CreateCategorizedResourceRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCategorizedResourceRequest
     */
    resourceId: string;
    /**
     * available if this is a categorized store
     * @type {number}
     * @memberof CreateCategorizedResourceRequest
     */
    sequenceNo?: number;
}

/**
 * 
 * @export
 * @interface CreateCategoryDiscoveryRowRequest
 */
export interface CreateCategoryDiscoveryRowRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCategoryDiscoveryRowRequest
     */
    categoryIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCategoryDiscoveryRowRequest
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryDiscoveryRowRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryDiscoveryRowRequest
     */
    urlCode: string;
}

/**
 * 
 * @export
 * @interface CreateCategoryRequest
 */
export interface CreateCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryRequest
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryRequest
     */
    imageUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryRequest
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryRequest
     */
    rootCategory: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCategoryRequest
     */
    enabled: boolean;
}

/**
 * 
 * @export
 * @interface CreateCategoryResponse
 */
export interface CreateCategoryResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateCategoryResponse
     */
    id: string;
}

/**
 * 
 * @export
 * @interface CreateCouponByAdminDto
 */
export interface CreateCouponByAdminDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponByAdminDto
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponByAdminDto
     */
    visible?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponByAdminDto
     */
    exclusive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponByAdminDto
     */
    quantityLimit: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateCouponByAdminDto
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCouponByAdminDto
     */
    startedAt: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCouponByAdminDto
     */
    expiredAt: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCouponByAdminDto
     */
    discountAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateCouponByAdminDto
     */
    minimalPurchase?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateCouponByAdminDto
     */
    maximumFreeShippingAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCouponByAdminDto
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCouponByAdminDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCouponByAdminDto
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCouponByAdminDto
     */
    pagUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCouponByAdminDto
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponByAdminDto
     */
    isTest?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCouponByAdminDto
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponByAdminDto
     */
    onlyNewUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponByAdminDto
     */
    onlyFollower?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponByAdminDto
     */
    onlyPurchasedUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponByAdminDto
     */
    onlyNewUserPerStore?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponByAdminDto
     */
    onlyReactivatedUser?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCouponByAdminDto
     */
    liveStreamIds?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateCouponByAdminDto
     */
    excludedDropshipPartnerIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof CreateCouponByAdminDto
     */
    applicableOrderType?: CreateCouponByAdminDtoApplicableOrderTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateCouponByAdminDto
     */
    maximumDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateCouponByAdminDto
     */
    discountPercent?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCouponByAdminDto
     */
    type: CreateCouponByAdminDtoTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCouponByAdminDto
     */
    storeIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponByAdminDto
     */
    followSelectedSellers?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCouponByAdminDto
     */
    sellerGroupIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponByAdminDto
     */
    oncePerStore?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponByAdminDto
     */
    onlyPopshopShipping?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateCouponByAdminDto
     */
    sellerShippingPriceSubsidy?: number;
}

/**
* @export
* @enum {string}
*/
export enum CreateCouponByAdminDtoApplicableOrderTypeEnum {
    OrderGroup = 'OrderGroup',
    ChildOrder = 'ChildOrder'
}/**
* @export
* @enum {string}
*/
export enum CreateCouponByAdminDtoTypeEnum {
    DiscountPercent = 'discountPercent',
    DiscountAmount = 'discountAmount',
    FreeShipping = 'freeShipping'
}

/**
 * 
 * @export
 * @interface CreateCouponBySellerDto
 */
export interface CreateCouponBySellerDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponBySellerDto
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponBySellerDto
     */
    visible?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponBySellerDto
     */
    exclusive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponBySellerDto
     */
    quantityLimit: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateCouponBySellerDto
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCouponBySellerDto
     */
    startedAt: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCouponBySellerDto
     */
    expiredAt: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCouponBySellerDto
     */
    discountAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateCouponBySellerDto
     */
    minimalPurchase?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateCouponBySellerDto
     */
    maximumFreeShippingAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCouponBySellerDto
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCouponBySellerDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCouponBySellerDto
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCouponBySellerDto
     */
    pagUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCouponBySellerDto
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponBySellerDto
     */
    isTest?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCouponBySellerDto
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponBySellerDto
     */
    onlyNewUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponBySellerDto
     */
    onlyFollower?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponBySellerDto
     */
    onlyPurchasedUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponBySellerDto
     */
    onlyNewUserPerStore?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponBySellerDto
     */
    onlyReactivatedUser?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCouponBySellerDto
     */
    liveStreamIds?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateCouponBySellerDto
     */
    excludedDropshipPartnerIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof CreateCouponBySellerDto
     */
    applicableOrderType?: CreateCouponBySellerDtoApplicableOrderTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateCouponBySellerDto
     */
    maximumDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateCouponBySellerDto
     */
    discountPercent?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCouponBySellerDto
     */
    type: CreateCouponBySellerDtoTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponBySellerDto
     */
    onlyAssignToUser?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum CreateCouponBySellerDtoApplicableOrderTypeEnum {
    OrderGroup = 'OrderGroup',
    ChildOrder = 'ChildOrder'
}/**
* @export
* @enum {string}
*/
export enum CreateCouponBySellerDtoTypeEnum {
    DiscountPercent = 'discountPercent',
    DiscountAmount = 'discountAmount'
}

/**
 * 
 * @export
 * @interface CreateCouponResponse
 */
export interface CreateCouponResponse {
    /**
     * Excel file download url. Only available when creating in batch and non-test mode 
     * @type {string}
     * @memberof CreateCouponResponse
     */
    excelFile?: string;
}

/**
 * 
 * @export
 * @interface CreateCustomNotificationDTO
 */
export interface CreateCustomNotificationDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCustomNotificationDTO
     */
    sourceIds: Array<string>;
    /**
     * 
     * @type {CreateFirebaseConsoleCustomPayload}
     * @memberof CreateCustomNotificationDTO
     */
    payload: CreateFirebaseConsoleCustomPayload;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomNotificationDTO
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomNotificationDTO
     */
    body?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomNotificationDTO
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomNotificationDTO
     */
    type: CreateCustomNotificationDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomNotificationDTO
     */
    scheduledDate?: string;
}

/**
* @export
* @enum {string}
*/
export enum CreateCustomNotificationDTOTypeEnum {
    UserGroupUsers = 'UserGroupUsers',
    ProfileFollowers = 'ProfileFollowers',
    ProfileFollowing = 'ProfileFollowing',
    Profile = 'Profile'
}

/**
 * 
 * @export
 * @interface CreateCustomNotificationResponse
 */
export interface CreateCustomNotificationResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateCustomNotificationResponse
     */
    id: string;
}

/**
 * 
 * @export
 * @interface CreateCustomerAccountRequest
 */
export interface CreateCustomerAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCustomerAccountRequest
     */
    usage?: CreateCustomerAccountRequestUsageEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCustomerAccountRequest
     */
    removable?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum CreateCustomerAccountRequestUsageEnum {
    OnSession = 'on_session',
    OffSession = 'off_session'
}

/**
 * 
 * @export
 * @interface CreateEventSettingTemplateRequest
 */
export interface CreateEventSettingTemplateRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateEventSettingTemplateRequest
     */
    commissionFeeRate?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEventSettingTemplateRequest
     */
    salesTaxRate?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEventSettingTemplateRequest
     */
    shippingFee?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEventSettingTemplateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventSettingTemplateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {object}
     * @memberof CreateEventSettingTemplateRequest
     */
    parcel: object;
    /**
     * 
     * @type {string}
     * @memberof CreateEventSettingTemplateRequest
     */
    shipmentProvider?: CreateEventSettingTemplateRequestShipmentProviderEnum;
}

/**
* @export
* @enum {string}
*/
export enum CreateEventSettingTemplateRequestShipmentProviderEnum {
    Ups = 'ups',
    Usps = 'usps',
    UspsFirst = 'usps_first'
}

/**
 * 
 * @export
 * @interface CreateFirebaseConsoleCustomPayload
 */
export interface CreateFirebaseConsoleCustomPayload {
    /**
     * 
     * @type {string}
     * @memberof CreateFirebaseConsoleCustomPayload
     */
    type: CreateFirebaseConsoleCustomPayloadTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateFirebaseConsoleCustomPayload
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFirebaseConsoleCustomPayload
     */
    showId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFirebaseConsoleCustomPayload
     */
    showEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFirebaseConsoleCustomPayload
     */
    userId?: string;
}

/**
* @export
* @enum {string}
*/
export enum CreateFirebaseConsoleCustomPayloadTypeEnum {
    Custom = 'custom'
}

/**
 * 
 * @export
 * @interface CreateFollowerDto
 */
export interface CreateFollowerDto {
    /**
     * 
     * @type {CreateFollowerSource}
     * @memberof CreateFollowerDto
     */
    source?: CreateFollowerSource;
}

/**
 * 
 * @export
 * @interface CreateFollowerSource
 */
export interface CreateFollowerSource {
    /**
     * 
     * @type {string}
     * @memberof CreateFollowerSource
     */
    type: CreateFollowerSourceTypeEnum;
    /**
     * belong type upcoming show
     * @type {string}
     * @memberof CreateFollowerSource
     */
    upcomingShowId?: string;
    /**
     * belong type live stream
     * @type {string}
     * @memberof CreateFollowerSource
     */
    liveStreamId?: string;
}

/**
* @export
* @enum {string}
*/
export enum CreateFollowerSourceTypeEnum {
    LiveStream = 'LIVE_STREAM',
    UpcomingShow = 'UPCOMING_SHOW'
}

/**
 * 
 * @export
 * @interface CreateGlobalMessageDto
 */
export interface CreateGlobalMessageDto {
    /**
     * 
     * @type {string}
     * @memberof CreateGlobalMessageDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGlobalMessageDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGlobalMessageDto
     */
    cta?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGlobalMessageDto
     */
    thumbnail?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateGlobalMessageDto
     */
    enabled: boolean;
}

/**
 * 
 * @export
 * @interface CreateGuestUserRequest
 */
export interface CreateGuestUserRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateGuestUserRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGuestUserRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGuestUserRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGuestUserRequest
     */
    recaptchaToken?: string;
}

/**
 * 
 * @export
 * @interface CreateHighlightVideoRequest
 */
export interface CreateHighlightVideoRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateHighlightVideoRequest
     */
    url: string;
}

/**
 * 
 * @export
 * @interface CreateInvitationRequest
 */
export interface CreateInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateInvitationRequest
     */
    code: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateInvitationRequest
     */
    sellerIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateInvitationRequest
     */
    couponCodes: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateInvitationRequest
     */
    enabled: boolean;
}

/**
 * 
 * @export
 * @interface CreateInvitationResponse
 */
export interface CreateInvitationResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateInvitationResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitationResponse
     */
    code: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateInvitationResponse
     */
    sellerIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateInvitationResponse
     */
    couponCodes: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateInvitationResponse
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateInvitationResponse
     */
    createdAt?: string;
}

/**
 * 
 * @export
 * @interface CreateInviteRequest
 */
export interface CreateInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateInviteRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInviteRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInviteRequest
     */
    storeFrontName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInviteRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInviteRequest
     */
    phone?: string;
}

/**
 * 
 * @export
 * @interface CreateLinkRequest
 */
export interface CreateLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLinkRequest
     */
    referrerId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLinkRequest
     */
    type: CreateLinkRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateLinkRequest
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLinkRequest
     */
    isWebOnly?: boolean;
    /**
     * 
     * @type {ContentFDLSocial}
     * @memberof CreateLinkRequest
     */
    social?: ContentFDLSocial;
    /**
     * 
     * @type {Analytics}
     * @memberof CreateLinkRequest
     */
    analytics?: Analytics;
    /**
     * 
     * @type {IOSConfig}
     * @memberof CreateLinkRequest
     */
    ios?: IOSConfig;
    /**
     * 
     * @type {AndroidConfig}
     * @memberof CreateLinkRequest
     */
    android?: AndroidConfig;
    /**
     * 
     * @type {CreateShareTargetItem}
     * @memberof CreateLinkRequest
     */
    shareTarget: CreateShareTargetItem;
    /**
     * 
     * @type {string}
     * @memberof CreateLinkRequest
     */
    method?: CreateLinkRequestMethodEnum;
    /**
     * 
     * @type {LinkActions}
     * @memberof CreateLinkRequest
     */
    actions: LinkActions;
    /**
     * 
     * @type {object}
     * @memberof CreateLinkRequest
     */
    linkParams?: object;
}

/**
* @export
* @enum {string}
*/
export enum CreateLinkRequestTypeEnum {
    Share = 'SHARE',
    Campaign = 'CAMPAIGN',
    ReferralGifting = 'REFERRAL_GIFTING'
}/**
* @export
* @enum {string}
*/
export enum CreateLinkRequestMethodEnum {
    Sms = 'SMS',
    Email = 'EMAIL',
    Facebook = 'FACEBOOK',
    Instagram = 'INSTAGRAM',
    Twitter = 'TWITTER',
    Embed = 'EMBED',
    Generic = 'GENERIC'
}

/**
 * 
 * @export
 * @interface CreateLinkResponse
 */
export interface CreateLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateLinkResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLinkResponse
     */
    shortLink: string;
    /**
     * Where the short link points to
     * @type {string}
     * @memberof CreateLinkResponse
     */
    originalLink: string;
}

/**
 * 
 * @export
 * @interface CreateLiveStreamListingRequest
 */
export interface CreateLiveStreamListingRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamListingRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLiveStreamListingRequest
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLiveStreamListingRequest
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamListingRequest
     */
    defaultImage: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamListingRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLiveStreamListingRequest
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamListingRequest
     */
    sku?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLiveStreamListingRequest
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {Array<LiveStreamListingVariant>}
     * @memberof CreateLiveStreamListingRequest
     */
    variants?: Array<LiveStreamListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof CreateLiveStreamListingRequest
     */
    maximumPurchaseQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLiveStreamListingRequest
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLiveStreamListingRequest
     */
    shippingFee?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLiveStreamListingRequest
     */
    tags?: Array<string>;
    /**
     * 
     * @type {DimsInfo}
     * @memberof CreateLiveStreamListingRequest
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {SingleUnitWeightInfo | PoundWithOunceWeightInfo}
     * @memberof CreateLiveStreamListingRequest
     */
    weight?: SingleUnitWeightInfo | PoundWithOunceWeightInfo;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof CreateLiveStreamListingRequest
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamListingRequest
     */
    categoryId?: string;
}

/**
 * 
 * @export
 * @interface CreateLiveStreamRequest
 */
export interface CreateLiveStreamRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamRequest
     */
    device: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamRequest
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamRequest
     */
    versionTag?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamRequest
     */
    showEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamRequest
     */
    showEventTemplateId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamRequest
     */
    permission: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLiveStreamRequest
     */
    shippingMode?: Array<CreateLiveStreamRequestShippingModeEnum>;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamRequest
     */
    addressId?: string;
    /**
     * prerequisite: nftGatedShows feature enabled for this seller
     * @type {boolean}
     * @memberof CreateLiveStreamRequest
     */
    isNftGated?: boolean;
    /**
     * prerequisite: patreonGatedShows feature enabled for this seller
     * @type {boolean}
     * @memberof CreateLiveStreamRequest
     */
    isPatreonGated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamRequest
     */
    accessLevel?: CreateLiveStreamRequestAccessLevelEnum;
}

/**
* @export
* @enum {string}
*/
export enum CreateLiveStreamRequestShippingModeEnum {
    Shipping = 'shipping',
    Pickup = 'pickup'
}/**
* @export
* @enum {string}
*/
export enum CreateLiveStreamRequestAccessLevelEnum {
    All = 'all',
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface CreateLiveStreamResponse
 */
export interface CreateLiveStreamResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateLiveStreamResponse
     */
    id: string;
}

/**
 * 
 * @export
 * @interface CreateMessageLinkRequest
 */
export interface CreateMessageLinkRequest {
    /**
     * 
     * @type {object}
     * @memberof CreateMessageLinkRequest
     */
    linkParams?: object;
}

/**
 * 
 * @export
 * @interface CreateMessageLinkResponse
 */
export interface CreateMessageLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateMessageLinkResponse
     */
    shortLink: string;
}

/**
 * 
 * @export
 * @interface CreateMessageReportRequest
 */
export interface CreateMessageReportRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateMessageReportRequest
     */
    reason: CreateMessageReportRequestReasonEnum;
}

/**
* @export
* @enum {string}
*/
export enum CreateMessageReportRequestReasonEnum {
    Spam = 'spam',
    Inappropriate = 'inappropriate',
    Aggressive = 'aggressive'
}

/**
 * 
 * @export
 * @interface CreateNewsRequest
 */
export interface CreateNewsRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateNewsRequest
     */
    brief: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateNewsRequest
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateNewsRequest
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNewsRequest
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNewsRequest
     */
    expiredAt?: string;
}

/**
 * 
 * @export
 * @interface CreateNftFakerRequest
 */
export interface CreateNftFakerRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateNftFakerRequest
     */
    walletAddress: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNftFakerRequest
     */
    asAddress: string;
}

/**
 * 
 * @export
 * @interface CreateOrderDto
 */
export interface CreateOrderDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    stripePaymentMethodId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    stripeApplePayNonce?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    listingId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    sellerId: string;
    /**
     * The recipient of this gift order
     * @type {string}
     * @memberof CreateOrderDto
     */
    recipientId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    sendItemId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    sentReferralGiftId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    variantId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    shippingMethod?: CreateOrderDtoShippingMethodEnum;
    /**
     * Optional for gifting orders or digital products
     * @type {AddressDto}
     * @memberof CreateOrderDto
     */
    shippingAddress?: AddressDto;
    /**
     * 
     * @type {PickupAddressDto}
     * @memberof CreateOrderDto
     */
    pickupAddress?: PickupAddressDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateOrderDto
     */
    redeemedCouponIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderDto
     */
    quantity: number;
    /**
     * 
     * @type {LiveStreamSource | TwoWayStreamSource | UpcomingShowSource | ReferralGiftingSource | StoreSource | ReplaySource | SendItemSource | ShopSource | TopProductsSource | CommentChatSource}
     * @memberof CreateOrderDto
     */
    source?: LiveStreamSource | TwoWayStreamSource | UpcomingShowSource | ReferralGiftingSource | StoreSource | ReplaySource | SendItemSource | ShopSource | TopProductsSource | CommentChatSource;
    /**
     * 
     * @type {PaymentAddressDto}
     * @memberof CreateOrderDto
     */
    paymentBillingAddress?: PaymentAddressDto;
    /**
     * 
     * @type {TippingDto}
     * @memberof CreateOrderDto
     */
    tipping?: TippingDto;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    fxQuoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    paymentType: CreateOrderDtoPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    buyerName: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderDto
     */
    useBonus?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    requestTrackingID: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    userAgent?: string;
    /**
     * 
     * @type {GiftPackageDto}
     * @memberof CreateOrderDto
     */
    giftPackage?: GiftPackageDto;
    /**
     * 
     * @type {object}
     * @memberof CreateOrderDto
     */
    utmParameters?: object;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    nonce?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    creditCardId?: string;
}

/**
* @export
* @enum {string}
*/
export enum CreateOrderDtoShippingMethodEnum {
    DropshipSupplierProvide = 'dropshipSupplierProvide',
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide',
    Pickup = 'pickup'
}/**
* @export
* @enum {string}
*/
export enum CreateOrderDtoPaymentTypeEnum {
    Applepay = 'applepay',
    Credit = 'credit',
    Empty = 'empty'
}

/**
 * 
 * @export
 * @interface CreateOrderDtoV2
 */
export interface CreateOrderDtoV2 {
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV2
     */
    stripePaymentMethodId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV2
     */
    stripeApplePayNonce?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV2
     */
    listingId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV2
     */
    sellerId: string;
    /**
     * The recipient of this gift order
     * @type {string}
     * @memberof CreateOrderDtoV2
     */
    recipientId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV2
     */
    sendItemId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV2
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV2
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV2
     */
    sentReferralGiftId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV2
     */
    variantId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV2
     */
    shippingMethod?: CreateOrderDtoV2ShippingMethodEnum;
    /**
     * Optional for gifting orders or digital products
     * @type {AddressDto}
     * @memberof CreateOrderDtoV2
     */
    shippingAddress?: AddressDto;
    /**
     * 
     * @type {PickupAddressDto}
     * @memberof CreateOrderDtoV2
     */
    pickupAddress?: PickupAddressDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateOrderDtoV2
     */
    redeemedCouponIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderDtoV2
     */
    quantity: number;
    /**
     * 
     * @type {LiveStreamSource | TwoWayStreamSource | UpcomingShowSource | ReferralGiftingSource | StoreSource | ReplaySource | SendItemSource | ShopSource | TopProductsSource | CommentChatSource}
     * @memberof CreateOrderDtoV2
     */
    source?: LiveStreamSource | TwoWayStreamSource | UpcomingShowSource | ReferralGiftingSource | StoreSource | ReplaySource | SendItemSource | ShopSource | TopProductsSource | CommentChatSource;
    /**
     * 
     * @type {PaymentAddressDto}
     * @memberof CreateOrderDtoV2
     */
    paymentBillingAddress?: PaymentAddressDto;
    /**
     * 
     * @type {TippingDto}
     * @memberof CreateOrderDtoV2
     */
    tipping?: TippingDto;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV2
     */
    fxQuoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV2
     */
    paymentType: CreateOrderDtoV2PaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV2
     */
    buyerName: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderDtoV2
     */
    useBonus?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV2
     */
    requestTrackingID: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV2
     */
    userAgent?: string;
    /**
     * 
     * @type {GiftPackageDto}
     * @memberof CreateOrderDtoV2
     */
    giftPackage?: GiftPackageDto;
    /**
     * 
     * @type {object}
     * @memberof CreateOrderDtoV2
     */
    utmParameters?: object;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV2
     */
    braintreeToken?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV2
     */
    braintreeApplePayNonce?: string;
}

/**
* @export
* @enum {string}
*/
export enum CreateOrderDtoV2ShippingMethodEnum {
    DropshipSupplierProvide = 'dropshipSupplierProvide',
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide',
    Pickup = 'pickup'
}/**
* @export
* @enum {string}
*/
export enum CreateOrderDtoV2PaymentTypeEnum {
    Applepay = 'applepay',
    Credit = 'credit',
    Empty = 'empty'
}

/**
 * 
 * @export
 * @interface CreateOrderDtoV3
 */
export interface CreateOrderDtoV3 {
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    stripePaymentMethodId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    stripeApplePayNonce?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    listingId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    sellerId: string;
    /**
     * The recipient of this gift order
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    recipientId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    sendItemId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    sentReferralGiftId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    variantId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    shippingMethod?: CreateOrderDtoV3ShippingMethodEnum;
    /**
     * Optional for gifting orders or digital products
     * @type {AddressDto}
     * @memberof CreateOrderDtoV3
     */
    shippingAddress?: AddressDto;
    /**
     * 
     * @type {PickupAddressDto}
     * @memberof CreateOrderDtoV3
     */
    pickupAddress?: PickupAddressDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateOrderDtoV3
     */
    redeemedCouponIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderDtoV3
     */
    quantity: number;
    /**
     * 
     * @type {LiveStreamSource | TwoWayStreamSource | UpcomingShowSource | ReferralGiftingSource | StoreSource | ReplaySource | SendItemSource | ShopSource | TopProductsSource | CommentChatSource}
     * @memberof CreateOrderDtoV3
     */
    source?: LiveStreamSource | TwoWayStreamSource | UpcomingShowSource | ReferralGiftingSource | StoreSource | ReplaySource | SendItemSource | ShopSource | TopProductsSource | CommentChatSource;
    /**
     * 
     * @type {PaymentAddressDto}
     * @memberof CreateOrderDtoV3
     */
    paymentBillingAddress?: PaymentAddressDto;
    /**
     * 
     * @type {TippingDto}
     * @memberof CreateOrderDtoV3
     */
    tipping?: TippingDto;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    fxQuoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    paymentType: CreateOrderDtoV3PaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    buyerName: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderDtoV3
     */
    useBonus?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    requestTrackingID: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    userAgent?: string;
    /**
     * 
     * @type {GiftPackageDto}
     * @memberof CreateOrderDtoV3
     */
    giftPackage?: GiftPackageDto;
    /**
     * 
     * @type {object}
     * @memberof CreateOrderDtoV3
     */
    utmParameters?: object;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    braintreeToken?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    braintreeApplePayNonce?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    stripeConfirmationToken: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDtoV3
     */
    returnUrl: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderDtoV3
     */
    savePaymentMethodForFutureOnSessionPayment?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum CreateOrderDtoV3ShippingMethodEnum {
    DropshipSupplierProvide = 'dropshipSupplierProvide',
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide',
    Pickup = 'pickup'
}/**
* @export
* @enum {string}
*/
export enum CreateOrderDtoV3PaymentTypeEnum {
    Applepay = 'applepay',
    Credit = 'credit',
    Empty = 'empty'
}

/**
 * 
 * @export
 * @interface CreateOrderRequest
 */
export interface CreateOrderRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateOrderRequest
     */
    masterOrderIds: Array<string>;
}

/**
 * 
 * @export
 * @interface CreateOrderResponse
 */
export interface CreateOrderResponse {
    /**
     * 
     * @type {CommentSoldOrderItem}
     * @memberof CreateOrderResponse
     */
    commentSold?: CommentSoldOrderItem;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    eventId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    orderNumber: string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    buyerName: string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    buyerPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    shippingFeeAdjusted: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderResponse
     */
    braintreeShippingFeeRefunded?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    salesTaxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    salesTaxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    buyerId: string;
    /**
     * 
     * @type {OrderProfileItem}
     * @memberof CreateOrderResponse
     */
    buyer: OrderProfileItem;
    /**
     * 
     * @type {OrderGiftingItem}
     * @memberof CreateOrderResponse
     */
    gifting?: OrderGiftingItem;
    /**
     * 
     * @type {OrderGiftPackageItem}
     * @memberof CreateOrderResponse
     */
    giftPackage?: OrderGiftPackageItem;
    /**
     * 
     * @type {ShipmentItem}
     * @memberof CreateOrderResponse
     */
    shipment?: ShipmentItem;
    /**
     * 
     * @type {PackingSlipItem}
     * @memberof CreateOrderResponse
     */
    packingSlip?: PackingSlipItem;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    refund?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    userAgent?: string;
    /**
     * 
     * @type {OrderPaymentItem}
     * @memberof CreateOrderResponse
     */
    orderPayment?: OrderPaymentItem;
    /**
     * 
     * @type {PaymentItem}
     * @memberof CreateOrderResponse
     */
    payment?: PaymentItem;
    /**
     * 
     * @type {Array<RedeemedCouponItem>}
     * @memberof CreateOrderResponse
     */
    coupons?: Array<RedeemedCouponItem>;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    couponDiscountProductAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    couponDiscountShippingFeeAmount?: number;
    /**
     * 
     * @type {SellerTrackingInfoItem}
     * @memberof CreateOrderResponse
     */
    sellerTrackingInfo?: SellerTrackingInfoItem;
    /**
     * 
     * @type {Array<SellerTrackingInfoItem>}
     * @memberof CreateOrderResponse
     */
    sellerTrackingInfoHistory?: Array<SellerTrackingInfoItem>;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    sellerGotAmount: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    bonus?: number;
    /**
     * 
     * @type {AddressItem}
     * @memberof CreateOrderResponse
     */
    shippingAddress: AddressItem;
    /**
     * 
     * @type {PickupAddressItem}
     * @memberof CreateOrderResponse
     */
    pickupAddress?: PickupAddressItem;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    listingId: string;
    /**
     * 
     * @type {StoreListingItem}
     * @memberof CreateOrderResponse
     */
    listingSnapshot: StoreListingItem;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    sendItemId?: string;
    /**
     * 
     * @type {NormalSendItemItem | LiveStreamAuctionSendItemItem | GiveawaySendItemItem}
     * @memberof CreateOrderResponse
     */
    sendItem?: NormalSendItemItem | LiveStreamAuctionSendItemItem | GiveawaySendItemItem;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    sellerId: string;
    /**
     * 
     * @type {OrderProfileItem}
     * @memberof CreateOrderResponse
     */
    seller: OrderProfileItem;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    status: CreateOrderResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    orderGroupStatus: CreateOrderResponseOrderGroupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    pickupStatus?: CreateOrderResponsePickupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    cancelStatus?: CreateOrderResponseCancelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    orderGroupCancelStatus?: CreateOrderResponseOrderGroupCancelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    orderRefundStatus?: CreateOrderResponseOrderRefundStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    orderGroupRefundStatus?: CreateOrderResponseOrderGroupRefundStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    shippingMethod: CreateOrderResponseShippingMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    shippoOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    variantId?: string;
    /**
     * 
     * @type {StoreFrontItem}
     * @memberof CreateOrderResponse
     */
    store: StoreFrontItem;
    /**
     * 
     * @type {OrderShipmentGroupStatus}
     * @memberof CreateOrderResponse
     */
    orderShipmentGroupStatus: OrderShipmentGroupStatus;
    /**
     * 
     * @type {ShippingLabelStatus}
     * @memberof CreateOrderResponse
     */
    shippingLabelStatus: ShippingLabelStatus;
    /**
     * 
     * @type {ShippingLabelStatus}
     * @memberof CreateOrderResponse
     */
    packingSlipStatus: ShippingLabelStatus;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    masterOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    planTimeOfShippingLabelGeneration?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    totalQuantitiesIncludeSlaveOrders: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    totalPriceIncludeSlaveOrders: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    totalPriceIncludeSlaveOrdersWithProductCoupon: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    totalRefundIncludeSlaveOrders?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderResponse
     */
    newCustomer?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    firstPurchaseAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    updatedAt?: string;
    /**
     * 
     * @type {OrderCompositionCancellationStatus}
     * @memberof CreateOrderResponse
     */
    orderCompositionCancellationStatus?: OrderCompositionCancellationStatus;
    /**
     * 
     * @type {OrderChargeDistributionItem}
     * @memberof CreateOrderResponse
     */
    orderChargeDistribution?: OrderChargeDistributionItem;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderResponse
     */
    packed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    pickupNotifiedAt?: string;
    /**
     * 
     * @type {OrderSource}
     * @memberof CreateOrderResponse
     */
    source?: OrderSource;
    /**
     * 
     * @type {OrderShipmentParcel}
     * @memberof CreateOrderResponse
     */
    shipmentParcel?: OrderShipmentParcel;
    /**
     * 
     * @type {OrderShipmentParcel}
     * @memberof CreateOrderResponse
     */
    shipmentOriginalParcel?: OrderShipmentParcel;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    shipmentOriginalParcelSource?: CreateOrderResponseShipmentOriginalParcelSourceEnum;
    /**
     * 
     * @type {OrderItemPriceComponents}
     * @memberof CreateOrderResponse
     */
    priceComponents?: OrderItemPriceComponents;
    /**
     * 
     * @type {Array<OrderRefund>}
     * @memberof CreateOrderResponse
     */
    refunds?: Array<OrderRefund>;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    packageTemplateId?: string;
    /**
     * 
     * @type {OrderItemPackageTemplate}
     * @memberof CreateOrderResponse
     */
    packageTemplate?: OrderItemPackageTemplate;
    /**
     * 
     * @type {OrderItemPresetShippingCost}
     * @memberof CreateOrderResponse
     */
    presetShippingCost?: OrderItemPresetShippingCost;
    /**
     * 
     * @type {OrderItemDropshipDetails}
     * @memberof CreateOrderResponse
     */
    dropshipDetails?: OrderItemDropshipDetails;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    fundAvailableDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    fundAvailableDate2?: string;
    /**
     * 
     * @type {LabelShippingCost}
     * @memberof CreateOrderResponse
     */
    labelShippingCost?: LabelShippingCost;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderResponse
     */
    totalRefundedSalesTax?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    paymentExpireAt?: string;
    /**
     * 
     * @type {MultiCurrencyOrderItem}
     * @memberof CreateOrderResponse
     */
    buyerCurrencyOrderDetails?: MultiCurrencyOrderItem;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderResponse
     */
    orderId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrderResponse
     */
    isFirstPurchaseFromSeller: boolean;
}

/**
* @export
* @enum {string}
*/
export enum CreateOrderResponseStatusEnum {
    Created = 'created',
    Completed = 'completed',
    Canceled = 'canceled',
    PendingPayment = 'pendingPayment',
    ProcessingPayment = 'processingPayment',
    Closed = 'closed'
}/**
* @export
* @enum {string}
*/
export enum CreateOrderResponseOrderGroupStatusEnum {
    Open = 'open',
    Processing = 'processing',
    Fulfilling = 'fulfilling',
    Completed = 'completed',
    Canceled = 'canceled'
}/**
* @export
* @enum {string}
*/
export enum CreateOrderResponsePickupStatusEnum {
    Open = 'open',
    New = 'new',
    Processing = 'processing',
    Pending = 'pending',
    Packed = 'packed',
    Completed = 'completed',
    Canceled = 'canceled'
}/**
* @export
* @enum {string}
*/
export enum CreateOrderResponseCancelStatusEnum {
    SellerApplied = 'seller_applied',
    AdminApproved = 'admin_approved'
}/**
* @export
* @enum {string}
*/
export enum CreateOrderResponseOrderGroupCancelStatusEnum {
    PartialCanceled = 'PARTIAL_CANCELED',
    FullyCanceled = 'FULLY_CANCELED'
}/**
* @export
* @enum {string}
*/
export enum CreateOrderResponseOrderRefundStatusEnum {
    PartiallyRefunded = 'PARTIALLY_REFUNDED',
    FullyRefunded = 'FULLY_REFUNDED'
}/**
* @export
* @enum {string}
*/
export enum CreateOrderResponseOrderGroupRefundStatusEnum {
    PartiallyRefunded = 'PARTIALLY_REFUNDED',
    FullyRefunded = 'FULLY_REFUNDED'
}/**
* @export
* @enum {string}
*/
export enum CreateOrderResponseShippingMethodEnum {
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide',
    Pickup = 'pickup',
    DropshipSupplierProvide = 'dropshipSupplierProvide'
}/**
* @export
* @enum {string}
*/
export enum CreateOrderResponseShipmentOriginalParcelSourceEnum {
    Default = 'DEFAULT',
    ShowEvent = 'SHOW_EVENT'
}

/**
 * 
 * @export
 * @interface CreateOrderV3Response
 */
export interface CreateOrderV3Response {
    /**
     * 
     * @type {CreateOrderResponse}
     * @memberof CreateOrderV3Response
     */
    order: CreateOrderResponse;
    /**
     * 
     * @type {object}
     * @memberof CreateOrderV3Response
     */
    nextAction?: object;
}

/**
 * 
 * @export
 * @interface CreatePackageTemplateRequest
 */
export interface CreatePackageTemplateRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CreatePackageTemplateRequest
     */
    isDefault: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePackageTemplateRequest
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePackageTemplateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePackageTemplateRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePackageTemplateRequest
     */
    shippingPrice: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePackageTemplateRequest
     */
    shippingCost?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePackageTemplateRequest
     */
    carrierId: CreatePackageTemplateRequestCarrierIdEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePackageTemplateRequest
     */
    parcelTemplateId?: CreatePackageTemplateRequestParcelTemplateIdEnum;
    /**
     * 
     * @type {number}
     * @memberof CreatePackageTemplateRequest
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePackageTemplateRequest
     */
    height: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePackageTemplateRequest
     */
    depth: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePackageTemplateRequest
     */
    distanceUnit: CreatePackageTemplateRequestDistanceUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof CreatePackageTemplateRequest
     */
    weight: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePackageTemplateRequest
     */
    massUnit: CreatePackageTemplateRequestMassUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePackageTemplateRequest
     */
    signatureConfirmationId?: CreatePackageTemplateRequestSignatureConfirmationIdEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePackageTemplateRequest
     */
    serviceLevelId: CreatePackageTemplateRequestServiceLevelIdEnum;
}

/**
* @export
* @enum {string}
*/
export enum CreatePackageTemplateRequestCarrierIdEnum {
    Usps = 'usps'
}/**
* @export
* @enum {string}
*/
export enum CreatePackageTemplateRequestParcelTemplateIdEnum {
    Envelope = 'Envelope',
    Package = 'Package',
    UspsRegionalRateBoxB1 = 'USPS_RegionalRateBoxB1',
    UspsRegionalRateBoxB2 = 'USPS_RegionalRateBoxB2',
    UspsIrregularParcel = 'USPS_IrregularParcel',
    UspsCard = 'USPS_Card',
    UspsFlatRateCardboardEnvelope = 'USPS_FlatRateCardboardEnvelope',
    UspsFlatRateLegalEnvelope = 'USPS_FlatRateLegalEnvelope',
    UspsFlatRateEnvelope = 'USPS_FlatRateEnvelope',
    UspsFlatRateGiftCardEnvelope = 'USPS_FlatRateGiftCardEnvelope',
    UspsLargeVideoFlatRateBox = 'USPS_LargeVideoFlatRateBox',
    UspsLargeFlatRateBoardGameBox = 'USPS_LargeFlatRateBoardGameBox',
    UspsSmallFlatRateEnvelope = 'USPS_SmallFlatRateEnvelope',
    UspsSoftPack = 'USPS_SoftPack',
    UspsLargeFlatRateBox = 'USPS_LargeFlatRateBox',
    UspsMediumFlatRateBox1 = 'USPS_MediumFlatRateBox1',
    UspsMediumFlatRateBox2 = 'USPS_MediumFlatRateBox2',
    UspsSmallFlatRateBox = 'USPS_SmallFlatRateBox',
    UspsRegionalRateBoxA1 = 'USPS_RegionalRateBoxA1',
    UspsRegionalRateBoxA2 = 'USPS_RegionalRateBoxA2',
    UspsApoFlatRateBox = 'USPS_APOFlatRateBox',
    UspsFlatRateWindowEnvelope = 'USPS_FlatRateWindowEnvelope',
    UspsFlatRatePaddedEnvelope = 'USPS_FlatRatePaddedEnvelope'
}/**
* @export
* @enum {string}
*/
export enum CreatePackageTemplateRequestDistanceUnitEnum {
    Cm = 'cm',
    In = 'in',
    Ft = 'ft',
    M = 'm',
    Mm = 'mm',
    Yd = 'yd'
}/**
* @export
* @enum {string}
*/
export enum CreatePackageTemplateRequestMassUnitEnum {
    G = 'g',
    Kg = 'kg',
    Lb = 'lb',
    Oz = 'oz'
}/**
* @export
* @enum {string}
*/
export enum CreatePackageTemplateRequestSignatureConfirmationIdEnum {
    Standard = 'STANDARD',
    Adult = 'ADULT',
    Certified = 'CERTIFIED'
}/**
* @export
* @enum {string}
*/
export enum CreatePackageTemplateRequestServiceLevelIdEnum {
    Cheapest = 'CHEAPEST',
    Fastest = 'FASTEST',
    UspsGroundAdvantage = 'usps_ground_advantage',
    UspsPriority = 'usps_priority',
    UspsPriorityExpress = 'usps_priority_express'
}

/**
 * 
 * @export
 * @interface CreatePayoutMethodDto
 */
export interface CreatePayoutMethodDto {
    /**
     * 
     * @type {PayoutBankDto}
     * @memberof CreatePayoutMethodDto
     */
    payoutMethodBank: PayoutBankDto;
}

/**
 * 
 * @export
 * @interface CreatePayoutMethodResponse
 */
export interface CreatePayoutMethodResponse {
    /**
     * 
     * @type {string}
     * @memberof CreatePayoutMethodResponse
     */
    id: string;
}

/**
 * 
 * @export
 * @interface CreatePickupAddressRequest
 */
export interface CreatePickupAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePickupAddressRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePickupAddressRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePickupAddressRequest
     */
    primaryPhone: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePickupAddressRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePickupAddressRequest
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePickupAddressRequest
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePickupAddressRequest
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePickupAddressRequest
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePickupAddressRequest
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePickupAddressRequest
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePickupAddressRequest
     */
    pickupNote?: string;
}

/**
 * 
 * @export
 * @interface CreatePopStoreThemeTemplateRequest
 */
export interface CreatePopStoreThemeTemplateRequest {
    /**
     * Theme name
     * @type {string}
     * @memberof CreatePopStoreThemeTemplateRequest
     */
    name: string;
    /**
     * 
     * @type {PopStoreThemeTemplateStyleEnumItem}
     * @memberof CreatePopStoreThemeTemplateRequest
     */
    style: PopStoreThemeTemplateStyleEnumItem;
    /**
     * Theme type
     * @type {PopStoreThemeTemplateTypeRequestDto}
     * @memberof CreatePopStoreThemeTemplateRequest
     */
    type: PopStoreThemeTemplateTypeRequestDto;
    /**
     * Thumbnail URL of the theme
     * @type {string}
     * @memberof CreatePopStoreThemeTemplateRequest
     */
    thumbnailUrl?: string;
    /**
     * Subscription level required for using this theme
     * @type {SubscriptionAccessRequestDto}
     * @memberof CreatePopStoreThemeTemplateRequest
     */
    subscriptionLevel: SubscriptionAccessRequestDto;
    /**
     * Privacy flag
     * @type {boolean}
     * @memberof CreatePopStoreThemeTemplateRequest
     */
    privacy: boolean;
    /**
     * Theme settings (complex JSON)
     * @type {string}
     * @memberof CreatePopStoreThemeTemplateRequest
     */
    theme: string;
}

/**
 * 
 * @export
 * @interface CreatePostCommentRequest
 */
export interface CreatePostCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePostCommentRequest
     */
    parentId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePostCommentRequest
     */
    text: string;
}

/**
 * 
 * @export
 * @interface CreatePostRequest
 */
export interface CreatePostRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePostRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePostRequest
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePostRequest
     */
    tags?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePostRequest
     */
    allowComments: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePostRequest
     */
    saveAsDraft?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePostRequest
     */
    scheduledReleaseTime?: string;
    /**
     * 
     * @type {PayToViewOnlyModeDto}
     * @memberof CreatePostRequest
     */
    payToViewOnlyMode?: PayToViewOnlyModeDto;
    /**
     * 
     * @type {SubscribeToViewDto}
     * @memberof CreatePostRequest
     */
    subscribeToView?: SubscribeToViewDto;
    /**
     * 
     * @type {PayToViewDto}
     * @memberof CreatePostRequest
     */
    payToView?: PayToViewDto;
    /**
     * 
     * @type {CrowdTippingToViewDto}
     * @memberof CreatePostRequest
     */
    crowdTippingToView?: CrowdTippingToViewDto;
    /**
     * 
     * @type {TipToViewDto}
     * @memberof CreatePostRequest
     */
    tipToView?: TipToViewDto;
    /**
     * 
     * @type {Array<TippingAmountDto>}
     * @memberof CreatePostRequest
     */
    tippingAmounts?: Array<TippingAmountDto>;
    /**
     * 
     * @type {DmOnlyDto}
     * @memberof CreatePostRequest
     */
    dmOnly?: DmOnlyDto;
    /**
     * 
     * @type {PostContentTypeEnumItem}
     * @memberof CreatePostRequest
     */
    postType: PostContentTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof CreatePostRequest
     */
    textContent?: string;
    /**
     * 
     * @type {Array<PostMediaDto>}
     * @memberof CreatePostRequest
     */
    medias?: Array<PostMediaDto>;
    /**
     * 
     * @type {number}
     * @memberof CreatePostRequest
     */
    unrestrictedLeadingMediaCount?: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePostRequest
     */
    cid: string;
}

/**
 * 
 * @export
 * @interface CreateProductCategoryRequest
 */
export interface CreateProductCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateProductCategoryRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProductCategoryRequest
     */
    slug?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateProductCategoryRequest
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof CreateProductCategoryRequest
     */
    parentId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductCategoryRequest
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductCategoryRequest
     */
    isRoot: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductCategoryRequest
     */
    custom: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductCategoryRequest
     */
    digital?: boolean;
}

/**
 * 
 * @export
 * @interface CreateProductCollectionRequest
 */
export interface CreateProductCollectionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateProductCollectionRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CreateProductCollectionRequest
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof CreateProductCollectionRequest
     */
    strategy: CreateProductCollectionRequestStrategyEnum;
    /**
     * valid when strategy is BY_CATEGORY
     * @type {Array<string>}
     * @memberof CreateProductCollectionRequest
     */
    productCategoryIds: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum CreateProductCollectionRequestStrategyEnum {
    ByCategory = 'BY_CATEGORY',
    ManualSelection = 'MANUAL_SELECTION'
}

/**
 * 
 * @export
 * @interface CreateReferralGiftRequest
 */
export interface CreateReferralGiftRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateReferralGiftRequest
     */
    storeId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReferralGiftRequest
     */
    listingId: string;
}

/**
 * 
 * @export
 * @interface CreateReferralGiftResponse
 */
export interface CreateReferralGiftResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateReferralGiftResponse
     */
    id: string;
}

/**
 * 
 * @export
 * @interface CreateReferralRequest
 */
export interface CreateReferralRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateReferralRequest
     */
    passcode: string;
}

/**
 * 
 * @export
 * @interface CreateSellerApplicationTemplateRequest
 */
export interface CreateSellerApplicationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSellerApplicationTemplateRequest
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSellerApplicationTemplateRequest
     */
    sellerUserGroupIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateSellerApplicationTemplateRequest
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSellerApplicationTemplateRequest
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateSellerApplicationTemplateRequest
     */
    image?: string;
}

/**
 * 
 * @export
 * @interface CreateSellerApplicationsRequest
 */
export interface CreateSellerApplicationsRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSellerApplicationsRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSellerApplicationsRequest
     */
    sellerId?: string;
}

/**
 * 
 * @export
 * @interface CreateSendItemRequest
 */
export interface CreateSendItemRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSendItemRequest
     */
    listingId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSendItemRequest
     */
    variantId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSendItemRequest
     */
    to: string;
    /**
     * 
     * @type {number}
     * @memberof CreateSendItemRequest
     */
    quantity?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSendItemRequest
     */
    needShippingFee: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateSendItemRequest
     */
    price?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSendItemRequest
     */
    noNeedNotification?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateSendItemRequest
     */
    auctionId?: string;
}

/**
 * 
 * @export
 * @interface CreateSendItemResponse
 */
export interface CreateSendItemResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateSendItemResponse
     */
    id: string;
}

/**
 * 
 * @export
 * @interface CreateSeriesRequest
 */
export interface CreateSeriesRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    labelFormat?: CreateSeriesRequestLabelFormatEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSeriesRequest
     */
    showLabel?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSeriesRequest
     */
    hasChapter?: boolean;
    /**
     * 
     * @type {SeriesChapterLabelFormatEnumItem}
     * @memberof CreateSeriesRequest
     */
    chapterLabelFormat?: SeriesChapterLabelFormatEnumItem;
    /**
     * 
     * @type {number}
     * @memberof CreateSeriesRequest
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    elementSortingStrategy?: CreateSeriesRequestElementSortingStrategyEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    mobileBannerImage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    desktopBannerImage?: string;
    /**
     * 
     * @type {Array<AddSeriesPopClipDto>}
     * @memberof CreateSeriesRequest
     */
    popClips?: Array<AddSeriesPopClipDto>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSeriesRequest
     */
    standaloneSale?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateSeriesRequest
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSeriesRequest
     */
    discountPrice?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSeriesRequest
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    discountEndDate?: string;
    /**
     * 
     * @type {PopStoreUserAccessLevelEnumItem}
     * @memberof CreateSeriesRequest
     */
    accessLevel?: PopStoreUserAccessLevelEnumItem;
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    description?: string;
    /**
     * 
     * @type {SeriesTypeEnumItem}
     * @memberof CreateSeriesRequest
     */
    type?: SeriesTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    parentId?: string;
}

/**
* @export
* @enum {string}
*/
export enum CreateSeriesRequestLabelFormatEnum {
    Short = 'SHORT',
    Long = 'LONG'
}/**
* @export
* @enum {string}
*/
export enum CreateSeriesRequestElementSortingStrategyEnum {
    MostRecentFirst = 'MOST_RECENT_FIRST',
    MostRecentLast = 'MOST_RECENT_LAST',
    Custom = 'CUSTOM'
}

/**
 * 
 * @export
 * @interface CreateShareTargetItem
 */
export interface CreateShareTargetItem {
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetItem
     */
    type: CreateShareTargetItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetItem
     */
    profileId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetItem
     */
    storeId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetItem
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetItem
     */
    listingId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetItem
     */
    showEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetItem
     */
    ticketId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetItem
     */
    popClipId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetItem
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetItem
     */
    promotionId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetItem
     */
    referralGiftId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetItem
     */
    variantId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetItem
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetItem
     */
    userBadgeId?: string;
}

/**
* @export
* @enum {string}
*/
export enum CreateShareTargetItemTypeEnum {
    Profile = 'PROFILE',
    Store = 'STORE',
    LiveStream = 'LIVE_STREAM',
    Replay = 'REPLAY',
    UpcomingShow = 'UPCOMING_SHOW',
    ListingLiveStream = 'LISTING_LIVE_STREAM',
    ListingReplay = 'LISTING_REPLAY',
    ListingEvergreen = 'LISTING_EVERGREEN',
    ListingUpcomingShow = 'LISTING_UPCOMING_SHOW',
    ListingPromotion = 'LISTING_PROMOTION',
    Event = 'EVENT',
    EventDiscovery = 'EVENT_DISCOVERY',
    EventTicket = 'EVENT_TICKET',
    HomePage = 'HOME_PAGE',
    Promotion = 'PROMOTION',
    ReferralGifting = 'REFERRAL_GIFTING',
    UserBadge = 'USER_BADGE',
    LiveStreamGiveaway = 'LIVE_STREAM_GIVEAWAY',
    UpcomingShowGiveaway = 'UPCOMING_SHOW_GIVEAWAY',
    PopClip = 'POP_CLIP',
    BecomeASeller = 'BECOME_A_SELLER'
}

/**
 * 
 * @export
 * @interface CreateShareTargetRequest
 */
export interface CreateShareTargetRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetRequest
     */
    type: CreateShareTargetRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetRequest
     */
    profileId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetRequest
     */
    storeId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetRequest
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetRequest
     */
    listingId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetRequest
     */
    showEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShareTargetRequest
     */
    upcomingShowId?: string;
}

/**
* @export
* @enum {string}
*/
export enum CreateShareTargetRequestTypeEnum {
    Profile = 'PROFILE',
    Store = 'STORE',
    LiveStream = 'LIVE_STREAM',
    Replay = 'REPLAY',
    UpcomingShow = 'UPCOMING_SHOW',
    ListingLiveStream = 'LISTING_LIVE_STREAM',
    ListingReplay = 'LISTING_REPLAY',
    ListingEvergreen = 'LISTING_EVERGREEN',
    ListingUpcomingShow = 'LISTING_UPCOMING_SHOW',
    ListingPromotion = 'LISTING_PROMOTION',
    Event = 'EVENT',
    EventDiscovery = 'EVENT_DISCOVERY',
    EventTicket = 'EVENT_TICKET',
    HomePage = 'HOME_PAGE',
    Promotion = 'PROMOTION',
    ReferralGifting = 'REFERRAL_GIFTING',
    UserBadge = 'USER_BADGE',
    LiveStreamGiveaway = 'LIVE_STREAM_GIVEAWAY',
    UpcomingShowGiveaway = 'UPCOMING_SHOW_GIVEAWAY',
    PopClip = 'POP_CLIP',
    BecomeASeller = 'BECOME_A_SELLER'
}

/**
 * 
 * @export
 * @interface CreateShipmentRequest
 */
export interface CreateShipmentRequest {
    /**
     * 
     * @type {CreateShipmentRequestParcel}
     * @memberof CreateShipmentRequest
     */
    parcel: CreateShipmentRequestParcel;
}

/**
 * 
 * @export
 * @interface CreateShipmentRequestParcel
 */
export interface CreateShipmentRequestParcel {
    /**
     * 
     * @type {string}
     * @memberof CreateShipmentRequestParcel
     */
    distanceUnit: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShipmentRequestParcel
     */
    height: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShipmentRequestParcel
     */
    length: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShipmentRequestParcel
     */
    massUnit: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShipmentRequestParcel
     */
    weight: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShipmentRequestParcel
     */
    width: string;
}

/**
 * 
 * @export
 * @interface CreateShowEventRequest
 */
export interface CreateShowEventRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateShowEventRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShowEventRequest
     */
    urlCode: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowEventRequest
     */
    sellerUserGroupIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowEventRequest
     */
    userGroupIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateShowEventRequest
     */
    previewVideoURL?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShowEventRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShowEventRequest
     */
    backgroundURL?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShowEventRequest
     */
    verticalBackgroundURL?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateShowEventRequest
     */
    salesTaxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateShowEventRequest
     */
    maximumPurchaseQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateShowEventRequest
     */
    startedAfter?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShowEventRequest
     */
    endedBefore?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateShowEventRequest
     */
    shippingFee?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateShowEventRequest
     */
    isClosed?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowEventRequest
     */
    visibilityGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateShowEventRequest
     */
    sortedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateShowEventRequest
     */
    extraCommissionFeeRate?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateShowEventRequest
     */
    featuredStoreStackName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShowEventRequest
     */
    sellerApplicationDisclosure?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShowEventRequest
     */
    sellerApplicationDisclosureUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateShowEventRequest
     */
    unBundleOnDiscovery?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateShowEventRequest
     */
    visibilityOnDiscoveryBanner?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowEventRequest
     */
    customLightingBoltImages?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof CreateShowEventRequest
     */
    parcel: object;
    /**
     * 
     * @type {string}
     * @memberof CreateShowEventRequest
     */
    shipmentProvider?: CreateShowEventRequestShipmentProviderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateShowEventRequest
     */
    visibleOnCategoryBanner?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateShowEventRequest
     */
    categoryCoverUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateShowEventRequest
     */
    active: boolean;
}

/**
* @export
* @enum {string}
*/
export enum CreateShowEventRequestShipmentProviderEnum {
    Ups = 'ups',
    Usps = 'usps',
    UspsFirst = 'usps_first'
}

/**
 * 
 * @export
 * @interface CreateShowEventResponse
 */
export interface CreateShowEventResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateShowEventResponse
     */
    id: string;
}

/**
 * 
 * @export
 * @interface CreateShowEventTemplateDto
 */
export interface CreateShowEventTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof CreateShowEventTemplateDto
     */
    type: CreateShowEventTemplateDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateShowEventTemplateDto
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowEventTemplateDto
     */
    userGroupIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateShowEventTemplateDto
     */
    startedAfter: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShowEventTemplateDto
     */
    endedBefore: string;
}

/**
* @export
* @enum {string}
*/
export enum CreateShowEventTemplateDtoTypeEnum {
    TimeRange = 'timeRange'
}

/**
 * 
 * @export
 * @interface CreateShowTicketRequest
 */
export interface CreateShowTicketRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateShowTicketRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShowTicketRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateShowTicketRequest
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof CreateShowTicketRequest
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateShowTicketRequest
     */
    sku?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowTicketRequest
     */
    userGroupIds: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CreateShowTicketRequest
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateShowTicketRequest
     */
    maximumPurchaseQuantity?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateShowTicketRequest
     */
    upgradeTicket?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateShowTicketRequest
     */
    fromTicketId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateShowTicketRequest
     */
    toTicketId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateShowTicketRequest
     */
    emailConfirmationDisclosure?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShowTicketRequest
     */
    emailConfirmationDisclosureUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShowTicketRequest
     */
    emailConfirmationHeaderBackgroundUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateShowTicketRequest
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateShowTicketRequest
     */
    requireShipping: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateShowTicketRequest
     */
    shippingFee?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateShowTicketRequest
     */
    defaultImage: string;
}

/**
 * 
 * @export
 * @interface CreateStoreListingRequest
 */
export interface CreateStoreListingRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CreateStoreListingRequest
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateStoreListingRequest
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    defaultImage: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateStoreListingRequest
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    sku?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateStoreListingRequest
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {Array<StoreControllerStoreListingVariant>}
     * @memberof CreateStoreListingRequest
     */
    variants?: Array<StoreControllerStoreListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof CreateStoreListingRequest
     */
    maximumPurchaseQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateStoreListingRequest
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateStoreListingRequest
     */
    shippingFee?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateStoreListingRequest
     */
    tags?: Array<string>;
    /**
     * 
     * @type {StoreListingOriginalInfo}
     * @memberof CreateStoreListingRequest
     */
    originalInfo?: StoreListingOriginalInfo;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    externalId?: string;
    /**
     * 
     * @type {DimsInfo}
     * @memberof CreateStoreListingRequest
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {SingleUnitWeightInfo | PoundWithOunceWeightInfo}
     * @memberof CreateStoreListingRequest
     */
    weight?: SingleUnitWeightInfo | PoundWithOunceWeightInfo;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof CreateStoreListingRequest
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    taxCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateStoreListingRequest
     */
    nontaxable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateStoreListingRequest
     */
    useLocalPrice?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    sizingGuideImage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateStoreListingRequest
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    discountEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {UploadedFileDto}
     * @memberof CreateStoreListingRequest
     */
    uploadedFile?: UploadedFileDto;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    externalCheckoutUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    externalBrandName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    externalBrandImage?: string;
    /**
     * 
     * @type {ListingMeetingDto}
     * @memberof CreateStoreListingRequest
     */
    meeting?: ListingMeetingDto;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingRequest
     */
    type?: CreateStoreListingRequestTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum CreateStoreListingRequestTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}

/**
 * 
 * @export
 * @interface CreateStoreListingResponse
 */
export interface CreateStoreListingResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateStoreListingResponse
     */
    id: string;
    /**
     * when creating repeating slots, this is all the listings that are created
     * @type {Array<string>}
     * @memberof CreateStoreListingResponse
     */
    listingIds: Array<string>;
}

/**
 * 
 * @export
 * @interface CreateStoreRequest
 */
export interface CreateStoreRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateStoreRequest
     */
    passcode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreRequest
     */
    storeName?: string;
    /**
     * 
     * @type {SellerAddressRequest}
     * @memberof CreateStoreRequest
     */
    sellerAddress?: SellerAddressRequest;
    /**
     * 
     * @type {string}
     * @memberof CreateStoreRequest
     */
    userId: string;
}

/**
 * 
 * @export
 * @interface CreateStripeCustomerSessionResponse
 */
export interface CreateStripeCustomerSessionResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateStripeCustomerSessionResponse
     */
    clientSecret: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStripeCustomerSessionResponse
     */
    expireAt: string;
}

/**
 * 
 * @export
 * @interface CreateStripePayoutMethodRequest
 */
export interface CreateStripePayoutMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateStripePayoutMethodRequest
     */
    accountNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStripePayoutMethodRequest
     */
    routingNumber: string;
}

/**
 * 
 * @export
 * @interface CreateStripePayoutMethodResponse
 */
export interface CreateStripePayoutMethodResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateStripePayoutMethodResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStripePayoutMethodResponse
     */
    markedAccount: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStripePayoutMethodResponse
     */
    bankName: string;
}

/**
 * 
 * @export
 * @interface CreateSubscriptionRequest
 */
export interface CreateSubscriptionRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSubscriptionRequest
     */
    priceIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionRequest
     */
    paymentMethodId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionRequest
     */
    zipCode: string;
}

/**
 * 
 * @export
 * @interface CreateSubscriptionResponse
 */
export interface CreateSubscriptionResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionResponse
     */
    status: CreateSubscriptionResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionResponse
     */
    collectionMethod: string;
    /**
     * 
     * @type {number}
     * @memberof CreateSubscriptionResponse
     */
    discountedPrice: number;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionResponse
     */
    initialStartDate: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionResponse
     */
    currentPeriodStart: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionResponse
     */
    currentPeriodEnd: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionResponse
     */
    cancelledAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionResponse
     */
    cancellationAppliedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSubscriptionResponse
     */
    lastInvoiceId: string;
    /**
     * 
     * @type {Array<SubscriptionPlan>}
     * @memberof CreateSubscriptionResponse
     */
    plans: Array<SubscriptionPlan>;
}

/**
* @export
* @enum {string}
*/
export enum CreateSubscriptionResponseStatusEnum {
    Active = 'active',
    Canceled = 'canceled',
    Incomplete = 'incomplete',
    IncompleteExpired = 'incomplete_expired',
    Trialing = 'trialing',
    PastDue = 'past_due',
    Unpaid = 'unpaid',
    Paused = 'paused'
}

/**
 * 
 * @export
 * @interface CreateTicketOrderRequestV1
 */
export interface CreateTicketOrderRequestV1 {
    /**
     * 
     * @type {TicketOrderAddressRequest}
     * @memberof CreateTicketOrderRequestV1
     */
    shippingAddress?: TicketOrderAddressRequest;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketOrderRequestV1
     */
    paymentType: CreateTicketOrderRequestV1PaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketOrderRequestV1
     */
    creditCardId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketOrderRequestV1
     */
    nonce?: string;
}

/**
* @export
* @enum {string}
*/
export enum CreateTicketOrderRequestV1PaymentTypeEnum {
    Credit = 'credit',
    Applepay = 'applepay',
    Empty = 'empty'
}

/**
 * 
 * @export
 * @interface CreateTicketOrderRequestV2
 */
export interface CreateTicketOrderRequestV2 {
    /**
     * 
     * @type {TicketOrderAddressRequest}
     * @memberof CreateTicketOrderRequestV2
     */
    shippingAddress?: TicketOrderAddressRequest;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketOrderRequestV2
     */
    paymentType: CreateTicketOrderRequestV2PaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketOrderRequestV2
     */
    braintreeToken?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketOrderRequestV2
     */
    stripePaymentMethodId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketOrderRequestV2
     */
    braintreeApplePayNonce?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketOrderRequestV2
     */
    stripeApplePayNonce?: string;
}

/**
* @export
* @enum {string}
*/
export enum CreateTicketOrderRequestV2PaymentTypeEnum {
    Credit = 'credit',
    Applepay = 'applepay',
    Empty = 'empty'
}

/**
 * 
 * @export
 * @interface CreateTicketOrderResponse
 */
export interface CreateTicketOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof CreateTicketOrderResponse
     */
    id: number;
}

/**
 * 
 * @export
 * @interface CreateTicketRequest
 */
export interface CreateTicketRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTicketRequest
     */
    issue: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketRequest
     */
    issueOption?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketRequest
     */
    detail?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketRequest
     */
    orderId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTicketRequest
     */
    images?: Array<string>;
}

/**
 * 
 * @export
 * @interface CreateTicketResponse
 */
export interface CreateTicketResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateTicketResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketResponse
     */
    email: string;
}

/**
 * 
 * @export
 * @interface CreateTimerRequest
 */
export interface CreateTimerRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTimerRequest
     */
    type: CreateTimerRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateTimerRequest
     */
    maxDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTimerRequest
     */
    name: string;
}

/**
* @export
* @enum {string}
*/
export enum CreateTimerRequestTypeEnum {
    DateTime = 'DATE_TIME'
}

/**
 * 
 * @export
 * @interface CreateTipRequest
 */
export interface CreateTipRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTipRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTipRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateTipRequest
     */
    minimumAmount: number;
    /**
     * 
     * @type {number}
     * @memberof CreateTipRequest
     */
    stepAmount: number;
    /**
     * 
     * @type {string}
     * @memberof CreateTipRequest
     */
    defaultImage: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTipRequest
     */
    extraImages?: Array<string>;
}

/**
 * 
 * @export
 * @interface CreateTippingOrderDto
 */
export interface CreateTippingOrderDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTippingOrderDto
     */
    tipId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTippingOrderDto
     */
    userAgent?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTippingOrderDto
     */
    tipperId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTippingOrderDto
     */
    recipientId: string;
    /**
     * 
     * @type {number}
     * @memberof CreateTippingOrderDto
     */
    total: number;
    /**
     * 
     * @type {TippingOrderLiveStreamSource | TippingOrderUpcomingShowSource}
     * @memberof CreateTippingOrderDto
     */
    source: TippingOrderLiveStreamSource | TippingOrderUpcomingShowSource;
    /**
     * 
     * @type {string}
     * @memberof CreateTippingOrderDto
     */
    paymentType: CreateTippingOrderDtoPaymentTypeEnum;
    /**
     * stripe only
     * @type {string}
     * @memberof CreateTippingOrderDto
     */
    paymentMethodId: string;
}

/**
* @export
* @enum {string}
*/
export enum CreateTippingOrderDtoPaymentTypeEnum {
    Applepay = 'applepay',
    Credit = 'credit',
    Empty = 'empty'
}

/**
 * 
 * @export
 * @interface CreateTwoWayStreamRequest
 */
export interface CreateTwoWayStreamRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTwoWayStreamRequest
     */
    secondaryUserId: string;
}

/**
 * 
 * @export
 * @interface CreateUpcomingShowBySellerDto
 */
export interface CreateUpcomingShowBySellerDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowBySellerDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowBySellerDto
     */
    startsAt: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowBySellerDto
     */
    permission?: CreateUpcomingShowBySellerDtoPermissionEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowBySellerDto
     */
    eventId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowBySellerDto
     */
    eventTemplateId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpcomingShowBySellerDto
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowBySellerDto
     */
    previewVideoURL: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowBySellerDto
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowBySellerDto
     */
    accessLevel?: CreateUpcomingShowBySellerDtoAccessLevelEnum;
}

/**
* @export
* @enum {string}
*/
export enum CreateUpcomingShowBySellerDtoPermissionEnum {
    All = 'all',
    Follower = 'follower',
    Subscriber = 'subscriber',
    NoOne = 'no-one'
}/**
* @export
* @enum {string}
*/
export enum CreateUpcomingShowBySellerDtoAccessLevelEnum {
    All = 'all',
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface CreateUpcomingShowDto
 */
export interface CreateUpcomingShowDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowDto
     */
    startsAt: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowDto
     */
    permission?: CreateUpcomingShowDtoPermissionEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowDto
     */
    eventId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpcomingShowDto
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpcomingShowDto
     */
    available: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowDto
     */
    shareVideo?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowDto
     */
    previewVideoURL: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowDto
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowDto
     */
    originalCoverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowDto
     */
    transcodeStatus?: CreateUpcomingShowDtoTranscodeStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpcomingShowDto
     */
    accessLevel?: CreateUpcomingShowDtoAccessLevelEnum;
}

/**
* @export
* @enum {string}
*/
export enum CreateUpcomingShowDtoPermissionEnum {
    All = 'all',
    Follower = 'follower',
    Subscriber = 'subscriber',
    NoOne = 'no-one'
}/**
* @export
* @enum {string}
*/
export enum CreateUpcomingShowDtoTranscodeStatusEnum {
    Initial = 'initial',
    Processing = 'processing',
    TranscodeOriginal = 'transcode-original',
    TranscodeOriginalShare = 'transcode-original-share',
    RequestRetranscode = 'request-retranscode'
}/**
* @export
* @enum {string}
*/
export enum CreateUpcomingShowDtoAccessLevelEnum {
    All = 'all',
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface CreateUserGroupDto
 */
export interface CreateUserGroupDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUserGroupDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserGroupDto
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserGroupDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUserGroupDto
     */
    userType?: CreateUserGroupDtoUserTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum CreateUserGroupDtoUserTypeEnum {
    Guest = 'guest',
    Normal = 'normal',
    Seller = 'seller',
    VerifiedSeller = 'verifiedSeller'
}

/**
 * 
 * @export
 * @interface CreateUserParamsV2
 */
export interface CreateUserParamsV2 {
    /**
     * 
     * @type {string}
     * @memberof CreateUserParamsV2
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserParamsV2
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserParamsV2
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserParamsV2
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserParamsV2
     */
    bio?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserParamsV2
     */
    avatar?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserParamsV2
     */
    popStore?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUserParamsV2
     */
    popStoreDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserParamsV2
     */
    billingCountryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserParamsV2
     */
    birthday?: string;
}

/**
 * 
 * @export
 * @interface CreateVideoMessageRequest
 */
export interface CreateVideoMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateVideoMessageRequest
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVideoMessageRequest
     */
    userIdTo: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVideoMessageRequest
     */
    videoURL: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVideoMessageRequest
     */
    emoji?: CreateVideoMessageRequestEmojiEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateVideoMessageRequest
     */
    purpose?: CreateVideoMessageRequestPurposeEnum;
}

/**
* @export
* @enum {string}
*/
export enum CreateVideoMessageRequestEmojiEnum {
    RollingEyesFace = 'rolling_eyes_face',
    Sweat = 'sweat',
    Blush = 'blush',
    Smile = 'smile',
    HeartEyes = 'heart_eyes'
}/**
* @export
* @enum {string}
*/
export enum CreateVideoMessageRequestPurposeEnum {
    Review = 'review',
    ThankYou = 'thankYou'
}

/**
 * 
 * @export
 * @interface CreateVideoMessageResponse
 */
export interface CreateVideoMessageResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateVideoMessageResponse
     */
    id: string;
}

/**
 * 
 * @export
 * @interface CreateWithdrawByAdminDto
 */
export interface CreateWithdrawByAdminDto {
    /**
     * 
     * @type {number}
     * @memberof CreateWithdrawByAdminDto
     */
    withdrawableAmount: number;
    /**
     * 
     * @type {string}
     * @memberof CreateWithdrawByAdminDto
     */
    userAgent?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWithdrawByAdminDto
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWithdrawByAdminDto
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWithdrawByAdminDto
     */
    userId: string;
}

/**
 * 
 * @export
 * @interface CreateWithdrawDto
 */
export interface CreateWithdrawDto {
    /**
     * 
     * @type {number}
     * @memberof CreateWithdrawDto
     */
    withdrawableAmount: number;
    /**
     * 
     * @type {string}
     * @memberof CreateWithdrawDto
     */
    userAgent?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWithdrawDto
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWithdrawDto
     */
    note?: string;
}

/**
 * 
 * @export
 * @interface CreatorProfileItem
 */
export interface CreatorProfileItem {
    /**
     * 
     * @type {string}
     * @memberof CreatorProfileItem
     */
    avatar: string;
    /**
     * 
     * @type {string}
     * @memberof CreatorProfileItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreatorProfileItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreatorProfileItem
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof CreatorProfileItem
     */
    urlCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreatorProfileItem
     */
    storeFrontName: string;
}

/**
 * 
 * @export
 * @interface CrowdTippingToViewDto
 */
export interface CrowdTippingToViewDto {
    /**
     * 
     * @type {boolean}
     * @memberof CrowdTippingToViewDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CrowdTippingToViewDto
     */
    targetAmount: number;
    /**
     * currently only USD is supported
     * @type {string}
     * @memberof CrowdTippingToViewDto
     */
    currency: string;
}

/**
 * 
 * @export
 * @interface CrowdTippingToViewItem
 */
export interface CrowdTippingToViewItem {
    /**
     * 
     * @type {boolean}
     * @memberof CrowdTippingToViewItem
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CrowdTippingToViewItem
     */
    targetAmount: number;
    /**
     * 
     * @type {number}
     * @memberof CrowdTippingToViewItem
     */
    currentAmount: number;
    /**
     * currently only USD is supported
     * @type {string}
     * @memberof CrowdTippingToViewItem
     */
    currency: string;
}

/**
 * 
 * @export
 * @interface CustomFieldOptionItem
 */
export interface CustomFieldOptionItem {
    /**
     * 
     * @type {number}
     * @memberof CustomFieldOptionItem
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldOptionItem
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CustomFieldOptionItem
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof CustomFieldOptionItem
     */
    value: string;
}

/**
 * 
 * @export
 * @interface CustomTokenDto
 */
export interface CustomTokenDto {
    /**
     * 
     * @type {string}
     * @memberof CustomTokenDto
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof CustomTokenDto
     */
    storeId: string;
}

/**
 * 
 * @export
 * @interface CustomUserClaim
 */
export interface CustomUserClaim {
    /**
     * 
     * @type {boolean}
     * @memberof CustomUserClaim
     */
    isAdmin?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomUserClaim
     */
    roles?: Array<CustomUserClaimRolesEnum>;
}

/**
* @export
* @enum {string}
*/
export enum CustomUserClaimRolesEnum {
    Moderator = 'moderator',
    Seller = 'seller',
    SystemAdmin = 'system-admin',
    User = 'user',
    Finance = 'finance',
    AgencyAdmin = 'agency-admin',
    AgencyUser = 'agency-user'
}

/**
 * 
 * @export
 * @interface DimsInfo
 */
export interface DimsInfo {
    /**
     * 
     * @type {number}
     * @memberof DimsInfo
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof DimsInfo
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof DimsInfo
     */
    depth?: number;
    /**
     * 
     * @type {string}
     * @memberof DimsInfo
     */
    unit: DimsInfoUnitEnum;
}

/**
* @export
* @enum {string}
*/
export enum DimsInfoUnitEnum {
    Cm = 'cm',
    In = 'in',
    Ft = 'ft',
    M = 'm',
    Mm = 'mm',
    Yd = 'yd'
}

/**
 * 
 * @export
 * @interface DiscoveryCategoryEventsResponse
 */
export interface DiscoveryCategoryEventsResponse {
    /**
     * 
     * @type {Array<ShowEventWithoutMetaDataItem>}
     * @memberof DiscoveryCategoryEventsResponse
     */
    data: Array<ShowEventWithoutMetaDataItem>;
}

/**
 * 
 * @export
 * @interface DiscoveryFeaturedEventsResponse
 */
export interface DiscoveryFeaturedEventsResponse {
    /**
     * 
     * @type {Array<EventFeaturedShowItem>}
     * @memberof DiscoveryFeaturedEventsResponse
     */
    data: Array<EventFeaturedShowItem>;
}

/**
 * 
 * @export
 * @interface DiscoveryShowLiveStreamItem
 */
export interface DiscoveryShowLiveStreamItem {
    /**
     * 
     * @type {string}
     * @memberof DiscoveryShowLiveStreamItem
     */
    type: DiscoveryShowLiveStreamItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryShowLiveStreamItem
     */
    liveStreamId: string;
    /**
     * 
     * @type {LiveStreamItem}
     * @memberof DiscoveryShowLiveStreamItem
     */
    liveStream: LiveStreamItem;
}

/**
* @export
* @enum {string}
*/
export enum DiscoveryShowLiveStreamItemTypeEnum {
    LiveStream = 'liveStream'
}

/**
 * 
 * @export
 * @interface DiscoveryShowPromotionPageItem
 */
export interface DiscoveryShowPromotionPageItem {
    /**
     * 
     * @type {string}
     * @memberof DiscoveryShowPromotionPageItem
     */
    type: DiscoveryShowPromotionPageItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryShowPromotionPageItem
     */
    promotionPageId: string;
    /**
     * 
     * @type {BasePromotionPageItem}
     * @memberof DiscoveryShowPromotionPageItem
     */
    promotionPage: BasePromotionPageItem;
}

/**
* @export
* @enum {string}
*/
export enum DiscoveryShowPromotionPageItemTypeEnum {
    PromotionPage = 'promotionPage'
}

/**
 * 
 * @export
 * @interface DiscoveryShowResponse
 */
export interface DiscoveryShowResponse {
    /**
     * 
     * @type {Array<DiscoveryShowLiveStreamItem | DiscoveryShowPromotionPageItem | DiscoveryShowUpcomingShowItem>}
     * @memberof DiscoveryShowResponse
     */
    data: Array<DiscoveryShowLiveStreamItem | DiscoveryShowPromotionPageItem | DiscoveryShowUpcomingShowItem>;
}

/**
 * 
 * @export
 * @interface DiscoveryShowUpcomingShowItem
 */
export interface DiscoveryShowUpcomingShowItem {
    /**
     * 
     * @type {string}
     * @memberof DiscoveryShowUpcomingShowItem
     */
    type: DiscoveryShowUpcomingShowItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryShowUpcomingShowItem
     */
    upcomingShowId: string;
    /**
     * 
     * @type {BaseUpcomingShowItem}
     * @memberof DiscoveryShowUpcomingShowItem
     */
    upcomingShow: BaseUpcomingShowItem;
}

/**
* @export
* @enum {string}
*/
export enum DiscoveryShowUpcomingShowItemTypeEnum {
    UpcomingShow = 'upcomingShow'
}

/**
 * 
 * @export
 * @interface DiscoveryShowsByEventResponse
 */
export interface DiscoveryShowsByEventResponse {
    /**
     * 
     * @type {Array<DiscoveryShowLiveStreamItem | DiscoveryShowUpcomingShowItem>}
     * @memberof DiscoveryShowsByEventResponse
     */
    data: Array<DiscoveryShowLiveStreamItem | DiscoveryShowUpcomingShowItem>;
}

/**
 * 
 * @export
 * @interface DiscoveryStoreListingItem
 */
export interface DiscoveryStoreListingItem {
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscoveryStoreListingItem
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof DiscoveryStoreListingItem
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    defaultImage: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DiscoveryStoreListingItem
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof DiscoveryStoreListingItem
     */
    quantity: number;
    /**
     * 
     * @type {Array<StoreListingVariant>}
     * @memberof DiscoveryStoreListingItem
     */
    variants?: Array<StoreListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof DiscoveryStoreListingItem
     */
    maximumPurchaseQuantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DiscoveryStoreListingItem
     */
    shippingFee?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DiscoveryStoreListingItem
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    status?: DiscoveryStoreListingItemStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof DiscoveryStoreListingItem
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {StoreListingOriginalInfo}
     * @memberof DiscoveryStoreListingItem
     */
    originalInfo?: StoreListingOriginalInfo;
    /**
     * 
     * @type {DimsInfo}
     * @memberof DiscoveryStoreListingItem
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {SingleUnitWeightInfo | PoundWithOunceWeightInfo}
     * @memberof DiscoveryStoreListingItem
     */
    weight?: SingleUnitWeightInfo | PoundWithOunceWeightInfo;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof DiscoveryStoreListingItem
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    taxCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscoveryStoreListingItem
     */
    nontaxable?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DiscoveryStoreListingItem
     */
    soldQuantityLast7Days?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    storeCoverImage?: string;
    /**
     * 
     * @type {ListingDropshipDetailsItem}
     * @memberof DiscoveryStoreListingItem
     */
    dropshipDetails?: ListingDropshipDetailsItem;
    /**
     * 
     * @type {boolean}
     * @memberof DiscoveryStoreListingItem
     */
    useLocalPrice?: boolean;
    /**
     * 
     * @type {ListingProductCategoryItem}
     * @memberof DiscoveryStoreListingItem
     */
    category?: ListingProductCategoryItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof DiscoveryStoreListingItem
     */
    collectionIds?: Array<string>;
    /**
     * 
     * @type {ListingRatingType}
     * @memberof DiscoveryStoreListingItem
     */
    rating?: ListingRatingType;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    sizingGuideImage?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    defaultSizingGuideImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscoveryStoreListingItem
     */
    eligibleForModelMe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscoveryStoreListingItem
     */
    shopModelMe?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DiscoveryStoreListingItem
     */
    categoryIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    type?: DiscoveryStoreListingItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscoveryStoreListingItem
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    discountEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {UploadedFileItem}
     * @memberof DiscoveryStoreListingItem
     */
    uploadedFile?: UploadedFileItem;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    moderationStatus?: DiscoveryStoreListingItemModerationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    moderatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    moderatorUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    adminModerationReason?: string;
    /**
     * 
     * @type {ModeratorProfileItem}
     * @memberof DiscoveryStoreListingItem
     */
    moderatorProfile?: ModeratorProfileItem;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    externalCheckoutUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    externalBrandName?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    externalBrandImage?: string;
    /**
     * 
     * @type {ListingMeetingItem}
     * @memberof DiscoveryStoreListingItem
     */
    meeting?: ListingMeetingItem;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryStoreListingItem
     */
    sellerId: string;
}

/**
* @export
* @enum {string}
*/
export enum DiscoveryStoreListingItemStatusEnum {
    Active = 'active',
    Archived = 'archived'
}/**
* @export
* @enum {string}
*/
export enum DiscoveryStoreListingItemTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}/**
* @export
* @enum {string}
*/
export enum DiscoveryStoreListingItemModerationStatusEnum {
    Pending = 'Pending',
    Accepted = 'Accepted',
    Rejected = 'Rejected',
    ReviewRequired = 'ReviewRequired'
}

/**
 * 
 * @export
 * @interface DiscoveryUnBundleEventRow
 */
export interface DiscoveryUnBundleEventRow {
    /**
     * 
     * @type {string}
     * @memberof DiscoveryUnBundleEventRow
     */
    eventId: string;
    /**
     * 
     * @type {string}
     * @memberof DiscoveryUnBundleEventRow
     */
    eventName: string;
}

/**
 * 
 * @export
 * @interface DiscoveryUnBundleEventsResponse
 */
export interface DiscoveryUnBundleEventsResponse {
    /**
     * 
     * @type {Array<DiscoveryUnBundleEventRow>}
     * @memberof DiscoveryUnBundleEventsResponse
     */
    data: Array<DiscoveryUnBundleEventRow>;
}

/**
 * 
 * @export
 * @interface DisputeStatusHistoryItem
 */
export interface DisputeStatusHistoryItem {
    /**
     * 
     * @type {string}
     * @memberof DisputeStatusHistoryItem
     */
    disbursementDate: string;
    /**
     * 
     * @type {string}
     * @memberof DisputeStatusHistoryItem
     */
    effectiveDate: string;
    /**
     * 
     * @type {string}
     * @memberof DisputeStatusHistoryItem
     */
    status: DisputeStatusHistoryItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DisputeStatusHistoryItem
     */
    timestamp: string;
}

/**
* @export
* @enum {string}
*/
export enum DisputeStatusHistoryItemStatusEnum {
    Accepted = 'Accepted',
    Disputed = 'Disputed',
    Expired = 'Expired',
    Lost = 'Lost',
    Won = 'Won',
    Open = 'Open'
}

/**
 * 
 * @export
 * @interface DmOnlyDto
 */
export interface DmOnlyDto {
    /**
     * 
     * @type {boolean}
     * @memberof DmOnlyDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DmOnlyDto
     */
    message?: string;
    /**
     * 
     * @type {Array<PopStoreExtendedSubscriptionLevelEnumItem>}
     * @memberof DmOnlyDto
     */
    sendTo?: Array<PopStoreExtendedSubscriptionLevelEnumItem>;
}

/**
 * 
 * @export
 * @interface DmOnlyItem
 */
export interface DmOnlyItem {
    /**
     * 
     * @type {boolean}
     * @memberof DmOnlyItem
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DmOnlyItem
     */
    message?: string;
    /**
     * 
     * @type {Array<PopStoreExtendedSubscriptionLevelEnumItem>}
     * @memberof DmOnlyItem
     */
    sendTo?: Array<PopStoreExtendedSubscriptionLevelEnumItem>;
}

/**
 * 
 * @export
 * @interface DropshipAmountsItem
 */
export interface DropshipAmountsItem {
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    costAmount: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    soldAmount: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    subtotalPaidByPopshop?: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    subtotalPaidBySeller?: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    managementRate: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    managementFee: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    cumulativeListingDiscountedSubTotal: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    cumulativeBuyerPaidShippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    cumulativeBuyerPaidShippingSalesTaxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    freeShippingThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    freeShippingDiff?: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    freeShippingDiscountAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DropshipAmountsItem
     */
    qualifiedFreeShipping?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    shippingFeePaidByPopshop?: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    shippingFeePaidBySeller?: number;
    /**
     * 
     * @type {number}
     * @memberof DropshipAmountsItem
     */
    supplierWithdrawableAmount: number;
}

/**
 * 
 * @export
 * @interface DropshipSupplierItem
 */
export interface DropshipSupplierItem {
    /**
     * 
     * @type {string}
     * @memberof DropshipSupplierItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DropshipSupplierItem
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof DropshipSupplierItem
     */
    acceptReturn?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DropshipSupplierItem
     */
    freeShippingThreshold?: number;
}

/**
 * 
 * @export
 * @interface Edge
 */
export interface Edge {
    /**
     * 
     * @type {string}
     * @memberof Edge
     */
    cursor: string;
    /**
     * 
     * @type {StoreListingItem}
     * @memberof Edge
     */
    node: StoreListingItem;
}

/**
 * 
 * @export
 * @interface EditAppSellerApplicationRequest
 */
export interface EditAppSellerApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof EditAppSellerApplicationRequest
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof EditAppSellerApplicationRequest
     */
    rejectReason?: string;
    /**
     * 
     * @type {string}
     * @memberof EditAppSellerApplicationRequest
     */
    storeType?: EditAppSellerApplicationRequestStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EditAppSellerApplicationRequest
     */
    status?: EditAppSellerApplicationRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof EditAppSellerApplicationRequest
     */
    salesforceRecordId: string;
}

/**
* @export
* @enum {string}
*/
export enum EditAppSellerApplicationRequestStoreTypeEnum {
    Business = 'Business',
    Creator = 'Creator',
    CommentChat = 'CommentChat',
    Vfs = 'VFS'
}/**
* @export
* @enum {string}
*/
export enum EditAppSellerApplicationRequestStatusEnum {
    Approved = 'approved',
    Rejected = 'rejected'
}

/**
 * 
 * @export
 * @interface EditCategoryRequest
 */
export interface EditCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof EditCategoryRequest
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCategoryRequest
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCategoryRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCategoryRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCategoryRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCategoryRequest
     */
    rootCategory?: string;
    /**
     * 
     * @type {number}
     * @memberof EditCategoryRequest
     */
    sort?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EditCategoryRequest
     */
    enabled?: boolean;
}

/**
 * 
 * @export
 * @interface EditCouponByAdminDto
 */
export interface EditCouponByAdminDto {
    /**
     * 
     * @type {string}
     * @memberof EditCouponByAdminDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof EditCouponByAdminDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCouponByAdminDto
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCouponByAdminDto
     */
    pagUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCouponByAdminDto
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditCouponByAdminDto
     */
    storeIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EditCouponByAdminDto
     */
    startedAt: string;
    /**
     * 
     * @type {string}
     * @memberof EditCouponByAdminDto
     */
    expiredAt: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditCouponByAdminDto
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof EditCouponByAdminDto
     */
    minimalPurchase?: number;
    /**
     * 
     * @type {number}
     * @memberof EditCouponByAdminDto
     */
    maximumFreeShippingAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EditCouponByAdminDto
     */
    exclusive?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof EditCouponByAdminDto
     */
    excludedDropshipPartnerIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof EditCouponByAdminDto
     */
    applicableOrderType?: EditCouponByAdminDtoApplicableOrderTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof EditCouponByAdminDto
     */
    maximumDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof EditCouponByAdminDto
     */
    discountPercent?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EditCouponByAdminDto
     */
    oncePerStore?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditCouponByAdminDto
     */
    onlyPurchasedUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditCouponByAdminDto
     */
    onlyNewUserPerStore?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditCouponByAdminDto
     */
    onlyReactivatedUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditCouponByAdminDto
     */
    onlyNewUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditCouponByAdminDto
     */
    onlyFollower?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditCouponByAdminDto
     */
    onlyPopshopShipping?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditCouponByAdminDto
     */
    followSelectedSellers?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditCouponByAdminDto
     */
    sellerGroupIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof EditCouponByAdminDto
     */
    discountAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof EditCouponByAdminDto
     */
    sellerShippingPriceSubsidy?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EditCouponByAdminDto
     */
    quantityLimit?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EditCouponByAdminDto
     */
    quantity?: number;
}

/**
* @export
* @enum {string}
*/
export enum EditCouponByAdminDtoApplicableOrderTypeEnum {
    OrderGroup = 'OrderGroup',
    ChildOrder = 'ChildOrder'
}

/**
 * 
 * @export
 * @interface EditCouponBySellerDto
 */
export interface EditCouponBySellerDto {
    /**
     * 
     * @type {string}
     * @memberof EditCouponBySellerDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof EditCouponBySellerDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCouponBySellerDto
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCouponBySellerDto
     */
    pagUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof EditCouponBySellerDto
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditCouponBySellerDto
     */
    storeIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EditCouponBySellerDto
     */
    startedAt: string;
    /**
     * 
     * @type {string}
     * @memberof EditCouponBySellerDto
     */
    expiredAt: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditCouponBySellerDto
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof EditCouponBySellerDto
     */
    minimalPurchase?: number;
    /**
     * 
     * @type {number}
     * @memberof EditCouponBySellerDto
     */
    maximumFreeShippingAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EditCouponBySellerDto
     */
    exclusive?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof EditCouponBySellerDto
     */
    excludedDropshipPartnerIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof EditCouponBySellerDto
     */
    applicableOrderType?: EditCouponBySellerDtoApplicableOrderTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof EditCouponBySellerDto
     */
    maximumDiscount?: number;
    /**
     * 
     * @type {number}
     * @memberof EditCouponBySellerDto
     */
    discountPercent?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EditCouponBySellerDto
     */
    onlyAssignToUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditCouponBySellerDto
     */
    onlyNewUserPerStore?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum EditCouponBySellerDtoApplicableOrderTypeEnum {
    OrderGroup = 'OrderGroup',
    ChildOrder = 'ChildOrder'
}

/**
 * 
 * @export
 * @interface EditEventSettingTemplateRequest
 */
export interface EditEventSettingTemplateRequest {
    /**
     * 
     * @type {number}
     * @memberof EditEventSettingTemplateRequest
     */
    commissionFeeRate?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EditEventSettingTemplateRequest
     */
    salesTaxRate?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EditEventSettingTemplateRequest
     */
    shippingFee?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EditEventSettingTemplateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EditEventSettingTemplateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {object}
     * @memberof EditEventSettingTemplateRequest
     */
    parcel: object;
    /**
     * 
     * @type {string}
     * @memberof EditEventSettingTemplateRequest
     */
    shipmentProvider?: EditEventSettingTemplateRequestShipmentProviderEnum;
}

/**
* @export
* @enum {string}
*/
export enum EditEventSettingTemplateRequestShipmentProviderEnum {
    Ups = 'ups',
    Usps = 'usps',
    UspsFirst = 'usps_first'
}

/**
 * 
 * @export
 * @interface EditFeaturedTagRequest
 */
export interface EditFeaturedTagRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof EditFeaturedTagRequest
     */
    sellerTags: Array<string>;
}

/**
 * 
 * @export
 * @interface EditInvitationRequest
 */
export interface EditInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof EditInvitationRequest
     */
    code?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditInvitationRequest
     */
    sellerIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditInvitationRequest
     */
    couponCodes?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof EditInvitationRequest
     */
    enabled?: boolean;
}

/**
 * 
 * @export
 * @interface EditLinkRequest
 */
export interface EditLinkRequest {
    /**
     * 
     * @type {boolean}
     * @memberof EditLinkRequest
     */
    isActive: boolean;
}

/**
 * 
 * @export
 * @interface EditLiveStreamListingRequest
 */
export interface EditLiveStreamListingRequest {
    /**
     * 
     * @type {string}
     * @memberof EditLiveStreamListingRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof EditLiveStreamListingRequest
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof EditLiveStreamListingRequest
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof EditLiveStreamListingRequest
     */
    defaultImage: string;
    /**
     * 
     * @type {string}
     * @memberof EditLiveStreamListingRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof EditLiveStreamListingRequest
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof EditLiveStreamListingRequest
     */
    sku?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditLiveStreamListingRequest
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {Array<LiveStreamListingVariant>}
     * @memberof EditLiveStreamListingRequest
     */
    variants?: Array<LiveStreamListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof EditLiveStreamListingRequest
     */
    maximumPurchaseQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof EditLiveStreamListingRequest
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {number}
     * @memberof EditLiveStreamListingRequest
     */
    shippingFee?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditLiveStreamListingRequest
     */
    tags?: Array<string>;
    /**
     * 
     * @type {DimsInfo}
     * @memberof EditLiveStreamListingRequest
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {SingleUnitWeightInfo | PoundWithOunceWeightInfo}
     * @memberof EditLiveStreamListingRequest
     */
    weight?: SingleUnitWeightInfo | PoundWithOunceWeightInfo;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof EditLiveStreamListingRequest
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof EditLiveStreamListingRequest
     */
    categoryId?: string;
    /**
     * 
     * @type {number}
     * @memberof EditLiveStreamListingRequest
     */
    currentQuantity: number;
    /**
     * 
     * @type {Array<LiveStreamListingVariant>}
     * @memberof EditLiveStreamListingRequest
     */
    currentVariants?: Array<LiveStreamListingVariant>;
}

/**
 * 
 * @export
 * @interface EditLiveStreamRequest
 */
export interface EditLiveStreamRequest {
    /**
     * 
     * @type {string}
     * @memberof EditLiveStreamRequest
     */
    mode: string;
    /**
     * 
     * @type {string}
     * @memberof EditLiveStreamRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof EditLiveStreamRequest
     */
    background: string;
    /**
     * 
     * @type {string}
     * @memberof EditLiveStreamRequest
     */
    preview: string;
    /**
     * 
     * @type {string}
     * @memberof EditLiveStreamRequest
     */
    showEventId: string;
    /**
     * 
     * @type {string}
     * @memberof EditLiveStreamRequest
     */
    permission: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditLiveStreamRequest
     */
    shippingMode?: Array<EditLiveStreamRequestShippingModeEnum>;
    /**
     * 
     * @type {string}
     * @memberof EditLiveStreamRequest
     */
    addressId?: string;
    /**
     * 
     * @type {string}
     * @memberof EditLiveStreamRequest
     */
    accessLevel?: EditLiveStreamRequestAccessLevelEnum;
}

/**
* @export
* @enum {string}
*/
export enum EditLiveStreamRequestShippingModeEnum {
    Shipping = 'shipping',
    Pickup = 'pickup'
}/**
* @export
* @enum {string}
*/
export enum EditLiveStreamRequestAccessLevelEnum {
    All = 'all',
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface EditNewsRequest
 */
export interface EditNewsRequest {
    /**
     * 
     * @type {string}
     * @memberof EditNewsRequest
     */
    brief: string;
    /**
     * 
     * @type {boolean}
     * @memberof EditNewsRequest
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof EditNewsRequest
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof EditNewsRequest
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof EditNewsRequest
     */
    expiredAt?: string;
}

/**
 * 
 * @export
 * @interface EditPayoutRequest
 */
export interface EditPayoutRequest {
    /**
     * 
     * @type {string}
     * @memberof EditPayoutRequest
     */
    note?: string;
    /**
     * 
     * @type {number}
     * @memberof EditPayoutRequest
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof EditPayoutRequest
     */
    status: EditPayoutRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof EditPayoutRequest
     */
    payoutDate?: string;
}

/**
* @export
* @enum {string}
*/
export enum EditPayoutRequestStatusEnum {
    Pending = 'Pending',
    Processed = 'Processed',
    Completed = 'Completed',
    Failed = 'Failed'
}

/**
 * 
 * @export
 * @interface EditProductCategoryRequest
 */
export interface EditProductCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof EditProductCategoryRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EditProductCategoryRequest
     */
    slug?: string;
    /**
     * 
     * @type {number}
     * @memberof EditProductCategoryRequest
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof EditProductCategoryRequest
     */
    parentId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EditProductCategoryRequest
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditProductCategoryRequest
     */
    isRoot: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditProductCategoryRequest
     */
    custom: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditProductCategoryRequest
     */
    digital?: boolean;
}

/**
 * 
 * @export
 * @interface EditProductCollectionRequest
 */
export interface EditProductCollectionRequest {
    /**
     * 
     * @type {string}
     * @memberof EditProductCollectionRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof EditProductCollectionRequest
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof EditProductCollectionRequest
     */
    strategy: EditProductCollectionRequestStrategyEnum;
    /**
     * valid when strategy is BY_CATEGORY
     * @type {Array<string>}
     * @memberof EditProductCollectionRequest
     */
    productCategoryIds: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum EditProductCollectionRequestStrategyEnum {
    ByCategory = 'BY_CATEGORY',
    ManualSelection = 'MANUAL_SELECTION'
}

/**
 * 
 * @export
 * @interface EditSellerApplicationTemplateRequest
 */
export interface EditSellerApplicationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof EditSellerApplicationTemplateRequest
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditSellerApplicationTemplateRequest
     */
    sellerUserGroupIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EditSellerApplicationTemplateRequest
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EditSellerApplicationTemplateRequest
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof EditSellerApplicationTemplateRequest
     */
    image?: string;
}

/**
 * 
 * @export
 * @interface EditSeriesRequest
 */
export interface EditSeriesRequest {
    /**
     * 
     * @type {string}
     * @memberof EditSeriesRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EditSeriesRequest
     */
    labelFormat?: EditSeriesRequestLabelFormatEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EditSeriesRequest
     */
    showLabel?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditSeriesRequest
     */
    hasChapter?: boolean;
    /**
     * 
     * @type {SeriesChapterLabelFormatEnumItem}
     * @memberof EditSeriesRequest
     */
    chapterLabelFormat?: SeriesChapterLabelFormatEnumItem;
    /**
     * 
     * @type {number}
     * @memberof EditSeriesRequest
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof EditSeriesRequest
     */
    elementSortingStrategy?: EditSeriesRequestElementSortingStrategyEnum;
    /**
     * 
     * @type {string}
     * @memberof EditSeriesRequest
     */
    mobileBannerImage?: string;
    /**
     * 
     * @type {string}
     * @memberof EditSeriesRequest
     */
    desktopBannerImage?: string;
    /**
     * 
     * @type {Array<AddSeriesPopClipDto>}
     * @memberof EditSeriesRequest
     */
    popClips?: Array<AddSeriesPopClipDto>;
    /**
     * 
     * @type {boolean}
     * @memberof EditSeriesRequest
     */
    standaloneSale?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EditSeriesRequest
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof EditSeriesRequest
     */
    discountPrice?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EditSeriesRequest
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EditSeriesRequest
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof EditSeriesRequest
     */
    discountEndDate?: string;
    /**
     * 
     * @type {PopStoreUserAccessLevelEnumItem}
     * @memberof EditSeriesRequest
     */
    accessLevel?: PopStoreUserAccessLevelEnumItem;
    /**
     * 
     * @type {string}
     * @memberof EditSeriesRequest
     */
    description?: string;
}

/**
* @export
* @enum {string}
*/
export enum EditSeriesRequestLabelFormatEnum {
    Short = 'SHORT',
    Long = 'LONG'
}/**
* @export
* @enum {string}
*/
export enum EditSeriesRequestElementSortingStrategyEnum {
    MostRecentFirst = 'MOST_RECENT_FIRST',
    MostRecentLast = 'MOST_RECENT_LAST',
    Custom = 'CUSTOM'
}

/**
 * 
 * @export
 * @interface EditShowEventRequest
 */
export interface EditShowEventRequest {
    /**
     * 
     * @type {string}
     * @memberof EditShowEventRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EditShowEventRequest
     */
    urlCode: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditShowEventRequest
     */
    sellerUserGroupIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditShowEventRequest
     */
    userGroupIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EditShowEventRequest
     */
    previewVideoURL?: string;
    /**
     * 
     * @type {string}
     * @memberof EditShowEventRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof EditShowEventRequest
     */
    backgroundURL?: string;
    /**
     * 
     * @type {string}
     * @memberof EditShowEventRequest
     */
    verticalBackgroundURL?: string;
    /**
     * 
     * @type {number}
     * @memberof EditShowEventRequest
     */
    salesTaxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof EditShowEventRequest
     */
    maximumPurchaseQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof EditShowEventRequest
     */
    startedAfter?: string;
    /**
     * 
     * @type {string}
     * @memberof EditShowEventRequest
     */
    endedBefore?: string;
    /**
     * 
     * @type {number}
     * @memberof EditShowEventRequest
     */
    shippingFee?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EditShowEventRequest
     */
    isClosed?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditShowEventRequest
     */
    visibilityGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EditShowEventRequest
     */
    sortedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof EditShowEventRequest
     */
    extraCommissionFeeRate?: number;
    /**
     * 
     * @type {string}
     * @memberof EditShowEventRequest
     */
    featuredStoreStackName?: string;
    /**
     * 
     * @type {string}
     * @memberof EditShowEventRequest
     */
    sellerApplicationDisclosure?: string;
    /**
     * 
     * @type {string}
     * @memberof EditShowEventRequest
     */
    sellerApplicationDisclosureUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EditShowEventRequest
     */
    unBundleOnDiscovery?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditShowEventRequest
     */
    visibilityOnDiscoveryBanner?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditShowEventRequest
     */
    customLightingBoltImages?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof EditShowEventRequest
     */
    parcel: object;
    /**
     * 
     * @type {string}
     * @memberof EditShowEventRequest
     */
    shipmentProvider?: EditShowEventRequestShipmentProviderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EditShowEventRequest
     */
    visibleOnCategoryBanner?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EditShowEventRequest
     */
    categoryCoverUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EditShowEventRequest
     */
    active?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum EditShowEventRequestShipmentProviderEnum {
    Ups = 'ups',
    Usps = 'usps',
    UspsFirst = 'usps_first'
}

/**
 * 
 * @export
 * @interface EditShowEventResponse
 */
export interface EditShowEventResponse {
    /**
     * 
     * @type {string}
     * @memberof EditShowEventResponse
     */
    id: string;
}

/**
 * 
 * @export
 * @interface EditShowTicketRequest
 */
export interface EditShowTicketRequest {
    /**
     * 
     * @type {string}
     * @memberof EditShowTicketRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EditShowTicketRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof EditShowTicketRequest
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof EditShowTicketRequest
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof EditShowTicketRequest
     */
    sku?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditShowTicketRequest
     */
    userGroupIds: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof EditShowTicketRequest
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof EditShowTicketRequest
     */
    maximumPurchaseQuantity?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EditShowTicketRequest
     */
    upgradeTicket?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof EditShowTicketRequest
     */
    fromTicketId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditShowTicketRequest
     */
    toTicketId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditShowTicketRequest
     */
    emailConfirmationDisclosure?: string;
    /**
     * 
     * @type {string}
     * @memberof EditShowTicketRequest
     */
    emailConfirmationDisclosureUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof EditShowTicketRequest
     */
    emailConfirmationHeaderBackgroundUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EditShowTicketRequest
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditShowTicketRequest
     */
    requireShipping?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EditShowTicketRequest
     */
    shippingFee?: number;
    /**
     * 
     * @type {string}
     * @memberof EditShowTicketRequest
     */
    defaultImage?: string;
    /**
     * 
     * @type {string}
     * @memberof EditShowTicketRequest
     */
    sortedAt?: string;
}

/**
 * 
 * @export
 * @interface EditStoreListingRequest
 */
export interface EditStoreListingRequest {
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof EditStoreListingRequest
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof EditStoreListingRequest
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    defaultImage: string;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof EditStoreListingRequest
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    sku?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditStoreListingRequest
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {Array<StoreControllerStoreListingVariant>}
     * @memberof EditStoreListingRequest
     */
    variants?: Array<StoreControllerStoreListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof EditStoreListingRequest
     */
    maximumPurchaseQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof EditStoreListingRequest
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {number}
     * @memberof EditStoreListingRequest
     */
    shippingFee?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditStoreListingRequest
     */
    tags?: Array<string>;
    /**
     * 
     * @type {StoreListingOriginalInfo}
     * @memberof EditStoreListingRequest
     */
    originalInfo?: StoreListingOriginalInfo;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    externalId?: string;
    /**
     * 
     * @type {DimsInfo}
     * @memberof EditStoreListingRequest
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {SingleUnitWeightInfo | PoundWithOunceWeightInfo}
     * @memberof EditStoreListingRequest
     */
    weight?: SingleUnitWeightInfo | PoundWithOunceWeightInfo;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof EditStoreListingRequest
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    taxCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EditStoreListingRequest
     */
    nontaxable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditStoreListingRequest
     */
    useLocalPrice?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    sizingGuideImage?: string;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EditStoreListingRequest
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    discountEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {UploadedFileDto}
     * @memberof EditStoreListingRequest
     */
    uploadedFile?: UploadedFileDto;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    externalCheckoutUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    externalBrandName?: string;
    /**
     * 
     * @type {string}
     * @memberof EditStoreListingRequest
     */
    externalBrandImage?: string;
    /**
     * 
     * @type {ListingMeetingDto}
     * @memberof EditStoreListingRequest
     */
    meeting?: ListingMeetingDto;
    /**
     * 
     * @type {number}
     * @memberof EditStoreListingRequest
     */
    currentQuantity: number;
    /**
     * 
     * @type {Array<StoreControllerStoreListingVariant>}
     * @memberof EditStoreListingRequest
     */
    currentVariants?: Array<StoreControllerStoreListingVariant>;
}

/**
 * 
 * @export
 * @interface EditStripePayoutMethodResponse
 */
export interface EditStripePayoutMethodResponse {
    /**
     * 
     * @type {boolean}
     * @memberof EditStripePayoutMethodResponse
     */
    canWithdraw: boolean;
    /**
     * it means status is approved or reject.
     * @type {boolean}
     * @memberof EditStripePayoutMethodResponse
     */
    hasCompleteApply: boolean;
    /**
     * it means status is pending. can not withdraw.
     * @type {boolean}
     * @memberof EditStripePayoutMethodResponse
     */
    hasPendingApply: boolean;
    /**
     * it means whether the last request is within 24 hours. if hasCompleteApply && isInLimitHours && !firstCreate, can not withdraw 
     * @type {boolean}
     * @memberof EditStripePayoutMethodResponse
     */
    isInLimitHours?: boolean;
    /**
     * no status means seller never submits update request
     * @type {string}
     * @memberof EditStripePayoutMethodResponse
     */
    status?: EditStripePayoutMethodResponseStatusEnum;
    /**
     * first create payout method can be withdraw
     * @type {boolean}
     * @memberof EditStripePayoutMethodResponse
     */
    firstCreate?: boolean;
    /**
     * The last four digits of latest update bank account number when status is pending
     * @type {string}
     * @memberof EditStripePayoutMethodResponse
     */
    latestAccountNumber?: string;
}

/**
* @export
* @enum {string}
*/
export enum EditStripePayoutMethodResponseStatusEnum {
    Approved = 'approved',
    Pending = 'pending',
    Rejected = 'rejected',
    Canceled = 'canceled'
}

/**
 * 
 * @export
 * @interface EnsureAddressResponse
 */
export interface EnsureAddressResponse {
    /**
     * 
     * @type {boolean}
     * @memberof EnsureAddressResponse
     */
    haveAddress: boolean;
}

/**
 * 
 * @export
 * @interface EnsureStripeAccountResponse
 */
export interface EnsureStripeAccountResponse {
    /**
     * 
     * @type {string}
     * @memberof EnsureStripeAccountResponse
     */
    accountId: string;
    /**
     * 
     * @type {string}
     * @memberof EnsureStripeAccountResponse
     */
    billingCountry: string;
    /**
     * 
     * @type {boolean}
     * @memberof EnsureStripeAccountResponse
     */
    onBehalfOfChargeModeEnabled: boolean;
}

/**
 * 
 * @export
 * @interface EnterRoomParam
 */
export interface EnterRoomParam {
    /**
     * 
     * @type {string}
     * @memberof EnterRoomParam
     */
    targetUserId: string;
}

/**
 * 
 * @export
 * @interface EventFeaturedShowItem
 */
export interface EventFeaturedShowItem {
    /**
     * 
     * @type {string}
     * @memberof EventFeaturedShowItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EventFeaturedShowItem
     */
    sortedAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof EventFeaturedShowItem
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EventFeaturedShowItem
     */
    isLive?: boolean;
    /**
     * 
     * @type {BaseShowEventWithMetadataItem}
     * @memberof EventFeaturedShowItem
     */
    event: BaseShowEventWithMetadataItem;
}

/**
 * 
 * @export
 * @interface EvergreenVideoItem
 */
export interface EvergreenVideoItem {
    /**
     * 
     * @type {string}
     * @memberof EvergreenVideoItem
     */
    videoURL: string;
    /**
     * 
     * @type {string}
     * @memberof EvergreenVideoItem
     */
    previewImageURL: string;
    /**
     * 
     * @type {VideoResolution}
     * @memberof EvergreenVideoItem
     */
    size: VideoResolution;
}

/**
 * 
 * @export
 * @interface EvidenceItem
 */
export interface EvidenceItem {
    /**
     * 
     * @type {string}
     * @memberof EvidenceItem
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceItem
     */
    sendToProcessorAt: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceItem
     */
    url?: string;
}

/**
 * 
 * @export
 * @interface ExecuteActionRequest
 */
export interface ExecuteActionRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecuteActionRequest
     */
    userAgent?: string;
}

/**
 * 
 * @export
 * @interface ExecuteClaimActionRequest
 */
export interface ExecuteClaimActionRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecuteClaimActionRequest
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof ExecuteClaimActionRequest
     */
    userAgent?: string;
}

/**
 * 
 * @export
 * @interface ExportLiveStreamUserStatsParams
 */
export interface ExportLiveStreamUserStatsParams {
    /**
     * 
     * @type {string}
     * @memberof ExportLiveStreamUserStatsParams
     */
    order?: ExportLiveStreamUserStatsParamsOrderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ExportLiveStreamUserStatsParams
     */
    isFollower?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ExportLiveStreamUserStatsParams
     */
    isNewFollower?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ExportLiveStreamUserStatsParams
     */
    isNewSellerCustomer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ExportLiveStreamUserStatsParams
     */
    isRepeatSellerCustomer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ExportLiveStreamUserStatsParams
     */
    isNewSellerViewer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ExportLiveStreamUserStatsParams
     */
    isRepeatSellerViewer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ExportLiveStreamUserStatsParams
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExportLiveStreamUserStatsParams
     */
    userGroupId?: string;
    /**
     * 
     * @type {SearchLiveStreamUserStatsRangeFilter}
     * @memberof ExportLiveStreamUserStatsParams
     */
    range?: SearchLiveStreamUserStatsRangeFilter;
    /**
     * 
     * @type {string}
     * @memberof ExportLiveStreamUserStatsParams
     */
    query?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportLiveStreamUserStatsParams
     */
    sortBy?: ExportLiveStreamUserStatsParamsSortByEnum;
}

/**
* @export
* @enum {string}
*/
export enum ExportLiveStreamUserStatsParamsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}/**
* @export
* @enum {string}
*/
export enum ExportLiveStreamUserStatsParamsSortByEnum {
    Gmv = 'gmv',
    WatchedSec = 'watched_sec',
    LikeCnt = 'like_cnt',
    CommentCnt = 'comment_cnt',
    ItemCnt = 'item_cnt',
    ShareCnt = 'share_cnt',
    Gtv = 'gtv',
    Id = 'id'
}

/**
 * 
 * @export
 * @interface ExposureSellerStatsItem
 */
export interface ExposureSellerStatsItem {
    /**
     * 
     * @type {number}
     * @memberof ExposureSellerStatsItem
     */
    showCount: number;
    /**
     * 
     * @type {number}
     * @memberof ExposureSellerStatsItem
     */
    gt750sShowCount: number;
    /**
     * 
     * @type {number}
     * @memberof ExposureSellerStatsItem
     */
    durationSecond: number;
    /**
     * 
     * @type {number}
     * @memberof ExposureSellerStatsItem
     */
    commentCount: number;
    /**
     * 
     * @type {number}
     * @memberof ExposureSellerStatsItem
     */
    shareCount: number;
    /**
     * 
     * @type {number}
     * @memberof ExposureSellerStatsItem
     */
    likeCount: number;
    /**
     * 
     * @type {number}
     * @memberof ExposureSellerStatsItem
     */
    viewerCount: number;
    /**
     * 
     * @type {number}
     * @memberof ExposureSellerStatsItem
     */
    purchaseCount: number;
    /**
     * 
     * @type {number}
     * @memberof ExposureSellerStatsItem
     */
    mainOrderCount: number;
    /**
     * 
     * @type {number}
     * @memberof ExposureSellerStatsItem
     */
    customerOrderCount: number;
    /**
     * 
     * @type {number}
     * @memberof ExposureSellerStatsItem
     */
    masterOrderCount: number;
    /**
     * 
     * @type {number}
     * @memberof ExposureSellerStatsItem
     */
    revenue: number;
    /**
     * 
     * @type {number}
     * @memberof ExposureSellerStatsItem
     */
    netRevenue: number;
    /**
     * 
     * @type {number}
     * @memberof ExposureSellerStatsItem
     */
    referralCount: number;
    /**
     * 
     * @type {number}
     * @memberof ExposureSellerStatsItem
     */
    followerCount: number;
    /**
     * 
     * @type {string}
     * @memberof ExposureSellerStatsItem
     */
    durationFormatted: string;
    /**
     * 
     * @type {number}
     * @memberof ExposureSellerStatsItem
     */
    normalViewerWatchedSecond: number;
    /**
     * 
     * @type {string}
     * @memberof ExposureSellerStatsItem
     */
    normalViewerWatchedFormatted: string;
    /**
     * 
     * @type {number}
     * @memberof ExposureSellerStatsItem
     */
    sellerViewerWatchedSecond: number;
    /**
     * 
     * @type {string}
     * @memberof ExposureSellerStatsItem
     */
    sellerViewerWatchedFormatted: string;
    /**
     * 
     * @type {string}
     * @memberof ExposureSellerStatsItem
     */
    lastSellerDashboardUsedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ExposureSellerStatsItem
     */
    gmv: number;
}

/**
 * 
 * @export
 * @interface FacebookAuthResponseItem
 */
export interface FacebookAuthResponseItem {
    /**
     * 
     * @type {string}
     * @memberof FacebookAuthResponseItem
     */
    accessToken?: string;
    /**
     * 
     * @type {number}
     * @memberof FacebookAuthResponseItem
     */
    data_access_expiration_time?: number;
    /**
     * 
     * @type {number}
     * @memberof FacebookAuthResponseItem
     */
    expiresIn: number;
    /**
     * 
     * @type {string}
     * @memberof FacebookAuthResponseItem
     */
    signedRequest?: string;
    /**
     * 
     * @type {string}
     * @memberof FacebookAuthResponseItem
     */
    userID: string;
    /**
     * 
     * @type {string}
     * @memberof FacebookAuthResponseItem
     */
    grantedScopes?: string;
    /**
     * 
     * @type {number}
     * @memberof FacebookAuthResponseItem
     */
    reauthorize_required_in?: number;
    /**
     * 
     * @type {string}
     * @memberof FacebookAuthResponseItem
     */
    code?: string;
}

/**
 * 
 * @export
 * @interface FailedOrder
 */
export interface FailedOrder {
    /**
     * 
     * @type {string}
     * @memberof FailedOrder
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof FailedOrder
     */
    message: string;
}

/**
 * 
 * @export
 * @interface FeaturedShowItem
 */
export interface FeaturedShowItem {
    /**
     * 
     * @type {string}
     * @memberof FeaturedShowItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedShowItem
     */
    sortedAt: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedShowItem
     */
    type: string;
    /**
     * 
     * @type {boolean}
     * @memberof FeaturedShowItem
     */
    active: boolean;
    /**
     * 
     * @type {BaseUpcomingShowItem}
     * @memberof FeaturedShowItem
     */
    upcomingShow?: BaseUpcomingShowItem;
    /**
     * 
     * @type {LiveStreamItem}
     * @memberof FeaturedShowItem
     */
    liveStream?: LiveStreamItem;
    /**
     * 
     * @type {string}
     * @memberof FeaturedShowItem
     */
    featuredEvent?: FeaturedShowItemFeaturedEventEnum;
}

/**
* @export
* @enum {string}
*/
export enum FeaturedShowItemFeaturedEventEnum {
    AutoFeaturedStoreShow = 'autoFeaturedStoreShow'
}

/**
 * 
 * @export
 * @interface FeaturedShowPageRows
 */
export interface FeaturedShowPageRows {
    /**
     * 
     * @type {Array<FeaturedShowItem>}
     * @memberof FeaturedShowPageRows
     */
    rows: Array<FeaturedShowItem>;
}

/**
 * 
 * @export
 * @interface FeaturedShowSearchResponse
 */
export interface FeaturedShowSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof FeaturedShowSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof FeaturedShowSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {FeaturedShowPageRows}
     * @memberof FeaturedShowSearchResponse
     */
    data: FeaturedShowPageRows;
}

/**
 * 
 * @export
 * @interface FeaturedStoreItemWithId
 */
export interface FeaturedStoreItemWithId {
    /**
     * 
     * @type {string}
     * @memberof FeaturedStoreItemWithId
     */
    userId: string;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStoreItemWithId
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStoreItemWithId
     */
    sortedAt?: string;
    /**
     * 
     * @type {StoreFrontItem}
     * @memberof FeaturedStoreItemWithId
     */
    store: StoreFrontItem;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStoreItemWithId
     */
    id: string;
}

/**
 * 
 * @export
 * @interface FeaturedStorePublicListingItem
 */
export interface FeaturedStorePublicListingItem {
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStorePublicListingItem
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStorePublicListingItem
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    defaultImage: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FeaturedStorePublicListingItem
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStorePublicListingItem
     */
    quantity: number;
    /**
     * 
     * @type {Array<StoreListingVariant>}
     * @memberof FeaturedStorePublicListingItem
     */
    variants?: Array<StoreListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStorePublicListingItem
     */
    maximumPurchaseQuantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStorePublicListingItem
     */
    shippingFee?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FeaturedStorePublicListingItem
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    status?: FeaturedStorePublicListingItemStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStorePublicListingItem
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {StoreListingOriginalInfo}
     * @memberof FeaturedStorePublicListingItem
     */
    originalInfo?: StoreListingOriginalInfo;
    /**
     * 
     * @type {DimsInfo}
     * @memberof FeaturedStorePublicListingItem
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {SingleUnitWeightInfo | PoundWithOunceWeightInfo}
     * @memberof FeaturedStorePublicListingItem
     */
    weight?: SingleUnitWeightInfo | PoundWithOunceWeightInfo;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof FeaturedStorePublicListingItem
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    taxCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FeaturedStorePublicListingItem
     */
    nontaxable?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FeaturedStorePublicListingItem
     */
    soldQuantityLast7Days?: number;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    storeCoverImage?: string;
    /**
     * 
     * @type {ListingDropshipDetailsItem}
     * @memberof FeaturedStorePublicListingItem
     */
    dropshipDetails?: ListingDropshipDetailsItem;
    /**
     * 
     * @type {boolean}
     * @memberof FeaturedStorePublicListingItem
     */
    useLocalPrice?: boolean;
    /**
     * 
     * @type {ListingProductCategoryItem}
     * @memberof FeaturedStorePublicListingItem
     */
    category?: ListingProductCategoryItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof FeaturedStorePublicListingItem
     */
    collectionIds?: Array<string>;
    /**
     * 
     * @type {ListingRatingType}
     * @memberof FeaturedStorePublicListingItem
     */
    rating?: ListingRatingType;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    sizingGuideImage?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    defaultSizingGuideImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FeaturedStorePublicListingItem
     */
    eligibleForModelMe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeaturedStorePublicListingItem
     */
    shopModelMe?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FeaturedStorePublicListingItem
     */
    categoryIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    type?: FeaturedStorePublicListingItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FeaturedStorePublicListingItem
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    discountEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {UploadedFileItem}
     * @memberof FeaturedStorePublicListingItem
     */
    uploadedFile?: UploadedFileItem;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    moderationStatus?: FeaturedStorePublicListingItemModerationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    moderatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    moderatorUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    adminModerationReason?: string;
    /**
     * 
     * @type {ModeratorProfileItem}
     * @memberof FeaturedStorePublicListingItem
     */
    moderatorProfile?: ModeratorProfileItem;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    externalCheckoutUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    externalBrandName?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    externalBrandImage?: string;
    /**
     * 
     * @type {ListingMeetingItem}
     * @memberof FeaturedStorePublicListingItem
     */
    meeting?: ListingMeetingItem;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStorePublicListingItem
     */
    id: string;
    /**
     * 
     * @type {Metadata}
     * @memberof FeaturedStorePublicListingItem
     */
    metadata: Metadata;
    /**
     * 
     * @type {Relations}
     * @memberof FeaturedStorePublicListingItem
     */
    relations: Relations;
    /**
     * only available when searching top products
     * @type {boolean}
     * @memberof FeaturedStorePublicListingItem
     */
    featured?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum FeaturedStorePublicListingItemStatusEnum {
    Active = 'active',
    Archived = 'archived'
}/**
* @export
* @enum {string}
*/
export enum FeaturedStorePublicListingItemTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}/**
* @export
* @enum {string}
*/
export enum FeaturedStorePublicListingItemModerationStatusEnum {
    Pending = 'Pending',
    Accepted = 'Accepted',
    Rejected = 'Rejected',
    ReviewRequired = 'ReviewRequired'
}

/**
 * 
 * @export
 * @interface FeaturedStorePublicListingPageRows
 */
export interface FeaturedStorePublicListingPageRows {
    /**
     * 
     * @type {Array<FeaturedStorePublicListingItem>}
     * @memberof FeaturedStorePublicListingPageRows
     */
    rows: Array<FeaturedStorePublicListingItem>;
}

/**
 * 
 * @export
 * @interface FeaturedStorePublicListingSearchResponse
 */
export interface FeaturedStorePublicListingSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof FeaturedStorePublicListingSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof FeaturedStorePublicListingSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {FeaturedStorePublicListingPageRows}
     * @memberof FeaturedStorePublicListingSearchResponse
     */
    data: FeaturedStorePublicListingPageRows;
}

/**
 * 
 * @export
 * @interface FeaturedStoreRequestDto
 */
export interface FeaturedStoreRequestDto {
    /**
     * 
     * @type {string}
     * @memberof FeaturedStoreRequestDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStoreRequestDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedStoreRequestDto
     */
    sortedAt: string;
}

/**
 * 
 * @export
 * @interface FeaturedStoresPageRows
 */
export interface FeaturedStoresPageRows {
    /**
     * 
     * @type {Array<FeaturedStoreItemWithId>}
     * @memberof FeaturedStoresPageRows
     */
    rows: Array<FeaturedStoreItemWithId>;
}

/**
 * 
 * @export
 * @interface FeaturedStoresSearchResponse
 */
export interface FeaturedStoresSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof FeaturedStoresSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof FeaturedStoresSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {FeaturedStoresPageRows}
     * @memberof FeaturedStoresSearchResponse
     */
    data: FeaturedStoresPageRows;
}

/**
 * 
 * @export
 * @interface FeaturedTagOrder
 */
export interface FeaturedTagOrder {
    /**
     * 
     * @type {string}
     * @memberof FeaturedTagOrder
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedTagOrder
     */
    sortedAt: string;
}

/**
 * 
 * @export
 * @interface FeedAuthor
 */
export interface FeedAuthor {
    /**
     * 
     * @type {string}
     * @memberof FeedAuthor
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof FeedAuthor
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedAuthor
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedAuthor
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof FeedAuthor
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof FeedAuthor
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedAuthor
     */
    userType?: FeedAuthorUserTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FeedAuthor
     */
    storeType?: FeedAuthorStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FeedAuthor
     */
    urlCode?: string;
}

/**
* @export
* @enum {string}
*/
export enum FeedAuthorUserTypeEnum {
    Guest = 'guest',
    Normal = 'normal',
    Seller = 'seller',
    VerifiedSeller = 'verifiedSeller'
}/**
* @export
* @enum {string}
*/
export enum FeedAuthorStoreTypeEnum {
    Business = 'Business',
    Creator = 'Creator',
    CommentChat = 'CommentChat',
    Vfs = 'VFS'
}

/**
 * 
 * @export
 * @interface FeedItem
 */
export interface FeedItem {
    /**
     * 
     * @type {string}
     * @memberof FeedItem
     */
    feedType: FeedItemFeedTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FeedItem
     */
    feedId: string;
    /**
     * 
     * @type {string}
     * @memberof FeedItem
     */
    feedCreatedAt: string;
    /**
     * 
     * @type {number}
     * @memberof FeedItem
     */
    sortValue: number;
    /**
     * 
     * @type {FeedStore}
     * @memberof FeedItem
     */
    store: FeedStore;
    /**
     * 
     * @type {FeedAuthor}
     * @memberof FeedItem
     */
    author?: FeedAuthor;
    /**
     * Available if feedType is LIVE or REPLAY
     * @type {LiveStreamFeedItem}
     * @memberof FeedItem
     */
    liveStream?: LiveStreamFeedItem;
    /**
     * Available if feedType is PREVIEW
     * @type {UpcomingShowFeedItem}
     * @memberof FeedItem
     */
    upcomingShow?: UpcomingShowFeedItem;
    /**
     * Available if feedType is REVIEW
     * @type {ReviewFeedItem}
     * @memberof FeedItem
     */
    review?: ReviewFeedItem;
    /**
     * Available if feedType is POP_CLIP
     * @type {PopClipFeedItem}
     * @memberof FeedItem
     */
    popClip?: PopClipFeedItem;
    /**
     * 
     * @type {number}
     * @memberof FeedItem
     */
    upvoteCount?: number;
}

/**
* @export
* @enum {string}
*/
export enum FeedItemFeedTypeEnum {
    Live = 'LIVE',
    Replay = 'REPLAY',
    Preview = 'PREVIEW',
    Review = 'REVIEW',
    PopClip = 'POP_CLIP'
}

/**
 * 
 * @export
 * @interface FeedModelMeImageRequest
 */
export interface FeedModelMeImageRequest {
    /**
     * 
     * @type {number}
     * @memberof FeedModelMeImageRequest
     */
    rating: FeedModelMeImageRequestRatingEnum;
    /**
     * 
     * @type {string}
     * @memberof FeedModelMeImageRequest
     */
    note?: string;
}

/**
* @export
* @enum {string}
*/
export enum FeedModelMeImageRequestRatingEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5
}

/**
 * 
 * @export
 * @interface FeedStore
 */
export interface FeedStore {
    /**
     * 
     * @type {string}
     * @memberof FeedStore
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof FeedStore
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FeedStore
     */
    defaultCoverImage?: string;
}

/**
 * 
 * @export
 * @interface FeedsResponse
 */
export interface FeedsResponse {
    /**
     * 
     * @type {Array<FeedItem>}
     * @memberof FeedsResponse
     */
    feeds: Array<FeedItem>;
    /**
     * 
     * @type {string}
     * @memberof FeedsResponse
     */
    nextCursor?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedsResponse
     */
    sessionId: string;
}

/**
 * 
 * @export
 * @interface FetchCFVideoResponse
 */
export interface FetchCFVideoResponse {
    /**
     * 
     * @type {FetchCFVideoResult}
     * @memberof FetchCFVideoResponse
     */
    result: FetchCFVideoResult;
}

/**
 * 
 * @export
 * @interface FetchCFVideoResult
 */
export interface FetchCFVideoResult {
    /**
     * 
     * @type {string}
     * @memberof FetchCFVideoResult
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof FetchCFVideoResult
     */
    preview: string;
    /**
     * 
     * @type {string}
     * @memberof FetchCFVideoResult
     */
    thumbnail: string;
    /**
     * 
     * @type {string}
     * @memberof FetchCFVideoResult
     */
    created: string;
    /**
     * 
     * @type {number}
     * @memberof FetchCFVideoResult
     */
    size: number;
    /**
     * 
     * @type {Playback}
     * @memberof FetchCFVideoResult
     */
    playback: Playback;
    /**
     * 
     * @type {boolean}
     * @memberof FetchCFVideoResult
     */
    readyToStream: boolean;
}

/**
 * 
 * @export
 * @interface FetchUserSubscriptionLevelRequest
 */
export interface FetchUserSubscriptionLevelRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof FetchUserSubscriptionLevelRequest
     */
    userIds: Array<string>;
}

/**
 * 
 * @export
 * @interface FetchUserSubscriptionLevelResponse
 */
export interface FetchUserSubscriptionLevelResponse {
    /**
     * 
     * @type {string}
     * @memberof FetchUserSubscriptionLevelResponse
     */
    userId: string;
    /**
     * null if not subscribed
     * @type {number}
     * @memberof FetchUserSubscriptionLevelResponse
     */
    levelId?: number;
}

/**
 * 
 * @export
 * @interface FormW9RequestGetResponse
 */
export interface FormW9RequestGetResponse {
    /**
     * 
     * @type {SellerFormW9DTO}
     * @memberof FormW9RequestGetResponse
     */
    data?: SellerFormW9DTO | null;
}

/**
 * 
 * @export
 * @interface FormW9RequestResponse
 */
export interface FormW9RequestResponse {
    /**
     * 
     * @type {string}
     * @memberof FormW9RequestResponse
     */
    url: string;
}

/**
 * 
 * @export
 * @interface FormW9StatusResponse
 */
export interface FormW9StatusResponse {
    /**
     * 
     * @type {string}
     * @memberof FormW9StatusResponse
     */
    status: FormW9StatusResponseStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum FormW9StatusResponseStatusEnum {
    NotStart = 'NotStart',
    Pending = 'Pending',
    Completed = 'Completed',
    Expired = 'Expired'
}

/**
 * 
 * @export
 * @interface FormW9TinMatchByAdminRequest
 */
export interface FormW9TinMatchByAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof FormW9TinMatchByAdminRequest
     */
    sellerId: string;
}

/**
 * 
 * @export
 * @interface FulfillmentExtraSetting
 */
export interface FulfillmentExtraSetting {
    /**
     * 
     * @type {string}
     * @memberof FulfillmentExtraSetting
     */
    signatureConfirmation?: FulfillmentExtraSettingSignatureConfirmationEnum;
}

/**
* @export
* @enum {string}
*/
export enum FulfillmentExtraSettingSignatureConfirmationEnum {
    Standard = 'STANDARD',
    Adult = 'ADULT',
    Certified = 'CERTIFIED'
}

/**
 * 
 * @export
 * @interface GenerateCommentSoldShopLinkRequest
 */
export interface GenerateCommentSoldShopLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof GenerateCommentSoldShopLinkRequest
     */
    linkType: GenerateCommentSoldShopLinkRequestLinkTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GenerateCommentSoldShopLinkRequest
     */
    proxy?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum GenerateCommentSoldShopLinkRequestLinkTypeEnum {
    OrderList = 'ORDER_LIST',
    ProductList = 'PRODUCT_LIST',
    ProductAdd = 'PRODUCT_ADD',
    DropshipCatalog = 'DROPSHIP_CATALOG'
}

/**
 * 
 * @export
 * @interface GenerateCommentSoldShopLinkResponse
 */
export interface GenerateCommentSoldShopLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof GenerateCommentSoldShopLinkResponse
     */
    link: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateCommentSoldShopLinkResponse
     */
    linkType: GenerateCommentSoldShopLinkResponseLinkTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GenerateCommentSoldShopLinkResponse
     */
    token: string;
}

/**
* @export
* @enum {string}
*/
export enum GenerateCommentSoldShopLinkResponseLinkTypeEnum {
    OrderList = 'ORDER_LIST',
    ProductList = 'PRODUCT_LIST',
    ProductAdd = 'PRODUCT_ADD',
    DropshipCatalog = 'DROPSHIP_CATALOG'
}

/**
 * 
 * @export
 * @interface GenerateCoverImageRequest
 */
export interface GenerateCoverImageRequest {
    /**
     * 
     * @type {string}
     * @memberof GenerateCoverImageRequest
     */
    coverImage: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateCoverImageRequest
     */
    colorImage: string;
}

/**
 * 
 * @export
 * @interface GenerateCustomTokenRequest
 */
export interface GenerateCustomTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof GenerateCustomTokenRequest
     */
    uuid: string;
}

/**
 * 
 * @export
 * @interface GenerateLabelRequest
 */
export interface GenerateLabelRequest {
    /**
     * 
     * @type {string}
     * @memberof GenerateLabelRequest
     */
    templateId?: string;
    /**
     * 
     * @type {number}
     * @memberof GenerateLabelRequest
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof GenerateLabelRequest
     */
    height: number;
    /**
     * 
     * @type {number}
     * @memberof GenerateLabelRequest
     */
    depth: number;
    /**
     * 
     * @type {string}
     * @memberof GenerateLabelRequest
     */
    distanceUnit: GenerateLabelRequestDistanceUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof GenerateLabelRequest
     */
    weight: number;
    /**
     * 
     * @type {string}
     * @memberof GenerateLabelRequest
     */
    massUnit: GenerateLabelRequestMassUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof GenerateLabelRequest
     */
    shipmentId: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateLabelRequest
     */
    rateId: string;
    /**
     * 
     * @type {FulfillmentExtraSetting}
     * @memberof GenerateLabelRequest
     */
    extra?: FulfillmentExtraSetting;
}

/**
* @export
* @enum {string}
*/
export enum GenerateLabelRequestDistanceUnitEnum {
    Cm = 'cm',
    In = 'in',
    Ft = 'ft',
    M = 'm',
    Mm = 'mm',
    Yd = 'yd'
}/**
* @export
* @enum {string}
*/
export enum GenerateLabelRequestMassUnitEnum {
    G = 'g',
    Kg = 'kg',
    Lb = 'lb',
    Oz = 'oz'
}

/**
 * 
 * @export
 * @interface GenerateTokenRequest
 */
export interface GenerateTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof GenerateTokenRequest
     */
    deviceId: string;
    /**
     * used by host only
     * @type {boolean}
     * @memberof GenerateTokenRequest
     */
    publish?: boolean;
}

/**
 * 
 * @export
 * @interface GetAccessResponse
 */
export interface GetAccessResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetAccessResponse
     */
    access: boolean;
}

/**
 * 
 * @export
 * @interface GetAccountStatusResponse
 */
export interface GetAccountStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAccountStatusResponse
     */
    status?: string;
}

/**
 * 
 * @export
 * @interface GetAllParcelTemplatesByShippoCarrierPaResponse
 */
export interface GetAllParcelTemplatesByShippoCarrierPaResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAllParcelTemplatesByShippoCarrierPaResponse
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetAllParcelTemplatesByShippoCarrierPaResponse
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof GetAllParcelTemplatesByShippoCarrierPaResponse
     */
    type: GetAllParcelTemplatesByShippoCarrierPaResponseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetAllParcelTemplatesByShippoCarrierPaResponse
     */
    token: GetAllParcelTemplatesByShippoCarrierPaResponseTokenEnum;
    /**
     * 
     * @type {string}
     * @memberof GetAllParcelTemplatesByShippoCarrierPaResponse
     */
    name: GetAllParcelTemplatesByShippoCarrierPaResponseNameEnum;
    /**
     * 
     * @type {string}
     * @memberof GetAllParcelTemplatesByShippoCarrierPaResponse
     */
    alias: string;
    /**
     * 
     * @type {number}
     * @memberof GetAllParcelTemplatesByShippoCarrierPaResponse
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllParcelTemplatesByShippoCarrierPaResponse
     */
    height: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllParcelTemplatesByShippoCarrierPaResponse
     */
    depth: number;
    /**
     * 
     * @type {string}
     * @memberof GetAllParcelTemplatesByShippoCarrierPaResponse
     */
    distanceUnit: GetAllParcelTemplatesByShippoCarrierPaResponseDistanceUnitEnum;
}

/**
* @export
* @enum {string}
*/
export enum GetAllParcelTemplatesByShippoCarrierPaResponseTypeEnum {
    Custom = 'CUSTOM',
    ShippoCarrierParcelTemplate = 'SHIPPO_CARRIER_PARCEL_TEMPLATE'
}/**
* @export
* @enum {string}
*/
export enum GetAllParcelTemplatesByShippoCarrierPaResponseTokenEnum {
    RegionalRateBoxB1 = 'USPS_RegionalRateBoxB1',
    RegionalRateBoxB2 = 'USPS_RegionalRateBoxB2',
    IrregularParcel = 'USPS_IrregularParcel',
    Card = 'USPS_Card',
    FlatRateCardboardEnvelope = 'USPS_FlatRateCardboardEnvelope',
    FlatRateLegalEnvelope = 'USPS_FlatRateLegalEnvelope',
    FlatRateEnvelope = 'USPS_FlatRateEnvelope',
    FlatRateGiftCardEnvelope = 'USPS_FlatRateGiftCardEnvelope',
    LargeVideoFlatRateBox = 'USPS_LargeVideoFlatRateBox',
    LargeFlatRateBoardGameBox = 'USPS_LargeFlatRateBoardGameBox',
    SmallFlatRateEnvelope = 'USPS_SmallFlatRateEnvelope',
    SoftPack = 'USPS_SoftPack',
    LargeFlatRateBox = 'USPS_LargeFlatRateBox',
    MediumFlatRateBox1 = 'USPS_MediumFlatRateBox1',
    MediumFlatRateBox2 = 'USPS_MediumFlatRateBox2',
    SmallFlatRateBox = 'USPS_SmallFlatRateBox',
    RegionalRateBoxA1 = 'USPS_RegionalRateBoxA1',
    RegionalRateBoxA2 = 'USPS_RegionalRateBoxA2',
    ApoFlatRateBox = 'USPS_APOFlatRateBox',
    FlatRateWindowEnvelope = 'USPS_FlatRateWindowEnvelope',
    FlatRatePaddedEnvelope = 'USPS_FlatRatePaddedEnvelope'
}/**
* @export
* @enum {string}
*/
export enum GetAllParcelTemplatesByShippoCarrierPaResponseNameEnum {
    Envelope = 'Envelope',
    Package = 'Package',
    RegionalRateBoxB1 = 'Regional Rate Box B1',
    RegionalRateBoxB2 = 'Regional Rate Box B2',
    IrregularParcel = 'Irregular Parcel',
    Card = 'Card',
    FlatRateCardboardEnvelope = 'Flat Rate Cardboard Envelope',
    FlatRateLegalEnvelope = 'Flat Rate Legal Envelope',
    FlatRateEnvelope = 'Flat Rate Envelope',
    FlatRateGiftCardEnvelope = 'Flat Rate Gift Card Envelope',
    FlatRateLargeVideoBoxIntlOnly = 'Flat Rate Large Video Box (Int\'l only)',
    LargeFlatRateBoardGameBox = 'Large Flat Rate Board Game Box',
    SmallFlatRateEnvelope = 'Small Flat Rate Envelope',
    SoftPackPaddedEnvelope = 'Soft Pack Padded Envelope',
    LargeFlatRateBox = 'Large Flat Rate Box',
    MediumFlatRateBox1 = 'Medium Flat Rate Box 1',
    MediumFlatRateBox2 = 'Medium Flat Rate Box 2',
    SmallFlatRateBox = 'Small Flat Rate Box',
    RegionalRateBoxA1 = 'Regional Rate Box A1',
    RegionalRateBoxA2 = 'Regional Rate Box A2',
    ApoFpoDpoLargeFlatRateBox = 'APO/FPO/DPO Large Flat Rate Box',
    FlatRateWindowEnvelope = 'Flat Rate Window Envelope',
    FlatRatePaddedEnvelope = 'Flat Rate Padded Envelope'
}/**
* @export
* @enum {string}
*/
export enum GetAllParcelTemplatesByShippoCarrierPaResponseDistanceUnitEnum {
    Cm = 'cm',
    In = 'in',
    Ft = 'ft',
    M = 'm',
    Mm = 'mm',
    Yd = 'yd'
}

/**
 * 
 * @export
 * @interface GetAllServiceLevelsByShippoCarrierPaResponse
 */
export interface GetAllServiceLevelsByShippoCarrierPaResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAllServiceLevelsByShippoCarrierPaResponse
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetAllServiceLevelsByShippoCarrierPaResponse
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof GetAllServiceLevelsByShippoCarrierPaResponse
     */
    type: GetAllServiceLevelsByShippoCarrierPaResponseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetAllServiceLevelsByShippoCarrierPaResponse
     */
    token: GetAllServiceLevelsByShippoCarrierPaResponseTokenEnum;
    /**
     * 
     * @type {string}
     * @memberof GetAllServiceLevelsByShippoCarrierPaResponse
     */
    name: GetAllServiceLevelsByShippoCarrierPaResponseNameEnum;
    /**
     * 
     * @type {string}
     * @memberof GetAllServiceLevelsByShippoCarrierPaResponse
     */
    alias: string;
}

/**
* @export
* @enum {string}
*/
export enum GetAllServiceLevelsByShippoCarrierPaResponseTypeEnum {
    RateAttribute = 'SHIPPO_RATE_ATTRIBUTE',
    CarrierServiceLevel = 'SHIPPO_CARRIER_SERVICE_LEVEL'
}/**
* @export
* @enum {string}
*/
export enum GetAllServiceLevelsByShippoCarrierPaResponseTokenEnum {
    Cheapest = 'CHEAPEST',
    Fastest = 'FASTEST',
    UspsGroundAdvantage = 'usps_ground_advantage',
    UspsPriority = 'usps_priority',
    UspsPriorityExpress = 'usps_priority_express'
}/**
* @export
* @enum {string}
*/
export enum GetAllServiceLevelsByShippoCarrierPaResponseNameEnum {
    Cheapest = 'CHEAPEST',
    Fastest = 'FASTEST',
    GroundAdvantage = 'Ground Advantage',
    PriorityMail = 'Priority Mail',
    PriorityMailExpress = 'Priority Mail Express'
}

/**
 * 
 * @export
 * @interface GetAllShippoCarriersAllInOneResponse
 */
export interface GetAllShippoCarriersAllInOneResponse {
    /**
     * 
     * @type {GetAllShippoCarriersResponse}
     * @memberof GetAllShippoCarriersAllInOneResponse
     */
    carrier: GetAllShippoCarriersResponse;
    /**
     * 
     * @type {Array<GetAllParcelTemplatesByShippoCarrierPaResponse>}
     * @memberof GetAllShippoCarriersAllInOneResponse
     */
    parcelTemplates: Array<GetAllParcelTemplatesByShippoCarrierPaResponse>;
    /**
     * 
     * @type {Array<GetAllSignatureConfirmationsByShippoCarrierPaResponse>}
     * @memberof GetAllShippoCarriersAllInOneResponse
     */
    signatureConfirmations: Array<GetAllSignatureConfirmationsByShippoCarrierPaResponse>;
    /**
     * 
     * @type {Array<GetAllServiceLevelsByShippoCarrierPaResponse>}
     * @memberof GetAllShippoCarriersAllInOneResponse
     */
    serviceLevels: Array<GetAllServiceLevelsByShippoCarrierPaResponse>;
}

/**
 * 
 * @export
 * @interface GetAllShippoCarriersResponse
 */
export interface GetAllShippoCarriersResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAllShippoCarriersResponse
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetAllShippoCarriersResponse
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof GetAllShippoCarriersResponse
     */
    token: GetAllShippoCarriersResponseTokenEnum;
    /**
     * 
     * @type {string}
     * @memberof GetAllShippoCarriersResponse
     */
    name: GetAllShippoCarriersResponseNameEnum;
    /**
     * 
     * @type {string}
     * @memberof GetAllShippoCarriersResponse
     */
    alias: string;
}

/**
* @export
* @enum {string}
*/
export enum GetAllShippoCarriersResponseTokenEnum {
    Usps = 'usps'
}/**
* @export
* @enum {string}
*/
export enum GetAllShippoCarriersResponseNameEnum {
    Usps = 'USPS'
}

/**
 * 
 * @export
 * @interface GetAllSignatureConfirmationsByShippoCarrierPaResponse
 */
export interface GetAllSignatureConfirmationsByShippoCarrierPaResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAllSignatureConfirmationsByShippoCarrierPaResponse
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetAllSignatureConfirmationsByShippoCarrierPaResponse
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof GetAllSignatureConfirmationsByShippoCarrierPaResponse
     */
    token: GetAllSignatureConfirmationsByShippoCarrierPaResponseTokenEnum;
    /**
     * 
     * @type {string}
     * @memberof GetAllSignatureConfirmationsByShippoCarrierPaResponse
     */
    name: GetAllSignatureConfirmationsByShippoCarrierPaResponseNameEnum;
    /**
     * 
     * @type {string}
     * @memberof GetAllSignatureConfirmationsByShippoCarrierPaResponse
     */
    alias: string;
}

/**
* @export
* @enum {string}
*/
export enum GetAllSignatureConfirmationsByShippoCarrierPaResponseTokenEnum {
    Standard = 'STANDARD',
    Adult = 'ADULT',
    Certified = 'CERTIFIED'
}/**
* @export
* @enum {string}
*/
export enum GetAllSignatureConfirmationsByShippoCarrierPaResponseNameEnum {
    SignatureConfirmation = 'Signature Confirmation',
    AdultSignatureRequired = 'Adult Signature Required',
    CertifiedMail = 'Certified Mail'
}

/**
 * 
 * @export
 * @interface GetCommentChatSubscriptionInfoResponse
 */
export interface GetCommentChatSubscriptionInfoResponse {
    /**
     * 
     * @type {number}
     * @memberof GetCommentChatSubscriptionInfoResponse
     */
    contactCountUsed: number;
    /**
     * 
     * @type {MySubscription}
     * @memberof GetCommentChatSubscriptionInfoResponse
     */
    currentSubscription: MySubscription;
    /**
     * 
     * @type {SubscriptionPlan}
     * @memberof GetCommentChatSubscriptionInfoResponse
     */
    nextUpgradableSubscriptionPlan: SubscriptionPlan;
    /**
     * 
     * @type {SubscriptionPlan}
     * @memberof GetCommentChatSubscriptionInfoResponse
     */
    nextUpgradableAddonSubscriptionPlan?: SubscriptionPlan;
}

/**
 * 
 * @export
 * @interface GetDropshipApplicationResponse
 */
export interface GetDropshipApplicationResponse {
    /**
     * 
     * @type {PopStoreDropshipApplicationItem}
     * @memberof GetDropshipApplicationResponse
     */
    application?: PopStoreDropshipApplicationItem;
}

/**
 * 
 * @export
 * @interface GetFeatureResponse
 */
export interface GetFeatureResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    enableThemeCreator?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    pickup?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    unlimitedStoreFavorites?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    shopifyOrderSync?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    nftGatedShows?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    patreonGatedShows?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    customersTab?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    streaming?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    voidLabel?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    customBadge?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    captureGroup?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    commentSoldTax?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetFeatureResponse
     */
    customBadgeLimit?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetFeatureResponse
     */
    nftContracts?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetFeatureResponse
     */
    patreonIdentifier?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    tipping?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    dropshipUI?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    cloudRecording?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    preferReplaysHiddenInApp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    storeReelPopupOnProfile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    storeReplayPopupOnProfile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    isCommentchatOnboardingOptional?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    orders?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetFeatureResponse
     */
    storefrontUI?: boolean;
}

/**
 * 
 * @export
 * @interface GetFireStoreTimestamp
 */
export interface GetFireStoreTimestamp {
    /**
     * 
     * @type {string}
     * @memberof GetFireStoreTimestamp
     */
    timestamp: string;
}

/**
 * 
 * @export
 * @interface GetIcsResponse
 */
export interface GetIcsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetIcsResponse
     */
    ics: string;
}

/**
 * 
 * @export
 * @interface GetLatestPaymentMethodsResponse
 */
export interface GetLatestPaymentMethodsResponse {
    /**
     * 
     * @type {PaymentMethodDetail}
     * @memberof GetLatestPaymentMethodsResponse
     */
    data?: PaymentMethodDetail;
}

/**
 * 
 * @export
 * @interface GetLinkResponse
 */
export interface GetLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof GetLinkResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetLinkResponse
     */
    type: GetLinkResponseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetLinkResponse
     */
    userId?: string;
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof GetLinkResponse
     */
    profile?: BaseProfileItem;
    /**
     * 
     * @type {string}
     * @memberof GetLinkResponse
     */
    method?: GetLinkResponseMethodEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetLinkResponse
     */
    isActive: boolean;
}

/**
* @export
* @enum {string}
*/
export enum GetLinkResponseTypeEnum {
    Share = 'SHARE',
    Campaign = 'CAMPAIGN',
    ReferralGifting = 'REFERRAL_GIFTING'
}/**
* @export
* @enum {string}
*/
export enum GetLinkResponseMethodEnum {
    Sms = 'SMS',
    Email = 'EMAIL',
    Facebook = 'FACEBOOK',
    Instagram = 'INSTAGRAM',
    Twitter = 'TWITTER',
    Embed = 'EMBED',
    Generic = 'GENERIC'
}

/**
 * 
 * @export
 * @interface GetLiveStreamNftsResponse
 */
export interface GetLiveStreamNftsResponse {
    /**
     * 
     * @type {Array<NftItem>}
     * @memberof GetLiveStreamNftsResponse
     */
    nfts: Array<NftItem>;
}

/**
 * 
 * @export
 * @interface GetMinTippingAmountInMultiCurrencyResponse
 */
export interface GetMinTippingAmountInMultiCurrencyResponse {
    /**
     * 
     * @type {number}
     * @memberof GetMinTippingAmountInMultiCurrencyResponse
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof GetMinTippingAmountInMultiCurrencyResponse
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof GetMinTippingAmountInMultiCurrencyResponse
     */
    fxQuoteId?: string;
}

/**
 * 
 * @export
 * @interface GetModelMeResultResponse
 */
export interface GetModelMeResultResponse {
    /**
     * 
     * @type {string}
     * @memberof GetModelMeResultResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetModelMeResultResponse
     */
    awsS3Url: string;
    /**
     * 
     * @type {string}
     * @memberof GetModelMeResultResponse
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof GetModelMeResultResponse
     */
    status: GetModelMeResultResponseStatusEnum;
    /**
     * 
     * @type {object}
     * @memberof GetModelMeResultResponse
     */
    feedback?: object;
}

/**
* @export
* @enum {string}
*/
export enum GetModelMeResultResponseStatusEnum {
    Ready = 'READY',
    Approved = 'APPROVED',
    Dismissed = 'DISMISSED'
}

/**
 * 
 * @export
 * @interface GetMyEarningsResponse
 */
export interface GetMyEarningsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetMyEarningsResponse
     */
    payableEarnings: number;
    /**
     * 
     * @type {number}
     * @memberof GetMyEarningsResponse
     */
    last6MonthsEarnings: number;
    /**
     * 
     * @type {number}
     * @memberof GetMyEarningsResponse
     */
    activeSubscribers: number;
    /**
     * 
     * @type {number}
     * @memberof GetMyEarningsResponse
     */
    lifetimeEarnings: number;
    /**
     * 
     * @type {Array<MyPayout>}
     * @memberof GetMyEarningsResponse
     */
    payouts: Array<MyPayout>;
    /**
     * 
     * @type {Array<MyMonthEarning>}
     * @memberof GetMyEarningsResponse
     */
    monthlyEarnings: Array<MyMonthEarning>;
}

/**
 * 
 * @export
 * @interface GetMyPayoutsResponse
 */
export interface GetMyPayoutsResponse {
    /**
     * 
     * @type {Array<MyPayoutItem>}
     * @memberof GetMyPayoutsResponse
     */
    data: Array<MyPayoutItem>;
    /**
     * 
     * @type {string}
     * @memberof GetMyPayoutsResponse
     */
    lastDocId?: string;
}

/**
 * 
 * @export
 * @interface GetMySubscriptionDetailsResponse
 */
export interface GetMySubscriptionDetailsResponse {
    /**
     * 
     * @type {MySubscriptionDetails}
     * @memberof GetMySubscriptionDetailsResponse
     */
    data?: MySubscriptionDetails;
}

/**
 * 
 * @export
 * @interface GetNftAvatarResponse
 */
export interface GetNftAvatarResponse {
    /**
     * 
     * @type {string}
     * @memberof GetNftAvatarResponse
     */
    nftImageUri: string;
}

/**
 * 
 * @export
 * @interface GetOnboardingContestSubmissionResponse
 */
export interface GetOnboardingContestSubmissionResponse {
    /**
     * 
     * @type {PopStoreOnboardingContestSubmissionItem}
     * @memberof GetOnboardingContestSubmissionResponse
     */
    submission?: PopStoreOnboardingContestSubmissionItem;
}

/**
 * 
 * @export
 * @interface GetOrderDigitalProductResponse
 */
export interface GetOrderDigitalProductResponse {
    /**
     * 
     * @type {string}
     * @memberof GetOrderDigitalProductResponse
     */
    filename: string;
    /**
     * 
     * @type {number}
     * @memberof GetOrderDigitalProductResponse
     */
    downloadedCount: number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderDigitalProductResponse
     */
    downloadLimitCount?: number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDigitalProductResponse
     */
    downloadEndAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDigitalProductResponse
     */
    downloadUrl: string;
}

/**
 * 
 * @export
 * @interface GetPackageTemplateResponse
 */
export interface GetPackageTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof GetPackageTemplateResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetPackageTemplateResponse
     */
    type: GetPackageTemplateResponseTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetPackageTemplateResponse
     */
    isDefault: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPackageTemplateResponse
     */
    imageUrl: string;
    /**
     * 
     * @type {string}
     * @memberof GetPackageTemplateResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetPackageTemplateResponse
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof GetPackageTemplateResponse
     */
    shippingPrice: number;
    /**
     * 
     * @type {string}
     * @memberof GetPackageTemplateResponse
     */
    shippingCost: string;
    /**
     * 
     * @type {string}
     * @memberof GetPackageTemplateResponse
     */
    carrierId: string;
    /**
     * 
     * @type {ShippoCarrier}
     * @memberof GetPackageTemplateResponse
     */
    carrier: ShippoCarrier;
    /**
     * 
     * @type {string}
     * @memberof GetPackageTemplateResponse
     */
    parcelTemplateId: string;
    /**
     * 
     * @type {ShippoCarrierParcelTemplate}
     * @memberof GetPackageTemplateResponse
     */
    parcelTemplate: ShippoCarrierParcelTemplate;
    /**
     * 
     * @type {number}
     * @memberof GetPackageTemplateResponse
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof GetPackageTemplateResponse
     */
    height: number;
    /**
     * 
     * @type {number}
     * @memberof GetPackageTemplateResponse
     */
    depth: number;
    /**
     * 
     * @type {string}
     * @memberof GetPackageTemplateResponse
     */
    distanceUnit: GetPackageTemplateResponseDistanceUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof GetPackageTemplateResponse
     */
    weight: number;
    /**
     * 
     * @type {string}
     * @memberof GetPackageTemplateResponse
     */
    massUnit: GetPackageTemplateResponseMassUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPackageTemplateResponse
     */
    signatureConfirmationId: string;
    /**
     * 
     * @type {ShippoCarrierSignatureConfirmation}
     * @memberof GetPackageTemplateResponse
     */
    signatureConfirmation: ShippoCarrierSignatureConfirmation;
    /**
     * 
     * @type {string}
     * @memberof GetPackageTemplateResponse
     */
    serviceLevelId: string;
    /**
     * 
     * @type {ShippoCarrierServiceLevel}
     * @memberof GetPackageTemplateResponse
     */
    serviceLevel: ShippoCarrierServiceLevel;
    /**
     * 
     * @type {number}
     * @memberof GetPackageTemplateResponse
     */
    countUsedAsDefault: number;
}

/**
* @export
* @enum {string}
*/
export enum GetPackageTemplateResponseTypeEnum {
    Custom = 'CUSTOM',
    Preset = 'PRESET',
    Global = 'GLOBAL',
    SellerCustom = 'SELLER_CUSTOM',
    SellerArrangeMyOwn = 'SELLER_ARRANGE_MY_OWN'
}/**
* @export
* @enum {string}
*/
export enum GetPackageTemplateResponseDistanceUnitEnum {
    Cm = 'cm',
    In = 'in',
    Ft = 'ft',
    M = 'm',
    Mm = 'mm',
    Yd = 'yd'
}/**
* @export
* @enum {string}
*/
export enum GetPackageTemplateResponseMassUnitEnum {
    G = 'g',
    Kg = 'kg',
    Lb = 'lb',
    Oz = 'oz'
}

/**
 * 
 * @export
 * @interface GetPackageTemplateUnitResponse
 */
export interface GetPackageTemplateUnitResponse {
    /**
     * 
     * @type {string}
     * @memberof GetPackageTemplateUnitResponse
     */
    distanceUnit: GetPackageTemplateUnitResponseDistanceUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPackageTemplateUnitResponse
     */
    massUnit: GetPackageTemplateUnitResponseMassUnitEnum;
}

/**
* @export
* @enum {string}
*/
export enum GetPackageTemplateUnitResponseDistanceUnitEnum {
    Cm = 'cm',
    In = 'in',
    Ft = 'ft',
    M = 'm',
    Mm = 'mm',
    Yd = 'yd'
}/**
* @export
* @enum {string}
*/
export enum GetPackageTemplateUnitResponseMassUnitEnum {
    G = 'g',
    Kg = 'kg',
    Lb = 'lb',
    Oz = 'oz'
}

/**
 * 
 * @export
 * @interface GetPaymentMethodByCardTokenResponse
 */
export interface GetPaymentMethodByCardTokenResponse {
    /**
     * An empty string means no such card
     * @type {string}
     * @memberof GetPaymentMethodByCardTokenResponse
     */
    paymentMethodId: string;
}

/**
 * 
 * @export
 * @interface GetPaymentMethodsResponse
 */
export interface GetPaymentMethodsResponse {
    /**
     * 
     * @type {Array<PaymentMethodItem>}
     * @memberof GetPaymentMethodsResponse
     */
    data: Array<PaymentMethodItem>;
}

/**
 * 
 * @export
 * @interface GetPersonalDataResponse
 */
export interface GetPersonalDataResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetPersonalDataResponse
     */
    faceImageAwsS3Urls: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetPersonalDataResponse
     */
    bodyImageAwsS3Urls: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof GetPersonalDataResponse
     */
    height: number;
    /**
     * 
     * @type {string}
     * @memberof GetPersonalDataResponse
     */
    heightUnit: GetPersonalDataResponseHeightUnitEnum;
}

/**
* @export
* @enum {string}
*/
export enum GetPersonalDataResponseHeightUnitEnum {
    Cm = 'cm',
    In = 'in',
    Ft = 'ft',
    M = 'm'
}

/**
 * 
 * @export
 * @interface GetPhoneResponse
 */
export interface GetPhoneResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetPhoneResponse
     */
    exist: boolean;
}

/**
 * 
 * @export
 * @interface GetPublicFeatureResponse
 */
export interface GetPublicFeatureResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetPublicFeatureResponse
     */
    cloudRecording?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPublicFeatureResponse
     */
    preferReplaysHiddenInApp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPublicFeatureResponse
     */
    storeReelPopupOnProfile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPublicFeatureResponse
     */
    storeReplayPopupOnProfile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPublicFeatureResponse
     */
    orders?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPublicFeatureResponse
     */
    storefrontUI?: boolean;
}

/**
 * 
 * @export
 * @interface GetRecommendStoresResponse
 */
export interface GetRecommendStoresResponse {
    /**
     * 
     * @type {Array<Store>}
     * @memberof GetRecommendStoresResponse
     */
    stores: Array<Store>;
}

/**
 * 
 * @export
 * @interface GetRecordingURLsResponse
 */
export interface GetRecordingURLsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetRecordingURLsResponse
     */
    urls: Array<string>;
}

/**
 * 
 * @export
 * @interface GetRedirectionUrlResponse
 */
export interface GetRedirectionUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof GetRedirectionUrlResponse
     */
    url: string;
}

/**
 * 
 * @export
 * @interface GetSellerMetricsResponse
 */
export interface GetSellerMetricsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetSellerMetricsResponse
     */
    shippingSpeedOfDayMin: number;
    /**
     * 
     * @type {number}
     * @memberof GetSellerMetricsResponse
     */
    shippingSpeedOfDayMax: number;
    /**
     * 
     * @type {string}
     * @memberof GetSellerMetricsResponse
     */
    hoursViewed: string;
    /**
     * 
     * @type {number}
     * @memberof GetSellerMetricsResponse
     */
    hoursViewedNumeric: number;
    /**
     * 
     * @type {string}
     * @memberof GetSellerMetricsResponse
     */
    productsSold: string;
    /**
     * 
     * @type {number}
     * @memberof GetSellerMetricsResponse
     */
    productsSoldNumeric: number;
    /**
     * 
     * @type {string}
     * @memberof GetSellerMetricsResponse
     */
    revenue: string;
    /**
     * 
     * @type {number}
     * @memberof GetSellerMetricsResponse
     */
    followerCnt: number;
    /**
     * 
     * @type {number}
     * @memberof GetSellerMetricsResponse
     */
    followingCnt: number;
    /**
     * 
     * @type {number}
     * @memberof GetSellerMetricsResponse
     */
    bioPv: number;
}

/**
 * 
 * @export
 * @interface GetSellerUpgradableSubscriptionPlanResponse
 */
export interface GetSellerUpgradableSubscriptionPlanResponse {
    /**
     * 
     * @type {Array<SubscriptionPlan>}
     * @memberof GetSellerUpgradableSubscriptionPlanResponse
     */
    data: Array<SubscriptionPlan>;
}

/**
 * 
 * @export
 * @interface GetSessionsResponse
 */
export interface GetSessionsResponse {
    /**
     * 
     * @type {Array<GetSessionsResponseItem>}
     * @memberof GetSessionsResponse
     */
    data: Array<GetSessionsResponseItem>;
}

/**
 * 
 * @export
 * @interface GetSessionsResponseItem
 */
export interface GetSessionsResponseItem {
    /**
     * 
     * @type {number}
     * @memberof GetSessionsResponseItem
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof GetSessionsResponseItem
     */
    sessionId: string;
    /**
     * 
     * @type {number}
     * @memberof GetSessionsResponseItem
     */
    type: number;
    /**
     * 
     * @type {string}
     * @memberof GetSessionsResponseItem
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof GetSessionsResponseItem
     */
    avatar: string;
    /**
     * 
     * @type {string}
     * @memberof GetSessionsResponseItem
     */
    targetUserId: string;
    /**
     * 
     * @type {string}
     * @memberof GetSessionsResponseItem
     */
    targetUserName: string;
    /**
     * 
     * @type {string}
     * @memberof GetSessionsResponseItem
     */
    targetAvatar: string;
    /**
     * 
     * @type {Date}
     * @memberof GetSessionsResponseItem
     */
    lastMessageTime: Date;
    /**
     * 
     * @type {ChatMessageDto}
     * @memberof GetSessionsResponseItem
     */
    lastMessage?: ChatMessageDto;
    /**
     * 
     * @type {number}
     * @memberof GetSessionsResponseItem
     */
    unreadCount: number;
}

/**
 * 
 * @export
 * @interface GetShippingCostRequest
 */
export interface GetShippingCostRequest {
    /**
     * 
     * @type {string}
     * @memberof GetShippingCostRequest
     */
    packageTemplateId: string;
}

/**
 * 
 * @export
 * @interface GetShippingModeResponse
 */
export interface GetShippingModeResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetShippingModeResponse
     */
    shippingMode: Array<GetShippingModeResponseShippingModeEnum>;
    /**
     * 
     * @type {PickupAddressResponse}
     * @memberof GetShippingModeResponse
     */
    defaultPickupAddress?: PickupAddressResponse;
}

/**
* @export
* @enum {string}
*/
export enum GetShippingModeResponseShippingModeEnum {
    Shipping = 'shipping',
    Pickup = 'pickup'
}

/**
 * 
 * @export
 * @interface GetSignedUrlToUploadModelMeImageRequest
 */
export interface GetSignedUrlToUploadModelMeImageRequest {
    /**
     * 
     * @type {string}
     * @memberof GetSignedUrlToUploadModelMeImageRequest
     */
    imageType: GetSignedUrlToUploadModelMeImageRequestImageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSignedUrlToUploadModelMeImageRequest
     */
    imageExt: GetSignedUrlToUploadModelMeImageRequestImageExtEnum;
}

/**
* @export
* @enum {string}
*/
export enum GetSignedUrlToUploadModelMeImageRequestImageTypeEnum {
    Face = 'face',
    Body = 'body'
}/**
* @export
* @enum {string}
*/
export enum GetSignedUrlToUploadModelMeImageRequestImageExtEnum {
    Jpeg = 'jpeg',
    Jpg = 'jpg',
    Png = 'png'
}

/**
 * 
 * @export
 * @interface GetSignedUrlToUploadModelMeImageResponse
 */
export interface GetSignedUrlToUploadModelMeImageResponse {
    /**
     * 
     * @type {string}
     * @memberof GetSignedUrlToUploadModelMeImageResponse
     */
    awsS3SignedUrl: string;
}

/**
 * 
 * @export
 * @interface GetStripeAccountInfoResponse
 */
export interface GetStripeAccountInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof GetStripeAccountInfoResponse
     */
    accountId: string;
    /**
     * 
     * @type {string}
     * @memberof GetStripeAccountInfoResponse
     */
    billingCountry: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetStripeAccountInfoResponse
     */
    onBehalfOfChargeModeEnabled: boolean;
}

/**
 * 
 * @export
 * @interface GetStripeAccountResponse
 */
export interface GetStripeAccountResponse {
    /**
     * 
     * @type {string}
     * @memberof GetStripeAccountResponse
     */
    accountId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStripeAccountResponse
     */
    customerId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStripeAccountResponse
     */
    billingCountryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStripeAccountResponse
     */
    stripeBillingCountryCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetStripeAccountResponse
     */
    onBehalfOfChargeModeEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetStripeAccountResponse
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStripeAccountResponse
     */
    lastName?: string;
}

/**
 * 
 * @export
 * @interface GetStripeConnectedAccountResponse
 */
export interface GetStripeConnectedAccountResponse {
    /**
     * 
     * @type {object}
     * @memberof GetStripeConnectedAccountResponse
     */
    account: object;
}

/**
 * 
 * @export
 * @interface GetSubscriptionPaymentMethodsResponse
 */
export interface GetSubscriptionPaymentMethodsResponse {
    /**
     * 
     * @type {Array<SubscriptionPaymentMethod>}
     * @memberof GetSubscriptionPaymentMethodsResponse
     */
    data: Array<SubscriptionPaymentMethod>;
}

/**
 * 
 * @export
 * @interface GetSubscriptionPlansResponse
 */
export interface GetSubscriptionPlansResponse {
    /**
     * 
     * @type {Array<SubscriptionPlan>}
     * @memberof GetSubscriptionPlansResponse
     */
    data: Array<SubscriptionPlan>;
}

/**
 * 
 * @export
 * @interface GetSubscriptionTaxRequest
 */
export interface GetSubscriptionTaxRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSubscriptionTaxRequest
     */
    priceIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetSubscriptionTaxRequest
     */
    paymentMethodId?: string;
    /**
     * 
     * @type {TaxCalculationAddress}
     * @memberof GetSubscriptionTaxRequest
     */
    address?: TaxCalculationAddress;
}

/**
 * 
 * @export
 * @interface GetSubscriptionTaxResponse
 */
export interface GetSubscriptionTaxResponse {
    /**
     * 
     * @type {number}
     * @memberof GetSubscriptionTaxResponse
     */
    totalAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetSubscriptionTaxResponse
     */
    taxAmount: number;
    /**
     * 
     * @type {string}
     * @memberof GetSubscriptionTaxResponse
     */
    taxCode: string;
}

/**
 * 
 * @export
 * @interface GetUserMetricsResponse
 */
export interface GetUserMetricsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetUserMetricsResponse
     */
    followerCnt: number;
    /**
     * 
     * @type {number}
     * @memberof GetUserMetricsResponse
     */
    followingCnt: number;
}

/**
 * 
 * @export
 * @interface GetUserTokenRequest
 */
export interface GetUserTokenRequest {
    /**
     * 
     * @type {object}
     * @memberof GetUserTokenRequest
     */
    developerClaims?: object;
}

/**
 * 
 * @export
 * @interface GiftPackageDto
 */
export interface GiftPackageDto {
    /**
     * 
     * @type {boolean}
     * @memberof GiftPackageDto
     */
    isGiftPackage: boolean;
    /**
     * 
     * @type {string}
     * @memberof GiftPackageDto
     */
    giftMessage?: string;
}

/**
 * 
 * @export
 * @interface GiveawayItemLiveStreamSource
 */
export interface GiveawayItemLiveStreamSource {
    /**
     * 
     * @type {string}
     * @memberof GiveawayItemLiveStreamSource
     */
    type: GiveawayItemLiveStreamSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GiveawayItemLiveStreamSource
     */
    liveStreamId: string;
}

/**
* @export
* @enum {string}
*/
export enum GiveawayItemLiveStreamSourceTypeEnum {
    LiveStream = 'liveStream'
}

/**
 * 
 * @export
 * @interface GiveawayItemUpcomingShowSource
 */
export interface GiveawayItemUpcomingShowSource {
    /**
     * 
     * @type {string}
     * @memberof GiveawayItemUpcomingShowSource
     */
    type: GiveawayItemUpcomingShowSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GiveawayItemUpcomingShowSource
     */
    upcomingShowId: string;
}

/**
* @export
* @enum {string}
*/
export enum GiveawayItemUpcomingShowSourceTypeEnum {
    UpcomingShow = 'upcomingShow'
}

/**
 * 
 * @export
 * @interface GiveawayItemWithId
 */
export interface GiveawayItemWithId {
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof GiveawayItemWithId
     */
    seller: BaseProfileItem;
    /**
     * 
     * @type {string}
     * @memberof GiveawayItemWithId
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof GiveawayItemWithId
     */
    listingId: string;
    /**
     * 
     * @type {BaseStoreListingItem}
     * @memberof GiveawayItemWithId
     */
    listing: BaseStoreListingItem;
    /**
     * 
     * @type {string}
     * @memberof GiveawayItemWithId
     */
    variantId?: string;
    /**
     * 
     * @type {number}
     * @memberof GiveawayItemWithId
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof GiveawayItemWithId
     */
    discountPrice?: number;
    /**
     * 
     * @type {GiveawayItemLiveStreamSource | GiveawayItemUpcomingShowSource}
     * @memberof GiveawayItemWithId
     */
    source: GiveawayItemLiveStreamSource | GiveawayItemUpcomingShowSource;
    /**
     * 
     * @type {string}
     * @memberof GiveawayItemWithId
     */
    status: GiveawayItemWithIdStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof GiveawayItemWithId
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof GiveawayItemWithId
     */
    totalEntrants: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GiveawayItemWithId
     */
    prerequisites?: Array<GiveawayItemWithIdPrerequisitesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GiveawayItemWithId
     */
    criteria?: Array<GiveawayItemWithIdCriteriaEnum>;
    /**
     * 
     * @type {string}
     * @memberof GiveawayItemWithId
     */
    entryCloseAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GiveawayItemWithId
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof GiveawayItemWithId
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GiveawayItemWithId
     */
    title: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GiveawayItemWithId
     */
    coverImages: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GiveawayItemWithId
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof GiveawayItemWithId
     */
    id: string;
}

/**
* @export
* @enum {string}
*/
export enum GiveawayItemWithIdStatusEnum {
    Created = 'created',
    SellerPickedWinner = 'sellerPickedWinner',
    WinnerDeclined = 'winnerDeclined',
    Canceled = 'canceled',
    Finished = 'finished'
}/**
* @export
* @enum {string}
*/
export enum GiveawayItemWithIdPrerequisitesEnum {
    IsFollower = 'IsFollower',
    IsCustomer = 'isCustomer'
}/**
* @export
* @enum {string}
*/
export enum GiveawayItemWithIdCriteriaEnum {
    CommentToEnter = 'CommentToEnter',
    ShareToEnter = 'ShareToEnter'
}

/**
 * 
 * @export
 * @interface GiveawaySendItemItem
 */
export interface GiveawaySendItemItem {
    /**
     * 
     * @type {ProfileItem}
     * @memberof GiveawaySendItemItem
     */
    fromUser: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof GiveawaySendItemItem
     */
    fromUserId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof GiveawaySendItemItem
     */
    toUser: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof GiveawaySendItemItem
     */
    toUserId: string;
    /**
     * 
     * @type {string}
     * @memberof GiveawaySendItemItem
     */
    listingId: string;
    /**
     * 
     * @type {StoreListingItem}
     * @memberof GiveawaySendItemItem
     */
    listing: StoreListingItem;
    /**
     * 
     * @type {string}
     * @memberof GiveawaySendItemItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof GiveawaySendItemItem
     */
    variantId?: string;
    /**
     * 
     * @type {number}
     * @memberof GiveawaySendItemItem
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof GiveawaySendItemItem
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GiveawaySendItemItem
     */
    status: GiveawaySendItemItemStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GiveawaySendItemItem
     */
    needShippingFee: boolean;
    /**
     * 
     * @type {number}
     * @memberof GiveawaySendItemItem
     */
    quantity: number;
    /**
     * 
     * @type {LiveStreamAuctionItem}
     * @memberof GiveawaySendItemItem
     */
    liveStreamAuction: LiveStreamAuctionItem;
    /**
     * 
     * @type {string}
     * @memberof GiveawaySendItemItem
     */
    type: GiveawaySendItemItemTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum GiveawaySendItemItemStatusEnum {
    Processing = 'PROCESSING',
    Canceled = 'CANCELED',
    Confirmed = 'CONFIRMED',
    Rejected = ' REJECTED'
}/**
* @export
* @enum {string}
*/
export enum GiveawaySendItemItemTypeEnum {
    Giveaway = 'giveaway'
}

/**
 * 
 * @export
 * @interface GooglePlayAnalytics
 */
export interface GooglePlayAnalytics {
    /**
     * 
     * @type {string}
     * @memberof GooglePlayAnalytics
     */
    utm_source?: string;
    /**
     * 
     * @type {string}
     * @memberof GooglePlayAnalytics
     */
    utm_medium?: string;
    /**
     * 
     * @type {string}
     * @memberof GooglePlayAnalytics
     */
    utm_campaign?: string;
    /**
     * 
     * @type {string}
     * @memberof GooglePlayAnalytics
     */
    utm_term?: string;
    /**
     * 
     * @type {string}
     * @memberof GooglePlayAnalytics
     */
    utm_content?: string;
    /**
     * 
     * @type {string}
     * @memberof GooglePlayAnalytics
     */
    gclid?: string;
}

/**
 * 
 * @export
 * @interface GoogleProductCategoriesPageRows
 */
export interface GoogleProductCategoriesPageRows {
    /**
     * 
     * @type {Array<GoogleProductCategoryItem>}
     * @memberof GoogleProductCategoriesPageRows
     */
    rows: Array<GoogleProductCategoryItem>;
}

/**
 * 
 * @export
 * @interface GoogleProductCategoriesSearchResponse
 */
export interface GoogleProductCategoriesSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof GoogleProductCategoriesSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof GoogleProductCategoriesSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {GoogleProductCategoriesPageRows}
     * @memberof GoogleProductCategoriesSearchResponse
     */
    data: GoogleProductCategoriesPageRows;
}

/**
 * 
 * @export
 * @interface GoogleProductCategoryItem
 */
export interface GoogleProductCategoryItem {
    /**
     * 
     * @type {string}
     * @memberof GoogleProductCategoryItem
     */
    parentId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GoogleProductCategoryItem
     */
    ancestorIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GoogleProductCategoryItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleProductCategoryItem
     */
    fullName: string;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleProductCategoryItem
     */
    isRoot: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleProductCategoryItem
     */
    isLeaf: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleProductCategoryItem
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleProductCategoryItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleProductCategoryItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleProductCategoryItem
     */
    updatedAt: string;
}

/**
 * 
 * @export
 * @interface HasModelMeProcessTriggeredListingsResponse
 */
export interface HasModelMeProcessTriggeredListingsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof HasModelMeProcessTriggeredListingsResponse
     */
    result: boolean;
}

/**
 * 
 * @export
 * @interface IOSConfig
 */
export interface IOSConfig {
    /**
     * 
     * @type {string}
     * @memberof IOSConfig
     */
    ifl?: string;
    /**
     * 
     * @type {string}
     * @memberof IOSConfig
     */
    ius?: string;
    /**
     * 
     * @type {string}
     * @memberof IOSConfig
     */
    ipfl?: string;
    /**
     * 
     * @type {string}
     * @memberof IOSConfig
     */
    ipbi?: string;
    /**
     * 
     * @type {string}
     * @memberof IOSConfig
     */
    imv?: string;
    /**
     * 
     * @type {string}
     * @memberof IOSConfig
     */
    efr?: string;
}

/**
 * 
 * @export
 * @interface IdResponse
 */
export interface IdResponse {
    /**
     * 
     * @type {string}
     * @memberof IdResponse
     */
    id: string;
}

/**
 * 
 * @export
 * @interface ImportStoreListing
 */
export interface ImportStoreListing {
    /**
     * 
     * @type {string}
     * @memberof ImportStoreListing
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ImportStoreListing
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportStoreListing
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof ImportStoreListing
     */
    defaultImage: string;
    /**
     * 
     * @type {string}
     * @memberof ImportStoreListing
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof ImportStoreListing
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof ImportStoreListing
     */
    sku?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImportStoreListing
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {Array<StoreControllerStoreListingVariant>}
     * @memberof ImportStoreListing
     */
    variants?: Array<StoreControllerStoreListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof ImportStoreListing
     */
    maximumPurchaseQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportStoreListing
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportStoreListing
     */
    shippingFee?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImportStoreListing
     */
    tags?: Array<string>;
    /**
     * 
     * @type {StoreListingOriginalInfo}
     * @memberof ImportStoreListing
     */
    originalInfo?: StoreListingOriginalInfo;
    /**
     * 
     * @type {string}
     * @memberof ImportStoreListing
     */
    externalId?: string;
    /**
     * 
     * @type {DimsInfo}
     * @memberof ImportStoreListing
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {SingleUnitWeightInfo | PoundWithOunceWeightInfo}
     * @memberof ImportStoreListing
     */
    weight?: SingleUnitWeightInfo | PoundWithOunceWeightInfo;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof ImportStoreListing
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof ImportStoreListing
     */
    taxCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ImportStoreListing
     */
    nontaxable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ImportStoreListing
     */
    useLocalPrice?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ImportStoreListing
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportStoreListing
     */
    sizingGuideImage?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportStoreListing
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ImportStoreListing
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ImportStoreListing
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportStoreListing
     */
    discountEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportStoreListing
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportStoreListing
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {UploadedFileDto}
     * @memberof ImportStoreListing
     */
    uploadedFile?: UploadedFileDto;
    /**
     * 
     * @type {string}
     * @memberof ImportStoreListing
     */
    externalCheckoutUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportStoreListing
     */
    externalBrandName?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportStoreListing
     */
    externalBrandImage?: string;
    /**
     * 
     * @type {ListingMeetingDto}
     * @memberof ImportStoreListing
     */
    meeting?: ListingMeetingDto;
    /**
     * 
     * @type {string}
     * @memberof ImportStoreListing
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportStoreListing
     */
    status?: ImportStoreListingStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum ImportStoreListingStatusEnum {
    Active = 'active',
    Archived = 'archived'
}

/**
 * 
 * @export
 * @interface Invite
 */
export interface Invite {
    /**
     * 
     * @type {string}
     * @memberof Invite
     */
    referrerUserId: string;
    /**
     * 
     * @type {string}
     * @memberof Invite
     */
    referrerUserStoreName: string;
    /**
     * 
     * @type {InviteRequest}
     * @memberof Invite
     */
    presenteeUserProfile?: InviteRequest;
    /**
     * 
     * @type {string}
     * @memberof Invite
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Invite
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Invite
     */
    status?: string;
}

/**
 * 
 * @export
 * @interface InviteRequest
 */
export interface InviteRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof InviteRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof InviteRequest
     */
    storeFrontName: string;
    /**
     * 
     * @type {string}
     * @memberof InviteRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof InviteRequest
     */
    phone?: string;
}

/**
 * 
 * @export
 * @interface ItunesConnectAnalytics
 */
export interface ItunesConnectAnalytics {
    /**
     * 
     * @type {string}
     * @memberof ItunesConnectAnalytics
     */
    at?: string;
    /**
     * 
     * @type {string}
     * @memberof ItunesConnectAnalytics
     */
    ct?: string;
    /**
     * 
     * @type {string}
     * @memberof ItunesConnectAnalytics
     */
    mt?: string;
    /**
     * 
     * @type {string}
     * @memberof ItunesConnectAnalytics
     */
    pt?: string;
}

/**
 * 
 * @export
 * @interface JoinNftRequest
 */
export interface JoinNftRequest {
    /**
     * 
     * @type {number}
     * @memberof JoinNftRequest
     */
    tokenId: number;
    /**
     * 
     * @type {string}
     * @memberof JoinNftRequest
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof JoinNftRequest
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof JoinNftRequest
     */
    expiredAt: string;
}

/**
 * 
 * @export
 * @interface JoinPatreonRequest
 */
export interface JoinPatreonRequest {
    /**
     * 
     * @type {string}
     * @memberof JoinPatreonRequest
     */
    oauthCode: string;
    /**
     * 
     * @type {string}
     * @memberof JoinPatreonRequest
     */
    redirectUri: string;
}

/**
 * 
 * @export
 * @interface JoinRequest
 */
export interface JoinRequest {
    /**
     * 
     * @type {JoinNftRequest}
     * @memberof JoinRequest
     */
    nft?: JoinNftRequest;
    /**
     * 
     * @type {JoinPatreonRequest}
     * @memberof JoinRequest
     */
    patreon?: JoinPatreonRequest;
}

/**
 * 
 * @export
 * @interface LabelRegenerationJobStatus
 */
export interface LabelRegenerationJobStatus {
    /**
     * 
     * @type {boolean}
     * @memberof LabelRegenerationJobStatus
     */
    canRegenerate: boolean;
}

/**
 * 
 * @export
 * @interface LabelShippingCost
 */
export interface LabelShippingCost {
    /**
     * 
     * @type {number}
     * @memberof LabelShippingCost
     */
    initialCost: number;
    /**
     * 
     * @type {string}
     * @memberof LabelShippingCost
     */
    initialDate: string;
    /**
     * 
     * @type {number}
     * @memberof LabelShippingCost
     */
    totalCost: number;
    /**
     * 
     * @type {string}
     * @memberof LabelShippingCost
     */
    lastUpdatedAt: string;
}

/**
 * 
 * @export
 * @interface LandingUserRequest
 */
export interface LandingUserRequest {
    /**
     * 
     * @type {string}
     * @memberof LandingUserRequest
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof LandingUserRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof LandingUserRequest
     */
    url?: string;
}

/**
 * 
 * @export
 * @interface LatestUnreviewedOrdersResponse
 */
export interface LatestUnreviewedOrdersResponse {
    /**
     * 
     * @type {Array<OrderItem>}
     * @memberof LatestUnreviewedOrdersResponse
     */
    orders: Array<OrderItem>;
}

/**
 * 
 * @export
 * @interface LinkAccountResponse
 */
export interface LinkAccountResponse {
    /**
     * 
     * @type {string}
     * @memberof LinkAccountResponse
     */
    customToken: string;
}

/**
 * 
 * @export
 * @interface LinkActions
 */
export interface LinkActions {
    /**
     * 
     * @type {Array<string>}
     * @memberof LinkActions
     */
    usersToFollow?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LinkActions
     */
    joinToUserGroups?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LinkActions
     */
    addToWatchLists?: Array<string>;
}

/**
 * 
 * @export
 * @interface LinkGoogleProductCategoriesRequest
 */
export interface LinkGoogleProductCategoriesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof LinkGoogleProductCategoriesRequest
     */
    googleProductCategoryIds: Array<string>;
}

/**
 * 
 * @export
 * @interface LinkHistoryItem
 */
export interface LinkHistoryItem {
    /**
     * 
     * @type {LinkItem}
     * @memberof LinkHistoryItem
     */
    link: LinkItem;
}

/**
 * 
 * @export
 * @interface LinkItem
 */
export interface LinkItem {
    /**
     * 
     * @type {string}
     * @memberof LinkItem
     */
    type: LinkItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LinkItem
     */
    userId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof LinkItem
     */
    profile: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof LinkItem
     */
    method: LinkItemMethodEnum;
    /**
     * 
     * @type {object}
     * @memberof LinkItem
     */
    queryParams?: object;
    /**
     * 
     * @type {LinkUserToFollow}
     * @memberof LinkItem
     */
    actions: LinkUserToFollow;
    /**
     * 
     * @type {ShareTargetItem}
     * @memberof LinkItem
     */
    shareTarget: ShareTargetItem;
    /**
     * 
     * @type {string}
     * @memberof LinkItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LinkItem
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LinkItem
     */
    isWebOnly?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LinkItem
     */
    showEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkItem
     */
    profileId?: string;
    /**
     * 
     * @type {ContentFDLSocialItem}
     * @memberof LinkItem
     */
    social?: ContentFDLSocialItem;
    /**
     * 
     * @type {string}
     * @memberof LinkItem
     */
    shortLinkFDL: string;
    /**
     * 
     * @type {object}
     * @memberof LinkItem
     */
    contentFDL: object;
    /**
     * 
     * @type {string}
     * @memberof LinkItem
     */
    createdAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof LinkItem
     */
    isActive: boolean;
    /**
     * 
     * @type {string}
     * @memberof LinkItem
     */
    updatedAt: string;
}

/**
* @export
* @enum {string}
*/
export enum LinkItemTypeEnum {
    Share = 'SHARE',
    Campaign = 'CAMPAIGN',
    ReferralGifting = 'REFERRAL_GIFTING'
}/**
* @export
* @enum {string}
*/
export enum LinkItemMethodEnum {
    Sms = 'SMS',
    Email = 'EMAIL',
    Facebook = 'FACEBOOK',
    Instagram = 'INSTAGRAM',
    Twitter = 'TWITTER',
    Embed = 'EMBED',
    Generic = 'GENERIC'
}

/**
 * 
 * @export
 * @interface LinkListingsToProductCategoryRequest
 */
export interface LinkListingsToProductCategoryRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof LinkListingsToProductCategoryRequest
     */
    categoryIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LinkListingsToProductCategoryRequest
     */
    listingIds: Array<string>;
}

/**
 * 
 * @export
 * @interface LinkPageRows
 */
export interface LinkPageRows {
    /**
     * 
     * @type {Array<LinkItem>}
     * @memberof LinkPageRows
     */
    rows: Array<LinkItem>;
}

/**
 * 
 * @export
 * @interface LinkPopClipToSeriesRequest
 */
export interface LinkPopClipToSeriesRequest {
    /**
     * null is noop while an empty array means clear its elements
     * @type {Array<AddSeriesPopClipDto>}
     * @memberof LinkPopClipToSeriesRequest
     */
    popClips?: Array<AddSeriesPopClipDto>;
    /**
     * 
     * @type {boolean}
     * @memberof LinkPopClipToSeriesRequest
     */
    append?: boolean;
}

/**
 * 
 * @export
 * @interface LinkProductToCollectionRequest
 */
export interface LinkProductToCollectionRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof LinkProductToCollectionRequest
     */
    listingIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof LinkProductToCollectionRequest
     */
    reorder?: boolean;
}

/**
 * 
 * @export
 * @interface LinkUserDto
 */
export interface LinkUserDto {
    /**
     * 
     * @type {string}
     * @memberof LinkUserDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof LinkUserDto
     */
    verificationId: string;
}

/**
 * 
 * @export
 * @interface LinkUserToFollow
 */
export interface LinkUserToFollow {
    /**
     * 
     * @type {Array<string>}
     * @memberof LinkUserToFollow
     */
    usersToFollow?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LinkUserToFollow
     */
    joinToUserGroups?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LinkUserToFollow
     */
    addToWatchLists?: Array<string>;
}

/**
 * 
 * @export
 * @interface LinksSearchResponse
 */
export interface LinksSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof LinksSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof LinksSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {LinkPageRows}
     * @memberof LinksSearchResponse
     */
    data: LinkPageRows;
}

/**
 * 
 * @export
 * @interface ListingDerivedFromTipToPostDto
 */
export interface ListingDerivedFromTipToPostDto {
    /**
     * 
     * @type {string}
     * @memberof ListingDerivedFromTipToPostDto
     */
    to: ListingDerivedFromTipToPostDtoToEnum;
    /**
     * 
     * @type {string}
     * @memberof ListingDerivedFromTipToPostDto
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof ListingDerivedFromTipToPostDto
     */
    postId: string;
}

/**
* @export
* @enum {string}
*/
export enum ListingDerivedFromTipToPostDtoToEnum {
    Post = 'POST'
}

/**
 * 
 * @export
 * @interface ListingDerivedFromTipToSellerDto
 */
export interface ListingDerivedFromTipToSellerDto {
    /**
     * 
     * @type {string}
     * @memberof ListingDerivedFromTipToSellerDto
     */
    to: ListingDerivedFromTipToSellerDtoToEnum;
    /**
     * 
     * @type {string}
     * @memberof ListingDerivedFromTipToSellerDto
     */
    sellerId: string;
}

/**
* @export
* @enum {string}
*/
export enum ListingDerivedFromTipToSellerDtoToEnum {
    Seller = 'SELLER'
}

/**
 * 
 * @export
 * @interface ListingDropshipDetailsItem
 */
export interface ListingDropshipDetailsItem {
    /**
     * 
     * @type {number}
     * @memberof ListingDropshipDetailsItem
     */
    partnerId: number;
    /**
     * 
     * @type {string}
     * @memberof ListingDropshipDetailsItem
     */
    partnerName: string;
    /**
     * 
     * @type {number}
     * @memberof ListingDropshipDetailsItem
     */
    supplierId: number;
    /**
     * 
     * @type {string}
     * @memberof ListingDropshipDetailsItem
     */
    supplierName: string;
    /**
     * 
     * @type {boolean}
     * @memberof ListingDropshipDetailsItem
     */
    hasActiveAllocation?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ListingDropshipDetailsItem
     */
    allocationStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ListingDropshipDetailsItem
     */
    allocationEndDate?: string;
}

/**
 * 
 * @export
 * @interface ListingMeetingDto
 */
export interface ListingMeetingDto {
    /**
     * 
     * @type {string}
     * @memberof ListingMeetingDto
     */
    startDate: string;
    /**
     * 
     * @type {number}
     * @memberof ListingMeetingDto
     */
    durationInSeconds: number;
    /**
     * 
     * @type {string}
     * @memberof ListingMeetingDto
     */
    timeZone?: string;
    /**
     * 
     * @type {MeetingRepeatFrequencyEnumItem}
     * @memberof ListingMeetingDto
     */
    repeatFrequency?: MeetingRepeatFrequencyEnumItem;
    /**
     * 
     * @type {number}
     * @memberof ListingMeetingDto
     */
    repeatCount?: number;
}

/**
 * 
 * @export
 * @interface ListingMeetingItem
 */
export interface ListingMeetingItem {
    /**
     * 
     * @type {string}
     * @memberof ListingMeetingItem
     */
    startDate: string;
    /**
     * 
     * @type {number}
     * @memberof ListingMeetingItem
     */
    durationInSeconds: number;
    /**
     * 
     * @type {string}
     * @memberof ListingMeetingItem
     */
    endDate: string;
    /**
     * 
     * @type {string}
     * @memberof ListingMeetingItem
     */
    timeZone?: string;
    /**
     * 
     * @type {MeetingRepeatFrequencyEnumItem}
     * @memberof ListingMeetingItem
     */
    repeatFrequency?: MeetingRepeatFrequencyEnumItem;
    /**
     * 
     * @type {number}
     * @memberof ListingMeetingItem
     */
    repeatCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListingMeetingItem
     */
    availableDates?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ListingMeetingItem
     */
    startTime?: number;
    /**
     * 
     * @type {number}
     * @memberof ListingMeetingItem
     */
    endTime?: number;
}

/**
 * 
 * @export
 * @interface ListingProductCategoryItem
 */
export interface ListingProductCategoryItem {
    /**
     * 
     * @type {string}
     * @memberof ListingProductCategoryItem
     */
    parentId?: string;
    /**
     * 
     * @type {string}
     * @memberof ListingProductCategoryItem
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ListingProductCategoryItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ListingProductCategoryItem
     */
    slug?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ListingProductCategoryItem
     */
    isRoot: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListingProductCategoryItem
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListingProductCategoryItem
     */
    custom: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListingProductCategoryItem
     */
    digital?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ListingProductCategoryItem
     */
    sort: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListingProductCategoryItem
     */
    googleProductCategoryIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ListingProductCategoryItem
     */
    id: string;
}

/**
 * 
 * @export
 * @interface ListingRatingType
 */
export interface ListingRatingType {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ListingRatingType
     */
    details?: { [key: string]: number; };
}

/**
 * 
 * @export
 * @interface ListingResponse
 */
export interface ListingResponse {
    /**
     * 
     * @type {string}
     * @memberof ListingResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ListingResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ListingResponse
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof ListingResponse
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof ListingResponse
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof ListingResponse
     */
    defaultImage: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListingResponse
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ListingResponse
     */
    quantity: number;
    /**
     * 
     * @type {Array<ListingVariantDto>}
     * @memberof ListingResponse
     */
    variants?: Array<ListingVariantDto>;
}

/**
 * 
 * @export
 * @interface ListingVariantDto
 */
export interface ListingVariantDto {
    /**
     * 
     * @type {string}
     * @memberof ListingVariantDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ListingVariantDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ListingVariantDto
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof ListingVariantDto
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof ListingVariantDto
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof ListingVariantDto
     */
    externalCheckoutUrl?: string;
}

/**
 * 
 * @export
 * @interface ListingVariantItem
 */
export interface ListingVariantItem {
    /**
     * 
     * @type {string}
     * @memberof ListingVariantItem
     */
    variantId: string;
    /**
     * 
     * @type {number}
     * @memberof ListingVariantItem
     */
    quantity: number;
    /**
     * 
     * @type {StoreListingVariant}
     * @memberof ListingVariantItem
     */
    variant?: StoreListingVariant;
}

/**
 * 
 * @export
 * @interface ListingsAggregatePerShowItem
 */
export interface ListingsAggregatePerShowItem {
    /**
     * 
     * @type {string}
     * @memberof ListingsAggregatePerShowItem
     */
    listingId: string;
    /**
     * 
     * @type {number}
     * @memberof ListingsAggregatePerShowItem
     */
    quantity: number;
    /**
     * 
     * @type {StoreListingItemWithMetadata}
     * @memberof ListingsAggregatePerShowItem
     */
    listing?: StoreListingItemWithMetadata;
    /**
     * 
     * @type {Array<ListingVariantItem>}
     * @memberof ListingsAggregatePerShowItem
     */
    variants?: Array<ListingVariantItem>;
}

/**
 * 
 * @export
 * @interface LiveShowsByEventIdResponse
 */
export interface LiveShowsByEventIdResponse {
    /**
     * 
     * @type {Array<DiscoveryShowLiveStreamItem>}
     * @memberof LiveShowsByEventIdResponse
     */
    data: Array<DiscoveryShowLiveStreamItem>;
}

/**
 * 
 * @export
 * @interface LiveShowsResponse
 */
export interface LiveShowsResponse {
    /**
     * 
     * @type {Array<DiscoveryShowLiveStreamItem>}
     * @memberof LiveShowsResponse
     */
    data: Array<DiscoveryShowLiveStreamItem>;
}

/**
 * 
 * @export
 * @interface LiveStreamAuction
 */
export interface LiveStreamAuction {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuction
     */
    liveStreamId: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuction
     */
    auctionId: string;
}

/**
 * 
 * @export
 * @interface LiveStreamAuctionItem
 */
export interface LiveStreamAuctionItem {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionItem
     */
    liveStreamId: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionItem
     */
    auctionId: string;
}

/**
 * 
 * @export
 * @interface LiveStreamAuctionSendItemItem
 */
export interface LiveStreamAuctionSendItemItem {
    /**
     * 
     * @type {ProfileItem}
     * @memberof LiveStreamAuctionSendItemItem
     */
    fromUser: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionSendItemItem
     */
    fromUserId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof LiveStreamAuctionSendItemItem
     */
    toUser: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionSendItemItem
     */
    toUserId: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionSendItemItem
     */
    listingId: string;
    /**
     * 
     * @type {StoreListingItem}
     * @memberof LiveStreamAuctionSendItemItem
     */
    listing: StoreListingItem;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionSendItemItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionSendItemItem
     */
    variantId?: string;
    /**
     * 
     * @type {number}
     * @memberof LiveStreamAuctionSendItemItem
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionSendItemItem
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionSendItemItem
     */
    status: LiveStreamAuctionSendItemItemStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamAuctionSendItemItem
     */
    needShippingFee: boolean;
    /**
     * 
     * @type {number}
     * @memberof LiveStreamAuctionSendItemItem
     */
    quantity: number;
    /**
     * 
     * @type {LiveStreamAuction}
     * @memberof LiveStreamAuctionSendItemItem
     */
    liveStreamAuction: LiveStreamAuction;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAuctionSendItemItem
     */
    type: LiveStreamAuctionSendItemItemTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum LiveStreamAuctionSendItemItemStatusEnum {
    Processing = 'PROCESSING',
    Canceled = 'CANCELED',
    Confirmed = 'CONFIRMED',
    Rejected = ' REJECTED'
}/**
* @export
* @enum {string}
*/
export enum LiveStreamAuctionSendItemItemTypeEnum {
    LiveStreamAuction = 'liveStreamAuction'
}

/**
 * 
 * @export
 * @interface LiveStreamAudiencesItem
 */
export interface LiveStreamAudiencesItem {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAudiencesItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAudiencesItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAudiencesItem
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAudiencesItem
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamAudiencesItem
     */
    id: string;
}

/**
 * 
 * @export
 * @interface LiveStreamAudiencesPageRows
 */
export interface LiveStreamAudiencesPageRows {
    /**
     * 
     * @type {Array<LiveStreamAudiencesItem>}
     * @memberof LiveStreamAudiencesPageRows
     */
    rows: Array<LiveStreamAudiencesItem>;
}

/**
 * 
 * @export
 * @interface LiveStreamAudiencesSearchResponse
 */
export interface LiveStreamAudiencesSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof LiveStreamAudiencesSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof LiveStreamAudiencesSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {LiveStreamAudiencesPageRows}
     * @memberof LiveStreamAudiencesSearchResponse
     */
    data: LiveStreamAudiencesPageRows;
}

/**
 * 
 * @export
 * @interface LiveStreamBasicOrder
 */
export interface LiveStreamBasicOrder {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamBasicOrder
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamBasicOrder
     */
    orderNumber: string;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamBasicOrder
     */
    canceled: boolean;
}

/**
 * 
 * @export
 * @interface LiveStreamBuyerAddressItemWithId
 */
export interface LiveStreamBuyerAddressItemWithId {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamBuyerAddressItemWithId
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamBuyerAddressItemWithId
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamBuyerAddressItemWithId
     */
    latestOrderCreatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamBuyerAddressItemWithId
     */
    buyerId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof LiveStreamBuyerAddressItemWithId
     */
    buyer: ProfileItem;
    /**
     * 
     * @type {AddressItem}
     * @memberof LiveStreamBuyerAddressItemWithId
     */
    shippingAddress: AddressItem;
    /**
     * 
     * @type {Array<LiveStreamBasicOrder>}
     * @memberof LiveStreamBuyerAddressItemWithId
     */
    masterOrders: Array<LiveStreamBasicOrder>;
    /**
     * 
     * @type {Array<LiveStreamBasicOrder>}
     * @memberof LiveStreamBuyerAddressItemWithId
     */
    slaveOrders: Array<LiveStreamBasicOrder>;
    /**
     * 
     * @type {Array<LiveStreamBasicOrder>}
     * @memberof LiveStreamBuyerAddressItemWithId
     */
    customerOrders: Array<LiveStreamBasicOrder>;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamBuyerAddressItemWithId
     */
    id: string;
}

/**
 * 
 * @export
 * @interface LiveStreamBuyerAddressSearchResponse
 */
export interface LiveStreamBuyerAddressSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof LiveStreamBuyerAddressSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof LiveStreamBuyerAddressSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {LiveStreamBuyerAddressesPageRows}
     * @memberof LiveStreamBuyerAddressSearchResponse
     */
    data: LiveStreamBuyerAddressesPageRows;
}

/**
 * 
 * @export
 * @interface LiveStreamBuyerAddressesPageRows
 */
export interface LiveStreamBuyerAddressesPageRows {
    /**
     * 
     * @type {Array<LiveStreamBuyerAddressItemWithId>}
     * @memberof LiveStreamBuyerAddressesPageRows
     */
    rows: Array<LiveStreamBuyerAddressItemWithId>;
}

/**
 * 
 * @export
 * @interface LiveStreamCloudRecordingItem
 */
export interface LiveStreamCloudRecordingItem {
    /**
     * 
     * @type {LiveStreamCloudRecordingResolutionItem}
     * @memberof LiveStreamCloudRecordingItem
     */
    R_720X960: LiveStreamCloudRecordingResolutionItem;
    /**
     * 
     * @type {LiveStreamCloudRecordingResolutionItem}
     * @memberof LiveStreamCloudRecordingItem
     */
    R_1080X1920: LiveStreamCloudRecordingResolutionItem;
}

/**
 * 
 * @export
 * @interface LiveStreamCloudRecordingResolutionItem
 */
export interface LiveStreamCloudRecordingResolutionItem {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamCloudRecordingResolutionItem
     */
    status: LiveStreamCloudRecordingResolutionItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamCloudRecordingResolutionItem
     */
    m3u8Url?: string;
    /**
     * 
     * @type {number}
     * @memberof LiveStreamCloudRecordingResolutionItem
     */
    bitrate?: number;
}

/**
* @export
* @enum {string}
*/
export enum LiveStreamCloudRecordingResolutionItemStatusEnum {
    Unknown = 'unknown',
    Recording = 'recording',
    Recorded = 'recorded',
    Error = 'error'
}

/**
 * 
 * @export
 * @interface LiveStreamCreateGiveawayItemRequest
 */
export interface LiveStreamCreateGiveawayItemRequest {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamCreateGiveawayItemRequest
     */
    listingId: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamCreateGiveawayItemRequest
     */
    variantId?: string;
    /**
     * 
     * @type {number}
     * @memberof LiveStreamCreateGiveawayItemRequest
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamCreateGiveawayItemRequest
     */
    entryCloseAt?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LiveStreamCreateGiveawayItemRequest
     */
    prerequisites?: Array<LiveStreamCreateGiveawayItemRequestPrerequisitesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LiveStreamCreateGiveawayItemRequest
     */
    criteria?: Array<LiveStreamCreateGiveawayItemRequestCriteriaEnum>;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamCreateGiveawayItemRequest
     */
    title: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LiveStreamCreateGiveawayItemRequest
     */
    coverImages: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamCreateGiveawayItemRequest
     */
    description?: string;
}

/**
* @export
* @enum {string}
*/
export enum LiveStreamCreateGiveawayItemRequestPrerequisitesEnum {
    CommentToEnter = 'CommentToEnter',
    ShareToEnter = 'ShareToEnter'
}/**
* @export
* @enum {string}
*/
export enum LiveStreamCreateGiveawayItemRequestCriteriaEnum {
    CommentToEnter = 'CommentToEnter',
    ShareToEnter = 'ShareToEnter'
}

/**
 * 
 * @export
 * @interface LiveStreamCreateGiveawayWinnerRequest
 */
export interface LiveStreamCreateGiveawayWinnerRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof LiveStreamCreateGiveawayWinnerRequest
     */
    winnerIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamCreateGiveawayWinnerRequest
     */
    needShippingFee: boolean;
    /**
     * 
     * @type {number}
     * @memberof LiveStreamCreateGiveawayWinnerRequest
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof LiveStreamCreateGiveawayWinnerRequest
     */
    price?: number;
}

/**
 * 
 * @export
 * @interface LiveStreamFeedItem
 */
export interface LiveStreamFeedItem {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamFeedItem
     */
    liveStreamId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LiveStreamFeedItem
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamFeedItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamFeedItem
     */
    masterPlaylist?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamFeedItem
     */
    permission?: LiveStreamFeedItemPermissionEnum;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamFeedItem
     */
    preview?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamFeedItem
     */
    background?: string;
}

/**
* @export
* @enum {string}
*/
export enum LiveStreamFeedItemPermissionEnum {
    All = 'all',
    Follower = 'follower',
    Subscriber = 'subscriber',
    NoOne = 'no-one'
}

/**
 * 
 * @export
 * @interface LiveStreamItem
 */
export interface LiveStreamItem {
    /**
     * 
     * @type {Array<string>}
     * @memberof LiveStreamItem
     */
    badges?: Array<string>;
    /**
     * 
     * @type {LiveStreamUserItem}
     * @memberof LiveStreamItem
     */
    primary: LiveStreamUserItem;
    /**
     * 
     * @type {LiveStreamUserItem}
     * @memberof LiveStreamItem
     */
    secondary?: LiveStreamUserItem;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    disconnectedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    mode: LiveStreamItemModeEnum;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    background?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    preview?: string;
    /**
     * 
     * @type {BaseUpcomingShowItem}
     * @memberof LiveStreamItem
     */
    upcomingShow?: BaseUpcomingShowItem;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    permission?: LiveStreamItemPermissionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamItem
     */
    hasListing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamItem
     */
    hasOrder?: boolean;
    /**
     * 
     * @type {LiveStreamRecordingItem}
     * @memberof LiveStreamItem
     */
    recording?: LiveStreamRecordingItem;
    /**
     * 
     * @type {LiveStreamCloudRecordingItem}
     * @memberof LiveStreamItem
     */
    cloudRecording?: LiveStreamCloudRecordingItem;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    eventId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LiveStreamItem
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    eventTemplateId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamItem
     */
    visibilityOfEventShowOnDiscovery?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    wrapUpEmailSentAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamItem
     */
    isDebutShow?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof LiveStreamItem
     */
    shippingMode?: Array<LiveStreamItemShippingModeEnum>;
    /**
     * 
     * @type {ShowCustomizationItem}
     * @memberof LiveStreamItem
     */
    showCustomization?: ShowCustomizationItem;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    masterPlaylist?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    moderationStatus?: LiveStreamItemModerationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    moderatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    moderatedAt?: string;
    /**
     * 
     * @type {ModeratorProfileItem}
     * @memberof LiveStreamItem
     */
    moderatorProfile?: ModeratorProfileItem;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    moderatorUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    moderationFlag?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    moderationAdditionalMsg?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    adminModerationReason?: string;
    /**
     * 
     * @type {AiModerationResultItem}
     * @memberof LiveStreamItem
     */
    aiModerationResult?: AiModerationResultItem;
    /**
     * 
     * @type {object}
     * @memberof LiveStreamItem
     */
    aiModerationLastError?: object;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItem
     */
    accessLevel?: LiveStreamItemAccessLevelEnum;
}

/**
* @export
* @enum {string}
*/
export enum LiveStreamItemModeEnum {
    Normal = 'normal',
    Cap = 'cap'
}/**
* @export
* @enum {string}
*/
export enum LiveStreamItemPermissionEnum {
    All = 'all',
    Follower = 'follower',
    Subscriber = 'subscriber',
    NoOne = 'no-one'
}/**
* @export
* @enum {string}
*/
export enum LiveStreamItemShippingModeEnum {
    Shipping = 'shipping',
    Pickup = 'pickup'
}/**
* @export
* @enum {string}
*/
export enum LiveStreamItemModerationStatusEnum {
    Pending = 'Pending',
    Accepted = 'Accepted',
    Rejected = 'Rejected',
    ReviewRequired = 'ReviewRequired'
}/**
* @export
* @enum {string}
*/
export enum LiveStreamItemAccessLevelEnum {
    All = 'all',
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface LiveStreamItemWithId
 */
export interface LiveStreamItemWithId {
    /**
     * 
     * @type {Array<string>}
     * @memberof LiveStreamItemWithId
     */
    badges?: Array<string>;
    /**
     * 
     * @type {LiveStreamUserItem}
     * @memberof LiveStreamItemWithId
     */
    primary: LiveStreamUserItem;
    /**
     * 
     * @type {LiveStreamUserItem}
     * @memberof LiveStreamItemWithId
     */
    secondary?: LiveStreamUserItem;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    disconnectedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    mode: LiveStreamItemWithIdModeEnum;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    background?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    preview?: string;
    /**
     * 
     * @type {BaseUpcomingShowItem}
     * @memberof LiveStreamItemWithId
     */
    upcomingShow?: BaseUpcomingShowItem;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    permission?: LiveStreamItemWithIdPermissionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamItemWithId
     */
    hasListing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamItemWithId
     */
    hasOrder?: boolean;
    /**
     * 
     * @type {LiveStreamRecordingItem}
     * @memberof LiveStreamItemWithId
     */
    recording?: LiveStreamRecordingItem;
    /**
     * 
     * @type {LiveStreamCloudRecordingItem}
     * @memberof LiveStreamItemWithId
     */
    cloudRecording?: LiveStreamCloudRecordingItem;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    eventId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LiveStreamItemWithId
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    eventTemplateId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamItemWithId
     */
    visibilityOfEventShowOnDiscovery?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    wrapUpEmailSentAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamItemWithId
     */
    isDebutShow?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof LiveStreamItemWithId
     */
    shippingMode?: Array<LiveStreamItemWithIdShippingModeEnum>;
    /**
     * 
     * @type {ShowCustomizationItem}
     * @memberof LiveStreamItemWithId
     */
    showCustomization?: ShowCustomizationItem;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    masterPlaylist?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    moderationStatus?: LiveStreamItemWithIdModerationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    moderatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    moderatedAt?: string;
    /**
     * 
     * @type {ModeratorProfileItem}
     * @memberof LiveStreamItemWithId
     */
    moderatorProfile?: ModeratorProfileItem;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    moderatorUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    moderationFlag?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    moderationAdditionalMsg?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    adminModerationReason?: string;
    /**
     * 
     * @type {AiModerationResultItem}
     * @memberof LiveStreamItemWithId
     */
    aiModerationResult?: AiModerationResultItem;
    /**
     * 
     * @type {object}
     * @memberof LiveStreamItemWithId
     */
    aiModerationLastError?: object;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    accessLevel?: LiveStreamItemWithIdAccessLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamItemWithId
     */
    id: string;
}

/**
* @export
* @enum {string}
*/
export enum LiveStreamItemWithIdModeEnum {
    Normal = 'normal',
    Cap = 'cap'
}/**
* @export
* @enum {string}
*/
export enum LiveStreamItemWithIdPermissionEnum {
    All = 'all',
    Follower = 'follower',
    Subscriber = 'subscriber',
    NoOne = 'no-one'
}/**
* @export
* @enum {string}
*/
export enum LiveStreamItemWithIdShippingModeEnum {
    Shipping = 'shipping',
    Pickup = 'pickup'
}/**
* @export
* @enum {string}
*/
export enum LiveStreamItemWithIdModerationStatusEnum {
    Pending = 'Pending',
    Accepted = 'Accepted',
    Rejected = 'Rejected',
    ReviewRequired = 'ReviewRequired'
}/**
* @export
* @enum {string}
*/
export enum LiveStreamItemWithIdAccessLevelEnum {
    All = 'all',
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface LiveStreamListingVariant
 */
export interface LiveStreamListingVariant {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamListingVariant
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamListingVariant
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof LiveStreamListingVariant
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamListingVariant
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof LiveStreamListingVariant
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof LiveStreamListingVariant
     */
    discountPrice?: number;
    /**
     * 
     * @type {DimsInfo}
     * @memberof LiveStreamListingVariant
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {SingleUnitWeightInfo | PoundWithOunceWeightInfo}
     * @memberof LiveStreamListingVariant
     */
    weight?: SingleUnitWeightInfo | PoundWithOunceWeightInfo;
}

/**
 * 
 * @export
 * @interface LiveStreamPageRows
 */
export interface LiveStreamPageRows {
    /**
     * 
     * @type {Array<SearchLiveStreamItem>}
     * @memberof LiveStreamPageRows
     */
    rows: Array<SearchLiveStreamItem>;
}

/**
 * 
 * @export
 * @interface LiveStreamRecordingItem
 */
export interface LiveStreamRecordingItem {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamRecordingItem
     */
    status: LiveStreamRecordingItemStatusEnum;
    /**
     * 
     * @type {Array<LiveStreamVideo>}
     * @memberof LiveStreamRecordingItem
     */
    videos?: Array<LiveStreamVideo>;
}

/**
* @export
* @enum {string}
*/
export enum LiveStreamRecordingItemStatusEnum {
    Unknown = 'unknown',
    Recording = 'recording',
    Recorded = 'recorded',
    Error = 'error'
}

/**
 * 
 * @export
 * @interface LiveStreamSendItemSourceSource
 */
export interface LiveStreamSendItemSourceSource {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamSendItemSourceSource
     */
    type: LiveStreamSendItemSourceSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamSendItemSourceSource
     */
    liveStreamId: string;
}

/**
* @export
* @enum {string}
*/
export enum LiveStreamSendItemSourceSourceTypeEnum {
    LiveStream = 'liveStream'
}

/**
 * 
 * @export
 * @interface LiveStreamSource
 */
export interface LiveStreamSource {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamSource
     */
    type: LiveStreamSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamSource
     */
    liveStreamId: string;
}

/**
* @export
* @enum {string}
*/
export enum LiveStreamSourceTypeEnum {
    LiveStream = 'LIVE_STREAM'
}

/**
 * 
 * @export
 * @interface LiveStreamStatusItem
 */
export interface LiveStreamStatusItem {
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamStatusItem
     */
    initialized: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamStatusItem
     */
    available: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamStatusItem
     */
    finished: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamStatusItem
     */
    aborted?: boolean;
}

/**
 * 
 * @export
 * @interface LiveStreamUserItem
 */
export interface LiveStreamUserItem {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUserItem
     */
    userId: string;
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof LiveStreamUserItem
     */
    profile: BaseProfileItem;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUserItem
     */
    device?: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUserItem
     */
    lastConnect?: string;
    /**
     * 
     * @type {LiveStreamStatusItem}
     * @memberof LiveStreamUserItem
     */
    status: LiveStreamStatusItem;
}

/**
 * 
 * @export
 * @interface LiveStreamUserStatSegment
 */
export interface LiveStreamUserStatSegment {
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamUserStatSegment
     */
    isNewViewer: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamUserStatSegment
     */
    isNewFollower: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamUserStatSegment
     */
    isNewPurchaser: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamUserStatSegment
     */
    isRepeatPurchaser: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamUserStatSegment
     */
    isRepeatViewer: boolean;
}

/**
 * 
 * @export
 * @interface LiveStreamUserStatsItem
 */
export interface LiveStreamUserStatsItem {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUserStatsItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUserStatsItem
     */
    liveStreamId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LiveStreamUserStatsItem
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUserStatsItem
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUserStatsItem
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUserStatsItem
     */
    userAvatar: string;
    /**
     * duration hours
     * @type {number}
     * @memberof LiveStreamUserStatsItem
     */
    watchedSeconds: number;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUserStatsItem
     */
    watchedFormatted: string;
    /**
     * likes
     * @type {number}
     * @memberof LiveStreamUserStatsItem
     */
    likeCount: number;
    /**
     * total comments number customer typed in the chat
     * @type {number}
     * @memberof LiveStreamUserStatsItem
     */
    commentCount: number;
    /**
     * 
     * @type {number}
     * @memberof LiveStreamUserStatsItem
     */
    shareCount: number;
    /**
     * the number of items that user purchased
     * @type {number}
     * @memberof LiveStreamUserStatsItem
     */
    unitsSold: number;
    /**
     * gmv
     * @type {number}
     * @memberof LiveStreamUserStatsItem
     */
    grossSales: number;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamUserStatsItem
     */
    isActive: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamUserStatsItem
     */
    isFollower: boolean;
    /**
     * 
     * @type {LiveStreamUserStatSegment}
     * @memberof LiveStreamUserStatsItem
     */
    segment: LiveStreamUserStatSegment;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUserStatsItem
     */
    sellerFirstName: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUserStatsItem
     */
    sellerLastName: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUserStatsItem
     */
    sellerUserName: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUserStatsItem
     */
    userFirstName: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUserStatsItem
     */
    userLastName: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUserStatsItem
     */
    customerUserName: string;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUserStatsItem
     */
    lastMainOrderId: string;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamUserStatsItem
     */
    isStoreBlockedUser?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LiveStreamUserStatsItem
     */
    storeBlockedAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof LiveStreamUserStatsItem
     */
    firstHostCustomer: boolean;
    /**
     * 
     * @type {number}
     * @memberof LiveStreamUserStatsItem
     */
    orderTotal: number;
    /**
     * 
     * @type {Array<UserBadgeItem>}
     * @memberof LiveStreamUserStatsItem
     */
    userBadges?: Array<UserBadgeItem>;
}

/**
 * 
 * @export
 * @interface LiveStreamUserStatsPageRows
 */
export interface LiveStreamUserStatsPageRows {
    /**
     * 
     * @type {Array<LiveStreamUserStatsItem>}
     * @memberof LiveStreamUserStatsPageRows
     */
    rows: Array<LiveStreamUserStatsItem>;
}

/**
 * 
 * @export
 * @interface LiveStreamVideo
 */
export interface LiveStreamVideo {
    /**
     * 
     * @type {string}
     * @memberof LiveStreamVideo
     */
    url: string;
    /**
     * 
     * @type {number}
     * @memberof LiveStreamVideo
     */
    size: number;
}

/**
 * 
 * @export
 * @interface LiveStreamsSearchResponse
 */
export interface LiveStreamsSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof LiveStreamsSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof LiveStreamsSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {LiveStreamPageRows}
     * @memberof LiveStreamsSearchResponse
     */
    data: LiveStreamPageRows;
}

/**
 * 
 * @export
 * @interface LocationDto
 */
export interface LocationDto {
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    name: string;
}

/**
 * 
 * @export
 * @interface LocationsDto
 */
export interface LocationsDto {
    /**
     * 
     * @type {Array<LocationDto>}
     * @memberof LocationsDto
     */
    locations: Array<LocationDto>;
}

/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    sessionId: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    deviceId: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    deviceModel: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    lastUsedAppVersion: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    lastUsedAppId: string;
    /**
     * 
     * @type {boolean}
     * @memberof LoginRequest
     */
    hasPushToken: boolean;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    userAgent?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    platform?: LoginRequestPlatformEnum;
}

/**
* @export
* @enum {string}
*/
export enum LoginRequestPlatformEnum {
    Web = 'web'
}

/**
 * 
 * @export
 * @interface LoginSessionData
 */
export interface LoginSessionData {
    /**
     * 
     * @type {boolean}
     * @memberof LoginSessionData
     */
    loggedIn: boolean;
    /**
     * 
     * @type {string}
     * @memberof LoginSessionData
     */
    loggedInAt: string;
    /**
     * 
     * @type {string}
     * @memberof LoginSessionData
     */
    deviceId: string;
    /**
     * 
     * @type {string}
     * @memberof LoginSessionData
     */
    deviceModel: string;
    /**
     * 
     * @type {string}
     * @memberof LoginSessionData
     */
    loggedOutAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginSessionData
     */
    abandonedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginSessionData
     */
    lastUsed: string;
    /**
     * 
     * @type {string}
     * @memberof LoginSessionData
     */
    lastUsedAppVersion: string;
    /**
     * 
     * @type {string}
     * @memberof LoginSessionData
     */
    lastUsedAppId: string;
    /**
     * 
     * @type {string}
     * @memberof LoginSessionData
     */
    userAgent?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginSessionData
     */
    platform?: string;
}

/**
 * 
 * @export
 * @interface LoginSessionResponse
 */
export interface LoginSessionResponse {
    /**
     * 
     * @type {LoginSessionData}
     * @memberof LoginSessionResponse
     */
    data?: LoginSessionData;
}

/**
 * 
 * @export
 * @interface LogoutRequest
 */
export interface LogoutRequest {
    /**
     * 
     * @type {string}
     * @memberof LogoutRequest
     */
    sessionId: string;
}

/**
 * 
 * @export
 * @interface MailDeliveryInfoItem
 */
export interface MailDeliveryInfoItem {
    /**
     * 
     * @type {string}
     * @memberof MailDeliveryInfoItem
     */
    messageId: string;
    /**
     * 
     * @type {string}
     * @memberof MailDeliveryInfoItem
     */
    response: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailDeliveryInfoItem
     */
    accepted: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailDeliveryInfoItem
     */
    rejected: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailDeliveryInfoItem
     */
    pending: Array<string>;
}

/**
 * 
 * @export
 * @interface MailDeliveryItem
 */
export interface MailDeliveryItem {
    /**
     * 
     * @type {string}
     * @memberof MailDeliveryItem
     */
    state: MailDeliveryItemStateEnum;
    /**
     * 
     * @type {string}
     * @memberof MailDeliveryItem
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof MailDeliveryItem
     */
    endTime: string;
    /**
     * 
     * @type {string}
     * @memberof MailDeliveryItem
     */
    leaseExpireTime: string;
    /**
     * 
     * @type {string}
     * @memberof MailDeliveryItem
     */
    error?: string;
    /**
     * 
     * @type {number}
     * @memberof MailDeliveryItem
     */
    attempts: number;
    /**
     * 
     * @type {MailDeliveryInfoItem}
     * @memberof MailDeliveryItem
     */
    info: MailDeliveryInfoItem;
}

/**
* @export
* @enum {string}
*/
export enum MailDeliveryItemStateEnum {
    Pending = 'PENDING',
    Processing = 'PROCESSING',
    Success = 'SUCCESS',
    Error = 'ERROR'
}

/**
 * 
 * @export
 * @interface MailItem
 */
export interface MailItem {
    /**
     * 
     * @type {string}
     * @memberof MailItem
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailItem
     */
    to?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailItem
     */
    toUids?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailItem
     */
    cc?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailItem
     */
    ccUids?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailItem
     */
    bcc?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailItem
     */
    bccUids?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof MailItem
     */
    headers?: object;
    /**
     * 
     * @type {MailMessageItem}
     * @memberof MailItem
     */
    message?: MailMessageItem;
    /**
     * 
     * @type {MailTemplateItem}
     * @memberof MailItem
     */
    template?: MailTemplateItem;
    /**
     * 
     * @type {string}
     * @memberof MailItem
     */
    createdAt?: string;
    /**
     * 
     * @type {MailDeliveryItem}
     * @memberof MailItem
     */
    delivery?: MailDeliveryItem;
    /**
     * 
     * @type {string}
     * @memberof MailItem
     */
    externalId?: string;
}

/**
 * 
 * @export
 * @interface MailMessageItem
 */
export interface MailMessageItem {
    /**
     * 
     * @type {string}
     * @memberof MailMessageItem
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof MailMessageItem
     */
    html: string;
    /**
     * 
     * @type {string}
     * @memberof MailMessageItem
     */
    text: string;
}

/**
 * 
 * @export
 * @interface MailPageRows
 */
export interface MailPageRows {
    /**
     * 
     * @type {Array<MailItem>}
     * @memberof MailPageRows
     */
    rows: Array<MailItem>;
}

/**
 * 
 * @export
 * @interface MailTemplateItem
 */
export interface MailTemplateItem {
    /**
     * 
     * @type {string}
     * @memberof MailTemplateItem
     */
    name: string;
    /**
     * 
     * @type {object}
     * @memberof MailTemplateItem
     */
    data?: object;
}

/**
 * 
 * @export
 * @interface MailsSearchResponse
 */
export interface MailsSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof MailsSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof MailsSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {MailPageRows}
     * @memberof MailsSearchResponse
     */
    data: MailPageRows;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum MeetingRepeatFrequencyEnumItem {
    OneTime = 'ONE_TIME',
    Daily = 'DAILY',
    Weekly = 'WEEKLY',
    Monthly = 'MONTHLY',
    OnWeekdays = 'ON_WEEKDAYS'
}

/**
 * 
 * @export
 * @interface MergeAccountDto
 */
export interface MergeAccountDto {
    /**
     * 
     * @type {string}
     * @memberof MergeAccountDto
     */
    token: string;
}

/**
 * 
 * @export
 * @interface MessageItemShow
 */
export interface MessageItemShow {
    /**
     * 
     * @type {string}
     * @memberof MessageItemShow
     */
    showName: string;
    /**
     * 
     * @type {string}
     * @memberof MessageItemShow
     */
    showImage?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageItemShow
     */
    showId: string;
    /**
     * 
     * @type {string}
     * @memberof MessageItemShow
     */
    showType: MessageItemShowShowTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum MessageItemShowShowTypeEnum {
    LiveStream = 'liveStream',
    UpcomingShow = 'upcomingShow'
}

/**
 * 
 * @export
 * @interface MessageItemWithId
 */
export interface MessageItemWithId {
    /**
     * 
     * @type {string}
     * @memberof MessageItemWithId
     */
    userIdFrom: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof MessageItemWithId
     */
    userProfileFrom: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof MessageItemWithId
     */
    userIdTo: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof MessageItemWithId
     */
    userProfileTo: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof MessageItemWithId
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof MessageItemWithId
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof MessageItemWithId
     */
    buyerId: string;
    /**
     * 
     * @type {string}
     * @memberof MessageItemWithId
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof MessageItemWithId
     */
    videoURL: string;
    /**
     * 
     * @type {string}
     * @memberof MessageItemWithId
     */
    originalVideoURL?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageItemWithId
     */
    transcodeStatus: MessageItemWithIdTranscodeStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MessageItemWithId
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof MessageItemWithId
     */
    gifURL?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageItemWithId
     */
    thumbnailURL?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageItemWithId
     */
    emoji?: MessageItemWithIdEmojiEnum;
    /**
     * 
     * @type {string}
     * @memberof MessageItemWithId
     */
    visibility: MessageItemWithIdVisibilityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof MessageItemWithId
     */
    available: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MessageItemWithId
     */
    featured?: boolean;
    /**
     * 
     * @type {OrderItem}
     * @memberof MessageItemWithId
     */
    order?: OrderItem;
    /**
     * 
     * @type {string}
     * @memberof MessageItemWithId
     */
    purpose?: MessageItemWithIdPurposeEnum;
    /**
     * 
     * @type {MessageItemShow}
     * @memberof MessageItemWithId
     */
    show?: MessageItemShow;
    /**
     * 
     * @type {number}
     * @memberof MessageItemWithId
     */
    upvoteCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MessageItemWithId
     */
    totalReportCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MessageItemWithId
     */
    newReportCount?: number;
    /**
     * 
     * @type {string}
     * @memberof MessageItemWithId
     */
    reportResolveStatus?: MessageItemWithIdReportResolveStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MessageItemWithId
     */
    thankYouType?: MessageItemWithIdThankYouTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MessageItemWithId
     */
    id: string;
}

/**
* @export
* @enum {string}
*/
export enum MessageItemWithIdTranscodeStatusEnum {
    None = 'none',
    Processing = 'processing',
    Transcode = 'transcode',
    Error = 'error'
}/**
* @export
* @enum {string}
*/
export enum MessageItemWithIdEmojiEnum {
    RollingEyesFace = 'rolling_eyes_face',
    Sweat = 'sweat',
    Blush = 'blush',
    Smile = 'smile',
    HeartEyes = 'heart_eyes'
}/**
* @export
* @enum {string}
*/
export enum MessageItemWithIdVisibilityEnum {
    Public = 'public',
    Private = 'private'
}/**
* @export
* @enum {string}
*/
export enum MessageItemWithIdPurposeEnum {
    Review = 'review',
    ThankYou = 'thankYou'
}/**
* @export
* @enum {string}
*/
export enum MessageItemWithIdReportResolveStatusEnum {
    Unresolved = 'Unresolved',
    Resolved = 'Resolved',
    Dismissed = 'Dismissed'
}/**
* @export
* @enum {string}
*/
export enum MessageItemWithIdThankYouTypeEnum {
    RecipientToBuyer = 'RecipientToBuyer',
    SellerToBuyer = 'SellerToBuyer'
}

/**
 * 
 * @export
 * @interface MessageReportItemWithId
 */
export interface MessageReportItemWithId {
    /**
     * 
     * @type {string}
     * @memberof MessageReportItemWithId
     */
    reporterId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof MessageReportItemWithId
     */
    reporterProfile: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof MessageReportItemWithId
     */
    reason: MessageReportItemWithIdReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof MessageReportItemWithId
     */
    resolveStatus: MessageReportItemWithIdResolveStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MessageReportItemWithId
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof MessageReportItemWithId
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof MessageReportItemWithId
     */
    id: string;
}

/**
* @export
* @enum {string}
*/
export enum MessageReportItemWithIdReasonEnum {
    Spam = 'spam',
    Inappropriate = 'inappropriate',
    Aggressive = 'aggressive'
}/**
* @export
* @enum {string}
*/
export enum MessageReportItemWithIdResolveStatusEnum {
    Unresolved = 'Unresolved',
    Resolved = 'Resolved',
    Dismissed = 'Dismissed'
}

/**
 * 
 * @export
 * @interface MessageReportPageRows
 */
export interface MessageReportPageRows {
    /**
     * 
     * @type {Array<MessageReportItemWithId>}
     * @memberof MessageReportPageRows
     */
    rows: Array<MessageReportItemWithId>;
}

/**
 * 
 * @export
 * @interface MessageReportSearchResponse
 */
export interface MessageReportSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof MessageReportSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof MessageReportSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {MessageReportPageRows}
     * @memberof MessageReportSearchResponse
     */
    data: MessageReportPageRows;
}

/**
 * 
 * @export
 * @interface MessagesPageRows
 */
export interface MessagesPageRows {
    /**
     * 
     * @type {Array<MessageItemWithId>}
     * @memberof MessagesPageRows
     */
    rows: Array<MessageItemWithId>;
}

/**
 * 
 * @export
 * @interface MessagesSearchResponse
 */
export interface MessagesSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof MessagesSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof MessagesSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {MessagesPageRows}
     * @memberof MessagesSearchResponse
     */
    data: MessagesPageRows;
}

/**
 * 
 * @export
 * @interface Metadata
 */
export interface Metadata {
    /**
     * 
     * @type {string}
     * @memberof Metadata
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof Metadata
     */
    updated_at: string;
}

/**
 * 
 * @export
 * @interface ModerateLiveStreamRequest
 */
export interface ModerateLiveStreamRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ModerateLiveStreamRequest
     */
    approve: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModerateLiveStreamRequest
     */
    reason?: string;
}

/**
 * 
 * @export
 * @interface ModeratePopStoreThemeTemplateRequest
 */
export interface ModeratePopStoreThemeTemplateRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ModeratePopStoreThemeTemplateRequest
     */
    approve: boolean;
}

/**
 * 
 * @export
 * @interface ModerateStoreListingRequest
 */
export interface ModerateStoreListingRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ModerateStoreListingRequest
     */
    approve: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModerateStoreListingRequest
     */
    reason?: string;
}

/**
 * 
 * @export
 * @interface ModerateStorePostByAdminRequest
 */
export interface ModerateStorePostByAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof ModerateStorePostByAdminRequest
     */
    metaIdentifier?: string;
    /**
     * 
     * @type {ModerationStatusEnumItem}
     * @memberof ModerateStorePostByAdminRequest
     */
    moderationStatus: ModerationStatusEnumItem;
    /**
     * 
     * @type {string}
     * @memberof ModerateStorePostByAdminRequest
     */
    reason?: string;
}

/**
 * 
 * @export
 * @interface ModerateStorePostByAiRequest
 */
export interface ModerateStorePostByAiRequest {
    /**
     * 
     * @type {string}
     * @memberof ModerateStorePostByAiRequest
     */
    metaIdentifier?: string;
    /**
     * 
     * @type {ModerationStatusEnumItem}
     * @memberof ModerateStorePostByAiRequest
     */
    moderationStatus: ModerationStatusEnumItem;
    /**
     * 
     * @type {string}
     * @memberof ModerateStorePostByAiRequest
     */
    reason?: string;
}

/**
 * 
 * @export
 * @interface ModerateStorePostRequest
 */
export interface ModerateStorePostRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ModerateStorePostRequest
     */
    approve: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModerateStorePostRequest
     */
    reason?: string;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ModerationStatusEnumItem {
    Pending = 'Pending',
    Accepted = 'Accepted',
    Rejected = 'Rejected',
    ReviewRequired = 'ReviewRequired'
}

/**
 * 
 * @export
 * @interface ModeratorProfileItem
 */
export interface ModeratorProfileItem {
    /**
     * 
     * @type {string}
     * @memberof ModeratorProfileItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ModeratorProfileItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ModeratorProfileItem
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ModeratorProfileItem
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof ModeratorProfileItem
     */
    avatar?: string;
}

/**
 * 
 * @export
 * @interface ModifyReceivedGiftListingRequest
 */
export interface ModifyReceivedGiftListingRequest {
    /**
     * 
     * @type {string}
     * @memberof ModifyReceivedGiftListingRequest
     */
    referralGiftId: string;
    /**
     * 
     * @type {string}
     * @memberof ModifyReceivedGiftListingRequest
     */
    variantId?: string;
}

/**
 * 
 * @export
 * @interface MostUpvotedCommentResponse
 */
export interface MostUpvotedCommentResponse {
    /**
     * 
     * @type {string}
     * @memberof MostUpvotedCommentResponse
     */
    commentId: string;
    /**
     * 
     * @type {BasicCommentItem}
     * @memberof MostUpvotedCommentResponse
     */
    comment: BasicCommentItem;
    /**
     * 
     * @type {CommentUpvoteItem}
     * @memberof MostUpvotedCommentResponse
     */
    commentUpvote: CommentUpvoteItem;
}

/**
 * 
 * @export
 * @interface MostUpvotedCommentResponseWrapper
 */
export interface MostUpvotedCommentResponseWrapper {
    /**
     * 
     * @type {MostUpvotedCommentResponse}
     * @memberof MostUpvotedCommentResponseWrapper
     */
    comment?: MostUpvotedCommentResponse | null;
}

/**
 * 
 * @export
 * @interface MsmAuthorizationApproveRequest
 */
export interface MsmAuthorizationApproveRequest {
    /**
     * 
     * @type {string}
     * @memberof MsmAuthorizationApproveRequest
     */
    encryptedData: string;
}

/**
 * 
 * @export
 * @interface MsmAuthorizationApproveResponse
 */
export interface MsmAuthorizationApproveResponse {
    /**
     * 
     * @type {string}
     * @memberof MsmAuthorizationApproveResponse
     */
    externalShopId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MsmAuthorizationApproveResponse
     */
    scopes: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MsmAuthorizationApproveResponse
     */
    approveUrl: string;
}

/**
 * 
 * @export
 * @interface MsmAuthorizationDenyResponse
 */
export interface MsmAuthorizationDenyResponse {
    /**
     * 
     * @type {string}
     * @memberof MsmAuthorizationDenyResponse
     */
    externalShopId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MsmAuthorizationDenyResponse
     */
    scopes: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MsmAuthorizationDenyResponse
     */
    denyUrl: string;
}

/**
 * 
 * @export
 * @interface MsmAuthorizationStatusResponse
 */
export interface MsmAuthorizationStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MsmAuthorizationStatusResponse
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof MsmAuthorizationStatusResponse
     */
    externalShopId?: string;
    /**
     * 
     * @type {string}
     * @memberof MsmAuthorizationStatusResponse
     */
    subscriptionLevel?: string;
}

/**
 * 
 * @export
 * @interface MsmAuthorizationValidateRequest
 */
export interface MsmAuthorizationValidateRequest {
    /**
     * 
     * @type {string}
     * @memberof MsmAuthorizationValidateRequest
     */
    encryptedData: string;
}

/**
 * 
 * @export
 * @interface MsmAuthorizationValidateResponse
 */
export interface MsmAuthorizationValidateResponse {
    /**
     * 
     * @type {string}
     * @memberof MsmAuthorizationValidateResponse
     */
    externalShopId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MsmAuthorizationValidateResponse
     */
    scopes: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MsmAuthorizationValidateResponse
     */
    denyUrl: string;
    /**
     * 
     * @type {string}
     * @memberof MsmAuthorizationValidateResponse
     */
    approveUrl: string;
}

/**
 * 
 * @export
 * @interface MultiCurrencyOrderItem
 */
export interface MultiCurrencyOrderItem {
    /**
     * 
     * @type {string}
     * @memberof MultiCurrencyOrderItem
     */
    currency: string;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    exchangeRate: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    buyerPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    shippingFeeAdjusted: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    salesTaxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    salesTaxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    totalPriceIncludeSlaveOrders: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    totalPriceIncludeSlaveOrdersWithProductCoupon: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    totalRefundIncludeSlaveOrders?: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    refund?: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    couponDiscountProductAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    couponDiscountShippingFeeAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    sellerGotAmount: number;
    /**
     * 
     * @type {number}
     * @memberof MultiCurrencyOrderItem
     */
    bonus?: number;
    /**
     * 
     * @type {OrderChargeDistributionItem}
     * @memberof MultiCurrencyOrderItem
     */
    orderChargeDistribution?: OrderChargeDistributionItem;
    /**
     * 
     * @type {Array<OrderRefund>}
     * @memberof MultiCurrencyOrderItem
     */
    refunds?: Array<OrderRefund>;
    /**
     * 
     * @type {OrderItemPriceComponents}
     * @memberof MultiCurrencyOrderItem
     */
    priceComponents?: OrderItemPriceComponents;
}

/**
 * 
 * @export
 * @interface MyCouponDto
 */
export interface MyCouponDto {
    /**
     * 
     * @type {string}
     * @memberof MyCouponDto
     */
    couponId: string;
    /**
     * redeemedCoupons/id
     * @type {string}
     * @memberof MyCouponDto
     */
    redeemedCouponId: string;
    /**
     * 
     * @type {CouponItem}
     * @memberof MyCouponDto
     */
    coupon: CouponItem;
    /**
     * 
     * @type {string}
     * @memberof MyCouponDto
     */
    usedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof MyCouponDto
     */
    redeemedQuantity: number;
}

/**
 * 
 * @export
 * @interface MyCouponsResponseDto
 */
export interface MyCouponsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof MyCouponsResponseDto
     */
    total: number;
    /**
     * 
     * @type {Array<MyCouponDto>}
     * @memberof MyCouponsResponseDto
     */
    coupons: Array<MyCouponDto>;
}

/**
 * 
 * @export
 * @interface MyMonthEarning
 */
export interface MyMonthEarning {
    /**
     * 
     * @type {number}
     * @memberof MyMonthEarning
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof MyMonthEarning
     */
    monthStartDate: string;
}

/**
 * 
 * @export
 * @interface MyPayout
 */
export interface MyPayout {
    /**
     * 
     * @type {number}
     * @memberof MyPayout
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof MyPayout
     */
    date: string;
}

/**
 * 
 * @export
 * @interface MyPayoutItem
 */
export interface MyPayoutItem {
    /**
     * 
     * @type {number}
     * @memberof MyPayoutItem
     */
    amount: number;
    /**
     * 
     * @type {object}
     * @memberof MyPayoutItem
     */
    createdAt: object;
}

/**
 * 
 * @export
 * @interface MyStoreListingItem
 */
export interface MyStoreListingItem {
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof MyStoreListingItem
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof MyStoreListingItem
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    defaultImage: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MyStoreListingItem
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof MyStoreListingItem
     */
    quantity: number;
    /**
     * 
     * @type {Array<StoreListingVariant>}
     * @memberof MyStoreListingItem
     */
    variants?: Array<StoreListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof MyStoreListingItem
     */
    maximumPurchaseQuantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MyStoreListingItem
     */
    shippingFee?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MyStoreListingItem
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    status?: MyStoreListingItemStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof MyStoreListingItem
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {StoreListingOriginalInfo}
     * @memberof MyStoreListingItem
     */
    originalInfo?: StoreListingOriginalInfo;
    /**
     * 
     * @type {DimsInfo}
     * @memberof MyStoreListingItem
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {SingleUnitWeightInfo | PoundWithOunceWeightInfo}
     * @memberof MyStoreListingItem
     */
    weight?: SingleUnitWeightInfo | PoundWithOunceWeightInfo;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof MyStoreListingItem
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    taxCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MyStoreListingItem
     */
    nontaxable?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MyStoreListingItem
     */
    soldQuantityLast7Days?: number;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    storeCoverImage?: string;
    /**
     * 
     * @type {ListingDropshipDetailsItem}
     * @memberof MyStoreListingItem
     */
    dropshipDetails?: ListingDropshipDetailsItem;
    /**
     * 
     * @type {boolean}
     * @memberof MyStoreListingItem
     */
    useLocalPrice?: boolean;
    /**
     * 
     * @type {ListingProductCategoryItem}
     * @memberof MyStoreListingItem
     */
    category?: ListingProductCategoryItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof MyStoreListingItem
     */
    collectionIds?: Array<string>;
    /**
     * 
     * @type {ListingRatingType}
     * @memberof MyStoreListingItem
     */
    rating?: ListingRatingType;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    sizingGuideImage?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    defaultSizingGuideImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MyStoreListingItem
     */
    eligibleForModelMe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MyStoreListingItem
     */
    shopModelMe?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MyStoreListingItem
     */
    categoryIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    type?: MyStoreListingItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MyStoreListingItem
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    discountEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {UploadedFileItem}
     * @memberof MyStoreListingItem
     */
    uploadedFile?: UploadedFileItem;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    moderationStatus?: MyStoreListingItemModerationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    moderatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    moderatorUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    adminModerationReason?: string;
    /**
     * 
     * @type {ModeratorProfileItem}
     * @memberof MyStoreListingItem
     */
    moderatorProfile?: ModeratorProfileItem;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    externalCheckoutUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    externalBrandName?: string;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    externalBrandImage?: string;
    /**
     * 
     * @type {ListingMeetingItem}
     * @memberof MyStoreListingItem
     */
    meeting?: ListingMeetingItem;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    id: string;
    /**
     * 
     * @type {Metadata}
     * @memberof MyStoreListingItem
     */
    metadata: Metadata;
    /**
     * 
     * @type {boolean}
     * @memberof MyStoreListingItem
     */
    isLive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MyStoreListingItem
     */
    externalId?: string;
    /**
     * 
     * @type {Relations}
     * @memberof MyStoreListingItem
     */
    relations?: Relations;
}

/**
* @export
* @enum {string}
*/
export enum MyStoreListingItemStatusEnum {
    Active = 'active',
    Archived = 'archived'
}/**
* @export
* @enum {string}
*/
export enum MyStoreListingItemTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}/**
* @export
* @enum {string}
*/
export enum MyStoreListingItemModerationStatusEnum {
    Pending = 'Pending',
    Accepted = 'Accepted',
    Rejected = 'Rejected',
    ReviewRequired = 'ReviewRequired'
}

/**
 * 
 * @export
 * @interface MyStoreListingPageRows
 */
export interface MyStoreListingPageRows {
    /**
     * 
     * @type {Array<MyStoreListingItem>}
     * @memberof MyStoreListingPageRows
     */
    rows: Array<MyStoreListingItem>;
}

/**
 * 
 * @export
 * @interface MyStoreListingSearchResponse
 */
export interface MyStoreListingSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof MyStoreListingSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof MyStoreListingSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {MyStoreListingPageRows}
     * @memberof MyStoreListingSearchResponse
     */
    data: MyStoreListingPageRows;
}

/**
 * 
 * @export
 * @interface MySubscription
 */
export interface MySubscription {
    /**
     * 
     * @type {string}
     * @memberof MySubscription
     */
    id: string;
    /**
     * 
     * @type {Array<SubscriptionPlan>}
     * @memberof MySubscription
     */
    plans: Array<SubscriptionPlan>;
}

/**
 * 
 * @export
 * @interface MySubscriptionDetails
 */
export interface MySubscriptionDetails {
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    id: string;
    /**
     * 
     * @type {Array<SubscriptionPlan>}
     * @memberof MySubscriptionDetails
     */
    plans: Array<SubscriptionPlan>;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    status: MySubscriptionDetailsStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    collectionMethod: string;
    /**
     * 
     * @type {number}
     * @memberof MySubscriptionDetails
     */
    discountedPrice: number;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    initialStartDate: string;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    currentPeriodStart: string;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    currentPeriodEnd: string;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    cancelledAt?: string;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    cancellationAppliedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    lastInvoiceId: string;
    /**
     * 
     * @type {string}
     * @memberof MySubscriptionDetails
     */
    defaultPaymentMethod: string;
    /**
     * 
     * @type {boolean}
     * @memberof MySubscriptionDetails
     */
    cancelAtPeriodEnd?: boolean;
    /**
     * 
     * @type {PaymentMethodAddress}
     * @memberof MySubscriptionDetails
     */
    address?: PaymentMethodAddress;
}

/**
* @export
* @enum {string}
*/
export enum MySubscriptionDetailsStatusEnum {
    Active = 'active',
    Canceled = 'canceled',
    Incomplete = 'incomplete',
    IncompleteExpired = 'incomplete_expired',
    Trialing = 'trialing',
    PastDue = 'past_due',
    Unpaid = 'unpaid',
    Paused = 'paused'
}

/**
 * 
 * @export
 * @interface NewToPopshopLiveResponse
 */
export interface NewToPopshopLiveResponse {
    /**
     * 
     * @type {Array<DiscoveryShowLiveStreamItem | DiscoveryShowUpcomingShowItem>}
     * @memberof NewToPopshopLiveResponse
     */
    data: Array<DiscoveryShowLiveStreamItem | DiscoveryShowUpcomingShowItem>;
}

/**
 * 
 * @export
 * @interface News
 */
export interface News {
    /**
     * 
     * @type {string}
     * @memberof News
     */
    brief: string;
    /**
     * 
     * @type {boolean}
     * @memberof News
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    expiredAt?: string;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    updatedAt?: string;
}

/**
 * 
 * @export
 * @interface NftItem
 */
export interface NftItem {
    /**
     * 
     * @type {number}
     * @memberof NftItem
     */
    blockNumber: number;
    /**
     * 
     * @type {string}
     * @memberof NftItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof NftItem
     */
    ownerAddress: string;
    /**
     * 
     * @type {NftRemoteInfo}
     * @memberof NftItem
     */
    detail: NftRemoteInfo;
    /**
     * 
     * @type {string}
     * @memberof NftItem
     */
    symbol: string;
    /**
     * 
     * @type {number}
     * @memberof NftItem
     */
    tokenId: number;
    /**
     * 
     * @type {string}
     * @memberof NftItem
     */
    tokenUri: string;
}

/**
 * 
 * @export
 * @interface NftRemoteInfo
 */
export interface NftRemoteInfo {
    /**
     * 
     * @type {string}
     * @memberof NftRemoteInfo
     */
    imageUri?: string;
}

/**
 * 
 * @export
 * @interface NormalSendItemItem
 */
export interface NormalSendItemItem {
    /**
     * 
     * @type {ProfileItem}
     * @memberof NormalSendItemItem
     */
    fromUser: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof NormalSendItemItem
     */
    fromUserId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof NormalSendItemItem
     */
    toUser: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof NormalSendItemItem
     */
    toUserId: string;
    /**
     * 
     * @type {string}
     * @memberof NormalSendItemItem
     */
    listingId: string;
    /**
     * 
     * @type {StoreListingItem}
     * @memberof NormalSendItemItem
     */
    listing: StoreListingItem;
    /**
     * 
     * @type {string}
     * @memberof NormalSendItemItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof NormalSendItemItem
     */
    variantId?: string;
    /**
     * 
     * @type {number}
     * @memberof NormalSendItemItem
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof NormalSendItemItem
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof NormalSendItemItem
     */
    status: NormalSendItemItemStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof NormalSendItemItem
     */
    needShippingFee: boolean;
    /**
     * 
     * @type {number}
     * @memberof NormalSendItemItem
     */
    quantity: number;
    /**
     * 
     * @type {LiveStreamAuctionItem}
     * @memberof NormalSendItemItem
     */
    liveStreamAuction: LiveStreamAuctionItem;
    /**
     * 
     * @type {string}
     * @memberof NormalSendItemItem
     */
    type: NormalSendItemItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NormalSendItemItem
     */
    liveStreamId: string;
}

/**
* @export
* @enum {string}
*/
export enum NormalSendItemItemStatusEnum {
    Processing = 'PROCESSING',
    Canceled = 'CANCELED',
    Confirmed = 'CONFIRMED',
    Rejected = ' REJECTED'
}/**
* @export
* @enum {string}
*/
export enum NormalSendItemItemTypeEnum {
    Normal = 'normal'
}

/**
 * 
 * @export
 * @interface NotificationSettingParam
 */
export interface NotificationSettingParam {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingParam
     */
    isMutedInLive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingParam
     */
    isMuted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingParam
     */
    isCanSendMessageToMe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingParam
     */
    isAutoAnnouncement?: boolean;
}

/**
 * 
 * @export
 * @interface NotificationSettingsData
 */
export interface NotificationSettingsData {
    /**
     * 
     * @type {string}
     * @memberof NotificationSettingsData
     */
    userId: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingsData
     */
    isSeller: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingsData
     */
    isMutedInLive: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingsData
     */
    isMuted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingsData
     */
    isCanSendMessageToMe: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettingsData
     */
    isAutoAnnouncement: boolean;
}

/**
 * 
 * @export
 * @interface NumberRange
 */
export interface NumberRange {
    /**
     * 
     * @type {number}
     * @memberof NumberRange
     */
    gt?: number;
    /**
     * 
     * @type {number}
     * @memberof NumberRange
     */
    gte?: number;
    /**
     * 
     * @type {number}
     * @memberof NumberRange
     */
    lt?: number;
    /**
     * 
     * @type {number}
     * @memberof NumberRange
     */
    lte?: number;
    /**
     * 
     * @type {number}
     * @memberof NumberRange
     */
    equal?: number;
}

/**
 * 
 * @export
 * @interface OAuth2AuthRequest
 */
export interface OAuth2AuthRequest {
    /**
     * 
     * @type {string}
     * @memberof OAuth2AuthRequest
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof OAuth2AuthRequest
     */
    redirectUri: string;
}

/**
 * 
 * @export
 * @interface OnboardingPushCtaItem
 */
export interface OnboardingPushCtaItem {
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushCtaItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushCtaItem
     */
    link: string;
}

/**
 * 
 * @export
 * @interface OnboardingPushCtaRequest
 */
export interface OnboardingPushCtaRequest {
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushCtaRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushCtaRequest
     */
    link: string;
}

/**
 * 
 * @export
 * @interface OnboardingPushItem
 */
export interface OnboardingPushItem {
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushItem
     */
    summary: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushItem
     */
    heading: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushItem
     */
    subtitle: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushItem
     */
    subjectLine: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushItem
     */
    editor: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushItem
     */
    embedCode: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushItem
     */
    contentType: OnboardingPushItemContentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushItem
     */
    cover?: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushItem
     */
    videoUrl?: string;
    /**
     * 
     * @type {VideoSizeItem}
     * @memberof OnboardingPushItem
     */
    videoSize?: VideoSizeItem;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingPushItem
     */
    appearOnAllScreens?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof OnboardingPushItem
     */
    appearOnSpecificPages?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OnboardingPushItem
     */
    visibleTo: Array<OnboardingPushItemVisibleToEnum>;
    /**
     * 
     * @type {number}
     * @memberof OnboardingPushItem
     */
    buttonDelayInSeconds: number;
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushItem
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushItem
     */
    updatedAt: string;
    /**
     * 
     * @type {number}
     * @memberof OnboardingPushItem
     */
    totalViewers: number;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingPushItem
     */
    disabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingPushItem
     */
    published?: boolean;
    /**
     * 
     * @type {OnboardingPushCtaItem}
     * @memberof OnboardingPushItem
     */
    cta?: OnboardingPushCtaItem;
    /**
     * 
     * @type {OnboardingPushNotificationItem}
     * @memberof OnboardingPushItem
     */
    notification?: OnboardingPushNotificationItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof OnboardingPushItem
     */
    sellerIds?: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum OnboardingPushItemContentTypeEnum {
    Video = 'video',
    RichText = 'richText'
}/**
* @export
* @enum {string}
*/
export enum OnboardingPushItemVisibleToEnum {
    Business = 'Business',
    Creator = 'Creator',
    CommentChat = 'CommentChat',
    Vfs = 'VFS'
}

/**
 * 
 * @export
 * @interface OnboardingPushNotificationItem
 */
export interface OnboardingPushNotificationItem {
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushNotificationItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushNotificationItem
     */
    body?: string;
}

/**
 * 
 * @export
 * @interface OnboardingPushNotificationRequest
 */
export interface OnboardingPushNotificationRequest {
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushNotificationRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushNotificationRequest
     */
    body?: string;
}

/**
 * 
 * @export
 * @interface OnboardingPushNotifyRequest
 */
export interface OnboardingPushNotifyRequest {
    /**
     * 
     * @type {string}
     * @memberof OnboardingPushNotifyRequest
     */
    sellerId: string;
}

/**
 * 
 * @export
 * @interface OnboardingPushSearchResponse
 */
export interface OnboardingPushSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof OnboardingPushSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof OnboardingPushSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {OnboardingPushesPageRows}
     * @memberof OnboardingPushSearchResponse
     */
    data: OnboardingPushesPageRows;
}

/**
 * 
 * @export
 * @interface OnboardingPushesPageRows
 */
export interface OnboardingPushesPageRows {
    /**
     * 
     * @type {Array<OnboardingPushItem>}
     * @memberof OnboardingPushesPageRows
     */
    rows: Array<OnboardingPushItem>;
}

/**
 * 
 * @export
 * @interface OneTimeLoginCodeDto
 */
export interface OneTimeLoginCodeDto {
    /**
     * 
     * @type {string}
     * @memberof OneTimeLoginCodeDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof OneTimeLoginCodeDto
     */
    signature: string;
}

/**
 * 
 * @export
 * @interface OneTimeUUIDDto
 */
export interface OneTimeUUIDDto {
    /**
     * 
     * @type {string}
     * @memberof OneTimeUUIDDto
     */
    uuid: string;
    /**
     * 
     * @type {string}
     * @memberof OneTimeUUIDDto
     */
    authUrl: string;
}

/**
 * 
 * @export
 * @interface OneTimeUUIDRequestDto
 */
export interface OneTimeUUIDRequestDto {
    /**
     * 
     * @type {string}
     * @memberof OneTimeUUIDRequestDto
     */
    shopName?: string;
}

/**
 * 
 * @export
 * @interface OnlyAssignToUserItem
 */
export interface OnlyAssignToUserItem {
    /**
     * 
     * @type {boolean}
     * @memberof OnlyAssignToUserItem
     */
    enabled: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof OnlyAssignToUserItem
     */
    userIds: Array<string>;
}

/**
 * 
 * @export
 * @interface OperatorItem
 */
export interface OperatorItem {
    /**
     * 
     * @type {string}
     * @memberof OperatorItem
     */
    profileId: string;
    /**
     * 
     * @type {SimpleProfileItem}
     * @memberof OperatorItem
     */
    profile?: SimpleProfileItem;
}

/**
 * 
 * @export
 * @interface OrderChargeDistributionDropshipAmountsItem
 */
export interface OrderChargeDistributionDropshipAmountsItem {
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    costAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    soldAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    subtotalPaidByPopshop?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    subtotalPaidBySeller?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    managementFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    freeShippingDiscountAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    shippingFeePaidByPopshop?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    shippingFeePaidBySeller?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionDropshipAmountsItem
     */
    supplierWithdrawableAmount: number;
}

/**
 * 
 * @export
 * @interface OrderChargeDistributionItem
 */
export interface OrderChargeDistributionItem {
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    commissionFeeRate: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    commissionFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    gatewayProcessingFeeRate: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    gatewayProcessingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    sellerWithdrawableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    buyerPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    salesTaxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    salesTaxRate: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    couponSellerGotAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    bonus: number;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    couponDiscountProductAmount: number;
    /**
     * 
     * @type {string}
     * @memberof OrderChargeDistributionItem
     */
    shippingFeePayer?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderChargeDistributionItem
     */
    popshopShippingFee?: number;
    /**
     * 
     * @type {OrderChargeDistributionDropshipAmountsItem}
     * @memberof OrderChargeDistributionItem
     */
    dropshipAmounts?: OrderChargeDistributionDropshipAmountsItem;
}

/**
 * 
 * @export
 * @interface OrderCompositionCancellationStatus
 */
export interface OrderCompositionCancellationStatus {
    /**
     * 
     * @type {boolean}
     * @memberof OrderCompositionCancellationStatus
     */
    allCancelled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderCompositionCancellationStatus
     */
    noneCancelled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderCompositionCancellationStatus
     */
    partiallyCancelled: boolean;
}

/**
 * 
 * @export
 * @interface OrderDetailItem
 */
export interface OrderDetailItem {
    /**
     * 
     * @type {RichOrderItemDetail}
     * @memberof OrderDetailItem
     */
    orderItem: RichOrderItemDetail;
    /**
     * 
     * @type {RichOrderItem}
     * @memberof OrderDetailItem
     */
    mainOrderItem?: RichOrderItem;
    /**
     * 
     * @type {OrderStats}
     * @memberof OrderDetailItem
     */
    stats?: OrderStats;
    /**
     * 
     * @type {OrderDetailShippingCostItem}
     * @memberof OrderDetailItem
     */
    shippingCost?: OrderDetailShippingCostItem;
}

/**
 * 
 * @export
 * @interface OrderDetailPageRows
 */
export interface OrderDetailPageRows {
    /**
     * 
     * @type {Array<OrderDetailItem>}
     * @memberof OrderDetailPageRows
     */
    rows: Array<OrderDetailItem>;
}

/**
 * 
 * @export
 * @interface OrderDetailShippingCostItem
 */
export interface OrderDetailShippingCostItem {
    /**
     * 
     * @type {number}
     * @memberof OrderDetailShippingCostItem
     */
    rate: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDetailShippingCostItem
     */
    margin: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDetailShippingCostItem
     */
    surcharge: number;
}

/**
 * 
 * @export
 * @interface OrderDetailWithRefundItem
 */
export interface OrderDetailWithRefundItem {
    /**
     * 
     * @type {OrderItemWithId}
     * @memberof OrderDetailWithRefundItem
     */
    order: OrderItemWithId;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderDetailWithRefundItem
     */
    refundStatus: Array<OrderDetailWithRefundItemRefundStatusEnum>;
    /**
     * 
     * @type {number}
     * @memberof OrderDetailWithRefundItem
     */
    quantity: number;
}

/**
* @export
* @enum {string}
*/
export enum OrderDetailWithRefundItemRefundStatusEnum {
    PartiallyRefunded = 'PartiallyRefunded',
    Refunded = 'Refunded',
    Canceled = 'Canceled'
}

/**
 * 
 * @export
 * @interface OrderDetailsSearchResponse
 */
export interface OrderDetailsSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof OrderDetailsSearchResponse
     */
    total: number;
    /**
     * 
     * @type {OrderDetailPageRows}
     * @memberof OrderDetailsSearchResponse
     */
    data: OrderDetailPageRows;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum OrderEnumItem {
    Asc = 'asc',
    Desc = 'desc'
}

/**
 * 
 * @export
 * @interface OrderGiftPackageItem
 */
export interface OrderGiftPackageItem {
    /**
     * 
     * @type {boolean}
     * @memberof OrderGiftPackageItem
     */
    isGiftPackage: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderGiftPackageItem
     */
    giftMessage?: string;
}

/**
 * 
 * @export
 * @interface OrderGiftingItem
 */
export interface OrderGiftingItem {
    /**
     * 
     * @type {string}
     * @memberof OrderGiftingItem
     */
    recipientId: string;
    /**
     * 
     * @type {RecipientItem}
     * @memberof OrderGiftingItem
     */
    recipient: RecipientItem;
    /**
     * 
     * @type {string}
     * @memberof OrderGiftingItem
     */
    status: OrderGiftingItemStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum OrderGiftingItemStatusEnum {
    Pending = 'PENDING',
    Accepted = 'ACCEPTED',
    Rejected = 'REJECTED'
}

/**
 * 
 * @export
 * @interface OrderItem
 */
export interface OrderItem {
    /**
     * 
     * @type {CommentSoldOrderItem}
     * @memberof OrderItem
     */
    commentSold?: CommentSoldOrderItem;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    eventId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    orderNumber: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    buyerName: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    buyerPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    shippingFeeAdjusted: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItem
     */
    braintreeShippingFeeRefunded?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    salesTaxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    salesTaxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    buyerId: string;
    /**
     * 
     * @type {OrderProfileItem}
     * @memberof OrderItem
     */
    buyer: OrderProfileItem;
    /**
     * 
     * @type {OrderGiftingItem}
     * @memberof OrderItem
     */
    gifting?: OrderGiftingItem;
    /**
     * 
     * @type {OrderGiftPackageItem}
     * @memberof OrderItem
     */
    giftPackage?: OrderGiftPackageItem;
    /**
     * 
     * @type {ShipmentItem}
     * @memberof OrderItem
     */
    shipment?: ShipmentItem;
    /**
     * 
     * @type {PackingSlipItem}
     * @memberof OrderItem
     */
    packingSlip?: PackingSlipItem;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    refund?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    userAgent?: string;
    /**
     * 
     * @type {OrderPaymentItem}
     * @memberof OrderItem
     */
    orderPayment?: OrderPaymentItem;
    /**
     * 
     * @type {PaymentItem}
     * @memberof OrderItem
     */
    payment?: PaymentItem;
    /**
     * 
     * @type {Array<RedeemedCouponItem>}
     * @memberof OrderItem
     */
    coupons?: Array<RedeemedCouponItem>;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    couponDiscountProductAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    couponDiscountShippingFeeAmount?: number;
    /**
     * 
     * @type {SellerTrackingInfoItem}
     * @memberof OrderItem
     */
    sellerTrackingInfo?: SellerTrackingInfoItem;
    /**
     * 
     * @type {Array<SellerTrackingInfoItem>}
     * @memberof OrderItem
     */
    sellerTrackingInfoHistory?: Array<SellerTrackingInfoItem>;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    sellerGotAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    bonus?: number;
    /**
     * 
     * @type {AddressItem}
     * @memberof OrderItem
     */
    shippingAddress: AddressItem;
    /**
     * 
     * @type {PickupAddressItem}
     * @memberof OrderItem
     */
    pickupAddress?: PickupAddressItem;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    listingId: string;
    /**
     * 
     * @type {StoreListingItem}
     * @memberof OrderItem
     */
    listingSnapshot: StoreListingItem;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    sendItemId?: string;
    /**
     * 
     * @type {NormalSendItemItem | LiveStreamAuctionSendItemItem | GiveawaySendItemItem}
     * @memberof OrderItem
     */
    sendItem?: NormalSendItemItem | LiveStreamAuctionSendItemItem | GiveawaySendItemItem;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    sellerId: string;
    /**
     * 
     * @type {OrderProfileItem}
     * @memberof OrderItem
     */
    seller: OrderProfileItem;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    status: OrderItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    orderGroupStatus: OrderItemOrderGroupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    pickupStatus?: OrderItemPickupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    cancelStatus?: OrderItemCancelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    orderGroupCancelStatus?: OrderItemOrderGroupCancelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    orderRefundStatus?: OrderItemOrderRefundStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    orderGroupRefundStatus?: OrderItemOrderGroupRefundStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    shippingMethod: OrderItemShippingMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    shippoOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    variantId?: string;
    /**
     * 
     * @type {StoreFrontItem}
     * @memberof OrderItem
     */
    store: StoreFrontItem;
    /**
     * 
     * @type {OrderShipmentGroupStatus}
     * @memberof OrderItem
     */
    orderShipmentGroupStatus: OrderShipmentGroupStatus;
    /**
     * 
     * @type {ShippingLabelStatus}
     * @memberof OrderItem
     */
    shippingLabelStatus: ShippingLabelStatus;
    /**
     * 
     * @type {ShippingLabelStatus}
     * @memberof OrderItem
     */
    packingSlipStatus: ShippingLabelStatus;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    masterOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    planTimeOfShippingLabelGeneration?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    totalQuantitiesIncludeSlaveOrders: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    totalPriceIncludeSlaveOrders: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    totalPriceIncludeSlaveOrdersWithProductCoupon: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    totalRefundIncludeSlaveOrders?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItem
     */
    newCustomer?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    firstPurchaseAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    updatedAt?: string;
    /**
     * 
     * @type {OrderCompositionCancellationStatus}
     * @memberof OrderItem
     */
    orderCompositionCancellationStatus?: OrderCompositionCancellationStatus;
    /**
     * 
     * @type {OrderChargeDistributionItem}
     * @memberof OrderItem
     */
    orderChargeDistribution?: OrderChargeDistributionItem;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItem
     */
    packed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    pickupNotifiedAt?: string;
    /**
     * 
     * @type {OrderSource}
     * @memberof OrderItem
     */
    source?: OrderSource;
    /**
     * 
     * @type {OrderShipmentParcel}
     * @memberof OrderItem
     */
    shipmentParcel?: OrderShipmentParcel;
    /**
     * 
     * @type {OrderShipmentParcel}
     * @memberof OrderItem
     */
    shipmentOriginalParcel?: OrderShipmentParcel;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    shipmentOriginalParcelSource?: OrderItemShipmentOriginalParcelSourceEnum;
    /**
     * 
     * @type {OrderItemPriceComponents}
     * @memberof OrderItem
     */
    priceComponents?: OrderItemPriceComponents;
    /**
     * 
     * @type {Array<OrderRefund>}
     * @memberof OrderItem
     */
    refunds?: Array<OrderRefund>;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    packageTemplateId?: string;
    /**
     * 
     * @type {OrderItemPackageTemplate}
     * @memberof OrderItem
     */
    packageTemplate?: OrderItemPackageTemplate;
    /**
     * 
     * @type {OrderItemPresetShippingCost}
     * @memberof OrderItem
     */
    presetShippingCost?: OrderItemPresetShippingCost;
    /**
     * 
     * @type {OrderItemDropshipDetails}
     * @memberof OrderItem
     */
    dropshipDetails?: OrderItemDropshipDetails;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    fundAvailableDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    fundAvailableDate2?: string;
    /**
     * 
     * @type {LabelShippingCost}
     * @memberof OrderItem
     */
    labelShippingCost?: LabelShippingCost;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    totalRefundedSalesTax?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    paymentExpireAt?: string;
    /**
     * 
     * @type {MultiCurrencyOrderItem}
     * @memberof OrderItem
     */
    buyerCurrencyOrderDetails?: MultiCurrencyOrderItem;
}

/**
* @export
* @enum {string}
*/
export enum OrderItemStatusEnum {
    Created = 'created',
    Completed = 'completed',
    Canceled = 'canceled',
    PendingPayment = 'pendingPayment',
    ProcessingPayment = 'processingPayment',
    Closed = 'closed'
}/**
* @export
* @enum {string}
*/
export enum OrderItemOrderGroupStatusEnum {
    Open = 'open',
    Processing = 'processing',
    Fulfilling = 'fulfilling',
    Completed = 'completed',
    Canceled = 'canceled'
}/**
* @export
* @enum {string}
*/
export enum OrderItemPickupStatusEnum {
    Open = 'open',
    New = 'new',
    Processing = 'processing',
    Pending = 'pending',
    Packed = 'packed',
    Completed = 'completed',
    Canceled = 'canceled'
}/**
* @export
* @enum {string}
*/
export enum OrderItemCancelStatusEnum {
    SellerApplied = 'seller_applied',
    AdminApproved = 'admin_approved'
}/**
* @export
* @enum {string}
*/
export enum OrderItemOrderGroupCancelStatusEnum {
    PartialCanceled = 'PARTIAL_CANCELED',
    FullyCanceled = 'FULLY_CANCELED'
}/**
* @export
* @enum {string}
*/
export enum OrderItemOrderRefundStatusEnum {
    PartiallyRefunded = 'PARTIALLY_REFUNDED',
    FullyRefunded = 'FULLY_REFUNDED'
}/**
* @export
* @enum {string}
*/
export enum OrderItemOrderGroupRefundStatusEnum {
    PartiallyRefunded = 'PARTIALLY_REFUNDED',
    FullyRefunded = 'FULLY_REFUNDED'
}/**
* @export
* @enum {string}
*/
export enum OrderItemShippingMethodEnum {
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide',
    Pickup = 'pickup',
    DropshipSupplierProvide = 'dropshipSupplierProvide'
}/**
* @export
* @enum {string}
*/
export enum OrderItemShipmentOriginalParcelSourceEnum {
    Default = 'DEFAULT',
    ShowEvent = 'SHOW_EVENT'
}

/**
 * 
 * @export
 * @interface OrderItemDropshipDetails
 */
export interface OrderItemDropshipDetails {
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemDropshipDetails
     */
    isDropship: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDropshipDetails
     */
    partnerId: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDropshipDetails
     */
    supplierId: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDropshipDetails
     */
    commentSoldProductId: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDropshipDetails
     */
    commentSoldVariantId: number;
}

/**
 * 
 * @export
 * @interface OrderItemPackageTemplate
 */
export interface OrderItemPackageTemplate {
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    type: OrderItemPackageTemplateTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemPackageTemplate
     */
    isDefault: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    imageUrl: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPackageTemplate
     */
    shippingPrice: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    shippingCost: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    carrierId: string;
    /**
     * 
     * @type {ShippoCarrier}
     * @memberof OrderItemPackageTemplate
     */
    carrier: ShippoCarrier;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    parcelTemplateId: string;
    /**
     * 
     * @type {ShippoCarrierParcelTemplate}
     * @memberof OrderItemPackageTemplate
     */
    parcelTemplate: ShippoCarrierParcelTemplate;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPackageTemplate
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPackageTemplate
     */
    height: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPackageTemplate
     */
    depth: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    distanceUnit: OrderItemPackageTemplateDistanceUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPackageTemplate
     */
    weight: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    massUnit: OrderItemPackageTemplateMassUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    signatureConfirmationId: string;
    /**
     * 
     * @type {ShippoCarrierSignatureConfirmation}
     * @memberof OrderItemPackageTemplate
     */
    signatureConfirmation: ShippoCarrierSignatureConfirmation;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPackageTemplate
     */
    serviceLevelId: string;
    /**
     * 
     * @type {ShippoCarrierServiceLevel}
     * @memberof OrderItemPackageTemplate
     */
    serviceLevel: ShippoCarrierServiceLevel;
}

/**
* @export
* @enum {string}
*/
export enum OrderItemPackageTemplateTypeEnum {
    Custom = 'CUSTOM',
    Preset = 'PRESET',
    Global = 'GLOBAL',
    SellerCustom = 'SELLER_CUSTOM',
    SellerArrangeMyOwn = 'SELLER_ARRANGE_MY_OWN'
}/**
* @export
* @enum {string}
*/
export enum OrderItemPackageTemplateDistanceUnitEnum {
    Cm = 'cm',
    In = 'in',
    Ft = 'ft',
    M = 'm',
    Mm = 'mm',
    Yd = 'yd'
}/**
* @export
* @enum {string}
*/
export enum OrderItemPackageTemplateMassUnitEnum {
    G = 'g',
    Kg = 'kg',
    Lb = 'lb',
    Oz = 'oz'
}

/**
 * 
 * @export
 * @interface OrderItemPresetShippingCost
 */
export interface OrderItemPresetShippingCost {
    /**
     * 
     * @type {string}
     * @memberof OrderItemPresetShippingCost
     */
    status: OrderItemPresetShippingCostStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPresetShippingCost
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPresetShippingCost
     */
    shippoShipmentId: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPresetShippingCost
     */
    shippoRateId: string;
    /**
     * 
     * @type {ShippoRate}
     * @memberof OrderItemPresetShippingCost
     */
    shippoRate: ShippoRate;
}

/**
* @export
* @enum {string}
*/
export enum OrderItemPresetShippingCostStatusEnum {
    Pending = 'pending',
    Failed = 'failed',
    Success = 'success'
}

/**
 * 
 * @export
 * @interface OrderItemPriceComponents
 */
export interface OrderItemPriceComponents {
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemPriceComponents
     */
    shippingFeeTaxable: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    salesTaxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    salesTaxRate: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponents
     */
    salesTaxRecipient?: OrderItemPriceComponentsSalesTaxRecipientEnum;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    buyerPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    sellerGotAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    sellerGotWithdrawableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    listingPrice: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    listingOriginPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponents
     */
    listingPriceSource?: OrderItemPriceComponentsListingPriceSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    listingQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    listingDiscountedSubTotal: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    commissionFeeRate: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    eventExtraCommissionFeeRate?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    baseCommissionFeeRate: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    commissionFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    gatewayProcessingFeeRate: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    gatewayProcessingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    shipmentDiscountedShippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    shipmentOriginShippingFee: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponents
     */
    shipmentShippingMethod: OrderItemPriceComponentsShipmentShippingMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponents
     */
    shipmentShippingFeePayer: OrderItemPriceComponentsShipmentShippingFeePayerEnum;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    couponDiscountProductAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    couponDiscountShippingFeeAmount: number;
    /**
     * 
     * @type {Array<OrderItemPriceComponentsCouponItem>}
     * @memberof OrderItemPriceComponents
     */
    coupons?: Array<OrderItemPriceComponentsCouponItem>;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponents
     */
    paymentProvider: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    couponSellerGotAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    popshopShippingFee?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponents
     */
    popshopShippingFeeSource?: OrderItemPriceComponentsPopshopShippingFeeSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    sellerShippingFee?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponents
     */
    sellerShippingFeeSource?: OrderItemPriceComponentsSellerShippingFeeSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    referralGiftingDiscountSubtotal?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    referralGiftingDiscountShippingFee?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    referralGiftingDiscountSalesTaxAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponents
     */
    shippingIntegrationType?: OrderItemPriceComponentsShippingIntegrationTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemPriceComponents
     */
    useArrangeMyOwnShippingV2?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    shippingMarginRate?: number;
    /**
     * 
     * @type {RichShippingCostItem}
     * @memberof OrderItemPriceComponents
     */
    defaultShippingCost?: RichShippingCostItem;
    /**
     * 
     * @type {RichShippingCostItem}
     * @memberof OrderItemPriceComponents
     */
    userSelectedShippingCost?: RichShippingCostItem;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    shippingSurcharge?: number;
    /**
     * 
     * @type {DropshipAmountsItem}
     * @memberof OrderItemPriceComponents
     */
    dropshipAmounts?: DropshipAmountsItem;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponents
     */
    subtotal?: number;
}

/**
* @export
* @enum {string}
*/
export enum OrderItemPriceComponentsSalesTaxRecipientEnum {
    Seller = 'seller',
    Popshop = 'popshop'
}/**
* @export
* @enum {string}
*/
export enum OrderItemPriceComponentsListingPriceSourceEnum {
    Listing = 'LISTING',
    Variant = 'VARIANT'
}/**
* @export
* @enum {string}
*/
export enum OrderItemPriceComponentsShipmentShippingMethodEnum {
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide',
    Pickup = 'pickup',
    DropshipSupplierProvide = 'dropshipSupplierProvide'
}/**
* @export
* @enum {string}
*/
export enum OrderItemPriceComponentsShipmentShippingFeePayerEnum {
    Buyer = 'Buyer',
    Seller = 'Seller',
    Popshop = 'Popshop'
}/**
* @export
* @enum {string}
*/
export enum OrderItemPriceComponentsPopshopShippingFeeSourceEnum {
    Default = 'DEFAULT',
    ReadonlyProfile = 'READONLY_PROFILE',
    ReadonlyProfileShippingPrice = 'READONLY_PROFILE_SHIPPING_PRICE',
    ShowEvent = 'SHOW_EVENT',
    Config = 'CONFIG',
    ShippoPlatform = 'SHIPPO_PLATFORM',
    PackageTemplate = 'PACKAGE_TEMPLATE'
}/**
* @export
* @enum {string}
*/
export enum OrderItemPriceComponentsSellerShippingFeeSourceEnum {
    Store = 'STORE',
    Listing = 'LISTING',
    PackageTemplate = 'PACKAGE_TEMPLATE'
}/**
* @export
* @enum {string}
*/
export enum OrderItemPriceComponentsShippingIntegrationTypeEnum {
    Shippo = 'shippo',
    ShippoPlatform = 'shippo_platform'
}

/**
 * 
 * @export
 * @interface OrderItemPriceComponentsCouponItem
 */
export interface OrderItemPriceComponentsCouponItem {
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponentsCouponItem
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponentsCouponItem
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemPriceComponentsCouponItem
     */
    discountedAmount: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponentsCouponItem
     */
    discountPublisher: OrderItemPriceComponentsCouponItemDiscountPublisherEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemPriceComponentsCouponItem
     */
    type: OrderItemPriceComponentsCouponItemTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum OrderItemPriceComponentsCouponItemDiscountPublisherEnum {
    Popshop = 'popshop',
    Seller = 'seller'
}/**
* @export
* @enum {string}
*/
export enum OrderItemPriceComponentsCouponItemTypeEnum {
    DiscountPercent = 'discountPercent',
    DiscountAmount = 'discountAmount',
    FreeShipping = 'freeShipping'
}

/**
 * 
 * @export
 * @interface OrderItemWithId
 */
export interface OrderItemWithId {
    /**
     * 
     * @type {CommentSoldOrderItem}
     * @memberof OrderItemWithId
     */
    commentSold?: CommentSoldOrderItem;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    eventId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    orderNumber: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    buyerName: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    buyerPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    shippingFeeAdjusted: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemWithId
     */
    braintreeShippingFeeRefunded?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    salesTaxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    salesTaxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    buyerId: string;
    /**
     * 
     * @type {OrderProfileItem}
     * @memberof OrderItemWithId
     */
    buyer: OrderProfileItem;
    /**
     * 
     * @type {OrderGiftingItem}
     * @memberof OrderItemWithId
     */
    gifting?: OrderGiftingItem;
    /**
     * 
     * @type {OrderGiftPackageItem}
     * @memberof OrderItemWithId
     */
    giftPackage?: OrderGiftPackageItem;
    /**
     * 
     * @type {ShipmentItem}
     * @memberof OrderItemWithId
     */
    shipment?: ShipmentItem;
    /**
     * 
     * @type {PackingSlipItem}
     * @memberof OrderItemWithId
     */
    packingSlip?: PackingSlipItem;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    refund?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    userAgent?: string;
    /**
     * 
     * @type {OrderPaymentItem}
     * @memberof OrderItemWithId
     */
    orderPayment?: OrderPaymentItem;
    /**
     * 
     * @type {PaymentItem}
     * @memberof OrderItemWithId
     */
    payment?: PaymentItem;
    /**
     * 
     * @type {Array<RedeemedCouponItem>}
     * @memberof OrderItemWithId
     */
    coupons?: Array<RedeemedCouponItem>;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    couponDiscountProductAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    couponDiscountShippingFeeAmount?: number;
    /**
     * 
     * @type {SellerTrackingInfoItem}
     * @memberof OrderItemWithId
     */
    sellerTrackingInfo?: SellerTrackingInfoItem;
    /**
     * 
     * @type {Array<SellerTrackingInfoItem>}
     * @memberof OrderItemWithId
     */
    sellerTrackingInfoHistory?: Array<SellerTrackingInfoItem>;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    sellerGotAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    bonus?: number;
    /**
     * 
     * @type {AddressItem}
     * @memberof OrderItemWithId
     */
    shippingAddress: AddressItem;
    /**
     * 
     * @type {PickupAddressItem}
     * @memberof OrderItemWithId
     */
    pickupAddress?: PickupAddressItem;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    listingId: string;
    /**
     * 
     * @type {StoreListingItem}
     * @memberof OrderItemWithId
     */
    listingSnapshot: StoreListingItem;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    sendItemId?: string;
    /**
     * 
     * @type {NormalSendItemItem | LiveStreamAuctionSendItemItem | GiveawaySendItemItem}
     * @memberof OrderItemWithId
     */
    sendItem?: NormalSendItemItem | LiveStreamAuctionSendItemItem | GiveawaySendItemItem;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    sellerId: string;
    /**
     * 
     * @type {OrderProfileItem}
     * @memberof OrderItemWithId
     */
    seller: OrderProfileItem;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    status: OrderItemWithIdStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    orderGroupStatus: OrderItemWithIdOrderGroupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    pickupStatus?: OrderItemWithIdPickupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    cancelStatus?: OrderItemWithIdCancelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    orderGroupCancelStatus?: OrderItemWithIdOrderGroupCancelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    orderRefundStatus?: OrderItemWithIdOrderRefundStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    orderGroupRefundStatus?: OrderItemWithIdOrderGroupRefundStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    shippingMethod: OrderItemWithIdShippingMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    shippoOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    variantId?: string;
    /**
     * 
     * @type {StoreFrontItem}
     * @memberof OrderItemWithId
     */
    store: StoreFrontItem;
    /**
     * 
     * @type {OrderShipmentGroupStatus}
     * @memberof OrderItemWithId
     */
    orderShipmentGroupStatus: OrderShipmentGroupStatus;
    /**
     * 
     * @type {ShippingLabelStatus}
     * @memberof OrderItemWithId
     */
    shippingLabelStatus: ShippingLabelStatus;
    /**
     * 
     * @type {ShippingLabelStatus}
     * @memberof OrderItemWithId
     */
    packingSlipStatus: ShippingLabelStatus;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    masterOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    planTimeOfShippingLabelGeneration?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    totalQuantitiesIncludeSlaveOrders: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    totalPriceIncludeSlaveOrders: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    totalPriceIncludeSlaveOrdersWithProductCoupon: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    totalRefundIncludeSlaveOrders?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemWithId
     */
    newCustomer?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    firstPurchaseAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    updatedAt?: string;
    /**
     * 
     * @type {OrderCompositionCancellationStatus}
     * @memberof OrderItemWithId
     */
    orderCompositionCancellationStatus?: OrderCompositionCancellationStatus;
    /**
     * 
     * @type {OrderChargeDistributionItem}
     * @memberof OrderItemWithId
     */
    orderChargeDistribution?: OrderChargeDistributionItem;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemWithId
     */
    packed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    pickupNotifiedAt?: string;
    /**
     * 
     * @type {OrderSource}
     * @memberof OrderItemWithId
     */
    source?: OrderSource;
    /**
     * 
     * @type {OrderShipmentParcel}
     * @memberof OrderItemWithId
     */
    shipmentParcel?: OrderShipmentParcel;
    /**
     * 
     * @type {OrderShipmentParcel}
     * @memberof OrderItemWithId
     */
    shipmentOriginalParcel?: OrderShipmentParcel;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    shipmentOriginalParcelSource?: OrderItemWithIdShipmentOriginalParcelSourceEnum;
    /**
     * 
     * @type {OrderItemPriceComponents}
     * @memberof OrderItemWithId
     */
    priceComponents?: OrderItemPriceComponents;
    /**
     * 
     * @type {Array<OrderRefund>}
     * @memberof OrderItemWithId
     */
    refunds?: Array<OrderRefund>;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    packageTemplateId?: string;
    /**
     * 
     * @type {OrderItemPackageTemplate}
     * @memberof OrderItemWithId
     */
    packageTemplate?: OrderItemPackageTemplate;
    /**
     * 
     * @type {OrderItemPresetShippingCost}
     * @memberof OrderItemWithId
     */
    presetShippingCost?: OrderItemPresetShippingCost;
    /**
     * 
     * @type {OrderItemDropshipDetails}
     * @memberof OrderItemWithId
     */
    dropshipDetails?: OrderItemDropshipDetails;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    fundAvailableDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    fundAvailableDate2?: string;
    /**
     * 
     * @type {LabelShippingCost}
     * @memberof OrderItemWithId
     */
    labelShippingCost?: LabelShippingCost;
    /**
     * 
     * @type {number}
     * @memberof OrderItemWithId
     */
    totalRefundedSalesTax?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    paymentExpireAt?: string;
    /**
     * 
     * @type {MultiCurrencyOrderItem}
     * @memberof OrderItemWithId
     */
    buyerCurrencyOrderDetails?: MultiCurrencyOrderItem;
    /**
     * 
     * @type {string}
     * @memberof OrderItemWithId
     */
    id: string;
}

/**
* @export
* @enum {string}
*/
export enum OrderItemWithIdStatusEnum {
    Created = 'created',
    Completed = 'completed',
    Canceled = 'canceled',
    PendingPayment = 'pendingPayment',
    ProcessingPayment = 'processingPayment',
    Closed = 'closed'
}/**
* @export
* @enum {string}
*/
export enum OrderItemWithIdOrderGroupStatusEnum {
    Open = 'open',
    Processing = 'processing',
    Fulfilling = 'fulfilling',
    Completed = 'completed',
    Canceled = 'canceled'
}/**
* @export
* @enum {string}
*/
export enum OrderItemWithIdPickupStatusEnum {
    Open = 'open',
    New = 'new',
    Processing = 'processing',
    Pending = 'pending',
    Packed = 'packed',
    Completed = 'completed',
    Canceled = 'canceled'
}/**
* @export
* @enum {string}
*/
export enum OrderItemWithIdCancelStatusEnum {
    SellerApplied = 'seller_applied',
    AdminApproved = 'admin_approved'
}/**
* @export
* @enum {string}
*/
export enum OrderItemWithIdOrderGroupCancelStatusEnum {
    PartialCanceled = 'PARTIAL_CANCELED',
    FullyCanceled = 'FULLY_CANCELED'
}/**
* @export
* @enum {string}
*/
export enum OrderItemWithIdOrderRefundStatusEnum {
    PartiallyRefunded = 'PARTIALLY_REFUNDED',
    FullyRefunded = 'FULLY_REFUNDED'
}/**
* @export
* @enum {string}
*/
export enum OrderItemWithIdOrderGroupRefundStatusEnum {
    PartiallyRefunded = 'PARTIALLY_REFUNDED',
    FullyRefunded = 'FULLY_REFUNDED'
}/**
* @export
* @enum {string}
*/
export enum OrderItemWithIdShippingMethodEnum {
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide',
    Pickup = 'pickup',
    DropshipSupplierProvide = 'dropshipSupplierProvide'
}/**
* @export
* @enum {string}
*/
export enum OrderItemWithIdShipmentOriginalParcelSourceEnum {
    Default = 'DEFAULT',
    ShowEvent = 'SHOW_EVENT'
}

/**
 * 
 * @export
 * @interface OrderPageRows
 */
export interface OrderPageRows {
    /**
     * 
     * @type {Array<RichOrderItem>}
     * @memberof OrderPageRows
     */
    rows: Array<RichOrderItem>;
}

/**
 * 
 * @export
 * @interface OrderPaymentItem
 */
export interface OrderPaymentItem {
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentItem
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentItem
     */
    braintreeId: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentItem
     */
    nonce?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentItem
     */
    creditCardId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentItem
     */
    paymentType: OrderPaymentItemPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentItem
     */
    status: OrderPaymentItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentItem
     */
    braintreeStatus?: string;
    /**
     * 
     * @type {BraintreeTransactionItem}
     * @memberof OrderPaymentItem
     */
    transaction?: BraintreeTransactionItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderPaymentItem
     */
    refundTransactions?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentItem
     */
    createdAt: string;
}

/**
* @export
* @enum {string}
*/
export enum OrderPaymentItemPaymentTypeEnum {
    Credit = 'credit',
    Applepay = 'applepay',
    Empty = 'empty'
}/**
* @export
* @enum {string}
*/
export enum OrderPaymentItemStatusEnum {
    Approved = 'approved',
    Rejected = 'rejected'
}

/**
 * 
 * @export
 * @interface OrderProfileItem
 */
export interface OrderProfileItem {
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    createdAt?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof OrderProfileItem
     */
    hashtags?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    userType?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    storeType?: OrderProfileItemStoreTypeEnum;
    /**
     * 
     * @type {ProfileAppsItem}
     * @memberof OrderProfileItem
     */
    apps?: ProfileAppsItem;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    popStoreDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    urlCode?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    username?: string;
    /**
     * 
     * @type {ProfileBadges}
     * @memberof OrderProfileItem
     */
    badges?: ProfileBadges;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrderProfileItem
     */
    email: string;
}

/**
* @export
* @enum {string}
*/
export enum OrderProfileItemStoreTypeEnum {
    Business = 'Business',
    Creator = 'Creator',
    CommentChat = 'CommentChat',
    Vfs = 'VFS'
}

/**
 * 
 * @export
 * @interface OrderRefund
 */
export interface OrderRefund {
    /**
     * 
     * @type {string}
     * @memberof OrderRefund
     */
    createdAt: string;
    /**
     * 
     * @type {OrderRefundDetail}
     * @memberof OrderRefund
     */
    detail: OrderRefundDetail;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderRefund
     */
    types: Array<OrderRefundTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof OrderRefund
     */
    updatedAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderRefund
     */
    shouldDeductProcessingAmount?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderRefund
     */
    shouldRestock?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderRefund
     */
    shouldFullyRefund?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderRefund
     */
    reason?: string;
    /**
     * 
     * @type {DropshipSupplierItem}
     * @memberof OrderRefund
     */
    dropshipSupplier: DropshipSupplierItem;
}

/**
* @export
* @enum {string}
*/
export enum OrderRefundTypesEnum {
    All = 'all',
    ShippingFee = 'shippingFee',
    Listing = 'listing',
    CustomAmount = 'customAmount',
    Cancel = 'cancel',
    CancelListing = 'cancelListing'
}

/**
 * 
 * @export
 * @interface OrderRefundDetail
 */
export interface OrderRefundDetail {
    /**
     * 
     * @type {number}
     * @memberof OrderRefundDetail
     */
    listingDiscountedSubTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundDetail
     */
    listingQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundDetail
     */
    salesTaxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundDetail
     */
    subtotal: number;
    /**
     * 
     * @type {string}
     * @memberof OrderRefundDetail
     */
    processingFeePayer: OrderRefundDetailProcessingFeePayerEnum;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundDetail
     */
    deductProcessingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundDetail
     */
    shipmentDiscountedShippingFee: number;
}

/**
* @export
* @enum {string}
*/
export enum OrderRefundDetailProcessingFeePayerEnum {
    Seller = 'SELLER',
    Popshop = 'POPSHOP'
}

/**
 * 
 * @export
 * @interface OrderRefundDetailDto
 */
export interface OrderRefundDetailDto {
    /**
     * 
     * @type {RefundRecordDetailItem}
     * @memberof OrderRefundDetailDto
     */
    refund: RefundRecordDetailItem;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundDetailDto
     */
    currentQuantity: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundDetailDto
     */
    unitRefundAmount: number | null;
}

/**
 * 
 * @export
 * @interface OrderRefundPreviewItem
 */
export interface OrderRefundPreviewItem {
    /**
     * 
     * @type {string}
     * @memberof OrderRefundPreviewItem
     */
    types: OrderRefundPreviewItemTypesEnum;
    /**
     * 
     * @type {OrderRefundPreviewResponseDetail}
     * @memberof OrderRefundPreviewItem
     */
    detail: OrderRefundPreviewResponseDetail;
    /**
     * 
     * @type {boolean}
     * @memberof OrderRefundPreviewItem
     */
    haveUnshippedRelatedOrders?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderRefundPreviewItem
     */
    restockable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderRefundPreviewItem
     */
    shouldRestock?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderRefundPreviewItem
     */
    shouldFullyRefund?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderRefundPreviewItem
     */
    orderId: string;
    /**
     * 
     * @type {OrderRefundPreviewItemRemain}
     * @memberof OrderRefundPreviewItem
     */
    remain: OrderRefundPreviewItemRemain;
    /**
     * 
     * @type {string}
     * @memberof OrderRefundPreviewItem
     */
    nonRestockableReason: OrderRefundPreviewItemNonRestockableReasonEnum;
    /**
     * 
     * @type {OrderRefundPreviewSellerAmountDistribution}
     * @memberof OrderRefundPreviewItem
     */
    sellerAmountDistribution: OrderRefundPreviewSellerAmountDistribution;
}

/**
* @export
* @enum {string}
*/
export enum OrderRefundPreviewItemTypesEnum {
    All = 'all',
    ShippingFee = 'shippingFee',
    Listing = 'listing',
    CustomAmount = 'customAmount',
    Cancel = 'cancel',
    CancelListing = 'cancelListing'
}/**
* @export
* @enum {string}
*/
export enum OrderRefundPreviewItemNonRestockableReasonEnum {
    ListingNotExists = 'LISTING_NOT_EXISTS',
    InventoryNotEnough = 'INVENTORY_NOT_ENOUGH',
    ItemNotFullyRefundedForCustomAmountRefund = 'ITEM_NOT_FULLY_REFUNDED_FOR_CUSTOM_AMOUNT_REFUND',
    IsFullyRestocked = 'IS_FULLY_RESTOCKED',
    RemainListingSubtotalEmpty = 'REMAIN_LISTING_SUBTOTAL_EMPTY'
}

/**
 * 
 * @export
 * @interface OrderRefundPreviewItemRemain
 */
export interface OrderRefundPreviewItemRemain {
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewItemRemain
     */
    remainSalesTaxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewItemRemain
     */
    remainShipmentDiscountedShippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewItemRemain
     */
    remainListingDiscountedSubTotal: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewItemRemain
     */
    remainListingQuantity: number;
}

/**
 * 
 * @export
 * @interface OrderRefundPreviewResponse
 */
export interface OrderRefundPreviewResponse {
    /**
     * 
     * @type {Array<OrderRefundPreviewItem>}
     * @memberof OrderRefundPreviewResponse
     */
    data: Array<OrderRefundPreviewItem>;
}

/**
 * 
 * @export
 * @interface OrderRefundPreviewResponseDetail
 */
export interface OrderRefundPreviewResponseDetail {
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewResponseDetail
     */
    listingDiscountedSubTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewResponseDetail
     */
    listingQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewResponseDetail
     */
    salesTaxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewResponseDetail
     */
    shipmentDiscountedShippingFee?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewResponseDetail
     */
    subtotal: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewResponseDetail
     */
    deductProcessingFee: number;
    /**
     * 
     * @type {string}
     * @memberof OrderRefundPreviewResponseDetail
     */
    processingFeePayer: OrderRefundPreviewResponseDetailProcessingFeePayerEnum;
}

/**
* @export
* @enum {string}
*/
export enum OrderRefundPreviewResponseDetailProcessingFeePayerEnum {
    Seller = 'SELLER',
    Popshop = 'POPSHOP'
}

/**
 * 
 * @export
 * @interface OrderRefundPreviewSellerAmountDistribution
 */
export interface OrderRefundPreviewSellerAmountDistribution {
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewSellerAmountDistribution
     */
    orderSellerGotWithdrawableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewSellerAmountDistribution
     */
    orderDeductSellerGotWithdrawableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewSellerAmountDistribution
     */
    commissionFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewSellerAmountDistribution
     */
    returnCommissionFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewSellerAmountDistribution
     */
    orderGatewayProcessingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewSellerAmountDistribution
     */
    orderReturnGatewayProcessingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewSellerAmountDistribution
     */
    deductItemCouponAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewSellerAmountDistribution
     */
    deductShippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewSellerAmountDistribution
     */
    deductSellerGotWithdrawableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewSellerAmountDistribution
     */
    returnGatewayProcessingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefundPreviewSellerAmountDistribution
     */
    deductBalanceByCoupon?: number;
}

/**
 * 
 * @export
 * @interface OrderRefundsDetailResponse
 */
export interface OrderRefundsDetailResponse {
    /**
     * 
     * @type {Array<OrderRefundDetailDto>}
     * @memberof OrderRefundsDetailResponse
     */
    data: Array<OrderRefundDetailDto>;
}

/**
 * 
 * @export
 * @interface OrderShipmentGroupStatus
 */
export interface OrderShipmentGroupStatus {
    /**
     * 
     * @type {boolean}
     * @memberof OrderShipmentGroupStatus
     */
    master: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderShipmentGroupStatus
     */
    slave: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderShipmentGroupStatus
     */
    customer: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderShipmentGroupStatus
     */
    legacy: boolean;
}

/**
 * 
 * @export
 * @interface OrderShipmentParcel
 */
export interface OrderShipmentParcel {
    /**
     * 
     * @type {string}
     * @memberof OrderShipmentParcel
     */
    distance_unit: string;
    /**
     * 
     * @type {string}
     * @memberof OrderShipmentParcel
     */
    height: string;
    /**
     * 
     * @type {string}
     * @memberof OrderShipmentParcel
     */
    length: string;
    /**
     * 
     * @type {string}
     * @memberof OrderShipmentParcel
     */
    mass_unit: string;
    /**
     * 
     * @type {string}
     * @memberof OrderShipmentParcel
     */
    weight: string;
    /**
     * 
     * @type {string}
     * @memberof OrderShipmentParcel
     */
    width: string;
}

/**
 * 
 * @export
 * @interface OrderSource
 */
export interface OrderSource {
    /**
     * 
     * @type {string}
     * @memberof OrderSource
     */
    type?: OrderSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderSource
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderSource
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderSource
     */
    storeId?: string;
}

/**
* @export
* @enum {string}
*/
export enum OrderSourceTypeEnum {
    UpcomingShow = 'UPCOMING_SHOW',
    LiveStream = 'LIVE_STREAM',
    Store = 'STORE',
    TwoWayStream = 'TWO_WAY_STREAM',
    ReferralGifting = 'REFERRAL_GIFTING',
    SendItem = 'SEND_ITEM',
    TopProducts = 'TOP_PRODUCTS',
    Shop = 'SHOP',
    Replay = 'REPLAY',
    CommentChat = 'COMMENT_CHAT'
}

/**
 * 
 * @export
 * @interface OrderStats
 */
export interface OrderStats {
    /**
     * 
     * @type {number}
     * @memberof OrderStats
     */
    gmv: number;
    /**
     * 
     * @type {number}
     * @memberof OrderStats
     */
    tax: number;
    /**
     * 
     * @type {number}
     * @memberof OrderStats
     */
    quantity: number;
    /**
     * 
     * @type {PackageWeight}
     * @memberof OrderStats
     */
    weight: PackageWeight;
    /**
     * total listing quantity of order group excluding those refunded
     * @type {number}
     * @memberof OrderStats
     */
    listingQuantity: number;
    /**
     * total listing weight of order group excluding those refunded
     * @type {number}
     * @memberof OrderStats
     */
    listingWeightInLb: number;
    /**
     * total listing weight of order group excluding those refunded
     * @type {number}
     * @memberof OrderStats
     */
    listingWeightInG: number;
    /**
     * adjusted shipping fee
     * @type {number}
     * @memberof OrderStats
     */
    shippingFee: number;
}

/**
 * 
 * @export
 * @interface OrderSummaryPriceAdjustmentItem
 */
export interface OrderSummaryPriceAdjustmentItem {
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceAdjustmentItem
     */
    totalAdjustment: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceAdjustmentItem
     */
    listingDiscountedSubTotal: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceAdjustmentItem
     */
    couponAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceAdjustmentItem
     */
    salesTaxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceAdjustmentItem
     */
    shipmentDiscountedShippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceAdjustmentItem
     */
    returnedCommissionFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceAdjustmentItem
     */
    returnGatewayProcessingFee: number;
}

/**
 * 
 * @export
 * @interface OrderSummaryPriceCustomerItem
 */
export interface OrderSummaryPriceCustomerItem {
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceCustomerItem
     */
    listingDiscountedSubTotal: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceCustomerItem
     */
    salesTaxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceCustomerItem
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceCustomerItem
     */
    couponDiscountAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceCustomerItem
     */
    totalAmount: number;
}

/**
 * 
 * @export
 * @interface OrderSummaryPriceIItemWithCurrency
 */
export interface OrderSummaryPriceIItemWithCurrency {
    /**
     * 
     * @type {boolean}
     * @memberof OrderSummaryPriceIItemWithCurrency
     */
    isLegacyOrder: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderSummaryPriceIItemWithCurrency
     */
    isLegacyRefund: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderSummaryPriceIItemWithCurrency
     */
    isLegacyOrderDetail: boolean;
    /**
     * 
     * @type {OrderSummaryPriceCustomerItem}
     * @memberof OrderSummaryPriceIItemWithCurrency
     */
    customer: OrderSummaryPriceCustomerItem;
    /**
     * 
     * @type {OrderSummaryPriceRefundItem}
     * @memberof OrderSummaryPriceIItemWithCurrency
     */
    refund: OrderSummaryPriceRefundItem;
    /**
     * 
     * @type {OrderSummaryPriceRevenueItem}
     * @memberof OrderSummaryPriceIItemWithCurrency
     */
    revenue: OrderSummaryPriceRevenueItem;
    /**
     * 
     * @type {string}
     * @memberof OrderSummaryPriceIItemWithCurrency
     */
    currency: string;
}

/**
 * 
 * @export
 * @interface OrderSummaryPriceItem
 */
export interface OrderSummaryPriceItem {
    /**
     * 
     * @type {boolean}
     * @memberof OrderSummaryPriceItem
     */
    isLegacyOrder: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderSummaryPriceItem
     */
    isLegacyRefund: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderSummaryPriceItem
     */
    isLegacyOrderDetail: boolean;
    /**
     * 
     * @type {OrderSummaryPriceCustomerItem}
     * @memberof OrderSummaryPriceItem
     */
    customer: OrderSummaryPriceCustomerItem;
    /**
     * 
     * @type {OrderSummaryPriceRefundItem}
     * @memberof OrderSummaryPriceItem
     */
    refund: OrderSummaryPriceRefundItem;
    /**
     * 
     * @type {OrderSummaryPriceRevenueItem}
     * @memberof OrderSummaryPriceItem
     */
    revenue: OrderSummaryPriceRevenueItem;
}

/**
 * 
 * @export
 * @interface OrderSummaryPriceOriginalItem
 */
export interface OrderSummaryPriceOriginalItem {
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceOriginalItem
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceOriginalItem
     */
    listingDiscountedSubTotal: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceOriginalItem
     */
    salesTaxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceOriginalItem
     */
    shipmentDiscountedShippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceOriginalItem
     */
    commissionFee: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceOriginalItem
     */
    gatewayProcessingFee: number;
}

/**
 * 
 * @export
 * @interface OrderSummaryPriceRefundItem
 */
export interface OrderSummaryPriceRefundItem {
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceRefundItem
     */
    subtotal: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceRefundItem
     */
    listingDiscountedSubTotal: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceRefundItem
     */
    salesTaxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceRefundItem
     */
    shipmentDiscountedShippingFee: number;
}

/**
 * 
 * @export
 * @interface OrderSummaryPriceRevenueItem
 */
export interface OrderSummaryPriceRevenueItem {
    /**
     * 
     * @type {number}
     * @memberof OrderSummaryPriceRevenueItem
     */
    subtotal: number;
    /**
     * 
     * @type {OrderSummaryPriceOriginalItem}
     * @memberof OrderSummaryPriceRevenueItem
     */
    original: OrderSummaryPriceOriginalItem;
    /**
     * 
     * @type {OrderSummaryPriceAdjustmentItem}
     * @memberof OrderSummaryPriceRevenueItem
     */
    adjustment: OrderSummaryPriceAdjustmentItem;
}

/**
 * 
 * @export
 * @interface OrderTransactionItem
 */
export interface OrderTransactionItem {
    /**
     * 
     * @type {string}
     * @memberof OrderTransactionItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTransactionItem
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTransactionItem
     */
    sellerId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTransactionItem
     */
    buyerId: string;
    /**
     * 
     * @type {number}
     * @memberof OrderTransactionItem
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof OrderTransactionItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTransactionItem
     */
    updatedAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderTransactionItem
     */
    fromBraintree: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderTransactionItem
     */
    type: OrderTransactionItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderTransactionItem
     */
    status: OrderTransactionItemStatusEnum;
    /**
     * 
     * @type {BraintreeTransactionItem}
     * @memberof OrderTransactionItem
     */
    braintreeTransaction: BraintreeTransactionItem;
    /**
     * 
     * @type {string}
     * @memberof OrderTransactionItem
     */
    orderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTransactionItem
     */
    listingName?: string;
}

/**
* @export
* @enum {string}
*/
export enum OrderTransactionItemTypeEnum {
    Sale = 'sale',
    RefundBraintree = 'refundBraintree',
    ShippingFee = 'shippingFee',
    RefundShippingFee = 'refundShippingFee',
    Bonus = 'bonus',
    RefundBonus = 'refundBonus',
    ProductCoupon = 'productCoupon',
    RefundProductCoupon = 'refundProductCoupon'
}/**
* @export
* @enum {string}
*/
export enum OrderTransactionItemStatusEnum {
    Pending = 'pending',
    Completed = 'completed',
    Canceled = 'canceled'
}

/**
 * 
 * @export
 * @interface OrderTransactionPageRows
 */
export interface OrderTransactionPageRows {
    /**
     * 
     * @type {Array<OrderTransactionItem>}
     * @memberof OrderTransactionPageRows
     */
    rows: Array<OrderTransactionItem>;
}

/**
 * 
 * @export
 * @interface OrderTransactionSearchResponse
 */
export interface OrderTransactionSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof OrderTransactionSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof OrderTransactionSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {OrderTransactionPageRows}
     * @memberof OrderTransactionSearchResponse
     */
    data: OrderTransactionPageRows;
}

/**
 * 
 * @export
 * @interface OrdersAggregateByPickupStatusResponse
 */
export interface OrdersAggregateByPickupStatusResponse {
    /**
     * 
     * @type {number}
     * @memberof OrdersAggregateByPickupStatusResponse
     */
    open?: number;
    /**
     * 
     * @type {number}
     * @memberof OrdersAggregateByPickupStatusResponse
     */
    pending?: number;
    /**
     * 
     * @type {number}
     * @memberof OrdersAggregateByPickupStatusResponse
     */
    _new?: number;
    /**
     * 
     * @type {number}
     * @memberof OrdersAggregateByPickupStatusResponse
     */
    processing?: number;
    /**
     * 
     * @type {number}
     * @memberof OrdersAggregateByPickupStatusResponse
     */
    packed?: number;
    /**
     * 
     * @type {number}
     * @memberof OrdersAggregateByPickupStatusResponse
     */
    completed?: number;
    /**
     * 
     * @type {number}
     * @memberof OrdersAggregateByPickupStatusResponse
     */
    canceled?: number;
}

/**
 * 
 * @export
 * @interface OrdersDetailWithRefundResponse
 */
export interface OrdersDetailWithRefundResponse {
    /**
     * 
     * @type {string}
     * @memberof OrdersDetailWithRefundResponse
     */
    orderGroupRefundStatus: OrdersDetailWithRefundResponseOrderGroupRefundStatusEnum;
    /**
     * 
     * @type {Array<OrderDetailWithRefundItem>}
     * @memberof OrdersDetailWithRefundResponse
     */
    enrichOrders: Array<OrderDetailWithRefundItem>;
    /**
     * 
     * @type {OrderSummaryPriceItem}
     * @memberof OrdersDetailWithRefundResponse
     */
    summaryPrice: OrderSummaryPriceItem;
    /**
     * 
     * @type {OrderSummaryPriceIItemWithCurrency}
     * @memberof OrdersDetailWithRefundResponse
     */
    summaryPriceInCurrency?: OrderSummaryPriceIItemWithCurrency;
}

/**
* @export
* @enum {string}
*/
export enum OrdersDetailWithRefundResponseOrderGroupRefundStatusEnum {
    PartiallyRefunded = 'PartiallyRefunded',
    Refunded = 'Refunded',
    Canceled = 'Canceled'
}

/**
 * 
 * @export
 * @interface OrdersSearchResponse
 */
export interface OrdersSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof OrdersSearchResponse
     */
    total: number;
    /**
     * 
     * @type {OrderPageRows}
     * @memberof OrdersSearchResponse
     */
    data: OrderPageRows;
}

/**
 * 
 * @export
 * @interface OurPicksForYouItem
 */
export interface OurPicksForYouItem {
    /**
     * 
     * @type {string}
     * @memberof OurPicksForYouItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OurPicksForYouItem
     */
    sellerPasscode?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OurPicksForYouItem
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OurPicksForYouItem
     */
    createdAt: string;
    /**
     * 
     * @type {SocialAccountDto}
     * @memberof OurPicksForYouItem
     */
    socialAccounts?: SocialAccountDto;
    /**
     * 
     * @type {string}
     * @memberof OurPicksForYouItem
     */
    agencyId?: string;
    /**
     * 
     * @type {AgencyItemWithId}
     * @memberof OurPicksForYouItem
     */
    agency?: AgencyItemWithId;
    /**
     * 
     * @type {string}
     * @memberof OurPicksForYouItem
     */
    passcode: string;
    /**
     * 
     * @type {string}
     * @memberof OurPicksForYouItem
     */
    lastLiveStreamDate?: string;
    /**
     * 
     * @type {number}
     * @memberof OurPicksForYouItem
     */
    shippingFee?: number;
    /**
     * 
     * @type {number}
     * @memberof OurPicksForYouItem
     */
    adjustedPopshopShippingFee?: number;
    /**
     * 
     * @type {string}
     * @memberof OurPicksForYouItem
     */
    bio?: string;
    /**
     * 
     * @type {string}
     * @memberof OurPicksForYouItem
     */
    announcement?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof OurPicksForYouItem
     */
    salesTaxRate?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof OurPicksForYouItem
     */
    secondOfShippingLabelGeneration: number;
    /**
     * 
     * @type {BaseUpcomingShowItem}
     * @memberof OurPicksForYouItem
     */
    upcomingShow?: BaseUpcomingShowItem;
    /**
     * 
     * @type {string}
     * @memberof OurPicksForYouItem
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {object}
     * @memberof OurPicksForYouItem
     */
    liveStream?: object;
    /**
     * 
     * @type {string}
     * @memberof OurPicksForYouItem
     */
    liveStreamId?: string;
    /**
     * 
     * @type {EvergreenVideoItem}
     * @memberof OurPicksForYouItem
     */
    evergreenVideo?: EvergreenVideoItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof OurPicksForYouItem
     */
    badges?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OurPicksForYouItem
     */
    shortDescription?: string;
    /**
     * 
     * @type {ShowCustomizationItem}
     * @memberof OurPicksForYouItem
     */
    showCustomization?: ShowCustomizationItem;
    /**
     * 
     * @type {string}
     * @memberof OurPicksForYouItem
     */
    defaultCoverImage?: string;
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof OurPicksForYouItem
     */
    profile: BaseProfileItem;
    /**
     * 
     * @type {string}
     * @memberof OurPicksForYouItem
     */
    id: string;
}

/**
 * 
 * @export
 * @interface OurPicksForYouResponse
 */
export interface OurPicksForYouResponse {
    /**
     * 
     * @type {Array<OurPicksForYouItem>}
     * @memberof OurPicksForYouResponse
     */
    data: Array<OurPicksForYouItem>;
}

/**
 * 
 * @export
 * @interface PackageWeight
 */
export interface PackageWeight {
    /**
     * 
     * @type {number}
     * @memberof PackageWeight
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof PackageWeight
     */
    unit: PackageWeightUnitEnum;
}

/**
* @export
* @enum {string}
*/
export enum PackageWeightUnitEnum {
    G = 'g',
    Kg = 'kg',
    Lb = 'lb',
    Oz = 'oz'
}

/**
 * 
 * @export
 * @interface PackingSlipItem
 */
export interface PackingSlipItem {
    /**
     * 
     * @type {string}
     * @memberof PackingSlipItem
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof PackingSlipItem
     */
    expires: string;
    /**
     * 
     * @type {string}
     * @memberof PackingSlipItem
     */
    slipUrl: string;
}

/**
 * 
 * @export
 * @interface PageInfo
 */
export interface PageInfo {
    /**
     * 
     * @type {boolean}
     * @memberof PageInfo
     */
    hasNextPage: boolean;
    /**
     * 
     * @type {string}
     * @memberof PageInfo
     */
    endCursor: string;
}

/**
 * 
 * @export
 * @interface PageLiveStreamRow
 */
export interface PageLiveStreamRow {
    /**
     * 
     * @type {string}
     * @memberof PageLiveStreamRow
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof PageLiveStreamRow
     */
    type: PageLiveStreamRowTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PageLiveStreamRow
     */
    liveStreamId: string;
}

/**
* @export
* @enum {string}
*/
export enum PageLiveStreamRowTypeEnum {
    LiveStream = 'liveStream'
}

/**
 * 
 * @export
 * @interface PageProductsResponse
 */
export interface PageProductsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof PageProductsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof PageProductsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {PageProductsRows}
     * @memberof PageProductsResponse
     */
    data: PageProductsRows;
}

/**
 * 
 * @export
 * @interface PageProductsRows
 */
export interface PageProductsRows {
    /**
     * 
     * @type {Array<PageLiveStreamRow | PageUpcomingShowRow>}
     * @memberof PageProductsRows
     */
    rows: Array<PageLiveStreamRow | PageUpcomingShowRow>;
}

/**
 * 
 * @export
 * @interface PageUpcomingShowRow
 */
export interface PageUpcomingShowRow {
    /**
     * 
     * @type {string}
     * @memberof PageUpcomingShowRow
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof PageUpcomingShowRow
     */
    type: PageUpcomingShowRowTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PageUpcomingShowRow
     */
    upcomingShowId: string;
}

/**
* @export
* @enum {string}
*/
export enum PageUpcomingShowRowTypeEnum {
    UpcomingShow = 'upcomingShow'
}

/**
 * 
 * @export
 * @interface PatchAppSellerApplicationRequest
 */
export interface PatchAppSellerApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchAppSellerApplicationRequest
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchAppSellerApplicationRequest
     */
    storeType?: PatchAppSellerApplicationRequestStoreTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchAppSellerApplicationRequest
     */
    updateMask: Array<PatchAppSellerApplicationRequestUpdateMaskEnum>;
}

/**
* @export
* @enum {string}
*/
export enum PatchAppSellerApplicationRequestStoreTypeEnum {
    Business = 'Business',
    Creator = 'Creator',
    CommentChat = 'CommentChat',
    Vfs = 'VFS'
}/**
* @export
* @enum {string}
*/
export enum PatchAppSellerApplicationRequestUpdateMaskEnum {
    Message = 'message',
    StoreType = 'storeType'
}

/**
 * 
 * @export
 * @interface PatchBadgeRequest
 */
export interface PatchBadgeRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchBadgeRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchBadgeRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchBadgeRequest
     */
    currentStep?: PatchBadgeRequestCurrentStepEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchBadgeRequest
     */
    limit?: PatchBadgeRequestLimitEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchBadgeRequest
     */
    url?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchBadgeRequest
     */
    updateMask: Array<PatchBadgeRequestUpdateMaskEnum>;
}

/**
* @export
* @enum {string}
*/
export enum PatchBadgeRequestCurrentStepEnum {
    FillBaseInfo = 'FILL_BASE_INFO',
    UploadBadge = 'UPLOAD_BADGE',
    ConfirmBadge = 'CONFIRM_BADGE',
    ReviewBadge = 'REVIEW_BADGE'
}/**
* @export
* @enum {string}
*/
export enum PatchBadgeRequestLimitEnum {
    BadgeLimit5 = 'Badge_LIMIT_5',
    BadgeLimit25 = 'Badge_LIMIT_25',
    BadgeLimit100 = 'Badge_LIMIT_100',
    BadgeLimit250 = 'Badge_LIMIT_250',
    BadgeLimit500 = 'Badge_LIMIT_500',
    BadgeLimit1000 = 'Badge_LIMIT_1000',
    Unlimited = 'Unlimited'
}/**
* @export
* @enum {string}
*/
export enum PatchBadgeRequestUpdateMaskEnum {
    Name = 'name',
    Description = 'description',
    CurrentStep = 'currentStep',
    Limit = 'limit',
    Url = 'url'
}

/**
 * 
 * @export
 * @interface PatchCategoryDiscoveryRowRequest
 */
export interface PatchCategoryDiscoveryRowRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PatchCategoryDiscoveryRowRequest
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchCategoryDiscoveryRowRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchCategoryDiscoveryRowRequest
     */
    urlCode?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchCategoryDiscoveryRowRequest
     */
    categoryIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchCategoryDiscoveryRowRequest
     */
    updateMask: Array<PatchCategoryDiscoveryRowRequestUpdateMaskEnum>;
}

/**
* @export
* @enum {string}
*/
export enum PatchCategoryDiscoveryRowRequestUpdateMaskEnum {
    Enabled = 'enabled',
    Title = 'title',
    UrlCode = 'urlCode',
    CategoryIds = 'categoryIds'
}

/**
 * 
 * @export
 * @interface PatchFeaturedShowRequest
 */
export interface PatchFeaturedShowRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PatchFeaturedShowRequest
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchFeaturedShowRequest
     */
    sortedAt?: string;
}

/**
 * 
 * @export
 * @interface PatchLinkRequest
 */
export interface PatchLinkRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PatchLinkRequest
     */
    sentSuccess?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchLinkRequest
     */
    updateMask: Array<PatchLinkRequestUpdateMaskEnum>;
}

/**
* @export
* @enum {string}
*/
export enum PatchLinkRequestUpdateMaskEnum {
    SentSuccess = 'sentSuccess'
}

/**
 * 
 * @export
 * @interface PatchLiveStreamRequest
 */
export interface PatchLiveStreamRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchLiveStreamRequest
     */
    soldOutAction?: PatchLiveStreamRequestSoldOutActionEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchLiveStreamRequest
     */
    mode?: PatchLiveStreamRequestModeEnum;
    /**
     * 
     * @type {SetShowCustomizationRequest}
     * @memberof PatchLiveStreamRequest
     */
    showCustomization?: SetShowCustomizationRequest;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchLiveStreamRequest
     */
    updateMask: Array<PatchLiveStreamRequestUpdateMaskEnum>;
}

/**
* @export
* @enum {string}
*/
export enum PatchLiveStreamRequestSoldOutActionEnum {
    MoveToBack = 'MoveToBack',
    RemoveFromShow = 'RemoveFromShow'
}/**
* @export
* @enum {string}
*/
export enum PatchLiveStreamRequestModeEnum {
    Normal = 'normal',
    Cap = 'cap'
}/**
* @export
* @enum {string}
*/
export enum PatchLiveStreamRequestUpdateMaskEnum {
    SoldOutAction = 'soldOutAction',
    Mode = 'mode',
    ShowCustomization = 'showCustomization'
}

/**
 * 
 * @export
 * @interface PatchPackageTemplateRequest
 */
export interface PatchPackageTemplateRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PatchPackageTemplateRequest
     */
    isDefault?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchPackageTemplateRequest
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchPackageTemplateRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchPackageTemplateRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchPackageTemplateRequest
     */
    shippingPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchPackageTemplateRequest
     */
    shippingCost?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchPackageTemplateRequest
     */
    carrierId?: PatchPackageTemplateRequestCarrierIdEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchPackageTemplateRequest
     */
    parcelTemplateId?: PatchPackageTemplateRequestParcelTemplateIdEnum;
    /**
     * 
     * @type {number}
     * @memberof PatchPackageTemplateRequest
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchPackageTemplateRequest
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchPackageTemplateRequest
     */
    depth?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchPackageTemplateRequest
     */
    weight?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchPackageTemplateRequest
     */
    distanceUnit?: PatchPackageTemplateRequestDistanceUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchPackageTemplateRequest
     */
    signatureConfirmationId?: PatchPackageTemplateRequestSignatureConfirmationIdEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchPackageTemplateRequest
     */
    massUnit?: PatchPackageTemplateRequestMassUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchPackageTemplateRequest
     */
    serviceLevelId?: PatchPackageTemplateRequestServiceLevelIdEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchPackageTemplateRequest
     */
    updateMask: Array<PatchPackageTemplateRequestUpdateMaskEnum>;
}

/**
* @export
* @enum {string}
*/
export enum PatchPackageTemplateRequestCarrierIdEnum {
    Usps = 'usps'
}/**
* @export
* @enum {string}
*/
export enum PatchPackageTemplateRequestParcelTemplateIdEnum {
    Envelope = 'Envelope',
    Package = 'Package',
    UspsRegionalRateBoxB1 = 'USPS_RegionalRateBoxB1',
    UspsRegionalRateBoxB2 = 'USPS_RegionalRateBoxB2',
    UspsIrregularParcel = 'USPS_IrregularParcel',
    UspsCard = 'USPS_Card',
    UspsFlatRateCardboardEnvelope = 'USPS_FlatRateCardboardEnvelope',
    UspsFlatRateLegalEnvelope = 'USPS_FlatRateLegalEnvelope',
    UspsFlatRateEnvelope = 'USPS_FlatRateEnvelope',
    UspsFlatRateGiftCardEnvelope = 'USPS_FlatRateGiftCardEnvelope',
    UspsLargeVideoFlatRateBox = 'USPS_LargeVideoFlatRateBox',
    UspsLargeFlatRateBoardGameBox = 'USPS_LargeFlatRateBoardGameBox',
    UspsSmallFlatRateEnvelope = 'USPS_SmallFlatRateEnvelope',
    UspsSoftPack = 'USPS_SoftPack',
    UspsLargeFlatRateBox = 'USPS_LargeFlatRateBox',
    UspsMediumFlatRateBox1 = 'USPS_MediumFlatRateBox1',
    UspsMediumFlatRateBox2 = 'USPS_MediumFlatRateBox2',
    UspsSmallFlatRateBox = 'USPS_SmallFlatRateBox',
    UspsRegionalRateBoxA1 = 'USPS_RegionalRateBoxA1',
    UspsRegionalRateBoxA2 = 'USPS_RegionalRateBoxA2',
    UspsApoFlatRateBox = 'USPS_APOFlatRateBox',
    UspsFlatRateWindowEnvelope = 'USPS_FlatRateWindowEnvelope',
    UspsFlatRatePaddedEnvelope = 'USPS_FlatRatePaddedEnvelope'
}/**
* @export
* @enum {string}
*/
export enum PatchPackageTemplateRequestDistanceUnitEnum {
    Cm = 'cm',
    In = 'in',
    Ft = 'ft',
    M = 'm',
    Mm = 'mm',
    Yd = 'yd'
}/**
* @export
* @enum {string}
*/
export enum PatchPackageTemplateRequestSignatureConfirmationIdEnum {
    Standard = 'STANDARD',
    Adult = 'ADULT',
    Certified = 'CERTIFIED'
}/**
* @export
* @enum {string}
*/
export enum PatchPackageTemplateRequestMassUnitEnum {
    G = 'g',
    Kg = 'kg',
    Lb = 'lb',
    Oz = 'oz'
}/**
* @export
* @enum {string}
*/
export enum PatchPackageTemplateRequestServiceLevelIdEnum {
    Cheapest = 'CHEAPEST',
    Fastest = 'FASTEST',
    UspsGroundAdvantage = 'usps_ground_advantage',
    UspsPriority = 'usps_priority',
    UspsPriorityExpress = 'usps_priority_express'
}/**
* @export
* @enum {string}
*/
export enum PatchPackageTemplateRequestUpdateMaskEnum {
    IsDefault = 'isDefault',
    ImageUrl = 'imageUrl',
    Name = 'name',
    Description = 'description',
    ShippingPrice = 'shippingPrice',
    ShippingCost = 'shippingCost',
    CarrierId = 'carrierId',
    ParcelTemplateId = 'parcelTemplateId',
    Width = 'width',
    Height = 'height',
    Depth = 'depth',
    Weight = 'weight',
    DistanceUnit = 'distanceUnit',
    SignatureConfirmationId = 'signatureConfirmationId',
    MassUnit = 'massUnit',
    ServiceLevelId = 'serviceLevelId'
}

/**
 * 
 * @export
 * @interface PatchPackageTemplateUnitRequest
 */
export interface PatchPackageTemplateUnitRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchPackageTemplateUnitRequest
     */
    distanceUnit: PatchPackageTemplateUnitRequestDistanceUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchPackageTemplateUnitRequest
     */
    massUnit: PatchPackageTemplateUnitRequestMassUnitEnum;
}

/**
* @export
* @enum {string}
*/
export enum PatchPackageTemplateUnitRequestDistanceUnitEnum {
    Cm = 'cm',
    In = 'in',
    Ft = 'ft',
    M = 'm',
    Mm = 'mm',
    Yd = 'yd'
}/**
* @export
* @enum {string}
*/
export enum PatchPackageTemplateUnitRequestMassUnitEnum {
    G = 'g',
    Kg = 'kg',
    Lb = 'lb',
    Oz = 'oz'
}

/**
 * 
 * @export
 * @interface PatchPayoutRequest
 */
export interface PatchPayoutRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchPayoutRequest
     */
    status?: PatchPayoutRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchPayoutRequest
     */
    payoutDate?: string;
}

/**
* @export
* @enum {string}
*/
export enum PatchPayoutRequestStatusEnum {
    Pending = 'Pending',
    Processed = 'Processed',
    Completed = 'Completed',
    Failed = 'Failed'
}

/**
 * 
 * @export
 * @interface PatchPrivateProfileDto
 */
export interface PatchPrivateProfileDto {
    /**
     * 
     * @type {string}
     * @memberof PatchPrivateProfileDto
     */
    defaultVisibility?: PatchPrivateProfileDtoDefaultVisibilityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PatchPrivateProfileDto
     */
    shouldStartShowByWeb?: boolean;
    /**
     * 
     * @type {PrintFormat}
     * @memberof PatchPrivateProfileDto
     */
    printFormat?: PrintFormat;
    /**
     * 
     * @type {string}
     * @memberof PatchPrivateProfileDto
     */
    mccCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchPrivateProfileDto
     */
    businessLocationConfirmed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchPrivateProfileDto
     */
    storeInfoConfirmed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchPrivateProfileDto
     */
    shippingOptionsConfirmed?: boolean;
    /**
     * 
     * @type {PopStoreNotification}
     * @memberof PatchPrivateProfileDto
     */
    popStoreNotification?: PopStoreNotification;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchPrivateProfileDto
     */
    updateMask: Array<PatchPrivateProfileDtoUpdateMaskEnum>;
}

/**
* @export
* @enum {string}
*/
export enum PatchPrivateProfileDtoDefaultVisibilityEnum {
    All = 'all',
    AllSeller = 'allSeller',
    AllBuyer = 'allBuyer',
    Deferred = 'deferred'
}/**
* @export
* @enum {string}
*/
export enum PatchPrivateProfileDtoUpdateMaskEnum {
    DefaultVisibility = 'defaultVisibility',
    ShouldStartShowByWeb = 'shouldStartShowByWeb',
    PrintFormat = 'printFormat',
    MccCode = 'mccCode',
    BusinessLocationConfirmed = 'businessLocationConfirmed',
    StoreInfoConfirmed = 'storeInfoConfirmed',
    ShippingOptionsConfirmed = 'shippingOptionsConfirmed',
    PopStoreNotification = 'popStoreNotification'
}

/**
 * 
 * @export
 * @interface PatchReadonlyProfileRequest
 */
export interface PatchReadonlyProfileRequest {
    /**
     * 
     * @type {number}
     * @memberof PatchReadonlyProfileRequest
     */
    commissionRate?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchReadonlyProfileRequest
     */
    taxIDConfirmed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchReadonlyProfileRequest
     */
    notes?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchReadonlyProfileRequest
     */
    updateMask: Array<PatchReadonlyProfileRequestUpdateMaskEnum>;
}

/**
* @export
* @enum {string}
*/
export enum PatchReadonlyProfileRequestUpdateMaskEnum {
    CommissionRate = 'commissionRate',
    TaxIdConfirmed = 'taxIDConfirmed',
    Notes = 'notes'
}

/**
 * 
 * @export
 * @interface PatchReferralGiftRequest
 */
export interface PatchReferralGiftRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PatchReferralGiftRequest
     */
    active?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchReferralGiftRequest
     */
    updateMask: Array<PatchReferralGiftRequestUpdateMaskEnum>;
}

/**
* @export
* @enum {string}
*/
export enum PatchReferralGiftRequestUpdateMaskEnum {
    Active = 'active'
}

/**
 * 
 * @export
 * @interface PatchSeriesElementRequest
 */
export interface PatchSeriesElementRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PatchSeriesElementRequest
     */
    pinned?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchSeriesElementRequest
     */
    updateMask: Array<PatchSeriesElementRequestUpdateMaskEnum>;
}

/**
* @export
* @enum {string}
*/
export enum PatchSeriesElementRequestUpdateMaskEnum {
    Pinned = 'pinned'
}

/**
 * 
 * @export
 * @interface PatchShipmentTrackingRecordItemRequest
 */
export interface PatchShipmentTrackingRecordItemRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchShipmentTrackingRecordItemRequest
     */
    trackingNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchShipmentTrackingRecordItemRequest
     */
    trackingUrlProvider?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchShipmentTrackingRecordItemRequest
     */
    carrier?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchShipmentTrackingRecordItemRequest
     */
    isRemoved?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PatchShipmentTrackingRecordItemRequest
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchShipmentTrackingRecordItemRequest
     */
    transactionId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchShipmentTrackingRecordItemRequest
     */
    updateMask: Array<PatchShipmentTrackingRecordItemRequestUpdateMaskEnum>;
}

/**
* @export
* @enum {string}
*/
export enum PatchShipmentTrackingRecordItemRequestUpdateMaskEnum {
    TrackingNumber = 'trackingNumber',
    TrackingUrlProvider = 'trackingUrlProvider',
    Carrier = 'carrier',
    IsRemoved = 'isRemoved',
    Status = 'status',
    TransactionId = 'transactionId'
}

/**
 * 
 * @export
 * @interface PatchShopifyStoreRequest
 */
export interface PatchShopifyStoreRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchShopifyStoreRequest
     */
    shopName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchShopifyStoreRequest
     */
    autoSync?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PatchShopifyStoreRequest
     */
    accessToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchShopifyStoreRequest
     */
    uuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchShopifyStoreRequest
     */
    locationId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchShopifyStoreRequest
     */
    needRefreshToken?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchShopifyStoreRequest
     */
    updateMask: Array<PatchShopifyStoreRequestUpdateMaskEnum>;
}

/**
* @export
* @enum {string}
*/
export enum PatchShopifyStoreRequestUpdateMaskEnum {
    ShopName = 'shopName',
    AutoSync = 'autoSync',
    AccessToken = 'accessToken',
    Uuid = 'uuid',
    LocationId = 'locationId',
    NeedRefreshToken = 'needRefreshToken'
}

/**
 * 
 * @export
 * @interface PatchShowEventFeaturedShowRequest
 */
export interface PatchShowEventFeaturedShowRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PatchShowEventFeaturedShowRequest
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchShowEventFeaturedShowRequest
     */
    sortedAt?: string;
}

/**
 * 
 * @export
 * @interface PatchShowEventRequest
 */
export interface PatchShowEventRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchShowEventRequest
     */
    featuredStoreStackName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchShowEventRequest
     */
    backgroundURL?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchShowEventRequest
     */
    verticalBackgroundURL?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchShowEventRequest
     */
    previewVideoURL?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchShowEventRequest
     */
    visibleOnCategoryBanner?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PatchShowEventRequest
     */
    categoryCoverUrl?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchShowEventRequest
     */
    showCover?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchShowEventRequest
     */
    updateMask: Array<PatchShowEventRequestUpdateMaskEnum>;
}

/**
* @export
* @enum {string}
*/
export enum PatchShowEventRequestUpdateMaskEnum {
    FeaturedStoreStackName = 'featuredStoreStackName',
    BackgroundUrl = 'backgroundURL',
    VerticalBackgroundUrl = 'verticalBackgroundURL',
    PreviewVideoUrl = 'previewVideoURL',
    VisibleOnCategoryBanner = 'visibleOnCategoryBanner',
    CategoryCoverUrl = 'categoryCoverUrl',
    ShowCover = 'showCover'
}

/**
 * 
 * @export
 * @interface PatchStoreListingRequest
 */
export interface PatchStoreListingRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchStoreListingRequest
     */
    status?: PatchStoreListingRequestStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchStoreListingRequest
     */
    tags?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchStoreListingRequest
     */
    variants?: Array<string>;
    /**
     * 
     * @type {DimsInfo}
     * @memberof PatchStoreListingRequest
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {SingleUnitWeightInfo | PoundWithOunceWeightInfo}
     * @memberof PatchStoreListingRequest
     */
    weight?: SingleUnitWeightInfo | PoundWithOunceWeightInfo;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof PatchStoreListingRequest
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof PatchStoreListingRequest
     */
    taxCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchStoreListingRequest
     */
    nontaxable?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchStoreListingRequest
     */
    updateMask: Array<PatchStoreListingRequestUpdateMaskEnum>;
}

/**
* @export
* @enum {string}
*/
export enum PatchStoreListingRequestStatusEnum {
    Active = 'active',
    Archived = 'archived'
}/**
* @export
* @enum {string}
*/
export enum PatchStoreListingRequestUpdateMaskEnum {
    Status = 'status',
    Tags = 'tags',
    Variants = 'variants',
    Dims = 'dims',
    Weight = 'weight',
    ShippingSurcharge = 'shippingSurcharge',
    TaxCode = 'taxCode',
    Nontaxable = 'nontaxable'
}

/**
 * 
 * @export
 * @interface PatchStoreRequest
 */
export interface PatchStoreRequest {
    /**
     * 
     * @type {number}
     * @memberof PatchStoreRequest
     */
    shippingFee?: number | null;
}

/**
 * 
 * @export
 * @interface PatchStoreV2Request
 */
export interface PatchStoreV2Request {
    /**
     * 
     * @type {string}
     * @memberof PatchStoreV2Request
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchStoreV2Request
     */
    bio?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchStoreV2Request
     */
    announcement?: string;
    /**
     * 
     * @type {EvergreenVideoItem}
     * @memberof PatchStoreV2Request
     */
    evergreenVideo?: EvergreenVideoItem;
    /**
     * 
     * @type {string}
     * @memberof PatchStoreV2Request
     */
    shortDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchStoreV2Request
     */
    sellerPasscode?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchStoreV2Request
     */
    secondOfShippingLabelGeneration?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchStoreV2Request
     */
    shippingFee?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchStoreV2Request
     */
    adjustedPopshopShippingFee?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PatchStoreV2Request
     */
    defaultCoverImage?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchStoreV2Request
     */
    tags?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchStoreV2Request
     */
    badges?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof PatchStoreV2Request
     */
    salesTaxRate?: { [key: string]: number; };
    /**
     * 
     * @type {string}
     * @memberof PatchStoreV2Request
     */
    storeType?: PatchStoreV2RequestStoreTypeEnum;
    /**
     * 
     * @type {SocialAccountDto}
     * @memberof PatchStoreV2Request
     */
    socialAccounts?: SocialAccountDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchStoreV2Request
     */
    defaultProductCategoryIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchStoreV2Request
     */
    updateMask: Array<PatchStoreV2RequestUpdateMaskEnum>;
}

/**
* @export
* @enum {string}
*/
export enum PatchStoreV2RequestStoreTypeEnum {
    Business = 'Business',
    Creator = 'Creator',
    CommentChat = 'CommentChat',
    Vfs = 'VFS'
}/**
* @export
* @enum {string}
*/
export enum PatchStoreV2RequestUpdateMaskEnum {
    Name = 'name',
    Bio = 'bio',
    Announcement = 'announcement',
    EvergreenVideo = 'evergreenVideo',
    ShortDescription = 'shortDescription',
    SellerPasscode = 'sellerPasscode',
    SecondOfShippingLabelGeneration = 'secondOfShippingLabelGeneration',
    ShippingFee = 'shippingFee',
    AdjustedPopshopShippingFee = 'adjustedPopshopShippingFee',
    DefaultCoverImage = 'defaultCoverImage',
    Tags = 'tags',
    Badges = 'badges',
    SalesTaxRate = 'salesTaxRate',
    StoreType = 'storeType',
    SocialAccounts = 'socialAccounts',
    DefaultProductCategoryIds = 'defaultProductCategoryIds'
}

/**
 * 
 * @export
 * @interface PatchUpcomingShowDto
 */
export interface PatchUpcomingShowDto {
    /**
     * 
     * @type {string}
     * @memberof PatchUpcomingShowDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUpcomingShowDto
     */
    startsAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUpcomingShowDto
     */
    permission?: PatchUpcomingShowDtoPermissionEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchUpcomingShowDto
     */
    eventId?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUpcomingShowDto
     */
    eventTemplateId?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUpcomingShowDto
     */
    previewVideoURL?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUpcomingShowDto
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchUpcomingShowDto
     */
    transcodeStatus?: PatchUpcomingShowDtoTranscodeStatusEnum;
    /**
     * 
     * @type {SetShowCustomizationRequest}
     * @memberof PatchUpcomingShowDto
     */
    showCustomization?: SetShowCustomizationRequest;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchUpcomingShowDto
     */
    updateMask: Array<PatchUpcomingShowDtoUpdateMaskEnum>;
}

/**
* @export
* @enum {string}
*/
export enum PatchUpcomingShowDtoPermissionEnum {
    All = 'all',
    Follower = 'follower',
    Subscriber = 'subscriber',
    NoOne = 'no-one'
}/**
* @export
* @enum {string}
*/
export enum PatchUpcomingShowDtoTranscodeStatusEnum {
    Initial = 'initial',
    Processing = 'processing',
    TranscodeOriginal = 'transcode-original',
    TranscodeOriginalShare = 'transcode-original-share',
    RequestRetranscode = 'request-retranscode'
}/**
* @export
* @enum {string}
*/
export enum PatchUpcomingShowDtoUpdateMaskEnum {
    Title = 'title',
    StartsAt = 'startsAt',
    Permission = 'permission',
    EventId = 'eventId',
    EventTemplateId = 'eventTemplateId',
    PreviewVideoUrl = 'previewVideoURL',
    CoverImage = 'coverImage',
    TranscodeStatus = 'transcodeStatus',
    ShowCustomization = 'showCustomization'
}

/**
 * 
 * @export
 * @interface PatchVideoMessageRequest
 */
export interface PatchVideoMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchVideoMessageRequest
     */
    videoURL?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchVideoMessageRequest
     */
    emoji?: PatchVideoMessageRequestEmojiEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchVideoMessageRequest
     */
    updateMask: Array<PatchVideoMessageRequestUpdateMaskEnum>;
}

/**
* @export
* @enum {string}
*/
export enum PatchVideoMessageRequestEmojiEnum {
    RollingEyesFace = 'rolling_eyes_face',
    Sweat = 'sweat',
    Blush = 'blush',
    Smile = 'smile',
    HeartEyes = 'heart_eyes'
}/**
* @export
* @enum {string}
*/
export enum PatchVideoMessageRequestUpdateMaskEnum {
    VideoUrl = 'videoURL',
    Emoji = 'emoji'
}

/**
 * 
 * @export
 * @interface PauseRequest
 */
export interface PauseRequest {
    /**
     * 
     * @type {string}
     * @memberof PauseRequest
     */
    streamPausedText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PauseRequest
     */
    manually?: boolean;
}

/**
 * 
 * @export
 * @interface PayToViewDto
 */
export interface PayToViewDto {
    /**
     * 
     * @type {boolean}
     * @memberof PayToViewDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PayToViewDto
     */
    price: number;
    /**
     * 
     * @type {boolean}
     * @memberof PayToViewDto
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PayToViewDto
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof PayToViewDto
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PayToViewDto
     */
    discountEndDate?: string;
}

/**
 * 
 * @export
 * @interface PayToViewItem
 */
export interface PayToViewItem {
    /**
     * 
     * @type {boolean}
     * @memberof PayToViewItem
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PayToViewItem
     */
    price: number;
    /**
     * 
     * @type {boolean}
     * @memberof PayToViewItem
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PayToViewItem
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof PayToViewItem
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PayToViewItem
     */
    discountEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PayToViewItem
     */
    listingId?: string;
}

/**
 * 
 * @export
 * @interface PayToViewOnlyModeDto
 */
export interface PayToViewOnlyModeDto {
    /**
     * 
     * @type {boolean}
     * @memberof PayToViewOnlyModeDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PayToViewOnlyModeDto
     */
    daysAfterPublished?: number;
}

/**
 * 
 * @export
 * @interface PayToViewOnlyModeItem
 */
export interface PayToViewOnlyModeItem {
    /**
     * 
     * @type {boolean}
     * @memberof PayToViewOnlyModeItem
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PayToViewOnlyModeItem
     */
    daysAfterPublished?: number;
}

/**
 * 
 * @export
 * @interface PaymentAddressDto
 */
export interface PaymentAddressDto {
    /**
     * 
     * @type {string}
     * @memberof PaymentAddressDto
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentAddressDto
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentAddressDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentAddressDto
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentAddressDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentAddressDto
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentAddressDto
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentAddressDto
     */
    postalCode: string;
}

/**
 * 
 * @export
 * @interface PaymentItem
 */
export interface PaymentItem {
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    buyerId: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    paymentMethodId: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    intentId: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    status: PaymentItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    paymentType: PaymentItemPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    captureGroupId?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    captureGroupStatus?: PaymentItemCaptureGroupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentItem
     */
    stripeClientSecret?: string;
}

/**
* @export
* @enum {string}
*/
export enum PaymentItemStatusEnum {
    Canceled = 'canceled',
    Processing = 'processing',
    RequiresAction = 'requires_action',
    RequiresCapture = 'requires_capture',
    RequiresConfirmation = 'requires_confirmation',
    RequiresPaymentMethod = 'requires_payment_method',
    Succeeded = 'succeeded'
}/**
* @export
* @enum {string}
*/
export enum PaymentItemPaymentTypeEnum {
    Credit = 'credit',
    Applepay = 'applepay',
    Empty = 'empty'
}/**
* @export
* @enum {string}
*/
export enum PaymentItemCaptureGroupStatusEnum {
    RequiresPayment = 'requiresPayment',
    RequiresCapture = 'requiresCapture',
    Captured = 'captured',
    Canceled = 'canceled',
    Failed = 'failed'
}

/**
 * 
 * @export
 * @interface PaymentMethodAddress
 */
export interface PaymentMethodAddress {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodAddress
     */
    line1?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodAddress
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodAddress
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodAddress
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodAddress
     */
    country?: string;
}

/**
 * 
 * @export
 * @interface PaymentMethodDetail
 */
export interface PaymentMethodDetail {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetail
     */
    paymentMethodId?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetail
     */
    stripeConfirmationToken?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetail
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetail
     */
    createdAt: string;
    /**
     * 
     * @type {PaymentMethodDetailItem}
     * @memberof PaymentMethodDetail
     */
    paymentMethodDetails?: PaymentMethodDetailItem;
}

/**
 * 
 * @export
 * @interface PaymentMethodDetailItem
 */
export interface PaymentMethodDetailItem {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailItem
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailItem
     */
    brand?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailItem
     */
    last4?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailItem
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailItem
     */
    network?: string;
    /**
     * 
     * @type {PaymentMethodDetailWalletItem}
     * @memberof PaymentMethodDetailItem
     */
    wallet?: PaymentMethodDetailWalletItem;
}

/**
 * 
 * @export
 * @interface PaymentMethodDetailWalletItem
 */
export interface PaymentMethodDetailWalletItem {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailWalletItem
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodDetailWalletItem
     */
    dynamicLast4?: string;
}

/**
 * 
 * @export
 * @interface PaymentMethodItem
 */
export interface PaymentMethodItem {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodItem
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethodItem
     */
    created: number;
    /**
     * 
     * @type {PaymentMethodItemCard}
     * @memberof PaymentMethodItem
     */
    card: PaymentMethodItemCard;
}

/**
 * 
 * @export
 * @interface PaymentMethodItemCard
 */
export interface PaymentMethodItemCard {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodItemCard
     */
    brand: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodItemCard
     */
    funding: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodItemCard
     */
    last4: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodItemCard
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodItemCard
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodItemCard
     */
    fingerprint?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodItemCard
     */
    iin?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodItemCard
     */
    issuer?: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethodItemCard
     */
    exp_month: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethodItemCard
     */
    exp_year: number;
    /**
     * 
     * @type {CardThreeDSecureUsage}
     * @memberof PaymentMethodItemCard
     */
    three_d_secure_usage?: CardThreeDSecureUsage;
    /**
     * 
     * @type {CardWallet}
     * @memberof PaymentMethodItemCard
     */
    wallet?: CardWallet;
}

/**
 * 
 * @export
 * @interface PayoutBankDto
 */
export interface PayoutBankDto {
    /**
     * 
     * @type {string}
     * @memberof PayoutBankDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankDto
     */
    accountNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankDto
     */
    routingNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankDto
     */
    accountType?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankDto
     */
    addressLine1?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankDto
     */
    addressLine2?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankDto
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankDto
     */
    zipcode?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankDto
     */
    country?: string;
}

/**
 * 
 * @export
 * @interface PayoutBankItem
 */
export interface PayoutBankItem {
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    accountNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    routingNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    accountType?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    addressLine1?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    addressLine2?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    zipcode?: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutBankItem
     */
    country?: string;
}

/**
 * 
 * @export
 * @interface PayoutPaypalDto
 */
export interface PayoutPaypalDto {
    /**
     * 
     * @type {string}
     * @memberof PayoutPaypalDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutPaypalDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutPaypalDto
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutPaypalDto
     */
    phone: string;
}

/**
 * 
 * @export
 * @interface PayoutPaypalItem
 */
export interface PayoutPaypalItem {
    /**
     * 
     * @type {string}
     * @memberof PayoutPaypalItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutPaypalItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutPaypalItem
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutPaypalItem
     */
    phone: string;
}

/**
 * 
 * @export
 * @interface PayoutVenmoDto
 */
export interface PayoutVenmoDto {
    /**
     * 
     * @type {string}
     * @memberof PayoutVenmoDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutVenmoDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutVenmoDto
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutVenmoDto
     */
    email: string;
}

/**
 * 
 * @export
 * @interface PayoutVenmoItem
 */
export interface PayoutVenmoItem {
    /**
     * 
     * @type {string}
     * @memberof PayoutVenmoItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutVenmoItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutVenmoItem
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof PayoutVenmoItem
     */
    email: string;
}

/**
 * 
 * @export
 * @interface PickOnboardingContestWinnerRequest
 */
export interface PickOnboardingContestWinnerRequest {
    /**
     * 
     * @type {string}
     * @memberof PickOnboardingContestWinnerRequest
     */
    customScreenshotImageURL?: string;
}

/**
 * 
 * @export
 * @interface PickWinnerRequest
 */
export interface PickWinnerRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PickWinnerRequest
     */
    needDeduplicate: boolean;
    /**
     * 
     * @type {string}
     * @memberof PickWinnerRequest
     */
    type: PickWinnerRequestTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum PickWinnerRequestTypeEnum {
    UserEnter = 'userEnter',
    UserFollow = 'userFollow',
    Purchase = 'purchase',
    Share = 'share'
}

/**
 * 
 * @export
 * @interface PickWinnerResponse
 */
export interface PickWinnerResponse {
    /**
     * 
     * @type {string}
     * @memberof PickWinnerResponse
     */
    winnerId: string;
}

/**
 * 
 * @export
 * @interface PickedByProfileItem
 */
export interface PickedByProfileItem {
    /**
     * 
     * @type {string}
     * @memberof PickedByProfileItem
     */
    avatar: string;
    /**
     * 
     * @type {string}
     * @memberof PickedByProfileItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PickedByProfileItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PickedByProfileItem
     */
    username: string;
}

/**
 * 
 * @export
 * @interface PickupAddressDto
 */
export interface PickupAddressDto {
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    primaryPhone: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    compareHash?: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    addressId: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressDto
     */
    pickupNote?: string;
}

/**
 * 
 * @export
 * @interface PickupAddressItem
 */
export interface PickupAddressItem {
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    primaryPhone: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    compareHash?: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressItem
     */
    addressId: string;
}

/**
 * 
 * @export
 * @interface PickupAddressResponse
 */
export interface PickupAddressResponse {
    /**
     * 
     * @type {string}
     * @memberof PickupAddressResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressResponse
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressResponse
     */
    primaryPhone: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressResponse
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressResponse
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressResponse
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressResponse
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressResponse
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressResponse
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressResponse
     */
    pickupNote?: string;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressResponse
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof PickupAddressResponse
     */
    isDefault: boolean;
    /**
     * 
     * @type {string}
     * @memberof PickupAddressResponse
     */
    compareHash: string;
    /**
     * 
     * @type {object}
     * @memberof PickupAddressResponse
     */
    createdAt: object;
    /**
     * 
     * @type {object}
     * @memberof PickupAddressResponse
     */
    updatedAt: object;
}

/**
 * 
 * @export
 * @interface PickupNotifyDto
 */
export interface PickupNotifyDto {
    /**
     * 
     * @type {string}
     * @memberof PickupNotifyDto
     */
    message?: string;
}

/**
 * 
 * @export
 * @interface PickupTimeWindowResponse
 */
export interface PickupTimeWindowResponse {
    /**
     * 
     * @type {number}
     * @memberof PickupTimeWindowResponse
     */
    window: number;
}

/**
 * 
 * @export
 * @interface Playback
 */
export interface Playback {
    /**
     * 
     * @type {string}
     * @memberof Playback
     */
    hls: string;
    /**
     * 
     * @type {string}
     * @memberof Playback
     */
    dash: string;
}

/**
 * 
 * @export
 * @interface PopClipFeedItem
 */
export interface PopClipFeedItem {
    /**
     * 
     * @type {string}
     * @memberof PopClipFeedItem
     */
    popClipId: string;
    /**
     * 
     * @type {string}
     * @memberof PopClipFeedItem
     */
    videoTitle: string;
    /**
     * 
     * @type {string}
     * @memberof PopClipFeedItem
     */
    videoDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof PopClipFeedItem
     */
    videoURL: string;
    /**
     * 
     * @type {string}
     * @memberof PopClipFeedItem
     */
    thumbnailURL: string;
    /**
     * 
     * @type {string}
     * @memberof PopClipFeedItem
     */
    gifURL: string;
    /**
     * 
     * @type {string}
     * @memberof PopClipFeedItem
     */
    shopifyDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof PopClipFeedItem
     */
    cdnUrl: string;
    /**
     * 
     * @type {string}
     * @memberof PopClipFeedItem
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof PopClipFeedItem
     */
    fileType: string;
    /**
     * 
     * @type {string}
     * @memberof PopClipFeedItem
     */
    processedURL: string;
    /**
     * 
     * @type {Array<PopClipShopifyProduct | StoreListingItem>}
     * @memberof PopClipFeedItem
     */
    products?: Array<PopClipShopifyProduct | StoreListingItem>;
}

/**
 * 
 * @export
 * @interface PopClipShopifyProduct
 */
export interface PopClipShopifyProduct {
    /**
     * 
     * @type {string}
     * @memberof PopClipShopifyProduct
     */
    defaultImage: string;
    /**
     * 
     * @type {string}
     * @memberof PopClipShopifyProduct
     */
    shopifyProductId: string;
    /**
     * 
     * @type {string}
     * @memberof PopClipShopifyProduct
     */
    shopifyProductUrl: string;
    /**
     * 
     * @type {string}
     * @memberof PopClipShopifyProduct
     */
    shopifyProductHandle: string;
}

/**
 * 
 * @export
 * @interface PopStoreDropshipApplicationItem
 */
export interface PopStoreDropshipApplicationItem {
    /**
     * 
     * @type {string}
     * @memberof PopStoreDropshipApplicationItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreDropshipApplicationItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreDropshipApplicationItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreDropshipApplicationItem
     */
    creatorId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof PopStoreDropshipApplicationItem
     */
    creatorProfile: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof PopStoreDropshipApplicationItem
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreDropshipApplicationItem
     */
    instagramId: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreDropshipApplicationItem
     */
    status: PopStoreDropshipApplicationItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PopStoreDropshipApplicationItem
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreDropshipApplicationItem
     */
    auditedAt: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreDropshipApplicationItem
     */
    auditorId?: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof PopStoreDropshipApplicationItem
     */
    auditorProfile?: ProfileItem;
}

/**
* @export
* @enum {string}
*/
export enum PopStoreDropshipApplicationItemStatusEnum {
    Submitted = 'submitted',
    Approved = 'approved',
    Rejected = 'rejected'
}

/**
 * 
 * @export
 * @interface PopStoreDropshipApplicationPageRows
 */
export interface PopStoreDropshipApplicationPageRows {
    /**
     * 
     * @type {Array<PopStoreDropshipApplicationItem>}
     * @memberof PopStoreDropshipApplicationPageRows
     */
    rows: Array<PopStoreDropshipApplicationItem>;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PopStoreExtendedSubscriptionLevelEnumItem {
    Follower = 'follower',
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface PopStoreNotification
 */
export interface PopStoreNotification {
    /**
     * 
     * @type {string}
     * @memberof PopStoreNotification
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreNotification
     */
    email?: string;
}

/**
 * 
 * @export
 * @interface PopStoreOnboardingContestSubmissionItem
 */
export interface PopStoreOnboardingContestSubmissionItem {
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingContestSubmissionItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingContestSubmissionItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingContestSubmissionItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingContestSubmissionItem
     */
    creatorId: string;
    /**
     * 
     * @type {CreatorProfileItem}
     * @memberof PopStoreOnboardingContestSubmissionItem
     */
    creatorProfile: CreatorProfileItem;
    /**
     * 
     * @type {object}
     * @memberof PopStoreOnboardingContestSubmissionItem
     */
    data: object;
    /**
     * 
     * @type {number}
     * @memberof PopStoreOnboardingContestSubmissionItem
     */
    numOfCompletedTasks: number;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingContestSubmissionItem
     */
    week: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingContestSubmissionItem
     */
    isWinner: boolean;
    /**
     * 
     * @type {PickedByProfileItem}
     * @memberof PopStoreOnboardingContestSubmissionItem
     */
    pickedBy?: PickedByProfileItem;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingContestSubmissionItem
     */
    pickedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingContestSubmissionItem
     */
    defaultScreenshotStatus?: PopStoreOnboardingContestSubmissionItemDefaultScreenshotStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingContestSubmissionItem
     */
    defaultScreenshotError?: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingContestSubmissionItem
     */
    defaultScreenshotImageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingContestSubmissionItem
     */
    customScreenshotImageURL?: string;
}

/**
* @export
* @enum {string}
*/
export enum PopStoreOnboardingContestSubmissionItemDefaultScreenshotStatusEnum {
    Initial = 'initial',
    Processing = 'processing',
    Completed = 'completed',
    Error = 'error'
}

/**
 * 
 * @export
 * @interface PopStoreOnboardingContestSubmissionPageRows
 */
export interface PopStoreOnboardingContestSubmissionPageRows {
    /**
     * 
     * @type {Array<PopStoreOnboardingContestSubmissionItem>}
     * @memberof PopStoreOnboardingContestSubmissionPageRows
     */
    rows: Array<PopStoreOnboardingContestSubmissionItem>;
}

/**
 * 
 * @export
 * @interface PopStoreOnboardingSessionItem
 */
export interface PopStoreOnboardingSessionItem {
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    reg: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    loginPhoneNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingSessionItem
     */
    receiveSmsChecked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    loginEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    provider?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingSessionItem
     */
    isNewUser?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    accountSetupCustomDomainSelected?: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    accountSetupSubmittingDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    accountSetupSubmittingUsername?: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    accountSetupSubmittingUrlCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    accountSetupSubmittingFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    accountSetupSubmittingLastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    accountSetupSubmittingEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    accountSetupSubmittingIgHandle?: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    accountSetupFailedAction?: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    accountSetupFailedReason?: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    accountSetupAvatarSelectedType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingSessionItem
     */
    eventStarted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    timestampStarted?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingSessionItem
     */
    eventPhoneNumberEntered?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    timestampPhoneNumberEntered?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingSessionItem
     */
    eventEmailPasswordEntered?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    timestampEmailPasswordEntered?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingSessionItem
     */
    eventVerificationCodeEntered?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    timestampVerificationCodeEntered?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingSessionItem
     */
    eventLoginSuccess?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    timestampLoginSuccess?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingSessionItem
     */
    eventAccountSetupStarted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    timestampAccountSetupStarted?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingSessionItem
     */
    eventAccountSetupCompleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    timestampAccountSetupCompleted?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingSessionItem
     */
    eventAccountSetupCustomDomainSelected?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    timestampAccountSetupCustomDomainSelected?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingSessionItem
     */
    eventAccountSetupSubmitting?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    timestampAccountSetupSubmitting?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingSessionItem
     */
    eventAccountSetupFailed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    timestampAccountSetupFailed?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingSessionItem
     */
    eventAccountSetupAvatarPageViewed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    timestampAccountSetupAvatarPageViewed?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingSessionItem
     */
    eventAccountSetupAvatarSelected?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    timestampAccountSetupAvatarSelected?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingSessionItem
     */
    eventAccountSetupAvatarSaved?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    timestampAccountSetupAvatarSaved?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingSessionItem
     */
    eventAccountSetupAvatarDone?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    timestampAccountSetupAvatarDone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingSessionItem
     */
    eventAccountSetupAvatarSkipped?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    timestampAccountSetupAvatarSkipped?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingSessionItem
     */
    eventSuccess?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    timestampSuccess?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PopStoreOnboardingSessionItem
     */
    eventDoneButtonPressed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PopStoreOnboardingSessionItem
     */
    timestampDoneButtonPressed?: string;
}

/**
 * 
 * @export
 * @interface PopStoreOnboardingSessionPageRows
 */
export interface PopStoreOnboardingSessionPageRows {
    /**
     * 
     * @type {Array<PopStoreOnboardingSessionItem>}
     * @memberof PopStoreOnboardingSessionPageRows
     */
    rows: Array<PopStoreOnboardingSessionItem>;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PopStoreSubscriptionLevelEnumItem {
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PopStoreThemeTemplateAccessTypeEnumItem {
    Free = 'free',
    Purchase = 'purchase',
    Subscription = 'subscription'
}

/**
 * 
 * @export
 * @interface PopStoreThemeTemplateResponse
 */
export interface PopStoreThemeTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof PopStoreThemeTemplateResponse
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreThemeTemplateResponse
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof PopStoreThemeTemplateResponse
     */
    id: string;
    /**
     * Theme name
     * @type {string}
     * @memberof PopStoreThemeTemplateResponse
     */
    name: string;
    /**
     * Theme style (e.g., "dark", "light", etc.)
     * @type {string}
     * @memberof PopStoreThemeTemplateResponse
     */
    style: string;
    /**
     * Theme type
     * @type {object}
     * @memberof PopStoreThemeTemplateResponse
     */
    type: object;
    /**
     * Thumbnail URL of the theme
     * @type {string}
     * @memberof PopStoreThemeTemplateResponse
     */
    thumbnailUrl?: string;
    /**
     * Theme description
     * @type {string}
     * @memberof PopStoreThemeTemplateResponse
     */
    createdByUserId?: string;
    /**
     * Created by user profile
     * @type {BasicProfileDto}
     * @memberof PopStoreThemeTemplateResponse
     */
    createdByProfile?: BasicProfileDto;
    /**
     * Subscription level required for using this theme
     * @type {object}
     * @memberof PopStoreThemeTemplateResponse
     */
    subscriptionLevel: object;
    /**
     * 
     * @type {string}
     * @memberof PopStoreThemeTemplateResponse
     */
    theme: string;
    /**
     * Privacy flag
     * @type {boolean}
     * @memberof PopStoreThemeTemplateResponse
     */
    privacy: boolean;
    /**
     * Moderation Status
     * @type {string}
     * @memberof PopStoreThemeTemplateResponse
     */
    moderationStatus: string;
    /**
     * Moderator User Id
     * @type {string}
     * @memberof PopStoreThemeTemplateResponse
     */
    moderatorUserId: string;
    /**
     * Moderation date
     * @type {object}
     * @memberof PopStoreThemeTemplateResponse
     */
    moderatedAt?: object;
    /**
     * Moderator Profile
     * @type {object}
     * @memberof PopStoreThemeTemplateResponse
     */
    moderatorProfile?: object;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PopStoreThemeTemplateStyleEnumItem {
    Light = 'light',
    Dark = 'dark'
}

/**
 * 
 * @export
 * @interface PopStoreThemeTemplateTypeRequestDto
 */
export interface PopStoreThemeTemplateTypeRequestDto {
    /**
     * Unique identifier
     * @type {string}
     * @memberof PopStoreThemeTemplateTypeRequestDto
     */
    id: string;
    /**
     * Internal type slug (identifier)
     * @type {string}
     * @memberof PopStoreThemeTemplateTypeRequestDto
     */
    slug: string;
    /**
     * Human-readable type label
     * @type {string}
     * @memberof PopStoreThemeTemplateTypeRequestDto
     */
    value: string;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PopStoreUserAccessLevelEnumItem {
    All = 'all',
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface PostCommentPageRows
 */
export interface PostCommentPageRows {
    /**
     * 
     * @type {Array<PostCommentSearchItem>}
     * @memberof PostCommentPageRows
     */
    rows: Array<PostCommentSearchItem>;
}

/**
 * 
 * @export
 * @interface PostCommentSearchItem
 */
export interface PostCommentSearchItem {
    /**
     * 
     * @type {string}
     * @memberof PostCommentSearchItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PostCommentSearchItem
     */
    updatedAt: string;
    /**
     * 
     * @type {number}
     * @memberof PostCommentSearchItem
     */
    level: number;
    /**
     * 
     * @type {string}
     * @memberof PostCommentSearchItem
     */
    parentId?: string;
    /**
     * 
     * @type {string}
     * @memberof PostCommentSearchItem
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof PostCommentSearchItem
     */
    userId: string;
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof PostCommentSearchItem
     */
    profile: BaseProfileItem;
    /**
     * 
     * @type {boolean}
     * @memberof PostCommentSearchItem
     */
    isFollower: boolean;
    /**
     * 
     * @type {PopStoreSubscriptionLevelEnumItem}
     * @memberof PostCommentSearchItem
     */
    subscriptionLevel?: PopStoreSubscriptionLevelEnumItem;
    /**
     * 
     * @type {number}
     * @memberof PostCommentSearchItem
     */
    likeCount: number;
    /**
     * 
     * @type {number}
     * @memberof PostCommentSearchItem
     */
    replyCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof PostCommentSearchItem
     */
    removed: boolean;
    /**
     * 
     * @type {string}
     * @memberof PostCommentSearchItem
     */
    id: string;
    /**
     * 
     * @type {Relations}
     * @memberof PostCommentSearchItem
     */
    relations: Relations;
    /**
     * if the user liked the comment
     * @type {boolean}
     * @memberof PostCommentSearchItem
     */
    liked?: boolean;
}

/**
 * 
 * @export
 * @interface PostCommentSearchResponse
 */
export interface PostCommentSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof PostCommentSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof PostCommentSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {PostCommentPageRows}
     * @memberof PostCommentSearchResponse
     */
    data: PostCommentPageRows;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PostContentTypeEnumItem {
    RichText = 'RICH_TEXT',
    MediaGallery = 'MEDIA_GALLERY'
}

/**
 * 
 * @export
 * @interface PostMediaDimensionsDto
 */
export interface PostMediaDimensionsDto {
    /**
     * 
     * @type {number}
     * @memberof PostMediaDimensionsDto
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof PostMediaDimensionsDto
     */
    height: number;
}

/**
 * 
 * @export
 * @interface PostMediaDto
 */
export interface PostMediaDto {
    /**
     * 
     * @type {PostMediaTypeEnumItem}
     * @memberof PostMediaDto
     */
    type?: PostMediaTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof PostMediaDto
     */
    contentType: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaDto
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaDto
     */
    processedUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaDto
     */
    thumbnailUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaDto
     */
    caption?: string;
    /**
     * 
     * @type {PostMediaMetadataDto}
     * @memberof PostMediaDto
     */
    metadata?: PostMediaMetadataDto;
}

/**
 * 
 * @export
 * @interface PostMediaItem
 */
export interface PostMediaItem {
    /**
     * 
     * @type {PostMediaTypeEnumItem}
     * @memberof PostMediaItem
     */
    type?: PostMediaTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof PostMediaItem
     */
    contentType: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaItem
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaItem
     */
    processedUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaItem
     */
    thumbnailUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaItem
     */
    thumbnailVideoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PostMediaItem
     */
    caption?: string;
    /**
     * 
     * @type {PostMediaMetadataDto}
     * @memberof PostMediaItem
     */
    metadata?: PostMediaMetadataDto;
    /**
     * 
     * @type {ContentModerationInfoItem}
     * @memberof PostMediaItem
     */
    moderation?: ContentModerationInfoItem;
}

/**
 * 
 * @export
 * @interface PostMediaMetadataDto
 */
export interface PostMediaMetadataDto {
    /**
     * 
     * @type {string}
     * @memberof PostMediaMetadataDto
     */
    blurhash?: string;
    /**
     * 
     * @type {PostMediaDimensionsDto}
     * @memberof PostMediaMetadataDto
     */
    dimensions?: PostMediaDimensionsDto;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PostMediaTypeEnumItem {
    Image = 'IMAGE',
    Video = 'VIDEO'
}

/**
 * 
 * @export
 * @interface PostPageRows
 */
export interface PostPageRows {
    /**
     * 
     * @type {Array<PostSearchItem>}
     * @memberof PostPageRows
     */
    rows: Array<PostSearchItem>;
}

/**
 * 
 * @export
 * @interface PostSearchItem
 */
export interface PostSearchItem {
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    cid: string;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostSearchItem
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    permaLink?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostSearchItem
     */
    pinned?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    pinnedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostSearchItem
     */
    allowComments: boolean;
    /**
     * 
     * @type {PostStatusEnumItem}
     * @memberof PostSearchItem
     */
    status: PostStatusEnumItem;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    scheduledReleaseTime?: string;
    /**
     * 
     * @type {PostVisibilityEnumItem}
     * @memberof PostSearchItem
     */
    visibility: PostVisibilityEnumItem;
    /**
     * 
     * @type {SubscribeToViewItem}
     * @memberof PostSearchItem
     */
    subscribeToView?: SubscribeToViewItem;
    /**
     * 
     * @type {PayToViewItem}
     * @memberof PostSearchItem
     */
    payToView?: PayToViewItem;
    /**
     * 
     * @type {PayToViewOnlyModeItem}
     * @memberof PostSearchItem
     */
    payToViewOnlyMode?: PayToViewOnlyModeItem;
    /**
     * 
     * @type {CrowdTippingToViewItem}
     * @memberof PostSearchItem
     */
    crowdTippingToView?: CrowdTippingToViewItem;
    /**
     * 
     * @type {TipToViewItem}
     * @memberof PostSearchItem
     */
    tipToView?: TipToViewItem;
    /**
     * 
     * @type {Array<TippingAmountItem>}
     * @memberof PostSearchItem
     */
    tippingAmounts?: Array<TippingAmountItem>;
    /**
     * 
     * @type {DmOnlyItem}
     * @memberof PostSearchItem
     */
    dmOnly?: DmOnlyItem;
    /**
     * 
     * @type {PostContentTypeEnumItem}
     * @memberof PostSearchItem
     */
    postType: PostContentTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    textContent?: string;
    /**
     * 
     * @type {Array<PostMediaItem>}
     * @memberof PostSearchItem
     */
    medias?: Array<PostMediaItem>;
    /**
     * 
     * @type {number}
     * @memberof PostSearchItem
     */
    unrestrictedLeadingMediaCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PostSearchItem
     */
    commentCount: number;
    /**
     * 
     * @type {number}
     * @memberof PostSearchItem
     */
    likeCount: number;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    publishedAt?: string;
    /**
     * 
     * @type {ContentModerationInfoItem}
     * @memberof PostSearchItem
     */
    moderation?: ContentModerationInfoItem;
    /**
     * 
     * @type {ContentModerationInfoItem}
     * @memberof PostSearchItem
     */
    textContentModeration?: ContentModerationInfoItem;
    /**
     * 
     * @type {string}
     * @memberof PostSearchItem
     */
    id: string;
    /**
     * 
     * @type {Relations}
     * @memberof PostSearchItem
     */
    relations: Relations;
    /**
     * if the user liked the post
     * @type {boolean}
     * @memberof PostSearchItem
     */
    liked?: boolean;
    /**
     * true if the user does not have required access level to this post
     * @type {boolean}
     * @memberof PostSearchItem
     */
    restricted?: boolean;
    /**
     * for debug purpose
     * @type {string}
     * @memberof PostSearchItem
     */
    restrictionReason?: string;
    /**
     * if the user is following the creator of this post
     * @type {BaseProfileItem}
     * @memberof PostSearchItem
     */
    creatorProfile?: BaseProfileItem;
}

/**
 * 
 * @export
 * @interface PostSearchResponse
 */
export interface PostSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof PostSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof PostSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {PostPageRows}
     * @memberof PostSearchResponse
     */
    data: PostPageRows;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PostStatusEnumItem {
    Draft = 'DRAFT',
    Published = 'PUBLISHED',
    Scheduled = 'SCHEDULED'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PostVisibilityEnumItem {
    Public = 'PUBLIC',
    Restricted = 'RESTRICTED',
    Private = 'PRIVATE'
}

/**
 * 
 * @export
 * @interface PoundWithOunceWeightInfo
 */
export interface PoundWithOunceWeightInfo {
    /**
     * 
     * @type {string}
     * @memberof PoundWithOunceWeightInfo
     */
    type: PoundWithOunceWeightInfoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PoundWithOunceWeightInfo
     */
    lbValue: number;
    /**
     * 
     * @type {number}
     * @memberof PoundWithOunceWeightInfo
     */
    ozValue: number;
}

/**
* @export
* @enum {string}
*/
export enum PoundWithOunceWeightInfoTypeEnum {
    PoundWithOunce = 'poundWithOunce'
}

/**
 * 
 * @export
 * @interface PreviewBatchRefundOrderRequest
 */
export interface PreviewBatchRefundOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof PreviewBatchRefundOrderRequest
     */
    reason?: string;
    /**
     * only admin can use
     * @type {string}
     * @memberof PreviewBatchRefundOrderRequest
     */
    processingFeePayer?: PreviewBatchRefundOrderRequestProcessingFeePayerEnum;
    /**
     * 
     * @type {Array<BatchPreviewRefundItem>}
     * @memberof PreviewBatchRefundOrderRequest
     */
    refundItems: Array<BatchPreviewRefundItem>;
}

/**
* @export
* @enum {string}
*/
export enum PreviewBatchRefundOrderRequestProcessingFeePayerEnum {
    Seller = 'SELLER',
    Popshop = 'POPSHOP'
}

/**
 * 
 * @export
 * @interface PreviewLiveStreamWrapEmailRequest
 */
export interface PreviewLiveStreamWrapEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof PreviewLiveStreamWrapEmailRequest
     */
    note?: string;
}

/**
 * 
 * @export
 * @interface PreviewLiveStreamWrapEmailResponse
 */
export interface PreviewLiveStreamWrapEmailResponse {
    /**
     * 
     * @type {string}
     * @memberof PreviewLiveStreamWrapEmailResponse
     */
    html: string;
}

/**
 * 
 * @export
 * @interface PreviewOrderAvailableCouponsDto
 */
export interface PreviewOrderAvailableCouponsDto {
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderAvailableCouponsDto
     */
    redeemedCouponId: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderAvailableCouponsDto
     */
    selectStatus: PreviewOrderAvailableCouponsDtoSelectStatusEnum;
    /**
     * 
     * @type {CouponItem}
     * @memberof PreviewOrderAvailableCouponsDto
     */
    coupon: CouponItem;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderAvailableCouponsDto
     */
    couponId: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderAvailableCouponsDto
     */
    reason?: string;
}

/**
* @export
* @enum {string}
*/
export enum PreviewOrderAvailableCouponsDtoSelectStatusEnum {
    Selected = 'selected',
    Selectable = 'selectable',
    Unselectable = 'unselectable'
}

/**
 * 
 * @export
 * @interface PreviewOrderDto
 */
export interface PreviewOrderDto {
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    stripePaymentMethodId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    stripeApplePayNonce?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    listingId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    sellerId: string;
    /**
     * The recipient of this gift order
     * @type {string}
     * @memberof PreviewOrderDto
     */
    recipientId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    sendItemId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    sentReferralGiftId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    variantId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    shippingMethod?: PreviewOrderDtoShippingMethodEnum;
    /**
     * Optional for gifting orders or digital products
     * @type {AddressDto}
     * @memberof PreviewOrderDto
     */
    shippingAddress?: AddressDto;
    /**
     * 
     * @type {PickupAddressDto}
     * @memberof PreviewOrderDto
     */
    pickupAddress?: PickupAddressDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof PreviewOrderDto
     */
    redeemedCouponIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PreviewOrderDto
     */
    quantity: number;
    /**
     * 
     * @type {LiveStreamSource | TwoWayStreamSource | UpcomingShowSource | ReferralGiftingSource | StoreSource | ReplaySource | SendItemSource | ShopSource | TopProductsSource | CommentChatSource}
     * @memberof PreviewOrderDto
     */
    source?: LiveStreamSource | TwoWayStreamSource | UpcomingShowSource | ReferralGiftingSource | StoreSource | ReplaySource | SendItemSource | ShopSource | TopProductsSource | CommentChatSource;
    /**
     * 
     * @type {PaymentAddressDto}
     * @memberof PreviewOrderDto
     */
    paymentBillingAddress?: PaymentAddressDto;
    /**
     * 
     * @type {TippingDto}
     * @memberof PreviewOrderDto
     */
    tipping?: TippingDto;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderDto
     */
    fxQuoteId?: string;
}

/**
* @export
* @enum {string}
*/
export enum PreviewOrderDtoShippingMethodEnum {
    DropshipSupplierProvide = 'dropshipSupplierProvide',
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide',
    Pickup = 'pickup'
}

/**
 * 
 * @export
 * @interface PreviewOrderResponse
 */
export interface PreviewOrderResponse {
    /**
     * 
     * @type {object}
     * @memberof PreviewOrderResponse
     */
    openboxCloseTime: object;
    /**
     * 
     * @type {DropshipAmountsItem}
     * @memberof PreviewOrderResponse
     */
    dropshipAmounts?: DropshipAmountsItem;
    /**
     * 
     * @type {number}
     * @memberof PreviewOrderResponse
     */
    buyerPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewOrderResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewOrderResponse
     */
    salesTaxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewOrderResponse
     */
    salesTaxRate: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewOrderResponse
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewOrderResponse
     */
    couponDiscountShippingFeeAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewOrderResponse
     */
    couponDiscountProductAmount: number;
    /**
     * 
     * @type {Array<PreviewOrderAvailableCouponsDto>}
     * @memberof PreviewOrderResponse
     */
    availableCoupons?: Array<PreviewOrderAvailableCouponsDto>;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderResponse
     */
    popshopShippingFeeSource?: PreviewOrderResponsePopshopShippingFeeSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderResponse
     */
    shipmentGroupStatus?: PreviewOrderResponseShipmentGroupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderResponse
     */
    shipmentShippingMethod: PreviewOrderResponseShipmentShippingMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderResponse
     */
    masterOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderResponse
     */
    currency?: string;
    /**
     * 
     * @type {number}
     * @memberof PreviewOrderResponse
     */
    subtotal?: number;
    /**
     * 
     * @type {string}
     * @memberof PreviewOrderResponse
     */
    fxQuoteId?: string;
}

/**
* @export
* @enum {string}
*/
export enum PreviewOrderResponsePopshopShippingFeeSourceEnum {
    ReadonlyProfile = 'READONLY_PROFILE',
    Default = 'DEFAULT',
    ShowEvent = 'SHOW_EVENT'
}/**
* @export
* @enum {string}
*/
export enum PreviewOrderResponseShipmentGroupStatusEnum {
    Customer = 'customer',
    Slave = 'slave',
    Master = 'master'
}/**
* @export
* @enum {string}
*/
export enum PreviewOrderResponseShipmentShippingMethodEnum {
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide',
    Pickup = 'pickup',
    DropshipSupplierProvide = 'dropshipSupplierProvide'
}

/**
 * 
 * @export
 * @interface PreviewPopStoreThemeRequest
 */
export interface PreviewPopStoreThemeRequest {
    /**
     * 
     * @type {string}
     * @memberof PreviewPopStoreThemeRequest
     */
    themeId: string;
}

/**
 * 
 * @export
 * @interface PreviewPopStoreThemeResponse
 */
export interface PreviewPopStoreThemeResponse {
    /**
     * 
     * @type {string}
     * @memberof PreviewPopStoreThemeResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewPopStoreThemeResponse
     */
    theme: string;
}

/**
 * 
 * @export
 * @interface PreviewRefundOrderRequest
 */
export interface PreviewRefundOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof PreviewRefundOrderRequest
     */
    quantity?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PreviewRefundOrderRequest
     */
    refundTypes: Array<PreviewRefundOrderRequestRefundTypesEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof PreviewRefundOrderRequest
     */
    shouldRestock?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PreviewRefundOrderRequest
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof PreviewRefundOrderRequest
     */
    reason?: string;
    /**
     * only admin can use
     * @type {string}
     * @memberof PreviewRefundOrderRequest
     */
    processingFeePayer?: PreviewRefundOrderRequestProcessingFeePayerEnum;
}

/**
* @export
* @enum {string}
*/
export enum PreviewRefundOrderRequestRefundTypesEnum {
    All = 'all',
    ShippingFee = 'shippingFee',
    Listing = 'listing',
    CustomAmount = 'customAmount',
    Cancel = 'cancel',
    CancelListing = 'cancelListing'
}/**
* @export
* @enum {string}
*/
export enum PreviewRefundOrderRequestProcessingFeePayerEnum {
    Seller = 'SELLER',
    Popshop = 'POPSHOP'
}

/**
 * 
 * @export
 * @interface PreviewShippingCostResponse
 */
export interface PreviewShippingCostResponse {
    /**
     * 
     * @type {string}
     * @memberof PreviewShippingCostResponse
     */
    orderId: string;
    /**
     * 
     * @type {number}
     * @memberof PreviewShippingCostResponse
     */
    shippingPricePaid: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewShippingCostResponse
     */
    shippingCost: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewShippingCostResponse
     */
    shippingPriceVariance: number;
}

/**
 * 
 * @export
 * @interface PreviewTicketOrderRequest
 */
export interface PreviewTicketOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof PreviewTicketOrderRequest
     */
    userAgent?: string;
    /**
     * 
     * @type {TicketOrderAddressRequest}
     * @memberof PreviewTicketOrderRequest
     */
    shippingAddress?: TicketOrderAddressRequest;
}

/**
 * 
 * @export
 * @interface PreviewTicketOrderResponse
 */
export interface PreviewTicketOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof PreviewTicketOrderResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewTicketOrderResponse
     */
    salesTaxRate: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewTicketOrderResponse
     */
    salesTaxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewTicketOrderResponse
     */
    shippingFee: number;
}

/**
 * 
 * @export
 * @interface PreviewTippingOrderDto
 */
export interface PreviewTippingOrderDto {
    /**
     * 
     * @type {string}
     * @memberof PreviewTippingOrderDto
     */
    tipId: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewTippingOrderDto
     */
    userAgent?: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewTippingOrderDto
     */
    tipperId: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewTippingOrderDto
     */
    recipientId: string;
    /**
     * 
     * @type {number}
     * @memberof PreviewTippingOrderDto
     */
    total: number;
    /**
     * 
     * @type {TippingOrderLiveStreamSource | TippingOrderUpcomingShowSource}
     * @memberof PreviewTippingOrderDto
     */
    source: TippingOrderLiveStreamSource | TippingOrderUpcomingShowSource;
}

/**
 * 
 * @export
 * @interface PreviewTippingOrderResponse
 */
export interface PreviewTippingOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof PreviewTippingOrderResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewTippingOrderResponse
     */
    tipperPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewTippingOrderResponse
     */
    recipientGotAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewTippingOrderResponse
     */
    recipientGotWithdrawableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewTippingOrderResponse
     */
    gatewayProcessingFeeRate: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewTippingOrderResponse
     */
    gatewayProcessingFee: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewTippingOrderResponse
     */
    commissionFeeRate: number;
    /**
     * 
     * @type {number}
     * @memberof PreviewTippingOrderResponse
     */
    commissionFee: number;
}

/**
 * 
 * @export
 * @interface PrintFormat
 */
export interface PrintFormat {
    /**
     * 
     * @type {string}
     * @memberof PrintFormat
     */
    packingSlip?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintFormat
     */
    shippingLabel?: string;
}

/**
 * 
 * @export
 * @interface PrivateProfileItem
 */
export interface PrivateProfileItem {
    /**
     * 
     * @type {string}
     * @memberof PrivateProfileItem
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PrivateProfileItem
     */
    email?: string;
    /**
     * 
     * @type {AddressItem}
     * @memberof PrivateProfileItem
     */
    defaultAddress?: AddressItem;
    /**
     * 
     * @type {AddressItem}
     * @memberof PrivateProfileItem
     */
    sellerShippingAddress?: AddressItem;
    /**
     * 
     * @type {string}
     * @memberof PrivateProfileItem
     */
    defaultVisibility?: PrivateProfileItemDefaultVisibilityEnum;
    /**
     * 
     * @type {PayoutBankItem}
     * @memberof PrivateProfileItem
     */
    payoutMethodBank?: PayoutBankItem;
    /**
     * 
     * @type {PayoutVenmoItem}
     * @memberof PrivateProfileItem
     */
    payoutMethodVenmo?: PayoutVenmoItem;
    /**
     * 
     * @type {PayoutPaypalItem}
     * @memberof PrivateProfileItem
     */
    payoutMethodPaypal?: PayoutPaypalItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrivateProfileItem
     */
    watchPasscodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PrivateProfileItem
     */
    referrerUserId?: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof PrivateProfileItem
     */
    referrerUserProfile?: ProfileItem;
    /**
     * 
     * @type {CommentChatItem}
     * @memberof PrivateProfileItem
     */
    commentchat?: CommentChatItem;
    /**
     * 
     * @type {boolean}
     * @memberof PrivateProfileItem
     */
    sellerOnboardingCompleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PrivateProfileItem
     */
    sellerOnboardingCompletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PrivateProfileItem
     */
    billingCountryCode?: string;
}

/**
* @export
* @enum {string}
*/
export enum PrivateProfileItemDefaultVisibilityEnum {
    All = 'all',
    AllSeller = 'allSeller',
    AllBuyer = 'allBuyer',
    Deferred = 'deferred'
}

/**
 * 
 * @export
 * @interface PrivateProfilesPayoutHistoryItemWithId
 */
export interface PrivateProfilesPayoutHistoryItemWithId {
    /**
     * 
     * @type {string}
     * @memberof PrivateProfilesPayoutHistoryItemWithId
     */
    userId?: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof PrivateProfilesPayoutHistoryItemWithId
     */
    profile: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof PrivateProfilesPayoutHistoryItemWithId
     */
    operatorId?: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof PrivateProfilesPayoutHistoryItemWithId
     */
    operatorProfile?: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof PrivateProfilesPayoutHistoryItemWithId
     */
    status?: PrivateProfilesPayoutHistoryItemWithIdStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PrivateProfilesPayoutHistoryItemWithId
     */
    sourceType?: PrivateProfilesPayoutHistoryItemWithIdSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PrivateProfilesPayoutHistoryItemWithId
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PrivateProfilesPayoutHistoryItemWithId
     */
    updatedAt: string;
    /**
     * 
     * @type {PayoutBankItem | PayoutVenmoItem | PayoutPaypalItem}
     * @memberof PrivateProfilesPayoutHistoryItemWithId
     */
    before?: PayoutBankItem | PayoutVenmoItem | PayoutPaypalItem;
    /**
     * 
     * @type {PayoutBankItem | PayoutVenmoItem | PayoutPaypalItem}
     * @memberof PrivateProfilesPayoutHistoryItemWithId
     */
    after?: PayoutBankItem | PayoutVenmoItem | PayoutPaypalItem;
    /**
     * 
     * @type {string}
     * @memberof PrivateProfilesPayoutHistoryItemWithId
     */
    id: string;
}

/**
* @export
* @enum {string}
*/
export enum PrivateProfilesPayoutHistoryItemWithIdStatusEnum {
    Approved = 'approved',
    Pending = 'pending',
    Rejected = 'rejected',
    Canceled = 'canceled'
}/**
* @export
* @enum {string}
*/
export enum PrivateProfilesPayoutHistoryItemWithIdSourceTypeEnum {
    Admin = 'admin',
    Seller = 'seller'
}

/**
 * 
 * @export
 * @interface PrivateProfilesPayoutHistoryPageRows
 */
export interface PrivateProfilesPayoutHistoryPageRows {
    /**
     * 
     * @type {Array<PrivateProfilesPayoutHistoryItemWithId>}
     * @memberof PrivateProfilesPayoutHistoryPageRows
     */
    rows: Array<PrivateProfilesPayoutHistoryItemWithId>;
}

/**
 * 
 * @export
 * @interface PrivateProfilesPayoutHistorySearchResponse
 */
export interface PrivateProfilesPayoutHistorySearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof PrivateProfilesPayoutHistorySearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof PrivateProfilesPayoutHistorySearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {PrivateProfilesPayoutHistoryPageRows}
     * @memberof PrivateProfilesPayoutHistorySearchResponse
     */
    data: PrivateProfilesPayoutHistoryPageRows;
}

/**
 * 
 * @export
 * @interface ProductCategoriesPageRows
 */
export interface ProductCategoriesPageRows {
    /**
     * 
     * @type {Array<ProductCategoryItem>}
     * @memberof ProductCategoriesPageRows
     */
    rows: Array<ProductCategoryItem>;
}

/**
 * 
 * @export
 * @interface ProductCategoriesSearchResponse
 */
export interface ProductCategoriesSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof ProductCategoriesSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof ProductCategoriesSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {ProductCategoriesPageRows}
     * @memberof ProductCategoriesSearchResponse
     */
    data: ProductCategoriesPageRows;
}

/**
 * 
 * @export
 * @interface ProductCategoryItem
 */
export interface ProductCategoryItem {
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryItem
     */
    parentId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryItem
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryItem
     */
    slug?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCategoryItem
     */
    isRoot: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCategoryItem
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCategoryItem
     */
    custom: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCategoryItem
     */
    digital?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductCategoryItem
     */
    sort: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductCategoryItem
     */
    googleProductCategoryIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryItem
     */
    updatedAt: string;
    /**
     * 
     * @type {Array<Array<BasicGoogleCategoryItem>>}
     * @memberof ProductCategoryItem
     */
    googleCategories?: Array<Array<BasicGoogleCategoryItem>>;
}

/**
 * 
 * @export
 * @interface ProductCollectionItem
 */
export interface ProductCollectionItem {
    /**
     * 
     * @type {string}
     * @memberof ProductCollectionItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCollectionItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCollectionItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCollectionItem
     */
    strategy: ProductCollectionItemStrategyEnum;
    /**
     * valid when strategy is BY_CATEGORY
     * @type {Array<string>}
     * @memberof ProductCollectionItem
     */
    productCategoryIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCollectionItem
     */
    archived: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductCollectionItem
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof ProductCollectionItem
     */
    id: string;
    /**
     * 
     * @type {Array<Array<BasicProductCategoryItem>>}
     * @memberof ProductCollectionItem
     */
    productCategories?: Array<Array<BasicProductCategoryItem>>;
}

/**
* @export
* @enum {string}
*/
export enum ProductCollectionItemStrategyEnum {
    ByCategory = 'BY_CATEGORY',
    ManualSelection = 'MANUAL_SELECTION'
}

/**
 * 
 * @export
 * @interface ProductCollectionsPageRows
 */
export interface ProductCollectionsPageRows {
    /**
     * 
     * @type {Array<ProductCollectionItem>}
     * @memberof ProductCollectionsPageRows
     */
    rows: Array<ProductCollectionItem>;
}

/**
 * 
 * @export
 * @interface ProductCollectionsSearchResponse
 */
export interface ProductCollectionsSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof ProductCollectionsSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof ProductCollectionsSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {ProductCollectionsPageRows}
     * @memberof ProductCollectionsSearchResponse
     */
    data: ProductCollectionsPageRows;
}

/**
 * 
 * @export
 * @interface ProductItem
 */
export interface ProductItem {
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductItem
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof ProductItem
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    defaultImage: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductItem
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ProductItem
     */
    quantity: number;
    /**
     * 
     * @type {Array<StoreListingVariant>}
     * @memberof ProductItem
     */
    variants?: Array<StoreListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof ProductItem
     */
    maximumPurchaseQuantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductItem
     */
    shippingFee?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductItem
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    status?: ProductItemStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ProductItem
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {StoreListingOriginalInfo}
     * @memberof ProductItem
     */
    originalInfo?: StoreListingOriginalInfo;
    /**
     * 
     * @type {DimsInfo}
     * @memberof ProductItem
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {SingleUnitWeightInfo | PoundWithOunceWeightInfo}
     * @memberof ProductItem
     */
    weight?: SingleUnitWeightInfo | PoundWithOunceWeightInfo;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof ProductItem
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    taxCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductItem
     */
    nontaxable?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductItem
     */
    soldQuantityLast7Days?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    storeCoverImage?: string;
    /**
     * 
     * @type {ListingDropshipDetailsItem}
     * @memberof ProductItem
     */
    dropshipDetails?: ListingDropshipDetailsItem;
    /**
     * 
     * @type {boolean}
     * @memberof ProductItem
     */
    useLocalPrice?: boolean;
    /**
     * 
     * @type {ListingProductCategoryItem}
     * @memberof ProductItem
     */
    category?: ListingProductCategoryItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductItem
     */
    collectionIds?: Array<string>;
    /**
     * 
     * @type {ListingRatingType}
     * @memberof ProductItem
     */
    rating?: ListingRatingType;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    sizingGuideImage?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    defaultSizingGuideImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductItem
     */
    eligibleForModelMe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductItem
     */
    shopModelMe?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductItem
     */
    categoryIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    type?: ProductItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductItem
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    discountEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {UploadedFileItem}
     * @memberof ProductItem
     */
    uploadedFile?: UploadedFileItem;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    moderationStatus?: ProductItemModerationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    moderatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    moderatorUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    adminModerationReason?: string;
    /**
     * 
     * @type {ModeratorProfileItem}
     * @memberof ProductItem
     */
    moderatorProfile?: ModeratorProfileItem;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    externalCheckoutUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    externalBrandName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    externalBrandImage?: string;
    /**
     * 
     * @type {ListingMeetingItem}
     * @memberof ProductItem
     */
    meeting?: ListingMeetingItem;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    listingId: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductItem
     */
    source?: ProductItemSourceEnum;
}

/**
* @export
* @enum {string}
*/
export enum ProductItemStatusEnum {
    Active = 'active',
    Archived = 'archived'
}/**
* @export
* @enum {string}
*/
export enum ProductItemTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}/**
* @export
* @enum {string}
*/
export enum ProductItemModerationStatusEnum {
    Pending = 'Pending',
    Accepted = 'Accepted',
    Rejected = 'Rejected',
    ReviewRequired = 'ReviewRequired'
}/**
* @export
* @enum {string}
*/
export enum ProductItemSourceEnum {
    LiveStream = 'LiveStream',
    StoreFavorites = 'StoreFavorites'
}

/**
 * 
 * @export
 * @interface ProductsListing
 */
export interface ProductsListing {
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductsListing
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof ProductsListing
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    defaultImage: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductsListing
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ProductsListing
     */
    quantity: number;
    /**
     * 
     * @type {Array<StoreListingVariant>}
     * @memberof ProductsListing
     */
    variants?: Array<StoreListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof ProductsListing
     */
    maximumPurchaseQuantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductsListing
     */
    shippingFee?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductsListing
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    status?: ProductsListingStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ProductsListing
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {StoreListingOriginalInfo}
     * @memberof ProductsListing
     */
    originalInfo?: StoreListingOriginalInfo;
    /**
     * 
     * @type {DimsInfo}
     * @memberof ProductsListing
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {SingleUnitWeightInfo | PoundWithOunceWeightInfo}
     * @memberof ProductsListing
     */
    weight?: SingleUnitWeightInfo | PoundWithOunceWeightInfo;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof ProductsListing
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    taxCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductsListing
     */
    nontaxable?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductsListing
     */
    soldQuantityLast7Days?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    storeCoverImage?: string;
    /**
     * 
     * @type {ListingDropshipDetailsItem}
     * @memberof ProductsListing
     */
    dropshipDetails?: ListingDropshipDetailsItem;
    /**
     * 
     * @type {boolean}
     * @memberof ProductsListing
     */
    useLocalPrice?: boolean;
    /**
     * 
     * @type {ListingProductCategoryItem}
     * @memberof ProductsListing
     */
    category?: ListingProductCategoryItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductsListing
     */
    collectionIds?: Array<string>;
    /**
     * 
     * @type {ListingRatingType}
     * @memberof ProductsListing
     */
    rating?: ListingRatingType;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    sizingGuideImage?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    defaultSizingGuideImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductsListing
     */
    eligibleForModelMe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductsListing
     */
    shopModelMe?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductsListing
     */
    categoryIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    type?: ProductsListingTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductsListing
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    discountEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {UploadedFileItem}
     * @memberof ProductsListing
     */
    uploadedFile?: UploadedFileItem;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    moderationStatus?: ProductsListingModerationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    moderatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    moderatorUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    adminModerationReason?: string;
    /**
     * 
     * @type {ModeratorProfileItem}
     * @memberof ProductsListing
     */
    moderatorProfile?: ModeratorProfileItem;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    externalCheckoutUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    externalBrandName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    externalBrandImage?: string;
    /**
     * 
     * @type {ListingMeetingItem}
     * @memberof ProductsListing
     */
    meeting?: ListingMeetingItem;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProductsListing
     */
    sellerId: string;
}

/**
* @export
* @enum {string}
*/
export enum ProductsListingStatusEnum {
    Active = 'active',
    Archived = 'archived'
}/**
* @export
* @enum {string}
*/
export enum ProductsListingTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}/**
* @export
* @enum {string}
*/
export enum ProductsListingModerationStatusEnum {
    Pending = 'Pending',
    Accepted = 'Accepted',
    Rejected = 'Rejected',
    ReviewRequired = 'ReviewRequired'
}

/**
 * 
 * @export
 * @interface ProductsPageRows
 */
export interface ProductsPageRows {
    /**
     * 
     * @type {Array<ProductItem>}
     * @memberof ProductsPageRows
     */
    rows: Array<ProductItem>;
}

/**
 * 
 * @export
 * @interface ProductsQueryInfo
 */
export interface ProductsQueryInfo {
    /**
     * 
     * @type {Array<Edge>}
     * @memberof ProductsQueryInfo
     */
    edges: Array<Edge>;
    /**
     * 
     * @type {PageInfo}
     * @memberof ProductsQueryInfo
     */
    pageInfo: PageInfo;
}

/**
 * 
 * @export
 * @interface ProfileAppsItem
 */
export interface ProfileAppsItem {
    /**
     * 
     * @type {boolean}
     * @memberof ProfileAppsItem
     */
    popStore?: boolean;
}

/**
 * 
 * @export
 * @interface ProfileBadges
 */
export interface ProfileBadges {
    /**
     * 
     * @type {boolean}
     * @memberof ProfileBadges
     */
    activeSeller?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileBadges
     */
    staff?: boolean;
}

/**
 * 
 * @export
 * @interface ProfileItem
 */
export interface ProfileItem {
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    createdAt?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProfileItem
     */
    hashtags?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    userType?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    storeType?: ProfileItemStoreTypeEnum;
    /**
     * 
     * @type {ProfileAppsItem}
     * @memberof ProfileItem
     */
    apps?: ProfileAppsItem;
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    popStoreDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    urlCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    username?: string;
    /**
     * 
     * @type {ProfileBadges}
     * @memberof ProfileItem
     */
    badges?: ProfileBadges;
    /**
     * 
     * @type {string}
     * @memberof ProfileItem
     */
    id: string;
}

/**
* @export
* @enum {string}
*/
export enum ProfileItemStoreTypeEnum {
    Business = 'Business',
    Creator = 'Creator',
    CommentChat = 'CommentChat',
    Vfs = 'VFS'
}

/**
 * 
 * @export
 * @interface ProfileItemWithMetadata
 */
export interface ProfileItemWithMetadata {
    /**
     * 
     * @type {string}
     * @memberof ProfileItemWithMetadata
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItemWithMetadata
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItemWithMetadata
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItemWithMetadata
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItemWithMetadata
     */
    createdAt?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProfileItemWithMetadata
     */
    hashtags?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ProfileItemWithMetadata
     */
    userType?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItemWithMetadata
     */
    storeType?: ProfileItemWithMetadataStoreTypeEnum;
    /**
     * 
     * @type {ProfileAppsItem}
     * @memberof ProfileItemWithMetadata
     */
    apps?: ProfileAppsItem;
    /**
     * 
     * @type {string}
     * @memberof ProfileItemWithMetadata
     */
    popStoreDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItemWithMetadata
     */
    urlCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileItemWithMetadata
     */
    username?: string;
    /**
     * 
     * @type {ProfileBadges}
     * @memberof ProfileItemWithMetadata
     */
    badges?: ProfileBadges;
    /**
     * 
     * @type {string}
     * @memberof ProfileItemWithMetadata
     */
    id: string;
    /**
     * 
     * @type {Metadata}
     * @memberof ProfileItemWithMetadata
     */
    metadata: Metadata;
}

/**
* @export
* @enum {string}
*/
export enum ProfileItemWithMetadataStoreTypeEnum {
    Business = 'Business',
    Creator = 'Creator',
    CommentChat = 'CommentChat',
    Vfs = 'VFS'
}

/**
 * 
 * @export
 * @interface ProfilePageRows
 */
export interface ProfilePageRows {
    /**
     * 
     * @type {Array<ProfileItemWithMetadata>}
     * @memberof ProfilePageRows
     */
    rows: Array<ProfileItemWithMetadata>;
}

/**
 * 
 * @export
 * @interface ProfileResponse
 */
export interface ProfileResponse {
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    avatar?: string;
    /**
     * 
     * @type {object}
     * @memberof ProfileResponse
     */
    createdAt?: object;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    firstName: string;
    /**
     * 
     * @type {object}
     * @memberof ProfileResponse
     */
    hashtags?: object;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    urlCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponse
     */
    userType?: string;
}

/**
 * 
 * @export
 * @interface ProfileSearchResponse
 */
export interface ProfileSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof ProfileSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof ProfileSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {ProfilePageRows}
     * @memberof ProfileSearchResponse
     */
    data: ProfilePageRows;
}

/**
 * 
 * @export
 * @interface ProfilesFollowerItem
 */
export interface ProfilesFollowerItem {
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    createdAt?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProfilesFollowerItem
     */
    hashtags?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    userType?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    storeType?: ProfilesFollowerItemStoreTypeEnum;
    /**
     * 
     * @type {ProfileAppsItem}
     * @memberof ProfilesFollowerItem
     */
    apps?: ProfileAppsItem;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    popStoreDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    urlCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    username?: string;
    /**
     * 
     * @type {ProfileBadges}
     * @memberof ProfilesFollowerItem
     */
    badges?: ProfileBadges;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    id: string;
    /**
     * 
     * @type {Metadata}
     * @memberof ProfilesFollowerItem
     */
    metadata: Metadata;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    timestamp: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilesFollowerItem
     */
    email: string;
}

/**
* @export
* @enum {string}
*/
export enum ProfilesFollowerItemStoreTypeEnum {
    Business = 'Business',
    Creator = 'Creator',
    CommentChat = 'CommentChat',
    Vfs = 'VFS'
}

/**
 * 
 * @export
 * @interface ProfilesFollowerPageRows
 */
export interface ProfilesFollowerPageRows {
    /**
     * 
     * @type {Array<ProfilesFollowerItem>}
     * @memberof ProfilesFollowerPageRows
     */
    rows: Array<ProfilesFollowerItem>;
}

/**
 * 
 * @export
 * @interface ProfilesFollowersSearchResponse
 */
export interface ProfilesFollowersSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof ProfilesFollowersSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof ProfilesFollowersSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {ProfilesFollowerPageRows}
     * @memberof ProfilesFollowersSearchResponse
     */
    data: ProfilesFollowerPageRows;
}

/**
 * 
 * @export
 * @interface ProfilesFollowingsSearchResponse
 */
export interface ProfilesFollowingsSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof ProfilesFollowingsSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof ProfilesFollowingsSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {ProfilesFollowerPageRows}
     * @memberof ProfilesFollowingsSearchResponse
     */
    data: ProfilesFollowerPageRows;
}

/**
 * 
 * @export
 * @interface PromotionPageItem
 */
export interface PromotionPageItem {
    /**
     * 
     * @type {string}
     * @memberof PromotionPageItem
     */
    video: string;
    /**
     * 
     * @type {string}
     * @memberof PromotionPageItem
     */
    avatar: string;
    /**
     * 
     * @type {string}
     * @memberof PromotionPageItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof PromotionPageItem
     */
    coverImage: string;
    /**
     * 
     * @type {boolean}
     * @memberof PromotionPageItem
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof PromotionPageItem
     */
    thumbnailNickName: string;
}

/**
 * 
 * @export
 * @interface ProviderUser
 */
export interface ProviderUser {
    /**
     * 
     * @type {string}
     * @memberof ProviderUser
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderUser
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderUser
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderUser
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderUser
     */
    photoURL: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderUser
     */
    providerId: string;
}

/**
 * 
 * @export
 * @interface PurchasedStoresItem
 */
export interface PurchasedStoresItem {
    /**
     * 
     * @type {string}
     * @memberof PurchasedStoresItem
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedStoresItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedStoresItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedStoresItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedStoresItem
     */
    createdAt?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PurchasedStoresItem
     */
    hashtags?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PurchasedStoresItem
     */
    userType?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedStoresItem
     */
    storeType?: PurchasedStoresItemStoreTypeEnum;
    /**
     * 
     * @type {ProfileAppsItem}
     * @memberof PurchasedStoresItem
     */
    apps?: ProfileAppsItem;
    /**
     * 
     * @type {string}
     * @memberof PurchasedStoresItem
     */
    popStoreDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedStoresItem
     */
    urlCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedStoresItem
     */
    username?: string;
    /**
     * 
     * @type {ProfileBadges}
     * @memberof PurchasedStoresItem
     */
    badges?: ProfileBadges;
    /**
     * 
     * @type {string}
     * @memberof PurchasedStoresItem
     */
    id: string;
    /**
     * 
     * @type {Metadata}
     * @memberof PurchasedStoresItem
     */
    metadata: Metadata;
    /**
     * 
     * @type {string}
     * @memberof PurchasedStoresItem
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof PurchasedStoresItem
     */
    latestPurchasedAt: string;
}

/**
* @export
* @enum {string}
*/
export enum PurchasedStoresItemStoreTypeEnum {
    Business = 'Business',
    Creator = 'Creator',
    CommentChat = 'CommentChat',
    Vfs = 'VFS'
}

/**
 * 
 * @export
 * @interface PurchasedStoresResponse
 */
export interface PurchasedStoresResponse {
    /**
     * 
     * @type {Array<PurchasedStoresItem>}
     * @memberof PurchasedStoresResponse
     */
    rows: Array<PurchasedStoresItem>;
}

/**
 * 
 * @export
 * @interface QueryProductsByHandleResponseDto
 */
export interface QueryProductsByHandleResponseDto {
    /**
     * 
     * @type {Array<StoreListingItem>}
     * @memberof QueryProductsByHandleResponseDto
     */
    products: Array<StoreListingItem>;
}

/**
 * 
 * @export
 * @interface QueryProductsResponseDto
 */
export interface QueryProductsResponseDto {
    /**
     * 
     * @type {ProductsQueryInfo}
     * @memberof QueryProductsResponseDto
     */
    products: ProductsQueryInfo;
}

/**
 * 
 * @export
 * @interface QueryShipmentRequest
 */
export interface QueryShipmentRequest {
    /**
     * 
     * @type {string}
     * @memberof QueryShipmentRequest
     */
    templateId?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryShipmentRequest
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof QueryShipmentRequest
     */
    height: number;
    /**
     * 
     * @type {number}
     * @memberof QueryShipmentRequest
     */
    depth: number;
    /**
     * 
     * @type {string}
     * @memberof QueryShipmentRequest
     */
    distanceUnit: QueryShipmentRequestDistanceUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof QueryShipmentRequest
     */
    weight: number;
    /**
     * 
     * @type {string}
     * @memberof QueryShipmentRequest
     */
    massUnit: QueryShipmentRequestMassUnitEnum;
    /**
     * 
     * @type {FulfillmentExtraSetting}
     * @memberof QueryShipmentRequest
     */
    extra?: FulfillmentExtraSetting;
}

/**
* @export
* @enum {string}
*/
export enum QueryShipmentRequestDistanceUnitEnum {
    Cm = 'cm',
    In = 'in',
    Ft = 'ft',
    M = 'm',
    Mm = 'mm',
    Yd = 'yd'
}/**
* @export
* @enum {string}
*/
export enum QueryShipmentRequestMassUnitEnum {
    G = 'g',
    Kg = 'kg',
    Lb = 'lb',
    Oz = 'oz'
}

/**
 * 
 * @export
 * @interface ReadonlyProfileItem
 */
export interface ReadonlyProfileItem {
    /**
     * 
     * @type {number}
     * @memberof ReadonlyProfileItem
     */
    commissionRate?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadonlyProfileItem
     */
    shippingFee?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadonlyProfileItem
     */
    adjustedPopshopShippingFee?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReadonlyProfileItem
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ReadonlyProfileItem
     */
    withdrawableBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadonlyProfileItem
     */
    withdrawablePendingBalance?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReadonlyProfileItem
     */
    isDormantSeller?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReadonlyProfileItem
     */
    noteDormantSeller?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReadonlyProfileItem
     */
    nftContracts?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ReadonlyProfileItem
     */
    patreonIdentifier?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReadonlyProfileItem
     */
    taxIDConfirmed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReadonlyProfileItem
     */
    notes?: string;
    /**
     * 
     * @type {number}
     * @memberof ReadonlyProfileItem
     */
    customBadgeLimit?: number;
}

/**
 * 
 * @export
 * @interface RecentlyAddedShowsResponse
 */
export interface RecentlyAddedShowsResponse {
    /**
     * 
     * @type {Array<DiscoveryShowUpcomingShowItem>}
     * @memberof RecentlyAddedShowsResponse
     */
    data: Array<DiscoveryShowUpcomingShowItem>;
}

/**
 * 
 * @export
 * @interface RecipientItem
 */
export interface RecipientItem {
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    createdAt?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RecipientItem
     */
    hashtags?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    userType?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    storeType?: RecipientItemStoreTypeEnum;
    /**
     * 
     * @type {ProfileAppsItem}
     * @memberof RecipientItem
     */
    apps?: ProfileAppsItem;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    popStoreDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    urlCode?: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    username?: string;
    /**
     * 
     * @type {ProfileBadges}
     * @memberof RecipientItem
     */
    badges?: ProfileBadges;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientItem
     */
    nftImageUrl?: string;
}

/**
* @export
* @enum {string}
*/
export enum RecipientItemStoreTypeEnum {
    Business = 'Business',
    Creator = 'Creator',
    CommentChat = 'CommentChat',
    Vfs = 'VFS'
}

/**
 * 
 * @export
 * @interface RedeemCouponRequest
 */
export interface RedeemCouponRequest {
    /**
     * 
     * @type {string}
     * @memberof RedeemCouponRequest
     */
    sellerId?: string;
}

/**
 * 
 * @export
 * @interface RedeemedCouponDetailItem
 */
export interface RedeemedCouponDetailItem {
    /**
     * 
     * @type {string}
     * @memberof RedeemedCouponDetailItem
     */
    couponId: string;
    /**
     * 
     * @type {CouponItem}
     * @memberof RedeemedCouponDetailItem
     */
    coupon: CouponItem;
    /**
     * 
     * @type {string}
     * @memberof RedeemedCouponDetailItem
     */
    usedAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof RedeemedCouponDetailItem
     */
    used: boolean;
}

/**
 * 
 * @export
 * @interface RedeemedCouponItem
 */
export interface RedeemedCouponItem {
    /**
     * 
     * @type {string}
     * @memberof RedeemedCouponItem
     */
    redeemedCouponId: string;
    /**
     * 
     * @type {string}
     * @memberof RedeemedCouponItem
     */
    couponId: string;
    /**
     * 
     * @type {CouponItem}
     * @memberof RedeemedCouponItem
     */
    coupon: CouponItem;
    /**
     * 
     * @type {string}
     * @memberof RedeemedCouponItem
     */
    buyerId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof RedeemedCouponItem
     */
    buyerProfile: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof RedeemedCouponItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof RedeemedCouponItem
     */
    usedAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof RedeemedCouponItem
     */
    used: boolean;
    /**
     * 
     * @type {string}
     * @memberof RedeemedCouponItem
     */
    orderId?: string;
    /**
     * 
     * @type {string}
     * @memberof RedeemedCouponItem
     */
    targetSellerId?: string;
}

/**
 * 
 * @export
 * @interface ReferralGiftingSource
 */
export interface ReferralGiftingSource {
    /**
     * 
     * @type {string}
     * @memberof ReferralGiftingSource
     */
    type: ReferralGiftingSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ReferralGiftingSource
     */
    sentReferralGiftId: string;
}

/**
* @export
* @enum {string}
*/
export enum ReferralGiftingSourceTypeEnum {
    ReferralGifting = 'REFERRAL_GIFTING'
}

/**
 * 
 * @export
 * @interface RefreshUserSubscriptionLevelRequest
 */
export interface RefreshUserSubscriptionLevelRequest {
    /**
     * 
     * @type {string}
     * @memberof RefreshUserSubscriptionLevelRequest
     */
    creatorId: string;
}

/**
 * 
 * @export
 * @interface RefundOrderRequest
 */
export interface RefundOrderRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof RefundOrderRequest
     */
    refundTypes: Array<RefundOrderRequestRefundTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof RefundOrderRequest
     */
    reason?: string;
    /**
     * 
     * @type {number}
     * @memberof RefundOrderRequest
     */
    quantity?: number;
    /**
     * only admin can use
     * @type {string}
     * @memberof RefundOrderRequest
     */
    processingFeePayer?: RefundOrderRequestProcessingFeePayerEnum;
    /**
     * 
     * @type {boolean}
     * @memberof RefundOrderRequest
     */
    shouldRestock: boolean;
}

/**
* @export
* @enum {string}
*/
export enum RefundOrderRequestRefundTypesEnum {
    All = 'all',
    ShippingFee = 'shippingFee',
    Listing = 'listing',
    CancelListing = 'cancelListing',
    CustomAmount = 'customAmount'
}/**
* @export
* @enum {string}
*/
export enum RefundOrderRequestProcessingFeePayerEnum {
    Seller = 'SELLER',
    Popshop = 'POPSHOP'
}

/**
 * 
 * @export
 * @interface RefundRecordDetailItem
 */
export interface RefundRecordDetailItem {
    /**
     * 
     * @type {string}
     * @memberof RefundRecordDetailItem
     */
    id: string;
    /**
     * 
     * @type {OrderRefundPreviewResponseDetail}
     * @memberof RefundRecordDetailItem
     */
    detail: OrderRefundPreviewResponseDetail;
    /**
     * 
     * @type {Array<string>}
     * @memberof RefundRecordDetailItem
     */
    types: Array<RefundRecordDetailItemTypesEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof RefundRecordDetailItem
     */
    shouldRestock?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RefundRecordDetailItem
     */
    shouldFullyRefund?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RefundRecordDetailItem
     */
    reason?: string;
    /**
     * 
     * @type {BraintreeTransactionItem | StripeRefundItem}
     * @memberof RefundRecordDetailItem
     */
    intent: BraintreeTransactionItem | StripeRefundItem;
    /**
     * 
     * @type {string}
     * @memberof RefundRecordDetailItem
     */
    operatorId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof RefundRecordDetailItem
     */
    operator: ProfileItem | null;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailItem
     */
    quantity?: number;
    /**
     * 
     * @type {StoreListingItem}
     * @memberof RefundRecordDetailItem
     */
    listingSnapshot: StoreListingItem;
    /**
     * 
     * @type {string}
     * @memberof RefundRecordDetailItem
     */
    listingId: string;
    /**
     * 
     * @type {string}
     * @memberof RefundRecordDetailItem
     */
    variantId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RefundRecordDetailItem
     */
    sellerId: string;
    /**
     * 
     * @type {RefundRecordDetailSellerAmountDistribution}
     * @memberof RefundRecordDetailItem
     */
    sellerAmountDistribution: RefundRecordDetailSellerAmountDistribution;
    /**
     * 
     * @type {string}
     * @memberof RefundRecordDetailItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof RefundRecordDetailItem
     */
    updatedAt: string;
}

/**
* @export
* @enum {string}
*/
export enum RefundRecordDetailItemTypesEnum {
    All = 'all',
    ShippingFee = 'shippingFee',
    Listing = 'listing',
    CustomAmount = 'customAmount',
    Cancel = 'cancel',
    CancelListing = 'cancelListing'
}

/**
 * 
 * @export
 * @interface RefundRecordDetailSellerAmountDistribution
 */
export interface RefundRecordDetailSellerAmountDistribution {
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    returnCommissionFee: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    orderReturnGatewayProcessingFee: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    orderDeductSellerGotWithdrawableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    returnGatewayProcessingFee: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    deductShippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    deductSellerGotWithdrawableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    deductCouponSellerGotAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    deductItemCouponAmount: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    deductShippingCouponSellerGotAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    deductSellerSubtotalPaidByPopshopToSeller?: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    deductPopshopShippingFee?: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    deductPopshopShippingFeePaidBySellerToPopshop?: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    deductPopshopShippingFeePaidByPopshopToSeller?: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    deductSellerShippingFee?: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    deductSellerShippingFeePaidByPopshopToSeller?: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    commissionFee: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    orderGatewayProcessingFee: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    orderSellerGotWithdrawableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    listingCouponSellerGotAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    shippingCouponSellerGotAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    sellerSubtotalPaidByPopshopToSeller?: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    popshopShippingFee?: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    popshopShippingFeePaidBySellerToPopshop?: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    popshopShippingFeePaidByPopshopToSeller?: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    sellerShippingFee?: number;
    /**
     * 
     * @type {number}
     * @memberof RefundRecordDetailSellerAmountDistribution
     */
    sellerShippingFeePaidByPopshopToSeller?: number;
}

/**
 * 
 * @export
 * @interface RejectWithdrawTransactionDto
 */
export interface RejectWithdrawTransactionDto {
    /**
     * 
     * @type {string}
     * @memberof RejectWithdrawTransactionDto
     */
    note?: string;
}

/**
 * 
 * @export
 * @interface Relations
 */
export interface Relations {
    /**
     * 
     * @type {string}
     * @memberof Relations
     */
    parentId: string;
}

/**
 * 
 * @export
 * @interface ReorderFeaturedTagsRequest
 */
export interface ReorderFeaturedTagsRequest {
    /**
     * 
     * @type {Array<FeaturedTagOrder>}
     * @memberof ReorderFeaturedTagsRequest
     */
    tags: Array<FeaturedTagOrder>;
}

/**
 * 
 * @export
 * @interface ReplaySource
 */
export interface ReplaySource {
    /**
     * 
     * @type {string}
     * @memberof ReplaySource
     */
    type: ReplaySourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ReplaySource
     */
    liveStreamId: string;
}

/**
* @export
* @enum {string}
*/
export enum ReplaySourceTypeEnum {
    Replay = 'REPLAY'
}

/**
 * 
 * @export
 * @interface ReportLiveStreamRequest
 */
export interface ReportLiveStreamRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportLiveStreamRequest
     */
    flag: string;
    /**
     * 
     * @type {string}
     * @memberof ReportLiveStreamRequest
     */
    additionalMsg?: string;
}

/**
 * 
 * @export
 * @interface ResumeLiveStreamRequest
 */
export interface ResumeLiveStreamRequest {
    /**
     * 
     * @type {string}
     * @memberof ResumeLiveStreamRequest
     */
    device?: string;
}

/**
 * 
 * @export
 * @interface RetryPaymentRequest
 */
export interface RetryPaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof RetryPaymentRequest
     */
    stripeConfirmationToken: string;
    /**
     * 
     * @type {string}
     * @memberof RetryPaymentRequest
     */
    returnUrl: string;
}

/**
 * 
 * @export
 * @interface RetryPaymentResponse
 */
export interface RetryPaymentResponse {
    /**
     * 
     * @type {CreateOrderResponse}
     * @memberof RetryPaymentResponse
     */
    order: CreateOrderResponse;
    /**
     * 
     * @type {object}
     * @memberof RetryPaymentResponse
     */
    nextAction?: object;
}

/**
 * 
 * @export
 * @interface ReviewFeedItem
 */
export interface ReviewFeedItem {
    /**
     * 
     * @type {string}
     * @memberof ReviewFeedItem
     */
    reviewId: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewFeedItem
     */
    userIdFrom: string;
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof ReviewFeedItem
     */
    userProfileFrom: BaseProfileItem;
    /**
     * 
     * @type {string}
     * @memberof ReviewFeedItem
     */
    userIdTo: string;
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof ReviewFeedItem
     */
    userProfileTo: BaseProfileItem;
    /**
     * 
     * @type {string}
     * @memberof ReviewFeedItem
     */
    videoURL: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewFeedItem
     */
    originalVideoURL?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewFeedItem
     */
    gifURL?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewFeedItem
     */
    thumbnailURL?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewFeedItem
     */
    emoji?: ReviewFeedItemEmojiEnum;
    /**
     * 
     * @type {string}
     * @memberof ReviewFeedItem
     */
    listingDefaultImage?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewFeedItem
     */
    listingId?: string;
    /**
     * 
     * @type {TopReviewListingItem}
     * @memberof ReviewFeedItem
     */
    listingSnapshot?: TopReviewListingItem;
}

/**
* @export
* @enum {string}
*/
export enum ReviewFeedItemEmojiEnum {
    RollingEyesFace = 'rolling_eyes_face',
    Sweat = 'sweat',
    Blush = 'blush',
    Smile = 'smile',
    HeartEyes = 'heart_eyes'
}

/**
 * 
 * @export
 * @interface RichFeaturedTagItem
 */
export interface RichFeaturedTagItem {
    /**
     * 
     * @type {string}
     * @memberof RichFeaturedTagItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RichFeaturedTagItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RichFeaturedTagItem
     */
    sortedAt: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RichFeaturedTagItem
     */
    sellerTags: Array<string>;
}

/**
 * 
 * @export
 * @interface RichOrderItem
 */
export interface RichOrderItem {
    /**
     * 
     * @type {CommentSoldOrderItem}
     * @memberof RichOrderItem
     */
    commentSold?: CommentSoldOrderItem;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    eventId?: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    orderNumber: string;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    buyerName: string;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    buyerPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    shippingFeeAdjusted: number;
    /**
     * 
     * @type {boolean}
     * @memberof RichOrderItem
     */
    braintreeShippingFeeRefunded?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    salesTaxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    salesTaxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    buyerId: string;
    /**
     * 
     * @type {OrderProfileItem}
     * @memberof RichOrderItem
     */
    buyer: OrderProfileItem;
    /**
     * 
     * @type {OrderGiftingItem}
     * @memberof RichOrderItem
     */
    gifting?: OrderGiftingItem;
    /**
     * 
     * @type {OrderGiftPackageItem}
     * @memberof RichOrderItem
     */
    giftPackage?: OrderGiftPackageItem;
    /**
     * 
     * @type {ShipmentItem}
     * @memberof RichOrderItem
     */
    shipment?: ShipmentItem;
    /**
     * 
     * @type {PackingSlipItem}
     * @memberof RichOrderItem
     */
    packingSlip?: PackingSlipItem;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    refund?: number;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    userAgent?: string;
    /**
     * 
     * @type {OrderPaymentItem}
     * @memberof RichOrderItem
     */
    orderPayment?: OrderPaymentItem;
    /**
     * 
     * @type {PaymentItem}
     * @memberof RichOrderItem
     */
    payment?: PaymentItem;
    /**
     * 
     * @type {Array<RedeemedCouponItem>}
     * @memberof RichOrderItem
     */
    coupons?: Array<RedeemedCouponItem>;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    couponDiscountProductAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    couponDiscountShippingFeeAmount?: number;
    /**
     * 
     * @type {SellerTrackingInfoItem}
     * @memberof RichOrderItem
     */
    sellerTrackingInfo?: SellerTrackingInfoItem;
    /**
     * 
     * @type {Array<SellerTrackingInfoItem>}
     * @memberof RichOrderItem
     */
    sellerTrackingInfoHistory?: Array<SellerTrackingInfoItem>;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    sellerGotAmount: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    bonus?: number;
    /**
     * 
     * @type {AddressItem}
     * @memberof RichOrderItem
     */
    shippingAddress: AddressItem;
    /**
     * 
     * @type {PickupAddressItem}
     * @memberof RichOrderItem
     */
    pickupAddress?: PickupAddressItem;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    listingId: string;
    /**
     * 
     * @type {StoreListingItem}
     * @memberof RichOrderItem
     */
    listingSnapshot: StoreListingItem;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    sendItemId?: string;
    /**
     * 
     * @type {NormalSendItemItem | LiveStreamAuctionSendItemItem | GiveawaySendItemItem}
     * @memberof RichOrderItem
     */
    sendItem?: NormalSendItemItem | LiveStreamAuctionSendItemItem | GiveawaySendItemItem;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    sellerId: string;
    /**
     * 
     * @type {OrderProfileItem}
     * @memberof RichOrderItem
     */
    seller: OrderProfileItem;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    status: RichOrderItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    orderGroupStatus: RichOrderItemOrderGroupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    pickupStatus?: RichOrderItemPickupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    cancelStatus?: RichOrderItemCancelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    orderGroupCancelStatus?: RichOrderItemOrderGroupCancelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    orderRefundStatus?: RichOrderItemOrderRefundStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    orderGroupRefundStatus?: RichOrderItemOrderGroupRefundStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    shippingMethod: RichOrderItemShippingMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    shippoOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    variantId?: string;
    /**
     * 
     * @type {StoreFrontItem}
     * @memberof RichOrderItem
     */
    store: StoreFrontItem;
    /**
     * 
     * @type {OrderShipmentGroupStatus}
     * @memberof RichOrderItem
     */
    orderShipmentGroupStatus: OrderShipmentGroupStatus;
    /**
     * 
     * @type {ShippingLabelStatus}
     * @memberof RichOrderItem
     */
    shippingLabelStatus: ShippingLabelStatus;
    /**
     * 
     * @type {ShippingLabelStatus}
     * @memberof RichOrderItem
     */
    packingSlipStatus: ShippingLabelStatus;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    masterOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    planTimeOfShippingLabelGeneration?: string;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    totalQuantitiesIncludeSlaveOrders: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    totalPriceIncludeSlaveOrders: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    totalPriceIncludeSlaveOrdersWithProductCoupon: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    totalRefundIncludeSlaveOrders?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RichOrderItem
     */
    newCustomer?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    firstPurchaseAt?: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    updatedAt?: string;
    /**
     * 
     * @type {OrderCompositionCancellationStatus}
     * @memberof RichOrderItem
     */
    orderCompositionCancellationStatus?: OrderCompositionCancellationStatus;
    /**
     * 
     * @type {OrderChargeDistributionItem}
     * @memberof RichOrderItem
     */
    orderChargeDistribution?: OrderChargeDistributionItem;
    /**
     * 
     * @type {boolean}
     * @memberof RichOrderItem
     */
    packed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    pickupNotifiedAt?: string;
    /**
     * 
     * @type {OrderSource}
     * @memberof RichOrderItem
     */
    source?: OrderSource;
    /**
     * 
     * @type {OrderShipmentParcel}
     * @memberof RichOrderItem
     */
    shipmentParcel?: OrderShipmentParcel;
    /**
     * 
     * @type {OrderShipmentParcel}
     * @memberof RichOrderItem
     */
    shipmentOriginalParcel?: OrderShipmentParcel;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    shipmentOriginalParcelSource?: RichOrderItemShipmentOriginalParcelSourceEnum;
    /**
     * 
     * @type {OrderItemPriceComponents}
     * @memberof RichOrderItem
     */
    priceComponents?: OrderItemPriceComponents;
    /**
     * 
     * @type {Array<OrderRefund>}
     * @memberof RichOrderItem
     */
    refunds?: Array<OrderRefund>;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    packageTemplateId?: string;
    /**
     * 
     * @type {OrderItemPackageTemplate}
     * @memberof RichOrderItem
     */
    packageTemplate?: OrderItemPackageTemplate;
    /**
     * 
     * @type {OrderItemPresetShippingCost}
     * @memberof RichOrderItem
     */
    presetShippingCost?: OrderItemPresetShippingCost;
    /**
     * 
     * @type {OrderItemDropshipDetails}
     * @memberof RichOrderItem
     */
    dropshipDetails?: OrderItemDropshipDetails;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    fundAvailableDate?: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    fundAvailableDate2?: string;
    /**
     * 
     * @type {LabelShippingCost}
     * @memberof RichOrderItem
     */
    labelShippingCost?: LabelShippingCost;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    totalRefundedSalesTax?: number;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    paymentExpireAt?: string;
    /**
     * 
     * @type {MultiCurrencyOrderItem}
     * @memberof RichOrderItem
     */
    buyerCurrencyOrderDetails?: MultiCurrencyOrderItem;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    totalSalesTaxAmountIncludeSlaveOrders?: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItem
     */
    totalSalesTaxAmountIncludeSlaveOrdersInCurrency?: number;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItem
     */
    type?: string;
}

/**
* @export
* @enum {string}
*/
export enum RichOrderItemStatusEnum {
    Created = 'created',
    Completed = 'completed',
    Canceled = 'canceled',
    PendingPayment = 'pendingPayment',
    ProcessingPayment = 'processingPayment',
    Closed = 'closed'
}/**
* @export
* @enum {string}
*/
export enum RichOrderItemOrderGroupStatusEnum {
    Open = 'open',
    Processing = 'processing',
    Fulfilling = 'fulfilling',
    Completed = 'completed',
    Canceled = 'canceled'
}/**
* @export
* @enum {string}
*/
export enum RichOrderItemPickupStatusEnum {
    Open = 'open',
    New = 'new',
    Processing = 'processing',
    Pending = 'pending',
    Packed = 'packed',
    Completed = 'completed',
    Canceled = 'canceled'
}/**
* @export
* @enum {string}
*/
export enum RichOrderItemCancelStatusEnum {
    SellerApplied = 'seller_applied',
    AdminApproved = 'admin_approved'
}/**
* @export
* @enum {string}
*/
export enum RichOrderItemOrderGroupCancelStatusEnum {
    PartialCanceled = 'PARTIAL_CANCELED',
    FullyCanceled = 'FULLY_CANCELED'
}/**
* @export
* @enum {string}
*/
export enum RichOrderItemOrderRefundStatusEnum {
    PartiallyRefunded = 'PARTIALLY_REFUNDED',
    FullyRefunded = 'FULLY_REFUNDED'
}/**
* @export
* @enum {string}
*/
export enum RichOrderItemOrderGroupRefundStatusEnum {
    PartiallyRefunded = 'PARTIALLY_REFUNDED',
    FullyRefunded = 'FULLY_REFUNDED'
}/**
* @export
* @enum {string}
*/
export enum RichOrderItemShippingMethodEnum {
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide',
    Pickup = 'pickup',
    DropshipSupplierProvide = 'dropshipSupplierProvide'
}/**
* @export
* @enum {string}
*/
export enum RichOrderItemShipmentOriginalParcelSourceEnum {
    Default = 'DEFAULT',
    ShowEvent = 'SHOW_EVENT'
}

/**
 * 
 * @export
 * @interface RichOrderItemDetail
 */
export interface RichOrderItemDetail {
    /**
     * 
     * @type {CommentSoldOrderItem}
     * @memberof RichOrderItemDetail
     */
    commentSold?: CommentSoldOrderItem;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    eventId?: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    orderNumber: string;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItemDetail
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    buyerName: string;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItemDetail
     */
    buyerPaidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItemDetail
     */
    shippingFee: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItemDetail
     */
    shippingFeeAdjusted: number;
    /**
     * 
     * @type {boolean}
     * @memberof RichOrderItemDetail
     */
    braintreeShippingFeeRefunded?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItemDetail
     */
    salesTaxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItemDetail
     */
    salesTaxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItemDetail
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    buyerId: string;
    /**
     * 
     * @type {OrderProfileItem}
     * @memberof RichOrderItemDetail
     */
    buyer: OrderProfileItem;
    /**
     * 
     * @type {OrderGiftingItem}
     * @memberof RichOrderItemDetail
     */
    gifting?: OrderGiftingItem;
    /**
     * 
     * @type {OrderGiftPackageItem}
     * @memberof RichOrderItemDetail
     */
    giftPackage?: OrderGiftPackageItem;
    /**
     * 
     * @type {ShipmentItem}
     * @memberof RichOrderItemDetail
     */
    shipment?: ShipmentItem;
    /**
     * 
     * @type {PackingSlipItem}
     * @memberof RichOrderItemDetail
     */
    packingSlip?: PackingSlipItem;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItemDetail
     */
    refund?: number;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    userAgent?: string;
    /**
     * 
     * @type {OrderPaymentItem}
     * @memberof RichOrderItemDetail
     */
    orderPayment?: OrderPaymentItem;
    /**
     * 
     * @type {PaymentItem}
     * @memberof RichOrderItemDetail
     */
    payment?: PaymentItem;
    /**
     * 
     * @type {Array<RedeemedCouponItem>}
     * @memberof RichOrderItemDetail
     */
    coupons?: Array<RedeemedCouponItem>;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItemDetail
     */
    couponDiscountProductAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItemDetail
     */
    couponDiscountShippingFeeAmount?: number;
    /**
     * 
     * @type {SellerTrackingInfoItem}
     * @memberof RichOrderItemDetail
     */
    sellerTrackingInfo?: SellerTrackingInfoItem;
    /**
     * 
     * @type {Array<SellerTrackingInfoItem>}
     * @memberof RichOrderItemDetail
     */
    sellerTrackingInfoHistory?: Array<SellerTrackingInfoItem>;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItemDetail
     */
    sellerGotAmount: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItemDetail
     */
    bonus?: number;
    /**
     * 
     * @type {AddressItem}
     * @memberof RichOrderItemDetail
     */
    shippingAddress: AddressItem;
    /**
     * 
     * @type {PickupAddressItem}
     * @memberof RichOrderItemDetail
     */
    pickupAddress?: PickupAddressItem;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    listingId: string;
    /**
     * 
     * @type {StoreListingItem}
     * @memberof RichOrderItemDetail
     */
    listingSnapshot: StoreListingItem;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    sendItemId?: string;
    /**
     * 
     * @type {NormalSendItemItem | LiveStreamAuctionSendItemItem | GiveawaySendItemItem}
     * @memberof RichOrderItemDetail
     */
    sendItem?: NormalSendItemItem | LiveStreamAuctionSendItemItem | GiveawaySendItemItem;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    sellerId: string;
    /**
     * 
     * @type {OrderProfileItem}
     * @memberof RichOrderItemDetail
     */
    seller: OrderProfileItem;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    status: RichOrderItemDetailStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    orderGroupStatus: RichOrderItemDetailOrderGroupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    pickupStatus?: RichOrderItemDetailPickupStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    cancelStatus?: RichOrderItemDetailCancelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    orderGroupCancelStatus?: RichOrderItemDetailOrderGroupCancelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    orderRefundStatus?: RichOrderItemDetailOrderRefundStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    orderGroupRefundStatus?: RichOrderItemDetailOrderGroupRefundStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    shippingMethod: RichOrderItemDetailShippingMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    shippoOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    variantId?: string;
    /**
     * 
     * @type {StoreFrontItem}
     * @memberof RichOrderItemDetail
     */
    store: StoreFrontItem;
    /**
     * 
     * @type {OrderShipmentGroupStatus}
     * @memberof RichOrderItemDetail
     */
    orderShipmentGroupStatus: OrderShipmentGroupStatus;
    /**
     * 
     * @type {ShippingLabelStatus}
     * @memberof RichOrderItemDetail
     */
    shippingLabelStatus: ShippingLabelStatus;
    /**
     * 
     * @type {ShippingLabelStatus}
     * @memberof RichOrderItemDetail
     */
    packingSlipStatus: ShippingLabelStatus;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    masterOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    planTimeOfShippingLabelGeneration?: string;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItemDetail
     */
    totalQuantitiesIncludeSlaveOrders: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItemDetail
     */
    totalPriceIncludeSlaveOrders: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItemDetail
     */
    totalPriceIncludeSlaveOrdersWithProductCoupon: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItemDetail
     */
    totalRefundIncludeSlaveOrders?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RichOrderItemDetail
     */
    newCustomer?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    firstPurchaseAt?: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    updatedAt?: string;
    /**
     * 
     * @type {OrderCompositionCancellationStatus}
     * @memberof RichOrderItemDetail
     */
    orderCompositionCancellationStatus?: OrderCompositionCancellationStatus;
    /**
     * 
     * @type {OrderChargeDistributionItem}
     * @memberof RichOrderItemDetail
     */
    orderChargeDistribution?: OrderChargeDistributionItem;
    /**
     * 
     * @type {boolean}
     * @memberof RichOrderItemDetail
     */
    packed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    pickupNotifiedAt?: string;
    /**
     * 
     * @type {OrderSource}
     * @memberof RichOrderItemDetail
     */
    source?: OrderSource;
    /**
     * 
     * @type {OrderShipmentParcel}
     * @memberof RichOrderItemDetail
     */
    shipmentParcel?: OrderShipmentParcel;
    /**
     * 
     * @type {OrderShipmentParcel}
     * @memberof RichOrderItemDetail
     */
    shipmentOriginalParcel?: OrderShipmentParcel;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    shipmentOriginalParcelSource?: RichOrderItemDetailShipmentOriginalParcelSourceEnum;
    /**
     * 
     * @type {OrderItemPriceComponents}
     * @memberof RichOrderItemDetail
     */
    priceComponents?: OrderItemPriceComponents;
    /**
     * 
     * @type {Array<OrderRefund>}
     * @memberof RichOrderItemDetail
     */
    refunds?: Array<OrderRefund>;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    packageTemplateId?: string;
    /**
     * 
     * @type {OrderItemPackageTemplate}
     * @memberof RichOrderItemDetail
     */
    packageTemplate?: OrderItemPackageTemplate;
    /**
     * 
     * @type {OrderItemPresetShippingCost}
     * @memberof RichOrderItemDetail
     */
    presetShippingCost?: OrderItemPresetShippingCost;
    /**
     * 
     * @type {OrderItemDropshipDetails}
     * @memberof RichOrderItemDetail
     */
    dropshipDetails?: OrderItemDropshipDetails;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    fundAvailableDate?: string;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    fundAvailableDate2?: string;
    /**
     * 
     * @type {LabelShippingCost}
     * @memberof RichOrderItemDetail
     */
    labelShippingCost?: LabelShippingCost;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItemDetail
     */
    totalRefundedSalesTax?: number;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    paymentExpireAt?: string;
    /**
     * 
     * @type {MultiCurrencyOrderItem}
     * @memberof RichOrderItemDetail
     */
    buyerCurrencyOrderDetails?: MultiCurrencyOrderItem;
    /**
     * 
     * @type {LiveStreamItem}
     * @memberof RichOrderItemDetail
     */
    liveStream?: LiveStreamItem;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItemDetail
     */
    totalSalesTaxAmountIncludeSlaveOrders?: number;
    /**
     * 
     * @type {number}
     * @memberof RichOrderItemDetail
     */
    totalSalesTaxAmountIncludeSlaveOrdersInCurrency?: number;
    /**
     * 
     * @type {string}
     * @memberof RichOrderItemDetail
     */
    type?: string;
}

/**
* @export
* @enum {string}
*/
export enum RichOrderItemDetailStatusEnum {
    Created = 'created',
    Completed = 'completed',
    Canceled = 'canceled',
    PendingPayment = 'pendingPayment',
    ProcessingPayment = 'processingPayment',
    Closed = 'closed'
}/**
* @export
* @enum {string}
*/
export enum RichOrderItemDetailOrderGroupStatusEnum {
    Open = 'open',
    Processing = 'processing',
    Fulfilling = 'fulfilling',
    Completed = 'completed',
    Canceled = 'canceled'
}/**
* @export
* @enum {string}
*/
export enum RichOrderItemDetailPickupStatusEnum {
    Open = 'open',
    New = 'new',
    Processing = 'processing',
    Pending = 'pending',
    Packed = 'packed',
    Completed = 'completed',
    Canceled = 'canceled'
}/**
* @export
* @enum {string}
*/
export enum RichOrderItemDetailCancelStatusEnum {
    SellerApplied = 'seller_applied',
    AdminApproved = 'admin_approved'
}/**
* @export
* @enum {string}
*/
export enum RichOrderItemDetailOrderGroupCancelStatusEnum {
    PartialCanceled = 'PARTIAL_CANCELED',
    FullyCanceled = 'FULLY_CANCELED'
}/**
* @export
* @enum {string}
*/
export enum RichOrderItemDetailOrderRefundStatusEnum {
    PartiallyRefunded = 'PARTIALLY_REFUNDED',
    FullyRefunded = 'FULLY_REFUNDED'
}/**
* @export
* @enum {string}
*/
export enum RichOrderItemDetailOrderGroupRefundStatusEnum {
    PartiallyRefunded = 'PARTIALLY_REFUNDED',
    FullyRefunded = 'FULLY_REFUNDED'
}/**
* @export
* @enum {string}
*/
export enum RichOrderItemDetailShippingMethodEnum {
    SellerProvide = 'sellerProvide',
    PopshopProvide = 'popshopProvide',
    Pickup = 'pickup',
    DropshipSupplierProvide = 'dropshipSupplierProvide'
}/**
* @export
* @enum {string}
*/
export enum RichOrderItemDetailShipmentOriginalParcelSourceEnum {
    Default = 'DEFAULT',
    ShowEvent = 'SHOW_EVENT'
}

/**
 * 
 * @export
 * @interface RichSellerTagItem
 */
export interface RichSellerTagItem {
    /**
     * 
     * @type {string}
     * @memberof RichSellerTagItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RichSellerTagItem
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof RichSellerTagItem
     */
    totalSellers?: number;
}

/**
 * 
 * @export
 * @interface RichShippingCostItem
 */
export interface RichShippingCostItem {
    /**
     * 
     * @type {string}
     * @memberof RichShippingCostItem
     */
    status: RichShippingCostItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RichShippingCostItem
     */
    message?: string;
    /**
     * available when status is success
     * @type {string}
     * @memberof RichShippingCostItem
     */
    shipmentId?: string;
    /**
     * available when status is success
     * @type {Array<ShippingRateItem>}
     * @memberof RichShippingCostItem
     */
    rates?: Array<ShippingRateItem>;
}

/**
* @export
* @enum {string}
*/
export enum RichShippingCostItemStatusEnum {
    Pending = 'pending',
    Failed = 'failed',
    Success = 'success'
}

/**
 * 
 * @export
 * @interface RolesSearchResponse
 */
export interface RolesSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof RolesSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof RolesSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {UserPageRows}
     * @memberof RolesSearchResponse
     */
    data: UserPageRows;
}

/**
 * 
 * @export
 * @interface RouteSegmentRawEventRequest
 */
export interface RouteSegmentRawEventRequest {
    /**
     * segment raw event
     * @type {{ [key: string]: string | number | boolean | object; }}
     * @memberof RouteSegmentRawEventRequest
     */
    payload: { [key: string]: string | number | boolean | object; };
}

/**
 * 
 * @export
 * @interface SaveFromRemote
 */
export interface SaveFromRemote {
    /**
     * 
     * @type {string}
     * @memberof SaveFromRemote
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof SaveFromRemote
     */
    cloudPath: string;
}

/**
 * 
 * @export
 * @interface SaveFromRemoteResponse
 */
export interface SaveFromRemoteResponse {
    /**
     * 
     * @type {string}
     * @memberof SaveFromRemoteResponse
     */
    url: string;
}

/**
 * 
 * @export
 * @interface SearchAccountsResponse
 */
export interface SearchAccountsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchAccountsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchAccountsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {AccountsPageRows}
     * @memberof SearchAccountsResponse
     */
    data: AccountsPageRows;
}

/**
 * 
 * @export
 * @interface SearchAggregateLiveStreamUserStatsResponse
 */
export interface SearchAggregateLiveStreamUserStatsResponse {
    /**
     * 
     * @type {number}
     * @memberof SearchAggregateLiveStreamUserStatsResponse
     */
    repeatPurchasers?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchAggregateLiveStreamUserStatsResponse
     */
    newViewers?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchAggregateLiveStreamUserStatsResponse
     */
    newFollowers?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchAggregateLiveStreamUserStatsResponse
     */
    newPurchasers?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchAggregateLiveStreamUserStatsResponse
     */
    repeatViewers?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchAggregateLiveStreamUserStatsResponse
     */
    activeViewers?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchAggregateLiveStreamUserStatsResponse
     */
    total?: number;
}

/**
 * 
 * @export
 * @interface SearchAnlsUsersStatsPageRows
 */
export interface SearchAnlsUsersStatsPageRows {
    /**
     * 
     * @type {Array<AnlsUserItem>}
     * @memberof SearchAnlsUsersStatsPageRows
     */
    rows: Array<AnlsUserItem>;
}

/**
 * 
 * @export
 * @interface SearchAnlsUsersStatsResponse
 */
export interface SearchAnlsUsersStatsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchAnlsUsersStatsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchAnlsUsersStatsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SearchAnlsUsersStatsPageRows}
     * @memberof SearchAnlsUsersStatsResponse
     */
    data: SearchAnlsUsersStatsPageRows;
}

/**
 * 
 * @export
 * @interface SearchAvailableBillingCountryCodesResponse
 */
export interface SearchAvailableBillingCountryCodesResponse {
    /**
     * 
     * @type {Array<BillingCountryCodeItem>}
     * @memberof SearchAvailableBillingCountryCodesResponse
     */
    data: Array<BillingCountryCodeItem>;
}

/**
 * 
 * @export
 * @interface SearchBadgeUsersItem
 */
export interface SearchBadgeUsersItem {
    /**
     * 
     * @type {string}
     * @memberof SearchBadgeUsersItem
     */
    earnedAt: string;
    /**
     * 
     * @type {string}
     * @memberof SearchBadgeUsersItem
     */
    storeId: string;
    /**
     * 
     * @type {string}
     * @memberof SearchBadgeUsersItem
     */
    editionNo: string;
    /**
     * 
     * @type {string}
     * @memberof SearchBadgeUsersItem
     */
    badgeId: string;
    /**
     * 
     * @type {string}
     * @memberof SearchBadgeUsersItem
     */
    userId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof SearchBadgeUsersItem
     */
    profile: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof SearchBadgeUsersItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof SearchBadgeUsersItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof SearchBadgeUsersItem
     */
    id: string;
}

/**
 * 
 * @export
 * @interface SearchBadgeUsersPageRow
 */
export interface SearchBadgeUsersPageRow {
    /**
     * 
     * @type {Array<SearchBadgeUsersItem>}
     * @memberof SearchBadgeUsersPageRow
     */
    rows: Array<SearchBadgeUsersItem>;
}

/**
 * 
 * @export
 * @interface SearchBadgeUsersResponse
 */
export interface SearchBadgeUsersResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchBadgeUsersResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchBadgeUsersResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SearchBadgeUsersPageRow}
     * @memberof SearchBadgeUsersResponse
     */
    data: SearchBadgeUsersPageRow;
}

/**
 * 
 * @export
 * @interface SearchBadgesItem
 */
export interface SearchBadgesItem {
    /**
     * 
     * @type {string}
     * @memberof SearchBadgesItem
     */
    status: SearchBadgesItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchBadgesItem
     */
    approvedById?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchBadgesItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SearchBadgesItem
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof SearchBadgesItem
     */
    currentStep: SearchBadgesItemCurrentStepEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchBadgesItem
     */
    generatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof SearchBadgesItem
     */
    storeId: string;
    /**
     * 
     * @type {StoreFrontItem}
     * @memberof SearchBadgesItem
     */
    store: StoreFrontItem;
    /**
     * 
     * @type {number}
     * @memberof SearchBadgesItem
     */
    assignedCount: number;
    /**
     * 
     * @type {number}
     * @memberof SearchBadgesItem
     */
    limitCount: number;
    /**
     * 
     * @type {string}
     * @memberof SearchBadgesItem
     */
    limit: SearchBadgesItemLimitEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchBadgesItem
     */
    url?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchBadgesItem
     */
    editionNoGaps?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SearchBadgesItem
     */
    nextEditionNo: number;
    /**
     * 
     * @type {string}
     * @memberof SearchBadgesItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof SearchBadgesItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof SearchBadgesItem
     */
    approvedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchBadgesItem
     */
    id: string;
}

/**
* @export
* @enum {string}
*/
export enum SearchBadgesItemStatusEnum {
    Draft = 'DRAFT',
    Pending = 'PENDING',
    Approved = 'APPROVED',
    EditRequire = 'EDIT_REQUIRE'
}/**
* @export
* @enum {string}
*/
export enum SearchBadgesItemCurrentStepEnum {
    FillBaseInfo = 'FILL_BASE_INFO',
    UploadBadge = 'UPLOAD_BADGE',
    ConfirmBadge = 'CONFIRM_BADGE',
    ReviewBadge = 'REVIEW_BADGE'
}/**
* @export
* @enum {string}
*/
export enum SearchBadgesItemLimitEnum {
    BadgeLimit5 = 'Badge_LIMIT_5',
    BadgeLimit25 = 'Badge_LIMIT_25',
    BadgeLimit100 = 'Badge_LIMIT_100',
    BadgeLimit250 = 'Badge_LIMIT_250',
    BadgeLimit500 = 'Badge_LIMIT_500',
    BadgeLimit1000 = 'Badge_LIMIT_1000',
    Unlimited = 'Unlimited'
}

/**
 * 
 * @export
 * @interface SearchBadgesPageRows
 */
export interface SearchBadgesPageRows {
    /**
     * 
     * @type {Array<SearchBadgesItem>}
     * @memberof SearchBadgesPageRows
     */
    rows: Array<SearchBadgesItem>;
}

/**
 * 
 * @export
 * @interface SearchBadgesResponse
 */
export interface SearchBadgesResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchBadgesResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchBadgesResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SearchBadgesPageRows}
     * @memberof SearchBadgesResponse
     */
    data: SearchBadgesPageRows;
}

/**
 * 
 * @export
 * @interface SearchCategoryDiscoveryRowItem
 */
export interface SearchCategoryDiscoveryRowItem {
    /**
     * 
     * @type {string}
     * @memberof SearchCategoryDiscoveryRowItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof SearchCategoryDiscoveryRowItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof SearchCategoryDiscoveryRowItem
     */
    sortedAt: string;
    /**
     * 
     * @type {string}
     * @memberof SearchCategoryDiscoveryRowItem
     */
    title: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchCategoryDiscoveryRowItem
     */
    enabled: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchCategoryDiscoveryRowItem
     */
    categoryIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SearchCategoryDiscoveryRowItem
     */
    urlCode?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchCategoryDiscoveryRowItem
     */
    id: string;
}

/**
 * 
 * @export
 * @interface SearchCategoryDiscoveryRowsPageRows
 */
export interface SearchCategoryDiscoveryRowsPageRows {
    /**
     * 
     * @type {Array<SearchCategoryDiscoveryRowItem>}
     * @memberof SearchCategoryDiscoveryRowsPageRows
     */
    rows: Array<SearchCategoryDiscoveryRowItem>;
}

/**
 * 
 * @export
 * @interface SearchCategoryDiscoveryRowsResponse
 */
export interface SearchCategoryDiscoveryRowsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchCategoryDiscoveryRowsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchCategoryDiscoveryRowsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SearchCategoryDiscoveryRowsPageRows}
     * @memberof SearchCategoryDiscoveryRowsResponse
     */
    data: SearchCategoryDiscoveryRowsPageRows;
}

/**
 * 
 * @export
 * @interface SearchCommunityWaitlistUsersPageRows
 */
export interface SearchCommunityWaitlistUsersPageRows {
    /**
     * 
     * @type {Array<CommunityWaitlistUserItem>}
     * @memberof SearchCommunityWaitlistUsersPageRows
     */
    rows: Array<CommunityWaitlistUserItem>;
}

/**
 * 
 * @export
 * @interface SearchCommunityWaitlistUsersResponse
 */
export interface SearchCommunityWaitlistUsersResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchCommunityWaitlistUsersResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchCommunityWaitlistUsersResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SearchCommunityWaitlistUsersPageRows}
     * @memberof SearchCommunityWaitlistUsersResponse
     */
    data: SearchCommunityWaitlistUsersPageRows;
}

/**
 * 
 * @export
 * @interface SearchCreatedGiveawaysItem
 */
export interface SearchCreatedGiveawaysItem {
    /**
     * 
     * @type {boolean}
     * @memberof SearchCreatedGiveawaysItem
     */
    isCurrentUserEntered: boolean;
    /**
     * 
     * @type {GiveawayItemWithId}
     * @memberof SearchCreatedGiveawaysItem
     */
    giveawayItem: GiveawayItemWithId;
}

/**
 * 
 * @export
 * @interface SearchCreatedGiveawaysResponse
 */
export interface SearchCreatedGiveawaysResponse {
    /**
     * 
     * @type {Array<SearchCreatedGiveawaysItem>}
     * @memberof SearchCreatedGiveawaysResponse
     */
    rows: Array<SearchCreatedGiveawaysItem>;
}

/**
 * 
 * @export
 * @interface SearchFeaturedTagsPageRows
 */
export interface SearchFeaturedTagsPageRows {
    /**
     * 
     * @type {Array<RichFeaturedTagItem>}
     * @memberof SearchFeaturedTagsPageRows
     */
    rows: Array<RichFeaturedTagItem>;
}

/**
 * 
 * @export
 * @interface SearchFeaturedTagsResponse
 */
export interface SearchFeaturedTagsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchFeaturedTagsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchFeaturedTagsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SearchFeaturedTagsPageRows}
     * @memberof SearchFeaturedTagsResponse
     */
    data: SearchFeaturedTagsPageRows;
}

/**
 * 
 * @export
 * @interface SearchLiveStreamCommentsPageRows
 */
export interface SearchLiveStreamCommentsPageRows {
    /**
     * 
     * @type {Array<CommentItem>}
     * @memberof SearchLiveStreamCommentsPageRows
     */
    rows: Array<CommentItem>;
}

/**
 * 
 * @export
 * @interface SearchLiveStreamCommentsResponse
 */
export interface SearchLiveStreamCommentsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchLiveStreamCommentsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchLiveStreamCommentsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SearchLiveStreamCommentsPageRows}
     * @memberof SearchLiveStreamCommentsResponse
     */
    data: SearchLiveStreamCommentsPageRows;
}

/**
 * 
 * @export
 * @interface SearchLiveStreamItem
 */
export interface SearchLiveStreamItem {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchLiveStreamItem
     */
    badges?: Array<string>;
    /**
     * 
     * @type {LiveStreamUserItem}
     * @memberof SearchLiveStreamItem
     */
    primary: LiveStreamUserItem;
    /**
     * 
     * @type {LiveStreamUserItem}
     * @memberof SearchLiveStreamItem
     */
    secondary?: LiveStreamUserItem;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    disconnectedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    mode: SearchLiveStreamItemModeEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    background?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    preview?: string;
    /**
     * 
     * @type {BaseUpcomingShowItem}
     * @memberof SearchLiveStreamItem
     */
    upcomingShow?: BaseUpcomingShowItem;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    permission?: SearchLiveStreamItemPermissionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SearchLiveStreamItem
     */
    hasListing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchLiveStreamItem
     */
    hasOrder?: boolean;
    /**
     * 
     * @type {LiveStreamRecordingItem}
     * @memberof SearchLiveStreamItem
     */
    recording?: LiveStreamRecordingItem;
    /**
     * 
     * @type {LiveStreamCloudRecordingItem}
     * @memberof SearchLiveStreamItem
     */
    cloudRecording?: LiveStreamCloudRecordingItem;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    eventId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchLiveStreamItem
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    eventTemplateId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchLiveStreamItem
     */
    visibilityOfEventShowOnDiscovery?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    wrapUpEmailSentAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchLiveStreamItem
     */
    isDebutShow?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchLiveStreamItem
     */
    shippingMode?: Array<SearchLiveStreamItemShippingModeEnum>;
    /**
     * 
     * @type {ShowCustomizationItem}
     * @memberof SearchLiveStreamItem
     */
    showCustomization?: ShowCustomizationItem;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    masterPlaylist?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    moderationStatus?: SearchLiveStreamItemModerationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    moderatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    moderatedAt?: string;
    /**
     * 
     * @type {ModeratorProfileItem}
     * @memberof SearchLiveStreamItem
     */
    moderatorProfile?: ModeratorProfileItem;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    moderatorUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    moderationFlag?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    moderationAdditionalMsg?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    adminModerationReason?: string;
    /**
     * 
     * @type {AiModerationResultItem}
     * @memberof SearchLiveStreamItem
     */
    aiModerationResult?: AiModerationResultItem;
    /**
     * 
     * @type {object}
     * @memberof SearchLiveStreamItem
     */
    aiModerationLastError?: object;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    accessLevel?: SearchLiveStreamItemAccessLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamItem
     */
    id: string;
    /**
     * 
     * @type {SellerLiveStreamsStatsItem}
     * @memberof SearchLiveStreamItem
     */
    stats?: SellerLiveStreamsStatsItem;
}

/**
* @export
* @enum {string}
*/
export enum SearchLiveStreamItemModeEnum {
    Normal = 'normal',
    Cap = 'cap'
}/**
* @export
* @enum {string}
*/
export enum SearchLiveStreamItemPermissionEnum {
    All = 'all',
    Follower = 'follower',
    Subscriber = 'subscriber',
    NoOne = 'no-one'
}/**
* @export
* @enum {string}
*/
export enum SearchLiveStreamItemShippingModeEnum {
    Shipping = 'shipping',
    Pickup = 'pickup'
}/**
* @export
* @enum {string}
*/
export enum SearchLiveStreamItemModerationStatusEnum {
    Pending = 'Pending',
    Accepted = 'Accepted',
    Rejected = 'Rejected',
    ReviewRequired = 'ReviewRequired'
}/**
* @export
* @enum {string}
*/
export enum SearchLiveStreamItemAccessLevelEnum {
    All = 'all',
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface SearchLiveStreamUserStatsParams
 */
export interface SearchLiveStreamUserStatsParams {
    /**
     * Must be greater than 0.
     * @type {number}
     * @memberof SearchLiveStreamUserStatsParams
     */
    pageNo: number;
    /**
     * Must be between 0 and 200. For special cases like exporting, can be 10000 at most
     * @type {number}
     * @memberof SearchLiveStreamUserStatsParams
     */
    pageSize: number;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamUserStatsParams
     */
    order?: SearchLiveStreamUserStatsParamsOrderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SearchLiveStreamUserStatsParams
     */
    isFollower?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchLiveStreamUserStatsParams
     */
    isNewFollower?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchLiveStreamUserStatsParams
     */
    isNewSellerCustomer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchLiveStreamUserStatsParams
     */
    isRepeatSellerCustomer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchLiveStreamUserStatsParams
     */
    isNewSellerViewer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchLiveStreamUserStatsParams
     */
    isRepeatSellerViewer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchLiveStreamUserStatsParams
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamUserStatsParams
     */
    userGroupId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchLiveStreamUserStatsParams
     */
    loadBlockedStatus?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchLiveStreamUserStatsParams
     */
    loadUserBadges?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchLiveStreamUserStatsParams
     */
    badgeIds?: Array<string>;
    /**
     * 
     * @type {SearchLiveStreamUserStatsRangeFilter}
     * @memberof SearchLiveStreamUserStatsParams
     */
    range?: SearchLiveStreamUserStatsRangeFilter;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamUserStatsParams
     */
    query?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchLiveStreamUserStatsParams
     */
    sortBy?: SearchLiveStreamUserStatsParamsSortByEnum;
}

/**
* @export
* @enum {string}
*/
export enum SearchLiveStreamUserStatsParamsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}/**
* @export
* @enum {string}
*/
export enum SearchLiveStreamUserStatsParamsSortByEnum {
    Gmv = 'gmv',
    WatchedSec = 'watched_sec',
    LikeCnt = 'like_cnt',
    CommentCnt = 'comment_cnt',
    ItemCnt = 'item_cnt',
    ShareCnt = 'share_cnt',
    Gtv = 'gtv',
    Id = 'id'
}

/**
 * 
 * @export
 * @interface SearchLiveStreamUserStatsRangeFilter
 */
export interface SearchLiveStreamUserStatsRangeFilter {
    /**
     * 
     * @type {NumberRange}
     * @memberof SearchLiveStreamUserStatsRangeFilter
     */
    watchedSec?: NumberRange;
    /**
     * 
     * @type {NumberRange}
     * @memberof SearchLiveStreamUserStatsRangeFilter
     */
    likeCnt?: NumberRange;
    /**
     * 
     * @type {NumberRange}
     * @memberof SearchLiveStreamUserStatsRangeFilter
     */
    commentCnt?: NumberRange;
    /**
     * 
     * @type {NumberRange}
     * @memberof SearchLiveStreamUserStatsRangeFilter
     */
    itemCnt?: NumberRange;
    /**
     * 
     * @type {NumberRange}
     * @memberof SearchLiveStreamUserStatsRangeFilter
     */
    gmv?: NumberRange;
    /**
     * 
     * @type {NumberRange}
     * @memberof SearchLiveStreamUserStatsRangeFilter
     */
    shareCnt?: NumberRange;
    /**
     * 
     * @type {NumberRange}
     * @memberof SearchLiveStreamUserStatsRangeFilter
     */
    purchaseCnt?: NumberRange;
}

/**
 * 
 * @export
 * @interface SearchLiveStreamUserStatsResponse
 */
export interface SearchLiveStreamUserStatsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchLiveStreamUserStatsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchLiveStreamUserStatsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {LiveStreamUserStatsPageRows}
     * @memberof SearchLiveStreamUserStatsResponse
     */
    data: LiveStreamUserStatsPageRows;
}

/**
 * 
 * @export
 * @interface SearchPastFinishedGiveawaysResponse
 */
export interface SearchPastFinishedGiveawaysResponse {
    /**
     * 
     * @type {Array<GiveawayItemWithId>}
     * @memberof SearchPastFinishedGiveawaysResponse
     */
    rows: Array<GiveawayItemWithId>;
}

/**
 * 
 * @export
 * @interface SearchPopStoreDropshipApplicationsResponse
 */
export interface SearchPopStoreDropshipApplicationsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchPopStoreDropshipApplicationsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchPopStoreDropshipApplicationsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {PopStoreDropshipApplicationPageRows}
     * @memberof SearchPopStoreDropshipApplicationsResponse
     */
    data: PopStoreDropshipApplicationPageRows;
}

/**
 * 
 * @export
 * @interface SearchPopStoreOnboardingContestSubmissionsResponse
 */
export interface SearchPopStoreOnboardingContestSubmissionsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchPopStoreOnboardingContestSubmissionsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchPopStoreOnboardingContestSubmissionsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {PopStoreOnboardingContestSubmissionPageRows}
     * @memberof SearchPopStoreOnboardingContestSubmissionsResponse
     */
    data: PopStoreOnboardingContestSubmissionPageRows;
}

/**
 * 
 * @export
 * @interface SearchPopStoreOnboardingSessionsResponse
 */
export interface SearchPopStoreOnboardingSessionsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchPopStoreOnboardingSessionsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchPopStoreOnboardingSessionsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {PopStoreOnboardingSessionPageRows}
     * @memberof SearchPopStoreOnboardingSessionsResponse
     */
    data: PopStoreOnboardingSessionPageRows;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SearchPopStoreThemeTemplatePurposeEnumItem {
    Manage = 'manage',
    Apply = 'apply'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SearchPostCommentSortByEnumItem {
    Id = 'id',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    LikeCount = 'likeCount',
    ReplyCount = 'replyCount'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SearchPostSortByEnumItem {
    Id = 'id',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    PublishedAt = 'publishedAt',
    Title = 'title',
    CommentCount = 'commentCount',
    LikeCount = 'likeCount'
}

/**
 * 
 * @export
 * @interface SearchProductsResponse
 */
export interface SearchProductsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchProductsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchProductsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {ProductsPageRows}
     * @memberof SearchProductsResponse
     */
    data: ProductsPageRows;
}

/**
 * 
 * @export
 * @interface SearchRedeemedCouponsItem
 */
export interface SearchRedeemedCouponsItem {
    /**
     * 
     * @type {string}
     * @memberof SearchRedeemedCouponsItem
     */
    redeemedCouponId: string;
    /**
     * 
     * @type {string}
     * @memberof SearchRedeemedCouponsItem
     */
    couponId: string;
    /**
     * 
     * @type {CouponItem}
     * @memberof SearchRedeemedCouponsItem
     */
    coupon: CouponItem;
    /**
     * 
     * @type {string}
     * @memberof SearchRedeemedCouponsItem
     */
    buyerId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof SearchRedeemedCouponsItem
     */
    buyerProfile: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof SearchRedeemedCouponsItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof SearchRedeemedCouponsItem
     */
    usedAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchRedeemedCouponsItem
     */
    used: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchRedeemedCouponsItem
     */
    orderId?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchRedeemedCouponsItem
     */
    targetSellerId?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchRedeemedCouponsItem
     */
    id: string;
}

/**
 * 
 * @export
 * @interface SearchRedeemedCouponsPageRows
 */
export interface SearchRedeemedCouponsPageRows {
    /**
     * 
     * @type {Array<SearchRedeemedCouponsItem>}
     * @memberof SearchRedeemedCouponsPageRows
     */
    rows: Array<SearchRedeemedCouponsItem>;
}

/**
 * 
 * @export
 * @interface SearchRedeemedCouponsResponse
 */
export interface SearchRedeemedCouponsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchRedeemedCouponsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchRedeemedCouponsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SearchRedeemedCouponsPageRows}
     * @memberof SearchRedeemedCouponsResponse
     */
    data: SearchRedeemedCouponsPageRows;
}

/**
 * 
 * @export
 * @interface SearchReferralGiftsItem
 */
export interface SearchReferralGiftsItem {
    /**
     * 
     * @type {boolean}
     * @memberof SearchReferralGiftsItem
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchReferralGiftsItem
     */
    sortedAt: string;
    /**
     * 
     * @type {StoreListingItem}
     * @memberof SearchReferralGiftsItem
     */
    listing: StoreListingItem;
    /**
     * 
     * @type {number}
     * @memberof SearchReferralGiftsItem
     */
    givenTimes: number;
    /**
     * 
     * @type {string}
     * @memberof SearchReferralGiftsItem
     */
    storeId: string;
    /**
     * 
     * @type {StoreFrontItem}
     * @memberof SearchReferralGiftsItem
     */
    store: StoreFrontItem;
    /**
     * 
     * @type {string}
     * @memberof SearchReferralGiftsItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof SearchReferralGiftsItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof SearchReferralGiftsItem
     */
    id: string;
}

/**
 * 
 * @export
 * @interface SearchReferralGiftsPageRows
 */
export interface SearchReferralGiftsPageRows {
    /**
     * 
     * @type {Array<SearchReferralGiftsItem>}
     * @memberof SearchReferralGiftsPageRows
     */
    rows: Array<SearchReferralGiftsItem>;
}

/**
 * 
 * @export
 * @interface SearchReferralGiftsResponse
 */
export interface SearchReferralGiftsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchReferralGiftsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchReferralGiftsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SearchReferralGiftsPageRows}
     * @memberof SearchReferralGiftsResponse
     */
    data: SearchReferralGiftsPageRows;
}

/**
 * 
 * @export
 * @interface SearchResponse
 */
export interface SearchResponse {
    /**
     * 
     * @type {Array<StoreDTO>}
     * @memberof SearchResponse
     */
    popshop_stores: Array<StoreDTO>;
}

/**
 * 
 * @export
 * @interface SearchSellerGiveawayResponse
 */
export interface SearchSellerGiveawayResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchSellerGiveawayResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchSellerGiveawayResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SearchSellerGiveawayRows}
     * @memberof SearchSellerGiveawayResponse
     */
    data: SearchSellerGiveawayRows;
}

/**
 * 
 * @export
 * @interface SearchSellerGiveawayRows
 */
export interface SearchSellerGiveawayRows {
    /**
     * 
     * @type {Array<SearchSellerGiveawaysItem>}
     * @memberof SearchSellerGiveawayRows
     */
    rows: Array<SearchSellerGiveawaysItem>;
}

/**
 * 
 * @export
 * @interface SearchSellerGiveawaysItem
 */
export interface SearchSellerGiveawaysItem {
    /**
     * 
     * @type {GiveawayItemWithId}
     * @memberof SearchSellerGiveawaysItem
     */
    giveawayItem: GiveawayItemWithId;
    /**
     * 
     * @type {ProfileItem}
     * @memberof SearchSellerGiveawaysItem
     */
    latestWinner?: ProfileItem;
}

/**
 * 
 * @export
 * @interface SearchSellerLifeTimeStatsResponse
 */
export interface SearchSellerLifeTimeStatsResponse {
    /**
     * 
     * @type {AnlsSellerItem}
     * @memberof SearchSellerLifeTimeStatsResponse
     */
    data: AnlsSellerItem;
}

/**
 * 
 * @export
 * @interface SearchSellerLiveStreamsStatsRaneFilter
 */
export interface SearchSellerLiveStreamsStatsRaneFilter {
    /**
     * 
     * @type {StringRange}
     * @memberof SearchSellerLiveStreamsStatsRaneFilter
     */
    disconnectedAt?: StringRange;
    /**
     * 
     * @type {StringRange}
     * @memberof SearchSellerLiveStreamsStatsRaneFilter
     */
    createdAt?: StringRange;
    /**
     * 
     * @type {StringRange}
     * @memberof SearchSellerLiveStreamsStatsRaneFilter
     */
    startedAt?: StringRange;
}

/**
 * 
 * @export
 * @interface SearchSellerLiveStreamsStatsRequest
 */
export interface SearchSellerLiveStreamsStatsRequest {
    /**
     * Must be greater than 0.
     * @type {number}
     * @memberof SearchSellerLiveStreamsStatsRequest
     */
    pageNo: number;
    /**
     * Must be between 0 and 200. For special cases like exporting, can be 10000 at most
     * @type {number}
     * @memberof SearchSellerLiveStreamsStatsRequest
     */
    pageSize: number;
    /**
     * 
     * @type {string}
     * @memberof SearchSellerLiveStreamsStatsRequest
     */
    order?: SearchSellerLiveStreamsStatsRequestOrderEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchSellerLiveStreamsStatsRequest
     */
    liveStreamId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSellerLiveStreamsStatsRequest
     */
    isFinished?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchSellerLiveStreamsStatsRequest
     */
    permission?: Array<SearchSellerLiveStreamsStatsRequestPermissionEnum>;
    /**
     * 
     * @type {SearchSellerLiveStreamsStatsRaneFilter}
     * @memberof SearchSellerLiveStreamsStatsRequest
     */
    range?: SearchSellerLiveStreamsStatsRaneFilter;
    /**
     * 
     * @type {string}
     * @memberof SearchSellerLiveStreamsStatsRequest
     */
    sortBy?: SearchSellerLiveStreamsStatsRequestSortByEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchSellerLiveStreamsStatsRequest
     */
    timezone?: string;
}

/**
* @export
* @enum {string}
*/
export enum SearchSellerLiveStreamsStatsRequestOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}/**
* @export
* @enum {string}
*/
export enum SearchSellerLiveStreamsStatsRequestPermissionEnum {
    All = 'all',
    Follower = 'follower',
    Subscriber = 'subscriber',
    NoOne = 'no-one'
}/**
* @export
* @enum {string}
*/
export enum SearchSellerLiveStreamsStatsRequestSortByEnum {
    CreatedAt = 'created_at',
    Gmv = 'gmv',
    MainOrderCnt = 'main_order_cnt',
    CustomerCnt = 'customer_cnt',
    NewCustomerCnt = 'new_customer_cnt',
    ViewerCnt = 'viewer_cnt',
    NewViewerCnt = 'new_viewer_cnt',
    ItemCnt = 'item_cnt',
    StartedAt = 'started_at',
    DurationSec = 'duration_sec',
    WatchedSec = 'watched_sec',
    AverageConcurrentViewerCnt = 'average_concurrent_viewer_cnt'
}

/**
 * 
 * @export
 * @interface SearchSellerLiveStreamsStatsResponse
 */
export interface SearchSellerLiveStreamsStatsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchSellerLiveStreamsStatsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchSellerLiveStreamsStatsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SellerLiveStreamsStatsPageRows}
     * @memberof SearchSellerLiveStreamsStatsResponse
     */
    data: SellerLiveStreamsStatsPageRows;
}

/**
 * 
 * @export
 * @interface SearchSellerMainOrderStatsPageRows
 */
export interface SearchSellerMainOrderStatsPageRows {
    /**
     * 
     * @type {Array<AnlsSellerMainOrderItem>}
     * @memberof SearchSellerMainOrderStatsPageRows
     */
    rows: Array<AnlsSellerMainOrderItem>;
}

/**
 * 
 * @export
 * @interface SearchSellerMainOrderStatsRangeFilter
 */
export interface SearchSellerMainOrderStatsRangeFilter {
    /**
     * 
     * @type {StringRange}
     * @memberof SearchSellerMainOrderStatsRangeFilter
     */
    createdAt?: StringRange;
}

/**
 * 
 * @export
 * @interface SearchSellerMainOrderStatsRequest
 */
export interface SearchSellerMainOrderStatsRequest {
    /**
     * Must be greater than 0.
     * @type {number}
     * @memberof SearchSellerMainOrderStatsRequest
     */
    pageNo: number;
    /**
     * Must be between 0 and 200. For special cases like exporting, can be 10000 at most
     * @type {number}
     * @memberof SearchSellerMainOrderStatsRequest
     */
    pageSize: number;
    /**
     * 
     * @type {string}
     * @memberof SearchSellerMainOrderStatsRequest
     */
    order?: SearchSellerMainOrderStatsRequestOrderEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchSellerMainOrderStatsRequest
     */
    id?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSellerMainOrderStatsRequest
     */
    groupStatusMaster?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSellerMainOrderStatsRequest
     */
    groupStatusCustomer?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchSellerMainOrderStatsRequest
     */
    mainOrderStatus?: Array<SearchSellerMainOrderStatsRequestMainOrderStatusEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchSellerMainOrderStatsRequest
     */
    status?: Array<SearchSellerMainOrderStatsRequestStatusEnum>;
    /**
     * 
     * @type {string}
     * @memberof SearchSellerMainOrderStatsRequest
     */
    sortBy?: SearchSellerMainOrderStatsRequestSortByEnum;
    /**
     * 
     * @type {SearchSellerMainOrderStatsRangeFilter}
     * @memberof SearchSellerMainOrderStatsRequest
     */
    range?: SearchSellerMainOrderStatsRangeFilter;
}

/**
* @export
* @enum {string}
*/
export enum SearchSellerMainOrderStatsRequestOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}/**
* @export
* @enum {string}
*/
export enum SearchSellerMainOrderStatsRequestMainOrderStatusEnum {
    Created = 'created',
    Completed = 'completed',
    Canceled = 'canceled',
    PendingPayment = 'pendingPayment',
    ProcessingPayment = 'processingPayment',
    Closed = 'closed'
}/**
* @export
* @enum {string}
*/
export enum SearchSellerMainOrderStatsRequestStatusEnum {
    Created = 'created',
    Completed = 'completed',
    Canceled = 'canceled',
    PendingPayment = 'pendingPayment',
    ProcessingPayment = 'processingPayment',
    Closed = 'closed'
}/**
* @export
* @enum {string}
*/
export enum SearchSellerMainOrderStatsRequestSortByEnum {
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt'
}

/**
 * 
 * @export
 * @interface SearchSellerMainOrderStatsResponse
 */
export interface SearchSellerMainOrderStatsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchSellerMainOrderStatsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchSellerMainOrderStatsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SearchSellerMainOrderStatsPageRows}
     * @memberof SearchSellerMainOrderStatsResponse
     */
    data: SearchSellerMainOrderStatsPageRows;
}

/**
 * 
 * @export
 * @interface SearchSellerPeriodStatsItem
 */
export interface SearchSellerPeriodStatsItem {
    /**
     * 
     * @type {string}
     * @memberof SearchSellerPeriodStatsItem
     */
    period: SearchSellerPeriodStatsItemPeriodEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchSellerPeriodStatsItem
     */
    periodFirstDate: string;
    /**
     * 
     * @type {string}
     * @memberof SearchSellerPeriodStatsItem
     */
    periodLastDate: string;
    /**
     * 
     * @type {number}
     * @memberof SearchSellerPeriodStatsItem
     */
    newFollowers: number;
    /**
     * 
     * @type {number}
     * @memberof SearchSellerPeriodStatsItem
     */
    totalFollowers: number;
    /**
     * 
     * @type {number}
     * @memberof SearchSellerPeriodStatsItem
     */
    newReferrals: number;
    /**
     * 
     * @type {number}
     * @memberof SearchSellerPeriodStatsItem
     */
    totalReferrals: number;
    /**
     * 
     * @type {number}
     * @memberof SearchSellerPeriodStatsItem
     */
    gmv: number;
    /**
     * 
     * @type {number}
     * @memberof SearchSellerPeriodStatsItem
     */
    taxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof SearchSellerPeriodStatsItem
     */
    mainOrderCount: number;
}

/**
* @export
* @enum {string}
*/
export enum SearchSellerPeriodStatsItemPeriodEnum {
    Day = 'day',
    Week = 'week',
    Month = 'month',
    Year = 'year'
}

/**
 * 
 * @export
 * @interface SearchSellerPeriodStatsResponse
 */
export interface SearchSellerPeriodStatsResponse {
    /**
     * 
     * @type {Array<SearchSellerPeriodStatsItem>}
     * @memberof SearchSellerPeriodStatsResponse
     */
    rows: Array<SearchSellerPeriodStatsItem>;
}

/**
 * 
 * @export
 * @interface SearchSellerTagsPageRows
 */
export interface SearchSellerTagsPageRows {
    /**
     * 
     * @type {Array<RichSellerTagItem>}
     * @memberof SearchSellerTagsPageRows
     */
    rows: Array<RichSellerTagItem>;
}

/**
 * 
 * @export
 * @interface SearchSellerTagsResponse
 */
export interface SearchSellerTagsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchSellerTagsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchSellerTagsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SearchSellerTagsPageRows}
     * @memberof SearchSellerTagsResponse
     */
    data: SearchSellerTagsPageRows;
}

/**
 * 
 * @export
 * @interface SearchSellerViewersParams
 */
export interface SearchSellerViewersParams {
    /**
     * Must be greater than 0.
     * @type {number}
     * @memberof SearchSellerViewersParams
     */
    pageNo: number;
    /**
     * Must be between 0 and 200. For special cases like exporting, can be 10000 at most
     * @type {number}
     * @memberof SearchSellerViewersParams
     */
    pageSize: number;
    /**
     * 
     * @type {string}
     * @memberof SearchSellerViewersParams
     */
    order?: SearchSellerViewersParamsOrderEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchSellerViewersParams
     */
    period?: SearchSellerViewersParamsPeriodEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchSellerViewersParams
     */
    year?: string;
    /**
     * search by username
     * @type {string}
     * @memberof SearchSellerViewersParams
     */
    query?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSellerViewersParams
     */
    isFollower?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSellerViewersParams
     */
    isReferral?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchSellerViewersParams
     */
    badgeIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SearchSellerViewersParams
     */
    badgeRelations?: SearchSellerViewersParamsBadgeRelationsEnum;
    /**
     * 
     * @type {SearchSellerViewersRaneFilter}
     * @memberof SearchSellerViewersParams
     */
    range?: SearchSellerViewersRaneFilter;
    /**
     * 
     * @type {string}
     * @memberof SearchSellerViewersParams
     */
    sortBy?: SearchSellerViewersParamsSortByEnum;
}

/**
* @export
* @enum {string}
*/
export enum SearchSellerViewersParamsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}/**
* @export
* @enum {string}
*/
export enum SearchSellerViewersParamsPeriodEnum {
    All = 'all',
    Recent1Y = 'recent1Y',
    Last1Y = 'last1Y',
    Recent30D = 'recent30D'
}/**
* @export
* @enum {string}
*/
export enum SearchSellerViewersParamsBadgeRelationsEnum {
    Any = 'CONTAINS_ANY',
    None = 'CONTAINS_NONE'
}/**
* @export
* @enum {string}
*/
export enum SearchSellerViewersParamsSortByEnum {
    Gmv = 'gmv',
    FirstPurchaseAt = 'first_purchase_at',
    LastPurchaseAt = 'last_purchase_at',
    FirstWatchedAt = 'first_watched_at',
    LastWatchedAt = 'last_watched_at',
    FollowedAt = 'followed_at',
    ReferralAt = 'referral_at',
    PurchaseCnt = 'purchase_cnt',
    WatchedSec = 'watched_sec',
    ReferralCnt = 'referral_cnt',
    WatchedShowCnt = 'watched_show_cnt',
    LikeCnt = 'like_cnt',
    ShareCnt = 'share_cnt',
    CommentCnt = 'comment_cnt',
    Id = 'id'
}

/**
 * 
 * @export
 * @interface SearchSellerViewersRaneFilter
 */
export interface SearchSellerViewersRaneFilter {
    /**
     * 
     * @type {StringRange}
     * @memberof SearchSellerViewersRaneFilter
     */
    firstPurchaseAt?: StringRange;
    /**
     * 
     * @type {StringRange}
     * @memberof SearchSellerViewersRaneFilter
     */
    lastPurchaseAt?: StringRange;
    /**
     * 
     * @type {StringRange}
     * @memberof SearchSellerViewersRaneFilter
     */
    firstWatchedAt?: StringRange;
    /**
     * 
     * @type {StringRange}
     * @memberof SearchSellerViewersRaneFilter
     */
    lastWatchedAt?: StringRange;
    /**
     * 
     * @type {StringRange}
     * @memberof SearchSellerViewersRaneFilter
     */
    followedAt?: StringRange;
    /**
     * 
     * @type {StringRange}
     * @memberof SearchSellerViewersRaneFilter
     */
    referralAt?: StringRange;
    /**
     * 
     * @type {NumberRange}
     * @memberof SearchSellerViewersRaneFilter
     */
    watchedSec?: NumberRange;
    /**
     * 
     * @type {NumberRange}
     * @memberof SearchSellerViewersRaneFilter
     */
    likeCnt?: NumberRange;
    /**
     * 
     * @type {NumberRange}
     * @memberof SearchSellerViewersRaneFilter
     */
    commentCnt?: NumberRange;
    /**
     * 
     * @type {NumberRange}
     * @memberof SearchSellerViewersRaneFilter
     */
    itemCnt?: NumberRange;
    /**
     * 
     * @type {NumberRange}
     * @memberof SearchSellerViewersRaneFilter
     */
    gmv?: NumberRange;
    /**
     * 
     * @type {NumberRange}
     * @memberof SearchSellerViewersRaneFilter
     */
    shareCnt?: NumberRange;
    /**
     * 
     * @type {NumberRange}
     * @memberof SearchSellerViewersRaneFilter
     */
    watchedShowCnt?: NumberRange;
    /**
     * 
     * @type {NumberRange}
     * @memberof SearchSellerViewersRaneFilter
     */
    referralCnt?: NumberRange;
}

/**
 * 
 * @export
 * @interface SearchSellerViewersResponse
 */
export interface SearchSellerViewersResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchSellerViewersResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchSellerViewersResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SellerViewersPageRows}
     * @memberof SearchSellerViewersResponse
     */
    data: SellerViewersPageRows;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SearchSeriesElementsSortByEnumItem {
    Id = 'id',
    CreatedAt = 'createdAt',
    UpdatedAt = 'updatedAt',
    Sort = 'sort'
}

/**
 * 
 * @export
 * @interface SearchShipmentsItem
 */
export interface SearchShipmentsItem {
    /**
     * 
     * @type {string}
     * @memberof SearchShipmentsItem
     */
    buyerId: string;
    /**
     * 
     * @type {string}
     * @memberof SearchShipmentsItem
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof SearchShipmentsItem
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof SearchShipmentsItem
     */
    shippoTransactionId: string;
    /**
     * 
     * @type {string}
     * @memberof SearchShipmentsItem
     */
    labelUrl: string;
    /**
     * 
     * @type {string}
     * @memberof SearchShipmentsItem
     */
    trackingNumber: string;
    /**
     * 
     * @type {string}
     * @memberof SearchShipmentsItem
     */
    trackingStatus: string;
    /**
     * 
     * @type {string}
     * @memberof SearchShipmentsItem
     */
    trackingUrlProvider: string;
    /**
     * 
     * @type {number}
     * @memberof SearchShipmentsItem
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof SearchShipmentsItem
     */
    transaction: string;
    /**
     * 
     * @type {string}
     * @memberof SearchShipmentsItem
     */
    transactionStatus: string;
    /**
     * 
     * @type {string}
     * @memberof SearchShipmentsItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof SearchShipmentsItem
     */
    updateAt: string;
    /**
     * 
     * @type {string}
     * @memberof SearchShipmentsItem
     */
    carrier?: SearchShipmentsItemCarrierEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchShipmentsItem
     */
    id: string;
}

/**
* @export
* @enum {string}
*/
export enum SearchShipmentsItemCarrierEnum {
    Shippo = 'SHIPPO',
    Usps = 'USPS',
    Ups = 'UPS',
    CanadaPost = 'CANADA_POST',
    DhlExpress = 'DHL_EXPRESS',
    DpdUk = 'DPD_UK',
    HermesUk = 'HERMES_UK'
}

/**
 * 
 * @export
 * @interface SearchShipmentsPageRows
 */
export interface SearchShipmentsPageRows {
    /**
     * 
     * @type {Array<SearchShipmentsItem>}
     * @memberof SearchShipmentsPageRows
     */
    rows: Array<SearchShipmentsItem>;
}

/**
 * 
 * @export
 * @interface SearchShipmentsResponse
 */
export interface SearchShipmentsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchShipmentsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchShipmentsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SearchShipmentsPageRows}
     * @memberof SearchShipmentsResponse
     */
    data: SearchShipmentsPageRows;
}

/**
 * 
 * @export
 * @interface SearchShowEventSellerApplicationsItem
 */
export interface SearchShowEventSellerApplicationsItem {
    /**
     * 
     * @type {string}
     * @memberof SearchShowEventSellerApplicationsItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof SearchShowEventSellerApplicationsItem
     */
    sellerId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof SearchShowEventSellerApplicationsItem
     */
    seller: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof SearchShowEventSellerApplicationsItem
     */
    status: SearchShowEventSellerApplicationsItemStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchShowEventSellerApplicationsItem
     */
    sellerUserGroupIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SearchShowEventSellerApplicationsItem
     */
    templateId: string;
    /**
     * 
     * @type {string}
     * @memberof SearchShowEventSellerApplicationsItem
     */
    id: string;
    /**
     * 
     * @type {Relations}
     * @memberof SearchShowEventSellerApplicationsItem
     */
    relations: Relations;
}

/**
* @export
* @enum {string}
*/
export enum SearchShowEventSellerApplicationsItemStatusEnum {
    Approved = 'approved',
    Pending = 'pending',
    Rejected = 'rejected'
}

/**
 * 
 * @export
 * @interface SearchShowEventSellerApplicationsPageRows
 */
export interface SearchShowEventSellerApplicationsPageRows {
    /**
     * 
     * @type {Array<SearchShowEventSellerApplicationsItem>}
     * @memberof SearchShowEventSellerApplicationsPageRows
     */
    rows: Array<SearchShowEventSellerApplicationsItem>;
}

/**
 * 
 * @export
 * @interface SearchShowEventSellerApplicationsResponse
 */
export interface SearchShowEventSellerApplicationsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchShowEventSellerApplicationsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchShowEventSellerApplicationsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SearchShowEventSellerApplicationsPageRows}
     * @memberof SearchShowEventSellerApplicationsResponse
     */
    data: SearchShowEventSellerApplicationsPageRows;
}

/**
 * 
 * @export
 * @interface SearchShowsResponse
 */
export interface SearchShowsResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchShowsResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchShowsResponse
     */
    exact: boolean;
    /**
     * 
     * @type {ShowsPageRows}
     * @memberof SearchShowsResponse
     */
    data: ShowsPageRows;
}

/**
 * 
 * @export
 * @interface SearchStoreBlockedUsersItem
 */
export interface SearchStoreBlockedUsersItem {
    /**
     * 
     * @type {string}
     * @memberof SearchStoreBlockedUsersItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SearchStoreBlockedUsersItem
     */
    reason: SearchStoreBlockedUsersItemReasonEnum;
    /**
     * 
     * @type {ProfileItem}
     * @memberof SearchStoreBlockedUsersItem
     */
    profile: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof SearchStoreBlockedUsersItem
     */
    blockedAt: string;
}

/**
* @export
* @enum {string}
*/
export enum SearchStoreBlockedUsersItemReasonEnum {
    Spam = 'spam',
    Inappropriate = 'inappropriate',
    Aggressive = 'aggressive',
    SellerBlock = 'seller_block'
}

/**
 * 
 * @export
 * @interface SearchStoreBlockedUsersPageRows
 */
export interface SearchStoreBlockedUsersPageRows {
    /**
     * 
     * @type {Array<SearchStoreBlockedUsersItem>}
     * @memberof SearchStoreBlockedUsersPageRows
     */
    rows: Array<SearchStoreBlockedUsersItem>;
}

/**
 * 
 * @export
 * @interface SearchStoreBlockedUsersResponse
 */
export interface SearchStoreBlockedUsersResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchStoreBlockedUsersResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchStoreBlockedUsersResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SearchStoreBlockedUsersPageRows}
     * @memberof SearchStoreBlockedUsersResponse
     */
    data: SearchStoreBlockedUsersPageRows;
}

/**
 * 
 * @export
 * @interface SearchUpcomingShowItem
 */
export interface SearchUpcomingShowItem {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchUpcomingShowItem
     */
    badges: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    title: string;
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof SearchUpcomingShowItem
     */
    user: BaseProfileItem;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    originalCoverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    previewVideoURL: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    shareVideo?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    startsAt: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    createdAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchUpcomingShowItem
     */
    available: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    visibility?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    permission?: SearchUpcomingShowItemPermissionEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    eventId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchUpcomingShowItem
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    eventTemplateId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchUpcomingShowItem
     */
    disableComments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchUpcomingShowItem
     */
    notificationSent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    liveStreamId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchUpcomingShowItem
     */
    historyLiveStreamIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    transcodeStatus?: SearchUpcomingShowItemTranscodeStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    accessLevel?: SearchUpcomingShowItemAccessLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchUpcomingShowItem
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof SearchUpcomingShowItem
     */
    watchListCount?: number;
}

/**
* @export
* @enum {string}
*/
export enum SearchUpcomingShowItemPermissionEnum {
    All = 'all',
    Follower = 'follower',
    Subscriber = 'subscriber',
    NoOne = 'no-one'
}/**
* @export
* @enum {string}
*/
export enum SearchUpcomingShowItemTranscodeStatusEnum {
    Initial = 'initial',
    Processing = 'processing',
    TranscodeOriginal = 'transcode-original',
    TranscodeOriginalShare = 'transcode-original-share',
    RequestRetranscode = 'request-retranscode'
}/**
* @export
* @enum {string}
*/
export enum SearchUpcomingShowItemAccessLevelEnum {
    All = 'all',
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface SearchUserGiveawayResponse
 */
export interface SearchUserGiveawayResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SearchUserGiveawayResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SearchUserGiveawayResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SearchSellerGiveawayRows}
     * @memberof SearchUserGiveawayResponse
     */
    data: SearchSellerGiveawayRows;
}

/**
 * 
 * @export
 * @interface SelectShipmentRateRequest
 */
export interface SelectShipmentRateRequest {
    /**
     * 
     * @type {string}
     * @memberof SelectShipmentRateRequest
     */
    rateId: string;
}

/**
 * 
 * @export
 * @interface SellerAddress
 */
export interface SellerAddress {
    /**
     * 
     * @type {string}
     * @memberof SellerAddress
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof SellerAddress
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof SellerAddress
     */
    primaryPhone: string;
    /**
     * 
     * @type {string}
     * @memberof SellerAddress
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SellerAddress
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof SellerAddress
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerAddress
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof SellerAddress
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof SellerAddress
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof SellerAddress
     */
    postalCode: string;
}

/**
 * 
 * @export
 * @interface SellerAddressRequest
 */
export interface SellerAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof SellerAddressRequest
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof SellerAddressRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SellerAddressRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof SellerAddressRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof SellerAddressRequest
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof SellerAddressRequest
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerAddressRequest
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof SellerAddressRequest
     */
    primaryPhone: string;
    /**
     * 
     * @type {string}
     * @memberof SellerAddressRequest
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof SellerAddressRequest
     */
    country: string;
}

/**
 * 
 * @export
 * @interface SellerBalanceResponse
 */
export interface SellerBalanceResponse {
    /**
     * 
     * @type {number}
     * @memberof SellerBalanceResponse
     */
    withdrawableBalance: number;
    /**
     * 
     * @type {number}
     * @memberof SellerBalanceResponse
     */
    withdrawablePendingBalance: number;
}

/**
 * 
 * @export
 * @interface SellerFormW9DTO
 */
export interface SellerFormW9DTO {
    /**
     * 
     * @type {string}
     * @memberof SellerFormW9DTO
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof SellerFormW9DTO
     */
    clientRecipientId: string;
    /**
     * 
     * @type {string}
     * @memberof SellerFormW9DTO
     */
    formW9Url?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerFormW9DTO
     */
    formW9CreatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerFormW9DTO
     */
    formW9ExpiredAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerFormW9DTO
     */
    formW9CompletedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerFormW9DTO
     */
    formW9Status: SellerFormW9DTOFormW9StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SellerFormW9DTO
     */
    tinStatus: SellerFormW9DTOTinStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SellerFormW9DTO
     */
    tinReason?: string;
}

/**
* @export
* @enum {string}
*/
export enum SellerFormW9DTOFormW9StatusEnum {
    NotStart = 'NotStart',
    Pending = 'Pending',
    Completed = 'Completed',
    Expired = 'Expired'
}/**
* @export
* @enum {string}
*/
export enum SellerFormW9DTOTinStatusEnum {
    NotStart = 'NotStart',
    Accepted = 'Accepted',
    Blocked = 'Blocked',
    Processing = 'Processing',
    Rejected = 'Rejected'
}

/**
 * 
 * @export
 * @interface SellerLiveStreamsStatsItem
 */
export interface SellerLiveStreamsStatsItem {
    /**
     * 
     * @type {string}
     * @memberof SellerLiveStreamsStatsItem
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof SellerLiveStreamsStatsItem
     */
    liveStreamId: string;
    /**
     * 
     * @type {LiveStreamItem}
     * @memberof SellerLiveStreamsStatsItem
     */
    liveStream: LiveStreamItem;
    /**
     * 
     * @type {number}
     * @memberof SellerLiveStreamsStatsItem
     */
    orders: number;
    /**
     * 
     * @type {number}
     * @memberof SellerLiveStreamsStatsItem
     */
    viewers: number;
    /**
     * 
     * @type {number}
     * @memberof SellerLiveStreamsStatsItem
     */
    newViewers: number;
    /**
     * 
     * @type {number}
     * @memberof SellerLiveStreamsStatsItem
     */
    customers: number;
    /**
     * 
     * @type {number}
     * @memberof SellerLiveStreamsStatsItem
     */
    newCustomers: number;
    /**
     * 
     * @type {number}
     * @memberof SellerLiveStreamsStatsItem
     */
    newFollowers: number;
    /**
     * 
     * @type {number}
     * @memberof SellerLiveStreamsStatsItem
     */
    gmv: number;
    /**
     * 
     * @type {string}
     * @memberof SellerLiveStreamsStatsItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof SellerLiveStreamsStatsItem
     */
    disconnectedAt: string;
    /**
     * 
     * @type {number}
     * @memberof SellerLiveStreamsStatsItem
     */
    duration: number;
    /**
     * 
     * @type {number}
     * @memberof SellerLiveStreamsStatsItem
     */
    likes: number;
    /**
     * 
     * @type {number}
     * @memberof SellerLiveStreamsStatsItem
     */
    comments: number;
    /**
     * 
     * @type {number}
     * @memberof SellerLiveStreamsStatsItem
     */
    hoursViewed: number;
    /**
     * 
     * @type {number}
     * @memberof SellerLiveStreamsStatsItem
     */
    concurrentViewers: number;
    /**
     * 
     * @type {string}
     * @memberof SellerLiveStreamsStatsItem
     */
    permission: SellerLiveStreamsStatsItemPermissionEnum;
    /**
     * 
     * @type {number}
     * @memberof SellerLiveStreamsStatsItem
     */
    productsSold: number;
    /**
     * 
     * @type {number}
     * @memberof SellerLiveStreamsStatsItem
     */
    auctionCount: number;
    /**
     * 
     * @type {number}
     * @memberof SellerLiveStreamsStatsItem
     */
    revenue: number;
    /**
     * 
     * @type {number}
     * @memberof SellerLiveStreamsStatsItem
     */
    shares: number;
    /**
     * 
     * @type {number}
     * @memberof SellerLiveStreamsStatsItem
     */
    activeViewers: number;
    /**
     * 
     * @type {number}
     * @memberof SellerLiveStreamsStatsItem
     */
    purchaseCount: number;
    /**
     * 
     * @type {number}
     * @memberof SellerLiveStreamsStatsItem
     */
    averageConcurrentViewerCount: number;
}

/**
* @export
* @enum {string}
*/
export enum SellerLiveStreamsStatsItemPermissionEnum {
    All = 'all',
    Follower = 'follower',
    Subscriber = 'subscriber',
    NoOne = 'no-one'
}

/**
 * 
 * @export
 * @interface SellerLiveStreamsStatsPageRows
 */
export interface SellerLiveStreamsStatsPageRows {
    /**
     * 
     * @type {Array<SellerLiveStreamsStatsItem>}
     * @memberof SellerLiveStreamsStatsPageRows
     */
    rows: Array<SellerLiveStreamsStatsItem>;
}

/**
 * 
 * @export
 * @interface SellerTrackingInfoItem
 */
export interface SellerTrackingInfoItem {
    /**
     * 
     * @type {string}
     * @memberof SellerTrackingInfoItem
     */
    trackingInfo: string;
    /**
     * 
     * @type {string}
     * @memberof SellerTrackingInfoItem
     */
    carrier?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerTrackingInfoItem
     */
    trackingURL?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerTrackingInfoItem
     */
    createdAt: string;
}

/**
 * 
 * @export
 * @interface SellerUpdateAddressDto
 */
export interface SellerUpdateAddressDto {
    /**
     * 
     * @type {string}
     * @memberof SellerUpdateAddressDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof SellerUpdateAddressDto
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerUpdateAddressDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof SellerUpdateAddressDto
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof SellerUpdateAddressDto
     */
    postalCode: string;
}

/**
 * 
 * @export
 * @interface SellerViewersItem
 */
export interface SellerViewersItem {
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    userAvatar: string;
    /**
     * duration hours
     * @type {number}
     * @memberof SellerViewersItem
     */
    watchedSeconds: number;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    watchedFormatted: string;
    /**
     * likes
     * @type {number}
     * @memberof SellerViewersItem
     */
    likeCount: number;
    /**
     * total comments number customer typed in the chat
     * @type {number}
     * @memberof SellerViewersItem
     */
    commentCount: number;
    /**
     * 
     * @type {number}
     * @memberof SellerViewersItem
     */
    shareCount: number;
    /**
     * the number of items that user purchased
     * @type {number}
     * @memberof SellerViewersItem
     */
    unitsSold: number;
    /**
     * gmv
     * @type {number}
     * @memberof SellerViewersItem
     */
    grossSales: number;
    /**
     * 
     * @type {number}
     * @memberof SellerViewersItem
     */
    referralCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof SellerViewersItem
     */
    isFollower: boolean;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    firstPurchaseAt: string;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    lastPurchaseAt: string;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    firstWatchedAt: string;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    lastWatchedAt: string;
    /**
     * 
     * @type {number}
     * @memberof SellerViewersItem
     */
    showsViewed: number;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    lastMainOrderId: string;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    referralPasscode?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    referralAt?: string;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    followedAt: string;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    sellerFirstName: string;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    sellerLastName: string;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    sellerUserName: string;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    userFirstName: string;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    userLastName: string;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    customerUserName: string;
    /**
     * 
     * @type {Array<UserBadgeItem>}
     * @memberof SellerViewersItem
     */
    userBadges: Array<UserBadgeItem>;
    /**
     * 
     * @type {boolean}
     * @memberof SellerViewersItem
     */
    isReferral: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SellerViewersItem
     */
    isStoreBlockedUser: boolean;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    storeBlockedAt: string;
    /**
     * 
     * @type {string}
     * @memberof SellerViewersItem
     */
    shareTargetType?: SellerViewersItemShareTargetTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum SellerViewersItemShareTargetTypeEnum {
    Profile = 'PROFILE',
    Store = 'STORE',
    LiveStream = 'LIVE_STREAM',
    Replay = 'REPLAY',
    UpcomingShow = 'UPCOMING_SHOW',
    ListingLiveStream = 'LISTING_LIVE_STREAM',
    ListingReplay = 'LISTING_REPLAY',
    ListingEvergreen = 'LISTING_EVERGREEN',
    ListingUpcomingShow = 'LISTING_UPCOMING_SHOW',
    ListingPromotion = 'LISTING_PROMOTION',
    Event = 'EVENT',
    EventDiscovery = 'EVENT_DISCOVERY',
    EventTicket = 'EVENT_TICKET',
    HomePage = 'HOME_PAGE',
    Promotion = 'PROMOTION',
    ReferralGifting = 'REFERRAL_GIFTING',
    UserBadge = 'USER_BADGE',
    LiveStreamGiveaway = 'LIVE_STREAM_GIVEAWAY',
    UpcomingShowGiveaway = 'UPCOMING_SHOW_GIVEAWAY',
    PopClip = 'POP_CLIP',
    BecomeASeller = 'BECOME_A_SELLER'
}

/**
 * 
 * @export
 * @interface SellerViewersPageRows
 */
export interface SellerViewersPageRows {
    /**
     * 
     * @type {Array<SellerViewersItem>}
     * @memberof SellerViewersPageRows
     */
    rows: Array<SellerViewersItem>;
}

/**
 * 
 * @export
 * @interface SendAdminFeedbackRequest
 */
export interface SendAdminFeedbackRequest {
    /**
     * 
     * @type {string}
     * @memberof SendAdminFeedbackRequest
     */
    orderId?: string;
    /**
     * showId is from seller dashboard
     * @type {string}
     * @memberof SendAdminFeedbackRequest
     */
    showId?: string;
    /**
     * 
     * @type {string}
     * @memberof SendAdminFeedbackRequest
     */
    message: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendAdminFeedbackRequest
     */
    imageUrls?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendAdminFeedbackRequest
     */
    videoUrls?: Array<string>;
    /**
     * liveStreamId is from live show
     * @type {string}
     * @memberof SendAdminFeedbackRequest
     */
    liveStreamId?: string;
}

/**
 * 
 * @export
 * @interface SendChatMessage
 */
export interface SendChatMessage {
    /**
     * 
     * @type {string}
     * @memberof SendChatMessage
     */
    toUserId: string;
    /**
     * 
     * @type {string}
     * @memberof SendChatMessage
     */
    clientId: string;
    /**
     * 
     * @type {number}
     * @memberof SendChatMessage
     */
    type: number;
    /**
     * 
     * @type {string}
     * @memberof SendChatMessage
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof SendChatMessage
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof SendChatMessage
     */
    ext: string;
    /**
     * 
     * @type {string}
     * @memberof SendChatMessage
     */
    quoteMsg: string;
    /**
     * 
     * @type {object}
     * @memberof SendChatMessage
     */
    group?: object;
}

/**
 * 
 * @export
 * @interface SendCommentChatEmailRequest
 */
export interface SendCommentChatEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof SendCommentChatEmailRequest
     */
    action: SendCommentChatEmailRequestActionEnum;
    /**
     * 
     * @type {string}
     * @memberof SendCommentChatEmailRequest
     */
    link: string;
    /**
     * 
     * @type {string}
     * @memberof SendCommentChatEmailRequest
     */
    email?: string;
}

/**
* @export
* @enum {string}
*/
export enum SendCommentChatEmailRequestActionEnum {
    EnableDmInInstagram = 'enable-dm-in-instagram',
    FinishViaDesktop = 'finish-via-desktop',
    LinkMetaAccount = 'link-meta-account'
}

/**
 * 
 * @export
 * @interface SendCommentRequest
 */
export interface SendCommentRequest {
    /**
     * 
     * @type {SendPlainCommentRequest | SendShareCommentRequest}
     * @memberof SendCommentRequest
     */
    comment: SendPlainCommentRequest | SendShareCommentRequest;
}

/**
 * 
 * @export
 * @interface SendCreatorSubscriptionEmailRequest
 */
export interface SendCreatorSubscriptionEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof SendCreatorSubscriptionEmailRequest
     */
    eventType: string;
    /**
     * 
     * @type {string}
     * @memberof SendCreatorSubscriptionEmailRequest
     */
    shopId: string;
    /**
     * 
     * @type {string}
     * @memberof SendCreatorSubscriptionEmailRequest
     */
    pslUserId: string;
    /**
     * 
     * @type {string}
     * @memberof SendCreatorSubscriptionEmailRequest
     */
    subscriptionLevel: SendCreatorSubscriptionEmailRequestSubscriptionLevelEnum;
    /**
     * 
     * @type {number}
     * @memberof SendCreatorSubscriptionEmailRequest
     */
    subscriptionPrice: number;
    /**
     * 
     * @type {string}
     * @memberof SendCreatorSubscriptionEmailRequest
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof SendCreatorSubscriptionEmailRequest
     */
    requestId: string;
}

/**
* @export
* @enum {string}
*/
export enum SendCreatorSubscriptionEmailRequestSubscriptionLevelEnum {
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface SendCreatorSubscriptionEmailRequest2
 */
export interface SendCreatorSubscriptionEmailRequest2 {
    /**
     * 
     * @type {string}
     * @memberof SendCreatorSubscriptionEmailRequest2
     */
    shopId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendCreatorSubscriptionEmailRequest2
     */
    pslUserIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SendCreatorSubscriptionEmailRequest2
     */
    requestId: string;
    /**
     * 
     * @type {SubscriptionCreationEmailPayload | SubscriptionCancellationEmailPayload | SubscriptionRepricingEmailPayload | SubscriptionUpgradeEmailPayload | SubscriptionPaymentFailureEmailPayload | SubscriptionRenewalEmailPayload | SubscriptionRenewalReminderEmailPayload}
     * @memberof SendCreatorSubscriptionEmailRequest2
     */
    data: SubscriptionCreationEmailPayload | SubscriptionCancellationEmailPayload | SubscriptionRepricingEmailPayload | SubscriptionUpgradeEmailPayload | SubscriptionPaymentFailureEmailPayload | SubscriptionRenewalEmailPayload | SubscriptionRenewalReminderEmailPayload;
}

/**
 * 
 * @export
 * @interface SendItemSource
 */
export interface SendItemSource {
    /**
     * 
     * @type {string}
     * @memberof SendItemSource
     */
    type: SendItemSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SendItemSource
     */
    sendItemId: string;
    /**
     * 
     * @type {LiveStreamSendItemSourceSource | UpcomingShowSendItemSourceSource}
     * @memberof SendItemSource
     */
    source: LiveStreamSendItemSourceSource | UpcomingShowSendItemSourceSource;
}

/**
* @export
* @enum {string}
*/
export enum SendItemSourceTypeEnum {
    SendItem = 'SEND_ITEM'
}

/**
 * 
 * @export
 * @interface SendPlainCommentRequest
 */
export interface SendPlainCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof SendPlainCommentRequest
     */
    type: SendPlainCommentRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SendPlainCommentRequest
     */
    content: string;
    /**
     * 
     * @type {Array<ChatMentionDto>}
     * @memberof SendPlainCommentRequest
     */
    mentions?: Array<ChatMentionDto>;
}

/**
* @export
* @enum {string}
*/
export enum SendPlainCommentRequestTypeEnum {
    Comment = 'comment'
}

/**
 * 
 * @export
 * @interface SendShareCommentRequest
 */
export interface SendShareCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof SendShareCommentRequest
     */
    type: SendShareCommentRequestTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum SendShareCommentRequestTypeEnum {
    Share = 'share'
}

/**
 * 
 * @export
 * @interface SendWrapUpEmailRequest
 */
export interface SendWrapUpEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof SendWrapUpEmailRequest
     */
    note?: string;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SeriesChapterLabelFormatEnumItem {
    Ch = 'CH',
    Chapter = 'CHAPTER'
}

/**
 * 
 * @export
 * @interface SeriesElementItem
 */
export interface SeriesElementItem {
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItem
     */
    type: SeriesElementItemTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SeriesElementItem
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItem
     */
    accessLevel?: SeriesElementItemAccessLevelEnum;
    /**
     * 
     * @type {SeriesPopClipElementItem}
     * @memberof SeriesElementItem
     */
    popClip?: SeriesPopClipElementItem;
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItem
     */
    contentType?: SeriesElementItemContentTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesElementItem
     */
    pinned?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesElementItem
     */
    startOfChapter?: boolean;
    /**
     * 
     * @type {Relations}
     * @memberof SeriesElementItem
     */
    relations?: Relations;
}

/**
* @export
* @enum {string}
*/
export enum SeriesElementItemTypeEnum {
    PopClip = 'POP_CLIP'
}/**
* @export
* @enum {string}
*/
export enum SeriesElementItemAccessLevelEnum {
    All = 'all',
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}/**
* @export
* @enum {string}
*/
export enum SeriesElementItemContentTypeEnum {
    Feed = 'FEED',
    Episode = 'EPISODE',
    Teaser = 'TEASER',
    Promo = 'PROMO',
    Sponsored = 'SPONSORED'
}

/**
 * 
 * @export
 * @interface SeriesElementItemV2
 */
export interface SeriesElementItemV2 {
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItemV2
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItemV2
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItemV2
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItemV2
     */
    type: SeriesElementItemV2TypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SeriesElementItemV2
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItemV2
     */
    accessLevel?: SeriesElementItemV2AccessLevelEnum;
    /**
     * 
     * @type {SeriesPopClipElementItemV2}
     * @memberof SeriesElementItemV2
     */
    popClip?: SeriesPopClipElementItemV2;
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItemV2
     */
    contentType?: SeriesElementItemV2ContentTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesElementItemV2
     */
    pinned?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesElementItemV2
     */
    startOfChapter?: boolean;
    /**
     * 
     * @type {Relations}
     * @memberof SeriesElementItemV2
     */
    relations?: Relations;
    /**
     * 
     * @type {string}
     * @memberof SeriesElementItemV2
     */
    seriesName?: string;
}

/**
* @export
* @enum {string}
*/
export enum SeriesElementItemV2TypeEnum {
    PopClip = 'POP_CLIP'
}/**
* @export
* @enum {string}
*/
export enum SeriesElementItemV2AccessLevelEnum {
    All = 'all',
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}/**
* @export
* @enum {string}
*/
export enum SeriesElementItemV2ContentTypeEnum {
    Feed = 'FEED',
    Episode = 'EPISODE',
    Teaser = 'TEASER',
    Promo = 'PROMO',
    Sponsored = 'SPONSORED'
}

/**
 * 
 * @export
 * @interface SeriesElementPageRows
 */
export interface SeriesElementPageRows {
    /**
     * 
     * @type {Array<SeriesElementItem>}
     * @memberof SeriesElementPageRows
     */
    rows: Array<SeriesElementItem>;
}

/**
 * 
 * @export
 * @interface SeriesElementPageRowsV2
 */
export interface SeriesElementPageRowsV2 {
    /**
     * 
     * @type {Array<SeriesElementItemV2>}
     * @memberof SeriesElementPageRowsV2
     */
    rows: Array<SeriesElementItemV2>;
}

/**
 * 
 * @export
 * @interface SeriesElementSearchResponse
 */
export interface SeriesElementSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SeriesElementSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SeriesElementSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SeriesElementPageRows}
     * @memberof SeriesElementSearchResponse
     */
    data: SeriesElementPageRows;
}

/**
 * 
 * @export
 * @interface SeriesElementSearchResponseV2
 */
export interface SeriesElementSearchResponseV2 {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SeriesElementSearchResponseV2
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SeriesElementSearchResponseV2
     */
    exact: boolean;
    /**
     * 
     * @type {SeriesElementPageRowsV2}
     * @memberof SeriesElementSearchResponseV2
     */
    data: SeriesElementPageRowsV2;
}

/**
 * 
 * @export
 * @interface SeriesItem
 */
export interface SeriesItem {
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesItem
     */
    archived: boolean;
    /**
     * 
     * @type {number}
     * @memberof SeriesItem
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    elementSortingStrategy?: SeriesItemElementSortingStrategyEnum;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    labelFormat?: SeriesItemLabelFormatEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesItem
     */
    showLabel?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesItem
     */
    hasChapter?: boolean;
    /**
     * 
     * @type {SeriesChapterLabelFormatEnumItem}
     * @memberof SeriesItem
     */
    chapterLabelFormat?: SeriesChapterLabelFormatEnumItem;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    mobileBannerImage?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    desktopBannerImage?: string;
    /**
     * 
     * @type {SeriesTypeEnumItem}
     * @memberof SeriesItem
     */
    type?: SeriesTypeEnumItem;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesItem
     */
    standaloneSale?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SeriesItem
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof SeriesItem
     */
    discountPrice?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesItem
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    discountEndDate?: string;
    /**
     * 
     * @type {PopStoreUserAccessLevelEnumItem}
     * @memberof SeriesItem
     */
    accessLevel?: PopStoreUserAccessLevelEnumItem;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    parentId?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    listingId?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    id: string;
}

/**
* @export
* @enum {string}
*/
export enum SeriesItemElementSortingStrategyEnum {
    MostRecentFirst = 'MOST_RECENT_FIRST',
    MostRecentLast = 'MOST_RECENT_LAST',
    Custom = 'CUSTOM'
}/**
* @export
* @enum {string}
*/
export enum SeriesItemLabelFormatEnum {
    Short = 'SHORT',
    Long = 'LONG'
}

/**
 * 
 * @export
 * @interface SeriesPageRows
 */
export interface SeriesPageRows {
    /**
     * 
     * @type {Array<SeriesItem>}
     * @memberof SeriesPageRows
     */
    rows: Array<SeriesItem>;
}

/**
 * 
 * @export
 * @interface SeriesPopClipElementItem
 */
export interface SeriesPopClipElementItem {
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItem
     */
    popClipId: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItem
     */
    videoTitle: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItem
     */
    videoDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItem
     */
    videoURL: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItem
     */
    thumbnailURL: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItem
     */
    gifURL: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItem
     */
    shopifyDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItem
     */
    cdnUrl: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItem
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItem
     */
    fileType: string;
    /**
     * 
     * @type {number}
     * @memberof SeriesPopClipElementItem
     */
    previewDuration?: number;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItem
     */
    processedURL: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItem
     */
    customThumbnailImageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItem
     */
    defaultThumbnailImageURL?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItem
     */
    defaultThumbnailImageStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItem
     */
    customThumbnailMetaidentifier?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesPopClipElementItem
     */
    muteForUnsubscribedUsers?: boolean;
    /**
     * 
     * @type {Array<PopClipShopifyProduct | StoreListingItem>}
     * @memberof SeriesPopClipElementItem
     */
    products?: Array<PopClipShopifyProduct | StoreListingItem>;
}

/**
 * 
 * @export
 * @interface SeriesPopClipElementItemV2
 */
export interface SeriesPopClipElementItemV2 {
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItemV2
     */
    metaIdentifier: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItemV2
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItemV2
     */
    cdnUrl: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItemV2
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItemV2
     */
    fileType: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesPopClipElementItemV2
     */
    createdAt?: string;
    /**
     * 
     * @type {object}
     * @memberof SeriesPopClipElementItemV2
     */
    metaData: object;
}

/**
 * 
 * @export
 * @interface SeriesSearchResponse
 */
export interface SeriesSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof SeriesSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof SeriesSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {SeriesPageRows}
     * @memberof SeriesSearchResponse
     */
    data: SeriesPageRows;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SeriesTypeEnumItem {
    Default = 'DEFAULT',
    Course = 'COURSE',
    SubSeries = 'SUB_SERIES'
}

/**
 * 
 * @export
 * @interface ServiceLevelItem
 */
export interface ServiceLevelItem {
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelItem
     */
    terms: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLevelItem
     */
    token: string;
}

/**
 * 
 * @export
 * @interface SetPaymentMethodBillingAddressRequest
 */
export interface SetPaymentMethodBillingAddressRequest {
    /**
     * 
     * @type {BillingAddressDto}
     * @memberof SetPaymentMethodBillingAddressRequest
     */
    billingAddress: BillingAddressDto;
}

/**
 * 
 * @export
 * @interface SetPayoutMethodDto
 */
export interface SetPayoutMethodDto {
    /**
     * 
     * @type {PayoutBankDto}
     * @memberof SetPayoutMethodDto
     */
    payoutMethodBank?: PayoutBankDto;
    /**
     * 
     * @type {PayoutVenmoDto}
     * @memberof SetPayoutMethodDto
     */
    payoutMethodVenmo?: PayoutVenmoDto;
    /**
     * 
     * @type {PayoutPaypalDto}
     * @memberof SetPayoutMethodDto
     */
    payoutMethodPaypal?: PayoutPaypalDto;
}

/**
 * 
 * @export
 * @interface SetPickupTimeWindowRequest
 */
export interface SetPickupTimeWindowRequest {
    /**
     * 
     * @type {number}
     * @memberof SetPickupTimeWindowRequest
     */
    minutes: number;
}

/**
 * 
 * @export
 * @interface SetReferrerRequest
 */
export interface SetReferrerRequest {
    /**
     * 
     * @type {string}
     * @memberof SetReferrerRequest
     */
    referrerUserId: string;
}

/**
 * 
 * @export
 * @interface SetShippingPrice
 */
export interface SetShippingPrice {
    /**
     * 
     * @type {number}
     * @memberof SetShippingPrice
     */
    shippingPrice: number;
    /**
     * 
     * @type {boolean}
     * @memberof SetShippingPrice
     */
    enableArrangeMyOwnShippingV2?: boolean;
}

/**
 * 
 * @export
 * @interface SetShowCustomizationRequest
 */
export interface SetShowCustomizationRequest {
    /**
     * 
     * @type {string}
     * @memberof SetShowCustomizationRequest
     */
    primaryLightColor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SetShowCustomizationRequest
     */
    primaryDarkColor?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SetShowCustomizationRequest
     */
    lightingBoltImages?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SetShowCustomizationRequest
     */
    lightingBoltButtonImage?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SetShowCustomizationRequest
     */
    disableLightingBoltForAll?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SetShowCustomizationRequest
     */
    tippingEnabled?: boolean;
}

/**
 * 
 * @export
 * @interface SetUrlCodeDto
 */
export interface SetUrlCodeDto {
    /**
     * 
     * @type {string}
     * @memberof SetUrlCodeDto
     */
    urlCode: string;
}

/**
 * 
 * @export
 * @interface SetUserPasswordRequest
 */
export interface SetUserPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof SetUserPasswordRequest
     */
    email: string;
    /**
     * if null or empty, will disable password login
     * @type {string}
     * @memberof SetUserPasswordRequest
     */
    password?: string;
}

/**
 * 
 * @export
 * @interface SetupLocationIdRequestDto
 */
export interface SetupLocationIdRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SetupLocationIdRequestDto
     */
    locationId: string;
}

/**
 * 
 * @export
 * @interface SetupProductRequestDto
 */
export interface SetupProductRequestDto {
    /**
     * 
     * @type {number}
     * @memberof SetupProductRequestDto
     */
    availableDelta: number;
}

/**
 * 
 * @export
 * @interface ShareTargetItem
 */
export interface ShareTargetItem {
    /**
     * 
     * @type {string}
     * @memberof ShareTargetItem
     */
    type: ShareTargetItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ShareTargetItem
     */
    profileId?: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof ShareTargetItem
     */
    profile?: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof ShareTargetItem
     */
    liveStreamId?: string;
    /**
     * 
     * @type {LiveStreamItem}
     * @memberof ShareTargetItem
     */
    liveStream?: LiveStreamItem;
    /**
     * 
     * @type {string}
     * @memberof ShareTargetItem
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {UpcomingShowItem}
     * @memberof ShareTargetItem
     */
    upcomingShow?: UpcomingShowItem;
    /**
     * 
     * @type {string}
     * @memberof ShareTargetItem
     */
    listingId?: string;
    /**
     * 
     * @type {StoreListingItemWithMetadata}
     * @memberof ShareTargetItem
     */
    listing?: StoreListingItemWithMetadata;
    /**
     * 
     * @type {string}
     * @memberof ShareTargetItem
     */
    storeId?: string;
    /**
     * 
     * @type {StoreFrontItem}
     * @memberof ShareTargetItem
     */
    store?: StoreFrontItem;
    /**
     * 
     * @type {string}
     * @memberof ShareTargetItem
     */
    showEventId?: string;
    /**
     * 
     * @type {ShowEventItem}
     * @memberof ShareTargetItem
     */
    showEvent?: ShowEventItem;
    /**
     * 
     * @type {string}
     * @memberof ShareTargetItem
     */
    ticketId?: string;
    /**
     * 
     * @type {ShowTicketItem}
     * @memberof ShareTargetItem
     */
    ticket?: ShowTicketItem;
    /**
     * 
     * @type {string}
     * @memberof ShareTargetItem
     */
    promotionId?: string;
    /**
     * 
     * @type {PromotionPageItem}
     * @memberof ShareTargetItem
     */
    promotion?: PromotionPageItem;
}

/**
* @export
* @enum {string}
*/
export enum ShareTargetItemTypeEnum {
    Profile = 'PROFILE',
    Store = 'STORE',
    LiveStream = 'LIVE_STREAM',
    Replay = 'REPLAY',
    UpcomingShow = 'UPCOMING_SHOW',
    ListingLiveStream = 'LISTING_LIVE_STREAM',
    ListingReplay = 'LISTING_REPLAY',
    ListingEvergreen = 'LISTING_EVERGREEN',
    ListingUpcomingShow = 'LISTING_UPCOMING_SHOW',
    ListingPromotion = 'LISTING_PROMOTION',
    Event = 'EVENT',
    EventDiscovery = 'EVENT_DISCOVERY',
    EventTicket = 'EVENT_TICKET',
    HomePage = 'HOME_PAGE',
    Promotion = 'PROMOTION',
    ReferralGifting = 'REFERRAL_GIFTING',
    UserBadge = 'USER_BADGE',
    LiveStreamGiveaway = 'LIVE_STREAM_GIVEAWAY',
    UpcomingShowGiveaway = 'UPCOMING_SHOW_GIVEAWAY',
    PopClip = 'POP_CLIP',
    BecomeASeller = 'BECOME_A_SELLER'
}

/**
 * 
 * @export
 * @interface ShipmentItem
 */
export interface ShipmentItem {
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    buyerId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    shippoTransactionId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    labelUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    trackingNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    trackingStatus: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    trackingUrlProvider: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentItem
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    transaction: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    transactionStatus: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    updateAt: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentItem
     */
    carrier?: ShipmentItemCarrierEnum;
}

/**
* @export
* @enum {string}
*/
export enum ShipmentItemCarrierEnum {
    Shippo = 'SHIPPO',
    Usps = 'USPS',
    Ups = 'UPS',
    CanadaPost = 'CANADA_POST',
    DhlExpress = 'DHL_EXPRESS',
    DpdUk = 'DPD_UK',
    HermesUk = 'HERMES_UK'
}

/**
 * 
 * @export
 * @interface ShipmentPlatformDto
 */
export interface ShipmentPlatformDto {
    /**
     * 
     * @type {string}
     * @memberof ShipmentPlatformDto
     */
    merchantId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentPlatformDto
     */
    rateId: string;
}

/**
 * 
 * @export
 * @interface ShipmentTrackingRecordBackwardCompatibleDto
 */
export interface ShipmentTrackingRecordBackwardCompatibleDto {
    /**
     * 
     * @type {object}
     * @memberof ShipmentTrackingRecordBackwardCompatibleDto
     */
    createdAt: object;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTrackingRecordBackwardCompatibleDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTrackingRecordBackwardCompatibleDto
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTrackingRecordBackwardCompatibleDto
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTrackingRecordBackwardCompatibleDto
     */
    buyerId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTrackingRecordBackwardCompatibleDto
     */
    trackingNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentTrackingRecordBackwardCompatibleDto
     */
    isRemoved?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTrackingRecordBackwardCompatibleDto
     */
    trackingUrlProvider?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTrackingRecordBackwardCompatibleDto
     */
    carrier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTrackingRecordBackwardCompatibleDto
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTrackingRecordBackwardCompatibleDto
     */
    transactionId?: string | null;
}

/**
 * 
 * @export
 * @interface ShipmentTrackingRecordBackwardCompatibleResponse
 */
export interface ShipmentTrackingRecordBackwardCompatibleResponse {
    /**
     * 
     * @type {Array<ShipmentTrackingRecordBackwardCompatibleDto>}
     * @memberof ShipmentTrackingRecordBackwardCompatibleResponse
     */
    records: Array<ShipmentTrackingRecordBackwardCompatibleDto>;
}

/**
 * 
 * @export
 * @interface ShipmentTrackingRecordDto
 */
export interface ShipmentTrackingRecordDto {
    /**
     * 
     * @type {string}
     * @memberof ShipmentTrackingRecordDto
     */
    id: string;
    /**
     * 
     * @type {object}
     * @memberof ShipmentTrackingRecordDto
     */
    createdAt: object;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTrackingRecordDto
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTrackingRecordDto
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTrackingRecordDto
     */
    buyerId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTrackingRecordDto
     */
    trackingNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShipmentTrackingRecordDto
     */
    isRemoved?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTrackingRecordDto
     */
    trackingUrlProvider?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTrackingRecordDto
     */
    carrier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTrackingRecordDto
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTrackingRecordDto
     */
    transactionId?: string | null;
}

/**
 * 
 * @export
 * @interface ShipmentTrackingRecordResponse
 */
export interface ShipmentTrackingRecordResponse {
    /**
     * 
     * @type {Array<ShipmentTrackingRecordDto>}
     * @memberof ShipmentTrackingRecordResponse
     */
    records: Array<ShipmentTrackingRecordDto>;
}

/**
 * 
 * @export
 * @interface ShipmentTransactionResponse
 */
export interface ShipmentTransactionResponse {
    /**
     * 
     * @type {Array<ShipmentTransactionsDto>}
     * @memberof ShipmentTransactionResponse
     */
    transactions: Array<ShipmentTransactionsDto>;
}

/**
 * 
 * @export
 * @interface ShipmentTransactionsDto
 */
export interface ShipmentTransactionsDto {
    /**
     * 
     * @type {string}
     * @memberof ShipmentTransactionsDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTransactionsDto
     */
    buyerId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTransactionsDto
     */
    sellerId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTransactionsDto
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTransactionsDto
     */
    shippoTransactionId: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTransactionsDto
     */
    labelUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTransactionsDto
     */
    trackingNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTransactionsDto
     */
    trackingStatus: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTransactionsDto
     */
    trackingUrlProvider: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentTransactionsDto
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentTransactionsDto
     */
    margin?: number;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTransactionsDto
     */
    transaction: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTransactionsDto
     */
    transactionStatus: string;
    /**
     * 
     * @type {object}
     * @memberof ShipmentTransactionsDto
     */
    createdAt: object;
    /**
     * 
     * @type {object}
     * @memberof ShipmentTransactionsDto
     */
    updateAt: object;
    /**
     * 
     * @type {string}
     * @memberof ShipmentTransactionsDto
     */
    carrier?: ShipmentTransactionsDtoCarrierEnum;
    /**
     * 
     * @type {ShipmentPlatformDto}
     * @memberof ShipmentTransactionsDto
     */
    platform?: ShipmentPlatformDto;
}

/**
* @export
* @enum {string}
*/
export enum ShipmentTransactionsDtoCarrierEnum {
    Shippo = 'SHIPPO',
    Usps = 'USPS',
    Ups = 'UPS',
    CanadaPost = 'CANADA_POST',
    DhlExpress = 'DHL_EXPRESS',
    DpdUk = 'DPD_UK',
    HermesUk = 'HERMES_UK'
}

/**
 * 
 * @export
 * @interface ShippingCostItem
 */
export interface ShippingCostItem {
    /**
     * 
     * @type {string}
     * @memberof ShippingCostItem
     */
    shipmentId: string;
    /**
     * 
     * @type {Array<ShippingRateItem>}
     * @memberof ShippingCostItem
     */
    rates: Array<ShippingRateItem>;
}

/**
 * 
 * @export
 * @interface ShippingFeeResponse
 */
export interface ShippingFeeResponse {
    /**
     * 
     * @type {number}
     * @memberof ShippingFeeResponse
     */
    shippingFee: number;
}

/**
 * 
 * @export
 * @interface ShippingLabelStatus
 */
export interface ShippingLabelStatus {
    /**
     * 
     * @type {boolean}
     * @memberof ShippingLabelStatus
     */
    disabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingLabelStatus
     */
    noLabel: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingLabelStatus
     */
    generating: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingLabelStatus
     */
    generated: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingLabelStatus
     */
    preGenerated: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingLabelStatus
     */
    failed: boolean;
}

/**
 * 
 * @export
 * @interface ShippingRateCostItem
 */
export interface ShippingRateCostItem {
    /**
     * 
     * @type {string}
     * @memberof ShippingRateCostItem
     */
    currency: string;
    /**
     * 
     * @type {number}
     * @memberof ShippingRateCostItem
     */
    base: number;
    /**
     * 
     * @type {number}
     * @memberof ShippingRateCostItem
     */
    margin: number;
    /**
     * 
     * @type {number}
     * @memberof ShippingRateCostItem
     */
    total: number;
}

/**
 * 
 * @export
 * @interface ShippingRateItem
 */
export interface ShippingRateItem {
    /**
     * 
     * @type {string}
     * @memberof ShippingRateItem
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShippingRateItem
     */
    attributes: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ShippingRateItem
     */
    duration_terms: string;
    /**
     * 
     * @type {number}
     * @memberof ShippingRateItem
     */
    estimated_days: number;
    /**
     * 
     * @type {string}
     * @memberof ShippingRateItem
     */
    provider_image_75: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingRateItem
     */
    provider_image_200: string;
    /**
     * 
     * @type {ServiceLevelItem}
     * @memberof ShippingRateItem
     */
    servicelevel: ServiceLevelItem;
    /**
     * 
     * @type {ShippingRateCostItem}
     * @memberof ShippingRateItem
     */
    cost: ShippingRateCostItem;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingRateItem
     */
    test: boolean;
}

/**
 * 
 * @export
 * @interface ShippingSurchargeInfo
 */
export interface ShippingSurchargeInfo {
    /**
     * 
     * @type {number}
     * @memberof ShippingSurchargeInfo
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof ShippingSurchargeInfo
     */
    rule: ShippingSurchargeInfoRuleEnum;
}

/**
* @export
* @enum {string}
*/
export enum ShippingSurchargeInfoRuleEnum {
    Item = 'PER_ITEM',
    OrderGroup = 'PER_ORDER_GROUP'
}

/**
 * 
 * @export
 * @interface ShippoCarrier
 */
export interface ShippoCarrier {
    /**
     * 
     * @type {number}
     * @memberof ShippoCarrier
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrier
     */
    token: ShippoCarrierTokenEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrier
     */
    name: ShippoCarrierNameEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrier
     */
    alias: string;
}

/**
* @export
* @enum {string}
*/
export enum ShippoCarrierTokenEnum {
    Usps = 'usps'
}/**
* @export
* @enum {string}
*/
export enum ShippoCarrierNameEnum {
    Usps = 'USPS'
}

/**
 * 
 * @export
 * @interface ShippoCarrierParcelTemplate
 */
export interface ShippoCarrierParcelTemplate {
    /**
     * 
     * @type {number}
     * @memberof ShippoCarrierParcelTemplate
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierParcelTemplate
     */
    type: ShippoCarrierParcelTemplateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierParcelTemplate
     */
    token: ShippoCarrierParcelTemplateTokenEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierParcelTemplate
     */
    name: ShippoCarrierParcelTemplateNameEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierParcelTemplate
     */
    alias: string;
    /**
     * 
     * @type {number}
     * @memberof ShippoCarrierParcelTemplate
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof ShippoCarrierParcelTemplate
     */
    height: number;
    /**
     * 
     * @type {number}
     * @memberof ShippoCarrierParcelTemplate
     */
    depth: number;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierParcelTemplate
     */
    distanceUnit: ShippoCarrierParcelTemplateDistanceUnitEnum;
}

/**
* @export
* @enum {string}
*/
export enum ShippoCarrierParcelTemplateTypeEnum {
    Custom = 'CUSTOM',
    ShippoCarrierParcelTemplate = 'SHIPPO_CARRIER_PARCEL_TEMPLATE'
}/**
* @export
* @enum {string}
*/
export enum ShippoCarrierParcelTemplateTokenEnum {
    RegionalRateBoxB1 = 'USPS_RegionalRateBoxB1',
    RegionalRateBoxB2 = 'USPS_RegionalRateBoxB2',
    IrregularParcel = 'USPS_IrregularParcel',
    Card = 'USPS_Card',
    FlatRateCardboardEnvelope = 'USPS_FlatRateCardboardEnvelope',
    FlatRateLegalEnvelope = 'USPS_FlatRateLegalEnvelope',
    FlatRateEnvelope = 'USPS_FlatRateEnvelope',
    FlatRateGiftCardEnvelope = 'USPS_FlatRateGiftCardEnvelope',
    LargeVideoFlatRateBox = 'USPS_LargeVideoFlatRateBox',
    LargeFlatRateBoardGameBox = 'USPS_LargeFlatRateBoardGameBox',
    SmallFlatRateEnvelope = 'USPS_SmallFlatRateEnvelope',
    SoftPack = 'USPS_SoftPack',
    LargeFlatRateBox = 'USPS_LargeFlatRateBox',
    MediumFlatRateBox1 = 'USPS_MediumFlatRateBox1',
    MediumFlatRateBox2 = 'USPS_MediumFlatRateBox2',
    SmallFlatRateBox = 'USPS_SmallFlatRateBox',
    RegionalRateBoxA1 = 'USPS_RegionalRateBoxA1',
    RegionalRateBoxA2 = 'USPS_RegionalRateBoxA2',
    ApoFlatRateBox = 'USPS_APOFlatRateBox',
    FlatRateWindowEnvelope = 'USPS_FlatRateWindowEnvelope',
    FlatRatePaddedEnvelope = 'USPS_FlatRatePaddedEnvelope'
}/**
* @export
* @enum {string}
*/
export enum ShippoCarrierParcelTemplateNameEnum {
    Envelope = 'Envelope',
    Package = 'Package',
    RegionalRateBoxB1 = 'Regional Rate Box B1',
    RegionalRateBoxB2 = 'Regional Rate Box B2',
    IrregularParcel = 'Irregular Parcel',
    Card = 'Card',
    FlatRateCardboardEnvelope = 'Flat Rate Cardboard Envelope',
    FlatRateLegalEnvelope = 'Flat Rate Legal Envelope',
    FlatRateEnvelope = 'Flat Rate Envelope',
    FlatRateGiftCardEnvelope = 'Flat Rate Gift Card Envelope',
    FlatRateLargeVideoBoxIntlOnly = 'Flat Rate Large Video Box (Int\'l only)',
    LargeFlatRateBoardGameBox = 'Large Flat Rate Board Game Box',
    SmallFlatRateEnvelope = 'Small Flat Rate Envelope',
    SoftPackPaddedEnvelope = 'Soft Pack Padded Envelope',
    LargeFlatRateBox = 'Large Flat Rate Box',
    MediumFlatRateBox1 = 'Medium Flat Rate Box 1',
    MediumFlatRateBox2 = 'Medium Flat Rate Box 2',
    SmallFlatRateBox = 'Small Flat Rate Box',
    RegionalRateBoxA1 = 'Regional Rate Box A1',
    RegionalRateBoxA2 = 'Regional Rate Box A2',
    ApoFpoDpoLargeFlatRateBox = 'APO/FPO/DPO Large Flat Rate Box',
    FlatRateWindowEnvelope = 'Flat Rate Window Envelope',
    FlatRatePaddedEnvelope = 'Flat Rate Padded Envelope'
}/**
* @export
* @enum {string}
*/
export enum ShippoCarrierParcelTemplateDistanceUnitEnum {
    Cm = 'cm',
    In = 'in',
    Ft = 'ft',
    M = 'm',
    Mm = 'mm',
    Yd = 'yd'
}

/**
 * 
 * @export
 * @interface ShippoCarrierServiceLevel
 */
export interface ShippoCarrierServiceLevel {
    /**
     * 
     * @type {number}
     * @memberof ShippoCarrierServiceLevel
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierServiceLevel
     */
    type: ShippoCarrierServiceLevelTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierServiceLevel
     */
    token: ShippoCarrierServiceLevelTokenEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierServiceLevel
     */
    name: ShippoCarrierServiceLevelNameEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierServiceLevel
     */
    alias: string;
}

/**
* @export
* @enum {string}
*/
export enum ShippoCarrierServiceLevelTypeEnum {
    RateAttribute = 'SHIPPO_RATE_ATTRIBUTE',
    CarrierServiceLevel = 'SHIPPO_CARRIER_SERVICE_LEVEL'
}/**
* @export
* @enum {string}
*/
export enum ShippoCarrierServiceLevelTokenEnum {
    Cheapest = 'CHEAPEST',
    Fastest = 'FASTEST',
    UspsGroundAdvantage = 'usps_ground_advantage',
    UspsPriority = 'usps_priority',
    UspsPriorityExpress = 'usps_priority_express'
}/**
* @export
* @enum {string}
*/
export enum ShippoCarrierServiceLevelNameEnum {
    Cheapest = 'CHEAPEST',
    Fastest = 'FASTEST',
    GroundAdvantage = 'Ground Advantage',
    PriorityMail = 'Priority Mail',
    PriorityMailExpress = 'Priority Mail Express'
}

/**
 * 
 * @export
 * @interface ShippoCarrierSignatureConfirmation
 */
export interface ShippoCarrierSignatureConfirmation {
    /**
     * 
     * @type {number}
     * @memberof ShippoCarrierSignatureConfirmation
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierSignatureConfirmation
     */
    token: ShippoCarrierSignatureConfirmationTokenEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierSignatureConfirmation
     */
    name: ShippoCarrierSignatureConfirmationNameEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippoCarrierSignatureConfirmation
     */
    alias: string;
}

/**
* @export
* @enum {string}
*/
export enum ShippoCarrierSignatureConfirmationTokenEnum {
    Standard = 'STANDARD',
    Adult = 'ADULT',
    Certified = 'CERTIFIED'
}/**
* @export
* @enum {string}
*/
export enum ShippoCarrierSignatureConfirmationNameEnum {
    SignatureConfirmation = 'Signature Confirmation',
    AdultSignatureRequired = 'Adult Signature Required',
    CertifiedMail = 'Certified Mail'
}

/**
 * 
 * @export
 * @interface ShippoRate
 */
export interface ShippoRate {
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    object_created: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    object_updated: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    object_id: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    object_owner: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    shipment: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    amount_local: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    currency_local: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    provider: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    provider_image_75: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    provider_image_200: string;
    /**
     * 
     * @type {ShippoServicelevel}
     * @memberof ShippoRate
     */
    servicelevel: ShippoServicelevel;
    /**
     * 
     * @type {number}
     * @memberof ShippoRate
     */
    estimated_days: number;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    duration_terms: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    carrier_account: string;
    /**
     * 
     * @type {object}
     * @memberof ShippoRate
     */
    arrives_by: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShippoRate
     */
    attributes: Array<ShippoRateAttributesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShippoRate
     */
    messages: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ShippoRate
     */
    test: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShippoRate
     */
    zone: string;
}

/**
* @export
* @enum {string}
*/
export enum ShippoRateAttributesEnum {
    Cheapest = 'CHEAPEST',
    Fastest = 'FASTEST',
    Bestvalue = 'BESTVALUE'
}

/**
 * 
 * @export
 * @interface ShippoServicelevel
 */
export interface ShippoServicelevel {
    /**
     * 
     * @type {string}
     * @memberof ShippoServicelevel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoServicelevel
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoServicelevel
     */
    terms: string;
    /**
     * 
     * @type {string}
     * @memberof ShippoServicelevel
     */
    extended_token: string;
    /**
     * 
     * @type {object}
     * @memberof ShippoServicelevel
     */
    parent_servicelevel: object;
}

/**
 * 
 * @export
 * @interface ShoifyStoresDto
 */
export interface ShoifyStoresDto {
    /**
     * 
     * @type {Array<LocationDto>}
     * @memberof ShoifyStoresDto
     */
    stores: Array<LocationDto>;
}

/**
 * 
 * @export
 * @interface ShoifyStoresWebhooksConfigStatusResponse
 */
export interface ShoifyStoresWebhooksConfigStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ShoifyStoresWebhooksConfigStatusResponse
     */
    configured: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShoifyStoresWebhooksConfigStatusResponse
     */
    fulfillments: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShoifyStoresWebhooksConfigStatusResponse
     */
    productsUpdate: boolean;
}

/**
 * 
 * @export
 * @interface ShopSource
 */
export interface ShopSource {
    /**
     * 
     * @type {string}
     * @memberof ShopSource
     */
    type: ShopSourceTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum ShopSourceTypeEnum {
    Shop = 'SHOP'
}

/**
 * 
 * @export
 * @interface ShopTokenResponse
 */
export interface ShopTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof ShopTokenResponse
     */
    token: string;
}

/**
 * 
 * @export
 * @interface ShowCustomizationItem
 */
export interface ShowCustomizationItem {
    /**
     * 
     * @type {string}
     * @memberof ShowCustomizationItem
     */
    primaryLightColor?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowCustomizationItem
     */
    primaryDarkColor?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShowCustomizationItem
     */
    lightingBoltImages?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ShowCustomizationItem
     */
    lightingBoltButtonImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShowCustomizationItem
     */
    disableLightingBoltForAll?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShowCustomizationItem
     */
    tippingEnabled?: boolean;
}

/**
 * 
 * @export
 * @interface ShowEventFeaturedShowItem
 */
export interface ShowEventFeaturedShowItem {
    /**
     * 
     * @type {string}
     * @memberof ShowEventFeaturedShowItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventFeaturedShowItem
     */
    sortedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventFeaturedShowItem
     */
    type: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShowEventFeaturedShowItem
     */
    active: boolean;
    /**
     * 
     * @type {BaseUpcomingShowItem}
     * @memberof ShowEventFeaturedShowItem
     */
    upcomingShow?: BaseUpcomingShowItem;
    /**
     * 
     * @type {LiveStreamItem}
     * @memberof ShowEventFeaturedShowItem
     */
    liveStream?: LiveStreamItem;
    /**
     * 
     * @type {string}
     * @memberof ShowEventFeaturedShowItem
     */
    featuredEvent?: ShowEventFeaturedShowItemFeaturedEventEnum;
    /**
     * 
     * @type {Relations}
     * @memberof ShowEventFeaturedShowItem
     */
    relations: Relations;
}

/**
* @export
* @enum {string}
*/
export enum ShowEventFeaturedShowItemFeaturedEventEnum {
    AutoFeaturedStoreShow = 'autoFeaturedStoreShow'
}

/**
 * 
 * @export
 * @interface ShowEventFeaturedStoreRequestDto
 */
export interface ShowEventFeaturedStoreRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ShowEventFeaturedStoreRequestDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventFeaturedStoreRequestDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventFeaturedStoreRequestDto
     */
    sortedAt: string;
}

/**
 * 
 * @export
 * @interface ShowEventGenerateTokenRequest
 */
export interface ShowEventGenerateTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof ShowEventGenerateTokenRequest
     */
    deviceId: string;
}

/**
 * 
 * @export
 * @interface ShowEventItem
 */
export interface ShowEventItem {
    /**
     * 
     * @type {string}
     * @memberof ShowEventItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventItem
     */
    urlCode: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventItem
     */
    previewVideoURL?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventItem
     */
    backgroundURL?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShowEventItem
     */
    active: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShowEventItem
     */
    sellerUserGroupIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShowEventItem
     */
    userGroupIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ShowEventItem
     */
    createdAt: string;
    /**
     * 
     * @type {number}
     * @memberof ShowEventItem
     */
    salesTaxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowEventItem
     */
    maximumPurchaseQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowEventItem
     */
    startedAfter?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventItem
     */
    endedBefore?: string;
    /**
     * 
     * @type {number}
     * @memberof ShowEventItem
     */
    shippingFee?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ShowEventItem
     */
    isClosed?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShowEventItem
     */
    visibilityGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ShowEventItem
     */
    sortedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShowEventItem
     */
    commissionFeeRate?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowEventItem
     */
    featuredStoreStackName?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventItem
     */
    sellerApplicationDisclosure?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventItem
     */
    sellerApplicationDisclosureUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShowEventItem
     */
    unBundleOnDiscovery?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShowEventItem
     */
    visibilityOnDiscoveryBanner?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShowEventItem
     */
    visibleOnCategoryBanner?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShowEventItem
     */
    id: string;
    /**
     * 
     * @type {Metadata}
     * @memberof ShowEventItem
     */
    metadata: Metadata;
    /**
     * 
     * @type {number}
     * @memberof ShowEventItem
     */
    scheduledShowsCount?: number;
}

/**
 * 
 * @export
 * @interface ShowEventPageRows
 */
export interface ShowEventPageRows {
    /**
     * 
     * @type {Array<ShowEventItem>}
     * @memberof ShowEventPageRows
     */
    rows: Array<ShowEventItem>;
}

/**
 * 
 * @export
 * @interface ShowEventTokenResponse
 */
export interface ShowEventTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof ShowEventTokenResponse
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventTokenResponse
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventTokenResponse
     */
    channel: string;
}

/**
 * 
 * @export
 * @interface ShowEventTokensResponse
 */
export interface ShowEventTokensResponse {
    /**
     * 
     * @type {ShowEventTokenResponse}
     * @memberof ShowEventTokensResponse
     */
    rtmComments: ShowEventTokenResponse;
    /**
     * 
     * @type {ShowEventTokenResponse}
     * @memberof ShowEventTokensResponse
     */
    rtmCommentUpvotes: ShowEventTokenResponse;
    /**
     * 
     * @type {ShowEventTokenResponse}
     * @memberof ShowEventTokensResponse
     */
    rtmLightningBolts: ShowEventTokenResponse;
}

/**
 * 
 * @export
 * @interface ShowEventWithoutMetaDataItem
 */
export interface ShowEventWithoutMetaDataItem {
    /**
     * 
     * @type {string}
     * @memberof ShowEventWithoutMetaDataItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventWithoutMetaDataItem
     */
    urlCode: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventWithoutMetaDataItem
     */
    previewVideoURL?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventWithoutMetaDataItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventWithoutMetaDataItem
     */
    backgroundURL?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShowEventWithoutMetaDataItem
     */
    active: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShowEventWithoutMetaDataItem
     */
    sellerUserGroupIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShowEventWithoutMetaDataItem
     */
    userGroupIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ShowEventWithoutMetaDataItem
     */
    createdAt: string;
    /**
     * 
     * @type {number}
     * @memberof ShowEventWithoutMetaDataItem
     */
    salesTaxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowEventWithoutMetaDataItem
     */
    maximumPurchaseQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowEventWithoutMetaDataItem
     */
    startedAfter?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventWithoutMetaDataItem
     */
    endedBefore?: string;
    /**
     * 
     * @type {number}
     * @memberof ShowEventWithoutMetaDataItem
     */
    shippingFee?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ShowEventWithoutMetaDataItem
     */
    isClosed?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShowEventWithoutMetaDataItem
     */
    visibilityGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ShowEventWithoutMetaDataItem
     */
    sortedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ShowEventWithoutMetaDataItem
     */
    commissionFeeRate?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowEventWithoutMetaDataItem
     */
    featuredStoreStackName?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventWithoutMetaDataItem
     */
    sellerApplicationDisclosure?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventWithoutMetaDataItem
     */
    sellerApplicationDisclosureUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShowEventWithoutMetaDataItem
     */
    unBundleOnDiscovery?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShowEventWithoutMetaDataItem
     */
    visibilityOnDiscoveryBanner?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShowEventWithoutMetaDataItem
     */
    visibleOnCategoryBanner?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShowEventWithoutMetaDataItem
     */
    id: string;
}

/**
 * 
 * @export
 * @interface ShowEventsFeaturedShowPageRows
 */
export interface ShowEventsFeaturedShowPageRows {
    /**
     * 
     * @type {Array<ShowEventFeaturedShowItem>}
     * @memberof ShowEventsFeaturedShowPageRows
     */
    rows: Array<ShowEventFeaturedShowItem>;
}

/**
 * 
 * @export
 * @interface ShowEventsFeaturedShowSearchResponse
 */
export interface ShowEventsFeaturedShowSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof ShowEventsFeaturedShowSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof ShowEventsFeaturedShowSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {ShowEventsFeaturedShowPageRows}
     * @memberof ShowEventsFeaturedShowSearchResponse
     */
    data: ShowEventsFeaturedShowPageRows;
}

/**
 * 
 * @export
 * @interface ShowEventsSearchResponse
 */
export interface ShowEventsSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof ShowEventsSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof ShowEventsSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {ShowEventPageRows}
     * @memberof ShowEventsSearchResponse
     */
    data: ShowEventPageRows;
}

/**
 * 
 * @export
 * @interface ShowItem
 */
export interface ShowItem {
    /**
     * 
     * @type {LiveStreamItemWithId}
     * @memberof ShowItem
     */
    liveStream?: LiveStreamItemWithId;
    /**
     * 
     * @type {UpcomingShowItem}
     * @memberof ShowItem
     */
    upcomingShow?: UpcomingShowItem;
    /**
     * 
     * @type {string}
     * @memberof ShowItem
     */
    showType: ShowItemShowTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum ShowItemShowTypeEnum {
    LiveStream = 'liveStream',
    UpcomingShow = 'upcomingShow'
}

/**
 * 
 * @export
 * @interface ShowTicketItem
 */
export interface ShowTicketItem {
    /**
     * 
     * @type {string}
     * @memberof ShowTicketItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ShowTicketItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowTicketItem
     */
    defaultImage: string;
    /**
     * 
     * @type {number}
     * @memberof ShowTicketItem
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof ShowTicketItem
     */
    discountPrice?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ShowTicketItem
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShowTicketItem
     */
    requireShipping: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShowTicketItem
     */
    shippingFee?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShowTicketItem
     */
    userGroupIds: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ShowTicketItem
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowTicketItem
     */
    soldQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowTicketItem
     */
    maximumPurchaseQuantity?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ShowTicketItem
     */
    upgradeTicket?: boolean | null;
    /**
     * 
     * @type {object}
     * @memberof ShowTicketItem
     */
    fromTicketId?: object;
    /**
     * 
     * @type {object}
     * @memberof ShowTicketItem
     */
    toTicketId?: object;
    /**
     * 
     * @type {string}
     * @memberof ShowTicketItem
     */
    emailConfirmationDisclosure?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowTicketItem
     */
    emailConfirmationDisclosureUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowTicketItem
     */
    emailConfirmationHeaderBackgroundUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowTicketItem
     */
    sortedAt: string;
}

/**
 * 
 * @export
 * @interface ShowTicketItemWithId
 */
export interface ShowTicketItemWithId {
    /**
     * 
     * @type {string}
     * @memberof ShowTicketItemWithId
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ShowTicketItemWithId
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowTicketItemWithId
     */
    defaultImage: string;
    /**
     * 
     * @type {number}
     * @memberof ShowTicketItemWithId
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof ShowTicketItemWithId
     */
    discountPrice?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ShowTicketItemWithId
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShowTicketItemWithId
     */
    requireShipping: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShowTicketItemWithId
     */
    shippingFee?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShowTicketItemWithId
     */
    userGroupIds: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ShowTicketItemWithId
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowTicketItemWithId
     */
    soldQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowTicketItemWithId
     */
    maximumPurchaseQuantity?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ShowTicketItemWithId
     */
    upgradeTicket?: boolean | null;
    /**
     * 
     * @type {object}
     * @memberof ShowTicketItemWithId
     */
    fromTicketId?: object;
    /**
     * 
     * @type {object}
     * @memberof ShowTicketItemWithId
     */
    toTicketId?: object;
    /**
     * 
     * @type {string}
     * @memberof ShowTicketItemWithId
     */
    emailConfirmationDisclosure?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowTicketItemWithId
     */
    emailConfirmationDisclosureUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowTicketItemWithId
     */
    emailConfirmationHeaderBackgroundUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowTicketItemWithId
     */
    sortedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ShowTicketItemWithId
     */
    id: string;
}

/**
 * 
 * @export
 * @interface ShowTicketPageRows
 */
export interface ShowTicketPageRows {
    /**
     * 
     * @type {Array<ShowTicketItemWithId>}
     * @memberof ShowTicketPageRows
     */
    rows: Array<ShowTicketItemWithId>;
}

/**
 * 
 * @export
 * @interface ShowTicketsSearchResponse
 */
export interface ShowTicketsSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof ShowTicketsSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof ShowTicketsSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {ShowTicketPageRows}
     * @memberof ShowTicketsSearchResponse
     */
    data: ShowTicketPageRows;
}

/**
 * 
 * @export
 * @interface ShowsPageRows
 */
export interface ShowsPageRows {
    /**
     * 
     * @type {Array<ShowItem>}
     * @memberof ShowsPageRows
     */
    rows: Array<ShowItem>;
}

/**
 * 
 * @export
 * @interface SignedUrlResponse
 */
export interface SignedUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof SignedUrlResponse
     */
    signedUrl: string;
}

/**
 * 
 * @export
 * @interface SimpleProfileItem
 */
export interface SimpleProfileItem {
    /**
     * 
     * @type {string}
     * @memberof SimpleProfileItem
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleProfileItem
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleProfileItem
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleProfileItem
     */
    avatar?: string;
}

/**
 * 
 * @export
 * @interface SingleUnitWeightInfo
 */
export interface SingleUnitWeightInfo {
    /**
     * 
     * @type {string}
     * @memberof SingleUnitWeightInfo
     */
    type: SingleUnitWeightInfoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SingleUnitWeightInfo
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof SingleUnitWeightInfo
     */
    unit: SingleUnitWeightInfoUnitEnum;
}

/**
* @export
* @enum {string}
*/
export enum SingleUnitWeightInfoTypeEnum {
    SingleUnit = 'singleUnit'
}/**
* @export
* @enum {string}
*/
export enum SingleUnitWeightInfoUnitEnum {
    G = 'g',
    Kg = 'kg',
    Lb = 'lb',
    Oz = 'oz'
}

/**
 * 
 * @export
 * @interface SocialAccountDto
 */
export interface SocialAccountDto {
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    instagramUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    youtubeUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    depopUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    ebayUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    facebookUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    tiktokUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    etsyUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    discordUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    lemon8Url?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    snapchatUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialAccountDto
     */
    twitterUrl?: string;
}

/**
 * 
 * @export
 * @interface SortCategoryDiscoveryRows
 */
export interface SortCategoryDiscoveryRows {
    /**
     * 
     * @type {string}
     * @memberof SortCategoryDiscoveryRows
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SortCategoryDiscoveryRows
     */
    sortedAt: string;
}

/**
 * 
 * @export
 * @interface SortFeaturedShow
 */
export interface SortFeaturedShow {
    /**
     * 
     * @type {string}
     * @memberof SortFeaturedShow
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SortFeaturedShow
     */
    sortedAt: string;
}

/**
 * 
 * @export
 * @interface SortReferralGift
 */
export interface SortReferralGift {
    /**
     * 
     * @type {string}
     * @memberof SortReferralGift
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SortReferralGift
     */
    sortedAt: string;
}

/**
 * 
 * @export
 * @interface SortShowEventFeaturedShow
 */
export interface SortShowEventFeaturedShow {
    /**
     * 
     * @type {string}
     * @memberof SortShowEventFeaturedShow
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SortShowEventFeaturedShow
     */
    sortedAt: string;
}

/**
 * 
 * @export
 * @interface SortShowEventItem
 */
export interface SortShowEventItem {
    /**
     * 
     * @type {string}
     * @memberof SortShowEventItem
     */
    showEventId: string;
    /**
     * 
     * @type {string}
     * @memberof SortShowEventItem
     */
    sortedAt: string;
}

/**
 * 
 * @export
 * @interface SortShowTickets
 */
export interface SortShowTickets {
    /**
     * 
     * @type {string}
     * @memberof SortShowTickets
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SortShowTickets
     */
    sortedAt: string;
}

/**
 * 
 * @export
 * @interface SortedPublicListingsDto
 */
export interface SortedPublicListingsDto {
    /**
     * 
     * @type {string}
     * @memberof SortedPublicListingsDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SortedPublicListingsDto
     */
    createdAt: string;
}

/**
 * 
 * @export
 * @interface StartAuctionRequest
 */
export interface StartAuctionRequest {
    /**
     * 
     * @type {string}
     * @memberof StartAuctionRequest
     */
    listingId: string;
    /**
     * 
     * @type {number}
     * @memberof StartAuctionRequest
     */
    startingPrice: number;
    /**
     * 
     * @type {AuctionTimer}
     * @memberof StartAuctionRequest
     */
    timer?: AuctionTimer;
}

/**
 * 
 * @export
 * @interface StartAuctionResponse
 */
export interface StartAuctionResponse {
    /**
     * 
     * @type {string}
     * @memberof StartAuctionResponse
     */
    auctionId: string;
}

/**
 * 
 * @export
 * @interface StartWatchRequest
 */
export interface StartWatchRequest {
    /**
     * 
     * @type {string}
     * @memberof StartWatchRequest
     */
    deviceId?: string;
}

/**
 * 
 * @export
 * @interface Store
 */
export interface Store {
    /**
     * 
     * @type {number}
     * @memberof Store
     */
    adjustedPopshopShippingFee?: number;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    announcement?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Store
     */
    badges?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    bio?: string;
    /**
     * 
     * @type {object}
     * @memberof Store
     */
    createdAt: object;
    /**
     * 
     * @type {object}
     * @memberof Store
     */
    evergreenVideo?: object;
    /**
     * 
     * @type {object}
     * @memberof Store
     */
    liveStream?: object;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    liveStreamId?: string;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    passcode: string;
    /**
     * 
     * @type {ProfileResponse}
     * @memberof Store
     */
    profile: ProfileResponse;
    /**
     * 
     * @type {object}
     * @memberof Store
     */
    salesTaxRate?: object;
    /**
     * 
     * @type {number}
     * @memberof Store
     */
    secondOfShippingLabelGeneration: number;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    sellerPasscode?: string;
    /**
     * 
     * @type {number}
     * @memberof Store
     */
    shippingFee?: number;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    shortDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    storeId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Store
     */
    tags?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof Store
     */
    upcomingShow?: object;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Store
     */
    shippingMode?: Array<StoreShippingModeEnum>;
}

/**
* @export
* @enum {string}
*/
export enum StoreShippingModeEnum {
    Shipping = 'shipping',
    Pickup = 'pickup'
}

/**
 * 
 * @export
 * @interface StoreControllerStoreListingVariant
 */
export interface StoreControllerStoreListingVariant {
    /**
     * 
     * @type {string}
     * @memberof StoreControllerStoreListingVariant
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof StoreControllerStoreListingVariant
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof StoreControllerStoreListingVariant
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof StoreControllerStoreListingVariant
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof StoreControllerStoreListingVariant
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreControllerStoreListingVariant
     */
    discountPrice?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StoreControllerStoreListingVariant
     */
    hidden?: boolean;
    /**
     * 
     * @type {StoreListingVariantOriginalInfo}
     * @memberof StoreControllerStoreListingVariant
     */
    originalInfo?: StoreListingVariantOriginalInfo;
    /**
     * 
     * @type {DimsInfo}
     * @memberof StoreControllerStoreListingVariant
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {SingleUnitWeightInfo | PoundWithOunceWeightInfo}
     * @memberof StoreControllerStoreListingVariant
     */
    weight?: SingleUnitWeightInfo | PoundWithOunceWeightInfo;
    /**
     * 
     * @type {string}
     * @memberof StoreControllerStoreListingVariant
     */
    externalCheckoutUrl?: string;
}

/**
 * 
 * @export
 * @interface StoreDTO
 */
export interface StoreDTO {
    /**
     * 
     * @type {string}
     * @memberof StoreDTO
     */
    user_id: string;
}

/**
 * 
 * @export
 * @interface StoreFrontItem
 */
export interface StoreFrontItem {
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    sellerPasscode?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreFrontItem
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    createdAt: string;
    /**
     * 
     * @type {SocialAccountDto}
     * @memberof StoreFrontItem
     */
    socialAccounts?: SocialAccountDto;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    agencyId?: string;
    /**
     * 
     * @type {AgencyItemWithId}
     * @memberof StoreFrontItem
     */
    agency?: AgencyItemWithId;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    passcode: string;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    lastLiveStreamDate?: string;
    /**
     * 
     * @type {number}
     * @memberof StoreFrontItem
     */
    shippingFee?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreFrontItem
     */
    adjustedPopshopShippingFee?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    bio?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    announcement?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof StoreFrontItem
     */
    salesTaxRate?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof StoreFrontItem
     */
    secondOfShippingLabelGeneration: number;
    /**
     * 
     * @type {BaseUpcomingShowItem}
     * @memberof StoreFrontItem
     */
    upcomingShow?: BaseUpcomingShowItem;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {object}
     * @memberof StoreFrontItem
     */
    liveStream?: object;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    liveStreamId?: string;
    /**
     * 
     * @type {EvergreenVideoItem}
     * @memberof StoreFrontItem
     */
    evergreenVideo?: EvergreenVideoItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreFrontItem
     */
    badges?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    shortDescription?: string;
    /**
     * 
     * @type {ShowCustomizationItem}
     * @memberof StoreFrontItem
     */
    showCustomization?: ShowCustomizationItem;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItem
     */
    defaultCoverImage?: string;
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof StoreFrontItem
     */
    profile: BaseProfileItem;
    /**
     * 
     * @type {StoreTypeEnumItem}
     * @memberof StoreFrontItem
     */
    storeType?: StoreTypeEnumItem;
}

/**
 * 
 * @export
 * @interface StoreFrontItemWithBaseProfile
 */
export interface StoreFrontItemWithBaseProfile {
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithBaseProfile
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithBaseProfile
     */
    sellerPasscode?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreFrontItemWithBaseProfile
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithBaseProfile
     */
    createdAt: string;
    /**
     * 
     * @type {SocialAccountDto}
     * @memberof StoreFrontItemWithBaseProfile
     */
    socialAccounts?: SocialAccountDto;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithBaseProfile
     */
    agencyId?: string;
    /**
     * 
     * @type {AgencyItemWithId}
     * @memberof StoreFrontItemWithBaseProfile
     */
    agency?: AgencyItemWithId;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithBaseProfile
     */
    passcode: string;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithBaseProfile
     */
    lastLiveStreamDate?: string;
    /**
     * 
     * @type {number}
     * @memberof StoreFrontItemWithBaseProfile
     */
    shippingFee?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreFrontItemWithBaseProfile
     */
    adjustedPopshopShippingFee?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithBaseProfile
     */
    bio?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithBaseProfile
     */
    announcement?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof StoreFrontItemWithBaseProfile
     */
    salesTaxRate?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof StoreFrontItemWithBaseProfile
     */
    secondOfShippingLabelGeneration: number;
    /**
     * 
     * @type {BaseUpcomingShowItem}
     * @memberof StoreFrontItemWithBaseProfile
     */
    upcomingShow?: BaseUpcomingShowItem;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithBaseProfile
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {object}
     * @memberof StoreFrontItemWithBaseProfile
     */
    liveStream?: object;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithBaseProfile
     */
    liveStreamId?: string;
    /**
     * 
     * @type {EvergreenVideoItem}
     * @memberof StoreFrontItemWithBaseProfile
     */
    evergreenVideo?: EvergreenVideoItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreFrontItemWithBaseProfile
     */
    badges?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithBaseProfile
     */
    shortDescription?: string;
    /**
     * 
     * @type {ShowCustomizationItem}
     * @memberof StoreFrontItemWithBaseProfile
     */
    showCustomization?: ShowCustomizationItem;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithBaseProfile
     */
    defaultCoverImage?: string;
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof StoreFrontItemWithBaseProfile
     */
    profile: BaseProfileItem;
}

/**
 * 
 * @export
 * @interface StoreFrontItemWithId
 */
export interface StoreFrontItemWithId {
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithId
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithId
     */
    sellerPasscode?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreFrontItemWithId
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithId
     */
    createdAt: string;
    /**
     * 
     * @type {SocialAccountDto}
     * @memberof StoreFrontItemWithId
     */
    socialAccounts?: SocialAccountDto;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithId
     */
    agencyId?: string;
    /**
     * 
     * @type {AgencyItemWithId}
     * @memberof StoreFrontItemWithId
     */
    agency?: AgencyItemWithId;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithId
     */
    passcode: string;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithId
     */
    lastLiveStreamDate?: string;
    /**
     * 
     * @type {number}
     * @memberof StoreFrontItemWithId
     */
    shippingFee?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreFrontItemWithId
     */
    adjustedPopshopShippingFee?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithId
     */
    bio?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithId
     */
    announcement?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof StoreFrontItemWithId
     */
    salesTaxRate?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof StoreFrontItemWithId
     */
    secondOfShippingLabelGeneration: number;
    /**
     * 
     * @type {BaseUpcomingShowItem}
     * @memberof StoreFrontItemWithId
     */
    upcomingShow?: BaseUpcomingShowItem;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithId
     */
    upcomingShowId?: string;
    /**
     * 
     * @type {object}
     * @memberof StoreFrontItemWithId
     */
    liveStream?: object;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithId
     */
    liveStreamId?: string;
    /**
     * 
     * @type {EvergreenVideoItem}
     * @memberof StoreFrontItemWithId
     */
    evergreenVideo?: EvergreenVideoItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreFrontItemWithId
     */
    badges?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithId
     */
    shortDescription?: string;
    /**
     * 
     * @type {ShowCustomizationItem}
     * @memberof StoreFrontItemWithId
     */
    showCustomization?: ShowCustomizationItem;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithId
     */
    defaultCoverImage?: string;
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof StoreFrontItemWithId
     */
    profile: BaseProfileItem;
    /**
     * 
     * @type {StoreTypeEnumItem}
     * @memberof StoreFrontItemWithId
     */
    storeType?: StoreTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof StoreFrontItemWithId
     */
    id: string;
}

/**
 * 
 * @export
 * @interface StoreHasPostsResponse
 */
export interface StoreHasPostsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof StoreHasPostsResponse
     */
    hasPosts: boolean;
}

/**
 * 
 * @export
 * @interface StoreIncentivePageRows
 */
export interface StoreIncentivePageRows {
    /**
     * 
     * @type {Array<StoreIncentivePayoutItem>}
     * @memberof StoreIncentivePageRows
     */
    rows: Array<StoreIncentivePayoutItem>;
}

/**
 * 
 * @export
 * @interface StoreIncentivePayoutItem
 */
export interface StoreIncentivePayoutItem {
    /**
     * 
     * @type {Relations}
     * @memberof StoreIncentivePayoutItem
     */
    relations: Relations;
    /**
     * 
     * @type {string}
     * @memberof StoreIncentivePayoutItem
     */
    note?: string;
    /**
     * 
     * @type {number}
     * @memberof StoreIncentivePayoutItem
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof StoreIncentivePayoutItem
     */
    status: StoreIncentivePayoutItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreIncentivePayoutItem
     */
    payoutDate?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreIncentivePayoutItem
     */
    sellerId: string;
    /**
     * 
     * @type {StoreFrontItem}
     * @memberof StoreIncentivePayoutItem
     */
    store: StoreFrontItem;
    /**
     * 
     * @type {OperatorItem}
     * @memberof StoreIncentivePayoutItem
     */
    createdBy: OperatorItem;
    /**
     * 
     * @type {OperatorItem}
     * @memberof StoreIncentivePayoutItem
     */
    lastUpdatedBy: OperatorItem;
    /**
     * 
     * @type {string}
     * @memberof StoreIncentivePayoutItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof StoreIncentivePayoutItem
     */
    updatedAt: string;
}

/**
* @export
* @enum {string}
*/
export enum StoreIncentivePayoutItemStatusEnum {
    Pending = 'Pending',
    Processed = 'Processed',
    Completed = 'Completed',
    Failed = 'Failed'
}

/**
 * 
 * @export
 * @interface StoreIncentivePayoutSearchResponse
 */
export interface StoreIncentivePayoutSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof StoreIncentivePayoutSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof StoreIncentivePayoutSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {StoreIncentivePageRows}
     * @memberof StoreIncentivePayoutSearchResponse
     */
    data: StoreIncentivePageRows;
}

/**
 * 
 * @export
 * @interface StoreItem
 */
export interface StoreItem {
    /**
     * 
     * @type {string}
     * @memberof StoreItem
     */
    name: string;
}

/**
 * 
 * @export
 * @interface StoreList
 */
export interface StoreList {
    /**
     * 
     * @type {Array<StoreFrontItemWithId>}
     * @memberof StoreList
     */
    stores: Array<StoreFrontItemWithId>;
    /**
     * 
     * @type {string}
     * @memberof StoreList
     */
    nextCursor?: string;
}

/**
 * 
 * @export
 * @interface StoreListingItem
 */
export interface StoreListingItem {
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItem
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItem
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    defaultImage: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreListingItem
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItem
     */
    quantity: number;
    /**
     * 
     * @type {Array<StoreListingVariant>}
     * @memberof StoreListingItem
     */
    variants?: Array<StoreListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItem
     */
    maximumPurchaseQuantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItem
     */
    shippingFee?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreListingItem
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    status?: StoreListingItemStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItem
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {StoreListingOriginalInfo}
     * @memberof StoreListingItem
     */
    originalInfo?: StoreListingOriginalInfo;
    /**
     * 
     * @type {DimsInfo}
     * @memberof StoreListingItem
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {SingleUnitWeightInfo | PoundWithOunceWeightInfo}
     * @memberof StoreListingItem
     */
    weight?: SingleUnitWeightInfo | PoundWithOunceWeightInfo;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof StoreListingItem
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    taxCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItem
     */
    nontaxable?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItem
     */
    soldQuantityLast7Days?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    storeCoverImage?: string;
    /**
     * 
     * @type {ListingDropshipDetailsItem}
     * @memberof StoreListingItem
     */
    dropshipDetails?: ListingDropshipDetailsItem;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItem
     */
    useLocalPrice?: boolean;
    /**
     * 
     * @type {ListingProductCategoryItem}
     * @memberof StoreListingItem
     */
    category?: ListingProductCategoryItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreListingItem
     */
    collectionIds?: Array<string>;
    /**
     * 
     * @type {ListingRatingType}
     * @memberof StoreListingItem
     */
    rating?: ListingRatingType;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    sizingGuideImage?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    defaultSizingGuideImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItem
     */
    eligibleForModelMe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItem
     */
    shopModelMe?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreListingItem
     */
    categoryIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    type?: StoreListingItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItem
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    discountEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {UploadedFileItem}
     * @memberof StoreListingItem
     */
    uploadedFile?: UploadedFileItem;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    moderationStatus?: StoreListingItemModerationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    moderatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    moderatorUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    adminModerationReason?: string;
    /**
     * 
     * @type {ModeratorProfileItem}
     * @memberof StoreListingItem
     */
    moderatorProfile?: ModeratorProfileItem;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    externalCheckoutUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    externalBrandName?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    externalBrandImage?: string;
    /**
     * 
     * @type {ListingMeetingItem}
     * @memberof StoreListingItem
     */
    meeting?: ListingMeetingItem;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItem
     */
    id: string;
}

/**
* @export
* @enum {string}
*/
export enum StoreListingItemStatusEnum {
    Active = 'active',
    Archived = 'archived'
}/**
* @export
* @enum {string}
*/
export enum StoreListingItemTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}/**
* @export
* @enum {string}
*/
export enum StoreListingItemModerationStatusEnum {
    Pending = 'Pending',
    Accepted = 'Accepted',
    Rejected = 'Rejected',
    ReviewRequired = 'ReviewRequired'
}

/**
 * 
 * @export
 * @interface StoreListingItemWithMetadata
 */
export interface StoreListingItemWithMetadata {
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItemWithMetadata
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItemWithMetadata
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    defaultImage: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreListingItemWithMetadata
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItemWithMetadata
     */
    quantity: number;
    /**
     * 
     * @type {Array<StoreListingVariant>}
     * @memberof StoreListingItemWithMetadata
     */
    variants?: Array<StoreListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItemWithMetadata
     */
    maximumPurchaseQuantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItemWithMetadata
     */
    shippingFee?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreListingItemWithMetadata
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    status?: StoreListingItemWithMetadataStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItemWithMetadata
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {StoreListingOriginalInfo}
     * @memberof StoreListingItemWithMetadata
     */
    originalInfo?: StoreListingOriginalInfo;
    /**
     * 
     * @type {DimsInfo}
     * @memberof StoreListingItemWithMetadata
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {SingleUnitWeightInfo | PoundWithOunceWeightInfo}
     * @memberof StoreListingItemWithMetadata
     */
    weight?: SingleUnitWeightInfo | PoundWithOunceWeightInfo;
    /**
     * 
     * @type {ShippingSurchargeInfo}
     * @memberof StoreListingItemWithMetadata
     */
    shippingSurcharge?: ShippingSurchargeInfo;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    taxCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItemWithMetadata
     */
    nontaxable?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StoreListingItemWithMetadata
     */
    soldQuantityLast7Days?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    storeCoverImage?: string;
    /**
     * 
     * @type {ListingDropshipDetailsItem}
     * @memberof StoreListingItemWithMetadata
     */
    dropshipDetails?: ListingDropshipDetailsItem;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItemWithMetadata
     */
    useLocalPrice?: boolean;
    /**
     * 
     * @type {ListingProductCategoryItem}
     * @memberof StoreListingItemWithMetadata
     */
    category?: ListingProductCategoryItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreListingItemWithMetadata
     */
    collectionIds?: Array<string>;
    /**
     * 
     * @type {ListingRatingType}
     * @memberof StoreListingItemWithMetadata
     */
    rating?: ListingRatingType;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    sizingGuideImage?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    defaultSizingGuideImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItemWithMetadata
     */
    eligibleForModelMe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItemWithMetadata
     */
    shopModelMe?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreListingItemWithMetadata
     */
    categoryIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    type?: StoreListingItemWithMetadataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    summary?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingItemWithMetadata
     */
    discountEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    discountStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    discountEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    thumbnailImage?: string;
    /**
     * 
     * @type {UploadedFileItem}
     * @memberof StoreListingItemWithMetadata
     */
    uploadedFile?: UploadedFileItem;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    moderationStatus?: StoreListingItemWithMetadataModerationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    moderatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    moderatorUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    adminModerationReason?: string;
    /**
     * 
     * @type {ModeratorProfileItem}
     * @memberof StoreListingItemWithMetadata
     */
    moderatorProfile?: ModeratorProfileItem;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    externalCheckoutUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    externalBrandName?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    externalBrandImage?: string;
    /**
     * 
     * @type {ListingMeetingItem}
     * @memberof StoreListingItemWithMetadata
     */
    meeting?: ListingMeetingItem;
    /**
     * 
     * @type {string}
     * @memberof StoreListingItemWithMetadata
     */
    id: string;
    /**
     * 
     * @type {Metadata}
     * @memberof StoreListingItemWithMetadata
     */
    metadata: Metadata;
    /**
     * 
     * @type {Relations}
     * @memberof StoreListingItemWithMetadata
     */
    relations: Relations;
    /**
     * only available when searching top products
     * @type {boolean}
     * @memberof StoreListingItemWithMetadata
     */
    featured?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum StoreListingItemWithMetadataStatusEnum {
    Active = 'active',
    Archived = 'archived'
}/**
* @export
* @enum {string}
*/
export enum StoreListingItemWithMetadataTypeEnum {
    Physical = 'PHYSICAL',
    Digital = 'DIGITAL',
    External = 'EXTERNAL',
    Meeting = 'MEETING',
    Affiliate = 'AFFILIATE',
    Derived = 'DERIVED'
}/**
* @export
* @enum {string}
*/
export enum StoreListingItemWithMetadataModerationStatusEnum {
    Pending = 'Pending',
    Accepted = 'Accepted',
    Rejected = 'Rejected',
    ReviewRequired = 'ReviewRequired'
}

/**
 * 
 * @export
 * @interface StoreListingOriginalInfo
 */
export interface StoreListingOriginalInfo {
    /**
     * 
     * @type {string}
     * @memberof StoreListingOriginalInfo
     */
    type: StoreListingOriginalInfoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreListingOriginalInfo
     */
    shopifyStoreId?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingOriginalInfo
     */
    shopifyLocationId?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingOriginalInfo
     */
    shopifyProductId?: string;
}

/**
* @export
* @enum {string}
*/
export enum StoreListingOriginalInfoTypeEnum {
    Shopify = 'shopify'
}

/**
 * 
 * @export
 * @interface StoreListingPageRows
 */
export interface StoreListingPageRows {
    /**
     * 
     * @type {Array<StoreListingItemWithMetadata>}
     * @memberof StoreListingPageRows
     */
    rows: Array<StoreListingItemWithMetadata>;
}

/**
 * 
 * @export
 * @interface StoreListingRatingRequest
 */
export interface StoreListingRatingRequest {
    /**
     * 
     * @type {number}
     * @memberof StoreListingRatingRequest
     */
    score: number;
    /**
     * 
     * @type {string}
     * @memberof StoreListingRatingRequest
     */
    message?: string;
}

/**
 * 
 * @export
 * @interface StoreListingRatingResponse
 */
export interface StoreListingRatingResponse {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof StoreListingRatingResponse
     */
    details?: { [key: string]: number; };
}

/**
 * 
 * @export
 * @interface StoreListingSearchResponse
 */
export interface StoreListingSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof StoreListingSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof StoreListingSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {StoreListingPageRows}
     * @memberof StoreListingSearchResponse
     */
    data: StoreListingPageRows;
}

/**
 * 
 * @export
 * @interface StoreListingVariant
 */
export interface StoreListingVariant {
    /**
     * 
     * @type {string}
     * @memberof StoreListingVariant
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingVariant
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof StoreListingVariant
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof StoreListingVariant
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof StoreListingVariant
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreListingVariant
     */
    discountPrice?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StoreListingVariant
     */
    hidden?: boolean;
    /**
     * 
     * @type {StoreListingVariantOriginalInfo}
     * @memberof StoreListingVariant
     */
    originalInfo?: StoreListingVariantOriginalInfo;
    /**
     * 
     * @type {DimsInfo}
     * @memberof StoreListingVariant
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {SingleUnitWeightInfo | PoundWithOunceWeightInfo}
     * @memberof StoreListingVariant
     */
    weight?: SingleUnitWeightInfo | PoundWithOunceWeightInfo;
    /**
     * 
     * @type {string}
     * @memberof StoreListingVariant
     */
    externalCheckoutUrl?: string;
}

/**
 * 
 * @export
 * @interface StoreListingVariantOriginalInfo
 */
export interface StoreListingVariantOriginalInfo {
    /**
     * 
     * @type {string}
     * @memberof StoreListingVariantOriginalInfo
     */
    type: StoreListingVariantOriginalInfoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreListingVariantOriginalInfo
     */
    shopifyVariantId?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreListingVariantOriginalInfo
     */
    shopifyInventoryLevelId?: string;
}

/**
* @export
* @enum {string}
*/
export enum StoreListingVariantOriginalInfoTypeEnum {
    Shopify = 'shopify'
}

/**
 * 
 * @export
 * @interface StoreOnboardingPushItem
 */
export interface StoreOnboardingPushItem {
    /**
     * 
     * @type {boolean}
     * @memberof StoreOnboardingPushItem
     */
    viewed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StoreOnboardingPushItem
     */
    disabled: boolean;
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof StoreOnboardingPushItem
     */
    profile: BaseProfileItem;
    /**
     * 
     * @type {Relations}
     * @memberof StoreOnboardingPushItem
     */
    relations: Relations;
    /**
     * 
     * @type {string}
     * @memberof StoreOnboardingPushItem
     */
    viewedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreOnboardingPushItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof StoreOnboardingPushItem
     */
    updatedAt: string;
}

/**
 * 
 * @export
 * @interface StoreOnboardingPushSearchResponse
 */
export interface StoreOnboardingPushSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof StoreOnboardingPushSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof StoreOnboardingPushSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {StoreOnboardingPushesPageRows}
     * @memberof StoreOnboardingPushSearchResponse
     */
    data: StoreOnboardingPushesPageRows;
}

/**
 * 
 * @export
 * @interface StoreOnboardingPushesPageRows
 */
export interface StoreOnboardingPushesPageRows {
    /**
     * 
     * @type {Array<StoreOnboardingPushItem>}
     * @memberof StoreOnboardingPushesPageRows
     */
    rows: Array<StoreOnboardingPushItem>;
}

/**
 * 
 * @export
 * @interface StorePackageTemplateItemWithId
 */
export interface StorePackageTemplateItemWithId {
    /**
     * 
     * @type {string}
     * @memberof StorePackageTemplateItemWithId
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof StorePackageTemplateItemWithId
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof StorePackageTemplateItemWithId
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof StorePackageTemplateItemWithId
     */
    type: StorePackageTemplateItemWithIdTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof StorePackageTemplateItemWithId
     */
    isDefault: boolean;
    /**
     * 
     * @type {string}
     * @memberof StorePackageTemplateItemWithId
     */
    imageUrl: string;
    /**
     * 
     * @type {string}
     * @memberof StorePackageTemplateItemWithId
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StorePackageTemplateItemWithId
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof StorePackageTemplateItemWithId
     */
    shippingPrice: number;
    /**
     * 
     * @type {string}
     * @memberof StorePackageTemplateItemWithId
     */
    shippingCost: string;
    /**
     * 
     * @type {string}
     * @memberof StorePackageTemplateItemWithId
     */
    carrierId: string;
    /**
     * 
     * @type {ShippoCarrier}
     * @memberof StorePackageTemplateItemWithId
     */
    carrier: ShippoCarrier;
    /**
     * 
     * @type {string}
     * @memberof StorePackageTemplateItemWithId
     */
    parcelTemplateId: string;
    /**
     * 
     * @type {ShippoCarrierParcelTemplate}
     * @memberof StorePackageTemplateItemWithId
     */
    parcelTemplate: ShippoCarrierParcelTemplate;
    /**
     * 
     * @type {number}
     * @memberof StorePackageTemplateItemWithId
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof StorePackageTemplateItemWithId
     */
    height: number;
    /**
     * 
     * @type {number}
     * @memberof StorePackageTemplateItemWithId
     */
    depth: number;
    /**
     * 
     * @type {string}
     * @memberof StorePackageTemplateItemWithId
     */
    distanceUnit: StorePackageTemplateItemWithIdDistanceUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof StorePackageTemplateItemWithId
     */
    weight: number;
    /**
     * 
     * @type {string}
     * @memberof StorePackageTemplateItemWithId
     */
    massUnit: StorePackageTemplateItemWithIdMassUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof StorePackageTemplateItemWithId
     */
    signatureConfirmationId: string;
    /**
     * 
     * @type {ShippoCarrierSignatureConfirmation}
     * @memberof StorePackageTemplateItemWithId
     */
    signatureConfirmation: ShippoCarrierSignatureConfirmation;
    /**
     * 
     * @type {string}
     * @memberof StorePackageTemplateItemWithId
     */
    serviceLevelId: string;
    /**
     * 
     * @type {ShippoCarrierServiceLevel}
     * @memberof StorePackageTemplateItemWithId
     */
    serviceLevel: ShippoCarrierServiceLevel;
    /**
     * 
     * @type {number}
     * @memberof StorePackageTemplateItemWithId
     */
    countUsedAsDefault?: number;
    /**
     * 
     * @type {string}
     * @memberof StorePackageTemplateItemWithId
     */
    storeId?: string;
    /**
     * 
     * @type {StoreFrontItem}
     * @memberof StorePackageTemplateItemWithId
     */
    store?: StoreFrontItem;
}

/**
* @export
* @enum {string}
*/
export enum StorePackageTemplateItemWithIdTypeEnum {
    Custom = 'CUSTOM',
    Preset = 'PRESET',
    Global = 'GLOBAL',
    SellerCustom = 'SELLER_CUSTOM',
    SellerArrangeMyOwn = 'SELLER_ARRANGE_MY_OWN'
}/**
* @export
* @enum {string}
*/
export enum StorePackageTemplateItemWithIdDistanceUnitEnum {
    Cm = 'cm',
    In = 'in',
    Ft = 'ft',
    M = 'm',
    Mm = 'mm',
    Yd = 'yd'
}/**
* @export
* @enum {string}
*/
export enum StorePackageTemplateItemWithIdMassUnitEnum {
    G = 'g',
    Kg = 'kg',
    Lb = 'lb',
    Oz = 'oz'
}

/**
 * 
 * @export
 * @interface StorePackageTemplatePageRows
 */
export interface StorePackageTemplatePageRows {
    /**
     * 
     * @type {Array<StorePackageTemplateItemWithId>}
     * @memberof StorePackageTemplatePageRows
     */
    rows: Array<StorePackageTemplateItemWithId>;
}

/**
 * 
 * @export
 * @interface StorePackageTemplatesSearchResponse
 */
export interface StorePackageTemplatesSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof StorePackageTemplatesSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof StorePackageTemplatesSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {StorePackageTemplatePageRows}
     * @memberof StorePackageTemplatesSearchResponse
     */
    data: StorePackageTemplatePageRows;
}

/**
 * 
 * @export
 * @interface StorePageRows
 */
export interface StorePageRows {
    /**
     * 
     * @type {Array<StoreFrontItemWithId>}
     * @memberof StorePageRows
     */
    rows: Array<StoreFrontItemWithId>;
}

/**
 * 
 * @export
 * @interface StorePublicListingMoveToTopRequest
 */
export interface StorePublicListingMoveToTopRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof StorePublicListingMoveToTopRequest
     */
    listingIds: Array<string>;
}

/**
 * 
 * @export
 * @interface StoreReferralLinkResponse
 */
export interface StoreReferralLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof StoreReferralLinkResponse
     */
    referralLink: string;
    /**
     * 
     * @type {string}
     * @memberof StoreReferralLinkResponse
     */
    sharingUrl: string;
}

/**
 * 
 * @export
 * @interface StoreSource
 */
export interface StoreSource {
    /**
     * 
     * @type {string}
     * @memberof StoreSource
     */
    type: StoreSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreSource
     */
    storeId: string;
    /**
     * 
     * @type {string}
     * @memberof StoreSource
     */
    liveStreamId?: string;
}

/**
* @export
* @enum {string}
*/
export enum StoreSourceTypeEnum {
    Store = 'STORE'
}

/**
 * 
 * @export
 * @interface StoreTabStatsResponse
 */
export interface StoreTabStatsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof StoreTabStatsResponse
     */
    hasClips?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StoreTabStatsResponse
     */
    hasUpcomingShows?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StoreTabStatsResponse
     */
    hasLiveShows?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StoreTabStatsResponse
     */
    hasStorefrontListings?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StoreTabStatsResponse
     */
    hasLiveRecordings?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StoreTabStatsResponse
     */
    hasReviews?: boolean;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum StoreTypeEnumItem {
    Business = 'Business',
    Creator = 'Creator',
    CommentChat = 'CommentChat',
    Vfs = 'VFS'
}

/**
 * 
 * @export
 * @interface StoresSearchResponse
 */
export interface StoresSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof StoresSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof StoresSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {StorePageRows}
     * @memberof StoresSearchResponse
     */
    data: StorePageRows;
}

/**
 * 
 * @export
 * @interface StringRange
 */
export interface StringRange {
    /**
     * 
     * @type {string}
     * @memberof StringRange
     */
    gt?: string;
    /**
     * 
     * @type {string}
     * @memberof StringRange
     */
    gte?: string;
    /**
     * 
     * @type {string}
     * @memberof StringRange
     */
    lt?: string;
    /**
     * 
     * @type {string}
     * @memberof StringRange
     */
    lte?: string;
    /**
     * 
     * @type {string}
     * @memberof StringRange
     */
    equal?: string;
}

/**
 * 
 * @export
 * @interface StripePayoutMethodResponse
 */
export interface StripePayoutMethodResponse {
    /**
     * 
     * @type {string}
     * @memberof StripePayoutMethodResponse
     */
    markedAccount: string;
    /**
     * 
     * @type {string}
     * @memberof StripePayoutMethodResponse
     */
    bankName: string;
}

/**
 * 
 * @export
 * @interface StripeRefundItem
 */
export interface StripeRefundItem {
    /**
     * 
     * @type {string}
     * @memberof StripeRefundItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof StripeRefundItem
     */
    object: StripeRefundItemObjectEnum;
    /**
     * 
     * @type {number}
     * @memberof StripeRefundItem
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof StripeRefundItem
     */
    balance_transaction: string | null;
    /**
     * 
     * @type {string}
     * @memberof StripeRefundItem
     */
    charge: string | null;
    /**
     * 
     * @type {number}
     * @memberof StripeRefundItem
     */
    created: number;
    /**
     * 
     * @type {string}
     * @memberof StripeRefundItem
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof StripeRefundItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof StripeRefundItem
     */
    failure_balance_transaction?: string;
    /**
     * 
     * @type {string}
     * @memberof StripeRefundItem
     */
    failure_reason?: string;
    /**
     * 
     * @type {string}
     * @memberof StripeRefundItem
     */
    instructions_email?: string;
    /**
     * 
     * @type {string}
     * @memberof StripeRefundItem
     */
    payment_intent: string | null;
    /**
     * 
     * @type {string}
     * @memberof StripeRefundItem
     */
    reason: string | null;
    /**
     * 
     * @type {string}
     * @memberof StripeRefundItem
     */
    receipt_number: string | null;
    /**
     * 
     * @type {string}
     * @memberof StripeRefundItem
     */
    source_transfer_reversal: string;
    /**
     * 
     * @type {string}
     * @memberof StripeRefundItem
     */
    status: string | null;
}

/**
* @export
* @enum {string}
*/
export enum StripeRefundItemObjectEnum {
    Refund = 'refund'
}

/**
 * 
 * @export
 * @interface SubmitDropshipApplicationRequest
 */
export interface SubmitDropshipApplicationRequest {
    /**
     * state(in USA)
     * @type {string}
     * @memberof SubmitDropshipApplicationRequest
     */
    state: string;
    /**
     * Instagram ID(i.g. @virat.kohli)
     * @type {string}
     * @memberof SubmitDropshipApplicationRequest
     */
    instagramId: string;
}

/**
 * 
 * @export
 * @interface SubscribeToViewDto
 */
export interface SubscribeToViewDto {
    /**
     * 
     * @type {boolean}
     * @memberof SubscribeToViewDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {PopStoreExtendedSubscriptionLevelEnumItem}
     * @memberof SubscribeToViewDto
     */
    level: PopStoreExtendedSubscriptionLevelEnumItem;
}

/**
 * 
 * @export
 * @interface SubscribeToViewItem
 */
export interface SubscribeToViewItem {
    /**
     * 
     * @type {boolean}
     * @memberof SubscribeToViewItem
     */
    enabled?: boolean;
    /**
     * 
     * @type {PopStoreExtendedSubscriptionLevelEnumItem}
     * @memberof SubscribeToViewItem
     */
    level: PopStoreExtendedSubscriptionLevelEnumItem;
}

/**
 * 
 * @export
 * @interface SubscriptionAccessRequestDto
 */
export interface SubscriptionAccessRequestDto {
    /**
     * 
     * @type {PopStoreThemeTemplateAccessTypeEnumItem}
     * @memberof SubscriptionAccessRequestDto
     */
    type: PopStoreThemeTemplateAccessTypeEnumItem;
    /**
     * Subscription Access Level Id
     * @type {string}
     * @memberof SubscriptionAccessRequestDto
     */
    id: string;
    /**
     * Subscription Access Level Price
     * @type {number}
     * @memberof SubscriptionAccessRequestDto
     */
    price: number;
    /**
     * Subscription Access Level
     * @type {object}
     * @memberof SubscriptionAccessRequestDto
     */
    level: object;
}

/**
 * 
 * @export
 * @interface SubscriptionCancellationEmailPayload
 */
export interface SubscriptionCancellationEmailPayload {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionCancellationEmailPayload
     */
    eventType: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionCancellationEmailPayload
     */
    subscriptionLevel: SubscriptionCancellationEmailPayloadSubscriptionLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionCancellationEmailPayload
     */
    endAt: string;
}

/**
* @export
* @enum {string}
*/
export enum SubscriptionCancellationEmailPayloadSubscriptionLevelEnum {
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface SubscriptionCreationEmailPayload
 */
export interface SubscriptionCreationEmailPayload {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionCreationEmailPayload
     */
    eventType: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionCreationEmailPayload
     */
    subscriptionLevel: SubscriptionCreationEmailPayloadSubscriptionLevelEnum;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionCreationEmailPayload
     */
    subscriptionPrice: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionCreationEmailPayload
     */
    currency: string;
}

/**
* @export
* @enum {string}
*/
export enum SubscriptionCreationEmailPayloadSubscriptionLevelEnum {
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface SubscriptionPaymentFailureEmailPayload
 */
export interface SubscriptionPaymentFailureEmailPayload {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentFailureEmailPayload
     */
    eventType: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentFailureEmailPayload
     */
    subscriptionLevel: SubscriptionPaymentFailureEmailPayloadSubscriptionLevelEnum;
}

/**
* @export
* @enum {string}
*/
export enum SubscriptionPaymentFailureEmailPayloadSubscriptionLevelEnum {
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface SubscriptionPaymentMethod
 */
export interface SubscriptionPaymentMethod {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentMethod
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentMethod
     */
    last4digits: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentMethod
     */
    paymentMethodId: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPaymentMethod
     */
    isDefault: boolean;
    /**
     * 
     * @type {PaymentMethodAddress}
     * @memberof SubscriptionPaymentMethod
     */
    address: PaymentMethodAddress;
}

/**
 * 
 * @export
 * @interface SubscriptionPlan
 */
export interface SubscriptionPlan {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlan
     */
    priceId: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlan
     */
    productName: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlan
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlan
     */
    interval: SubscriptionPlanIntervalEnum;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlan
     */
    planType: SubscriptionPlanPlanTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlan
     */
    intervalCount: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlan
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlan
     */
    commentChatContactCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlan
     */
    modelMePhotoCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlan
     */
    discountAmount?: number;
}

/**
* @export
* @enum {string}
*/
export enum SubscriptionPlanIntervalEnum {
    Day = 'day',
    Month = 'month',
    Year = 'year'
}/**
* @export
* @enum {string}
*/
export enum SubscriptionPlanPlanTypeEnum {
    Plan = 'plan',
    CommentChatAddOn = 'commentChatAddOn',
    ModelMeAddOn = 'modelMeAddOn',
    TaxProduct = 'taxProduct'
}

/**
 * 
 * @export
 * @interface SubscriptionRenewalEmailPayload
 */
export interface SubscriptionRenewalEmailPayload {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionRenewalEmailPayload
     */
    eventType: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionRenewalEmailPayload
     */
    subscriptionLevel: SubscriptionRenewalEmailPayloadSubscriptionLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionRenewalEmailPayload
     */
    currency: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionRenewalEmailPayload
     */
    subscriptionPrice: number;
}

/**
* @export
* @enum {string}
*/
export enum SubscriptionRenewalEmailPayloadSubscriptionLevelEnum {
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface SubscriptionRenewalReminderEmailPayload
 */
export interface SubscriptionRenewalReminderEmailPayload {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionRenewalReminderEmailPayload
     */
    eventType: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionRenewalReminderEmailPayload
     */
    subscriptionLevel: SubscriptionRenewalReminderEmailPayloadSubscriptionLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionRenewalReminderEmailPayload
     */
    currency: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionRenewalReminderEmailPayload
     */
    subscriptionPrice: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionRenewalReminderEmailPayload
     */
    daysToRenewal: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionRenewalReminderEmailPayload
     */
    renewalDate: string;
}

/**
* @export
* @enum {string}
*/
export enum SubscriptionRenewalReminderEmailPayloadSubscriptionLevelEnum {
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface SubscriptionRepricingEmailPayload
 */
export interface SubscriptionRepricingEmailPayload {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionRepricingEmailPayload
     */
    eventType: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionRepricingEmailPayload
     */
    subscriptionPrice: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionRepricingEmailPayload
     */
    newSubscriptionPrice: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionRepricingEmailPayload
     */
    billingPeriod: string;
}

/**
 * 
 * @export
 * @interface SubscriptionUpgradeEmailPayload
 */
export interface SubscriptionUpgradeEmailPayload {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUpgradeEmailPayload
     */
    eventType: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUpgradeEmailPayload
     */
    subscriptionLevel: SubscriptionUpgradeEmailPayloadSubscriptionLevelEnum;
}

/**
* @export
* @enum {string}
*/
export enum SubscriptionUpgradeEmailPayloadSubscriptionLevelEnum {
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface SwitchShowEventRequest
 */
export interface SwitchShowEventRequest {
    /**
     * 
     * @type {string}
     * @memberof SwitchShowEventRequest
     */
    showEventId?: string;
}

/**
 * 
 * @export
 * @interface SwitchUpcomingShowRequest
 */
export interface SwitchUpcomingShowRequest {
    /**
     * 
     * @type {string}
     * @memberof SwitchUpcomingShowRequest
     */
    upcomingShowId: string;
}

/**
 * 
 * @export
 * @interface TaxCalculationAddress
 */
export interface TaxCalculationAddress {
    /**
     * 
     * @type {string}
     * @memberof TaxCalculationAddress
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof TaxCalculationAddress
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof TaxCalculationAddress
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof TaxCalculationAddress
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof TaxCalculationAddress
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof TaxCalculationAddress
     */
    zipCode: string;
}

/**
 * 
 * @export
 * @interface ThemeItem
 */
export interface ThemeItem {
    /**
     * 
     * @type {string}
     * @memberof ThemeItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeItem
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeItem
     */
    id: string;
    /**
     * Theme name
     * @type {string}
     * @memberof ThemeItem
     */
    name: string;
    /**
     * Theme style (e.g., "dark", "light", etc.)
     * @type {string}
     * @memberof ThemeItem
     */
    style: string;
    /**
     * Theme type
     * @type {object}
     * @memberof ThemeItem
     */
    type: object;
    /**
     * Thumbnail URL of the theme
     * @type {string}
     * @memberof ThemeItem
     */
    thumbnailUrl?: string;
    /**
     * Theme description
     * @type {string}
     * @memberof ThemeItem
     */
    createdByUserId?: string;
    /**
     * Created by user profile
     * @type {BasicProfileDto}
     * @memberof ThemeItem
     */
    createdByProfile?: BasicProfileDto;
    /**
     * Subscription level required for using this theme
     * @type {object}
     * @memberof ThemeItem
     */
    subscriptionLevel: object;
    /**
     * 
     * @type {string}
     * @memberof ThemeItem
     */
    theme: string;
    /**
     * Privacy flag
     * @type {boolean}
     * @memberof ThemeItem
     */
    privacy: boolean;
    /**
     * Moderation Status
     * @type {string}
     * @memberof ThemeItem
     */
    moderationStatus: string;
    /**
     * Moderator User Id
     * @type {string}
     * @memberof ThemeItem
     */
    moderatorUserId: string;
    /**
     * Moderation date
     * @type {object}
     * @memberof ThemeItem
     */
    moderatedAt?: object;
    /**
     * Moderator Profile
     * @type {object}
     * @memberof ThemeItem
     */
    moderatorProfile?: object;
}

/**
 * 
 * @export
 * @interface ThemeTemplateSubscriptionLevelResponse
 */
export interface ThemeTemplateSubscriptionLevelResponse {
    /**
     * 
     * @type {PopStoreThemeTemplateAccessTypeEnumItem}
     * @memberof ThemeTemplateSubscriptionLevelResponse
     */
    type: PopStoreThemeTemplateAccessTypeEnumItem;
    /**
     * Subscription Access Level Id
     * @type {string}
     * @memberof ThemeTemplateSubscriptionLevelResponse
     */
    id: string;
    /**
     * Subscription Access Level Price
     * @type {number}
     * @memberof ThemeTemplateSubscriptionLevelResponse
     */
    price: number;
    /**
     * Subscription Access Level
     * @type {object}
     * @memberof ThemeTemplateSubscriptionLevelResponse
     */
    level: object;
}

/**
 * 
 * @export
 * @interface ThemeTemplateTypesResponse
 */
export interface ThemeTemplateTypesResponse {
    /**
     * Unique identifier
     * @type {string}
     * @memberof ThemeTemplateTypesResponse
     */
    id: string;
    /**
     * Internal type slug (identifier)
     * @type {string}
     * @memberof ThemeTemplateTypesResponse
     */
    slug: string;
    /**
     * Human-readable type label
     * @type {string}
     * @memberof ThemeTemplateTypesResponse
     */
    value: string;
}

/**
 * 
 * @export
 * @interface ThemeTemplatesSearchResponse
 */
export interface ThemeTemplatesSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof ThemeTemplatesSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof ThemeTemplatesSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {ThemesPageRows}
     * @memberof ThemeTemplatesSearchResponse
     */
    data: ThemesPageRows;
}

/**
 * 
 * @export
 * @interface ThemesPageRows
 */
export interface ThemesPageRows {
    /**
     * 
     * @type {Array<ThemeItem>}
     * @memberof ThemesPageRows
     */
    rows: Array<ThemeItem>;
}

/**
 * 
 * @export
 * @interface TicketOrderAddressRequest
 */
export interface TicketOrderAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof TicketOrderAddressRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof TicketOrderAddressRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof TicketOrderAddressRequest
     */
    primaryPhone: string;
    /**
     * 
     * @type {string}
     * @memberof TicketOrderAddressRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof TicketOrderAddressRequest
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof TicketOrderAddressRequest
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof TicketOrderAddressRequest
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof TicketOrderAddressRequest
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof TicketOrderAddressRequest
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof TicketOrderAddressRequest
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof TicketOrderAddressRequest
     */
    compareHash?: string;
}

/**
 * 
 * @export
 * @interface TipToViewDto
 */
export interface TipToViewDto {
    /**
     * 
     * @type {boolean}
     * @memberof TipToViewDto
     */
    enabled?: boolean;
}

/**
 * 
 * @export
 * @interface TipToViewItem
 */
export interface TipToViewItem {
    /**
     * 
     * @type {boolean}
     * @memberof TipToViewItem
     */
    enabled?: boolean;
}

/**
 * 
 * @export
 * @interface TippingAmountDto
 */
export interface TippingAmountDto {
    /**
     * 
     * @type {number}
     * @memberof TippingAmountDto
     */
    amount: number;
    /**
     * currently only USD is supported
     * @type {string}
     * @memberof TippingAmountDto
     */
    currency: string;
}

/**
 * 
 * @export
 * @interface TippingAmountItem
 */
export interface TippingAmountItem {
    /**
     * 
     * @type {number}
     * @memberof TippingAmountItem
     */
    amount: number;
    /**
     * currently only USD is supported
     * @type {string}
     * @memberof TippingAmountItem
     */
    currency: string;
}

/**
 * 
 * @export
 * @interface TippingDto
 */
export interface TippingDto {
    /**
     * 
     * @type {number}
     * @memberof TippingDto
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof TippingDto
     */
    currency: string;
    /**
     * 
     * @type {ListingDerivedFromTipToSellerDto | ListingDerivedFromTipToPostDto}
     * @memberof TippingDto
     */
    to: ListingDerivedFromTipToSellerDto | ListingDerivedFromTipToPostDto;
}

/**
 * 
 * @export
 * @interface TippingOrderLiveStreamSource
 */
export interface TippingOrderLiveStreamSource {
    /**
     * 
     * @type {string}
     * @memberof TippingOrderLiveStreamSource
     */
    type: TippingOrderLiveStreamSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TippingOrderLiveStreamSource
     */
    liveStreamId: string;
}

/**
* @export
* @enum {string}
*/
export enum TippingOrderLiveStreamSourceTypeEnum {
    LiveStream = 'liveStream'
}

/**
 * 
 * @export
 * @interface TippingOrderUpcomingShowSource
 */
export interface TippingOrderUpcomingShowSource {
    /**
     * 
     * @type {string}
     * @memberof TippingOrderUpcomingShowSource
     */
    type: TippingOrderUpcomingShowSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TippingOrderUpcomingShowSource
     */
    upcomingShowId: string;
}

/**
* @export
* @enum {string}
*/
export enum TippingOrderUpcomingShowSourceTypeEnum {
    UpcomingShow = 'upcomingShow'
}

/**
 * 
 * @export
 * @interface ToggleHiddenPostRequest
 */
export interface ToggleHiddenPostRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ToggleHiddenPostRequest
     */
    hidden: boolean;
}

/**
 * 
 * @export
 * @interface TokenResponse
 */
export interface TokenResponse {
    /**
     * 
     * @type {string}
     * @memberof TokenResponse
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof TokenResponse
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof TokenResponse
     */
    channel: string;
}

/**
 * 
 * @export
 * @interface TokensResponse
 */
export interface TokensResponse {
    /**
     * 
     * @type {TokenResponse}
     * @memberof TokensResponse
     */
    rtc: TokenResponse;
    /**
     * 
     * @type {TokenResponse}
     * @memberof TokensResponse
     */
    rtmComments: TokenResponse;
    /**
     * 
     * @type {TokenResponse}
     * @memberof TokensResponse
     */
    rtmCommentUpvotes: TokenResponse;
    /**
     * 
     * @type {TokenResponse}
     * @memberof TokensResponse
     */
    rtmLightningBolts: TokenResponse;
}

/**
 * 
 * @export
 * @interface TopCategoryRowsResponse
 */
export interface TopCategoryRowsResponse {
    /**
     * 
     * @type {Array<CategoryRowItem>}
     * @memberof TopCategoryRowsResponse
     */
    topRows: Array<CategoryRowItem>;
    /**
     * 
     * @type {Array<CategoryRowItem>}
     * @memberof TopCategoryRowsResponse
     */
    restOfRows: Array<CategoryRowItem>;
}

/**
 * 
 * @export
 * @interface TopProductsSource
 */
export interface TopProductsSource {
    /**
     * 
     * @type {string}
     * @memberof TopProductsSource
     */
    type: TopProductsSourceTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum TopProductsSourceTypeEnum {
    TopProducts = 'TOP_PRODUCTS'
}

/**
 * 
 * @export
 * @interface TopReviewItem
 */
export interface TopReviewItem {
    /**
     * 
     * @type {string}
     * @memberof TopReviewItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TopReviewItem
     */
    userIdFrom: string;
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof TopReviewItem
     */
    userProfileFrom: BaseProfileItem;
    /**
     * 
     * @type {string}
     * @memberof TopReviewItem
     */
    userIdTo: string;
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof TopReviewItem
     */
    userProfileTo: BaseProfileItem;
    /**
     * 
     * @type {string}
     * @memberof TopReviewItem
     */
    videoURL: string;
    /**
     * 
     * @type {string}
     * @memberof TopReviewItem
     */
    originalVideoURL?: string;
    /**
     * 
     * @type {string}
     * @memberof TopReviewItem
     */
    gifURL: string;
    /**
     * 
     * @type {string}
     * @memberof TopReviewItem
     */
    thumbnailURL?: string;
    /**
     * 
     * @type {string}
     * @memberof TopReviewItem
     */
    emoji: TopReviewItemEmojiEnum;
    /**
     * 
     * @type {number}
     * @memberof TopReviewItem
     */
    upvoteCount: number;
    /**
     * 
     * @type {string}
     * @memberof TopReviewItem
     */
    listingDefaultImage?: string;
    /**
     * 
     * @type {string}
     * @memberof TopReviewItem
     */
    listingId?: string;
    /**
     * 
     * @type {TopReviewListingItem}
     * @memberof TopReviewItem
     */
    listingSnapshot?: TopReviewListingItem;
}

/**
* @export
* @enum {string}
*/
export enum TopReviewItemEmojiEnum {
    RollingEyesFace = 'rolling_eyes_face',
    Sweat = 'sweat',
    Blush = 'blush',
    Smile = 'smile',
    HeartEyes = 'heart_eyes'
}

/**
 * 
 * @export
 * @interface TopReviewListingItem
 */
export interface TopReviewListingItem {
    /**
     * 
     * @type {string}
     * @memberof TopReviewListingItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TopReviewListingItem
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof TopReviewListingItem
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof TopReviewListingItem
     */
    discountPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof TopReviewListingItem
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof TopReviewListingItem
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof TopReviewListingItem
     */
    defaultImage: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TopReviewListingItem
     */
    extraImages?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof TopReviewListingItem
     */
    quantity: number;
    /**
     * 
     * @type {Array<TopReviewStoreListingVariant>}
     * @memberof TopReviewListingItem
     */
    variants?: Array<TopReviewStoreListingVariant>;
    /**
     * 
     * @type {number}
     * @memberof TopReviewListingItem
     */
    maximumPurchaseQuantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TopReviewListingItem
     */
    shippingFee?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TopReviewListingItem
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TopReviewListingItem
     */
    status?: TopReviewListingItemStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof TopReviewListingItem
     */
    maximumPurchaseQuantityPerLiveStream?: number;
    /**
     * 
     * @type {StoreListingOriginalInfo}
     * @memberof TopReviewListingItem
     */
    originalInfo?: StoreListingOriginalInfo;
    /**
     * 
     * @type {DimsInfo}
     * @memberof TopReviewListingItem
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {SingleUnitWeightInfo | PoundWithOunceWeightInfo}
     * @memberof TopReviewListingItem
     */
    weight?: SingleUnitWeightInfo | PoundWithOunceWeightInfo;
    /**
     * 
     * @type {string}
     * @memberof TopReviewListingItem
     */
    taxCode?: string;
    /**
     * 
     * @type {number}
     * @memberof TopReviewListingItem
     */
    soldQuantityLast7Days?: number;
    /**
     * 
     * @type {string}
     * @memberof TopReviewListingItem
     */
    storeFrontName?: string;
    /**
     * 
     * @type {string}
     * @memberof TopReviewListingItem
     */
    storeCoverImage?: string;
}

/**
* @export
* @enum {string}
*/
export enum TopReviewListingItemStatusEnum {
    Active = 'active',
    Archived = 'archived'
}

/**
 * 
 * @export
 * @interface TopReviewStoreListingVariant
 */
export interface TopReviewStoreListingVariant {
    /**
     * 
     * @type {string}
     * @memberof TopReviewStoreListingVariant
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TopReviewStoreListingVariant
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof TopReviewStoreListingVariant
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof TopReviewStoreListingVariant
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof TopReviewStoreListingVariant
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof TopReviewStoreListingVariant
     */
    discountPrice?: number;
    /**
     * 
     * @type {StoreListingVariantOriginalInfo}
     * @memberof TopReviewStoreListingVariant
     */
    originalInfo?: StoreListingVariantOriginalInfo;
    /**
     * 
     * @type {DimsInfo}
     * @memberof TopReviewStoreListingVariant
     */
    dims?: DimsInfo;
    /**
     * 
     * @type {SingleUnitWeightInfo | PoundWithOunceWeightInfo}
     * @memberof TopReviewStoreListingVariant
     */
    weight?: SingleUnitWeightInfo | PoundWithOunceWeightInfo;
}

/**
 * 
 * @export
 * @interface TopReviewsResponse
 */
export interface TopReviewsResponse {
    /**
     * 
     * @type {Array<TopReviewItem>}
     * @memberof TopReviewsResponse
     */
    data: Array<TopReviewItem>;
}

/**
 * 
 * @export
 * @interface TrackEventRequest
 */
export interface TrackEventRequest {
    /**
     * 
     * @type {string}
     * @memberof TrackEventRequest
     */
    messageId: string;
    /**
     * event name
     * @type {string}
     * @memberof TrackEventRequest
     */
    event: string;
    /**
     * 
     * @type {string}
     * @memberof TrackEventRequest
     */
    type: string;
    /**
     * event ISO8601 timestamp triggered by user
     * @type {string}
     * @memberof TrackEventRequest
     */
    timestamp: string;
    /**
     * event ISO8601 timestamp sent to backend
     * @type {string}
     * @memberof TrackEventRequest
     */
    sentAt?: string;
    /**
     * ID to identify the anonymous user
     * @type {string}
     * @memberof TrackEventRequest
     */
    anonymousId: string;
    /**
     * ID to identify the logged user
     * @type {string}
     * @memberof TrackEventRequest
     */
    userId?: string;
    /**
     * context
     * @type {{ [key: string]: string | number | boolean | object; }}
     * @memberof TrackEventRequest
     */
    context?: { [key: string]: string | number | boolean | object; };
    /**
     * properties
     * @type {{ [key: string]: string | number | boolean | object; }}
     * @memberof TrackEventRequest
     */
    properties?: { [key: string]: string | number | boolean | object; };
    /**
     * traits
     * @type {{ [key: string]: string | number | boolean | object; }}
     * @memberof TrackEventRequest
     */
    traits?: { [key: string]: string | number | boolean | object; };
    /**
     * integrations
     * @type {{ [key: string]: string | number | boolean | object; }}
     * @memberof TrackEventRequest
     */
    integrations?: { [key: string]: string | number | boolean | object; };
}

/**
 * 
 * @export
 * @interface TwoWayStreamSource
 */
export interface TwoWayStreamSource {
    /**
     * 
     * @type {string}
     * @memberof TwoWayStreamSource
     */
    type: TwoWayStreamSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TwoWayStreamSource
     */
    liveStreamId: string;
}

/**
* @export
* @enum {string}
*/
export enum TwoWayStreamSourceTypeEnum {
    TwoWayStream = 'TWO_WAY_STREAM'
}

/**
 * 
 * @export
 * @interface UnBlockAccessSourceResponse
 */
export interface UnBlockAccessSourceResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UnBlockAccessSourceResponse
     */
    result: boolean;
}

/**
 * 
 * @export
 * @interface UndoUpvoteFeedRequest
 */
export interface UndoUpvoteFeedRequest {
    /**
     * 
     * @type {string}
     * @memberof UndoUpvoteFeedRequest
     */
    type: UndoUpvoteFeedRequestTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum UndoUpvoteFeedRequestTypeEnum {
    Live = 'LIVE',
    Replay = 'REPLAY',
    Preview = 'PREVIEW',
    Review = 'REVIEW',
    PopClip = 'POP_CLIP'
}

/**
 * 
 * @export
 * @interface UndoUpvoteFeedResponse
 */
export interface UndoUpvoteFeedResponse {
    /**
     * 
     * @type {number}
     * @memberof UndoUpvoteFeedResponse
     */
    upvoteCount: number;
}

/**
 * 
 * @export
 * @interface UnlinkSignInProvidersRequest
 */
export interface UnlinkSignInProvidersRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UnlinkSignInProvidersRequest
     */
    providers: Array<UnlinkSignInProvidersRequestProvidersEnum>;
}

/**
* @export
* @enum {string}
*/
export enum UnlinkSignInProvidersRequestProvidersEnum {
    AppleCom = 'apple.com',
    Phone = 'phone',
    Password = 'password',
    FacebookCom = 'facebook.com'
}

/**
 * 
 * @export
 * @interface UnupvoteReviewMessageResponse
 */
export interface UnupvoteReviewMessageResponse {
    /**
     * 
     * @type {number}
     * @memberof UnupvoteReviewMessageResponse
     */
    upvoteCount: number;
}

/**
 * 
 * @export
 * @interface UpcomingShowCloseSendItemRequest
 */
export interface UpcomingShowCloseSendItemRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpcomingShowCloseSendItemRequest
     */
    noNeedNotification?: boolean;
}

/**
 * 
 * @export
 * @interface UpcomingShowCreateGiveawayItemRequest
 */
export interface UpcomingShowCreateGiveawayItemRequest {
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowCreateGiveawayItemRequest
     */
    listingId: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowCreateGiveawayItemRequest
     */
    variantId?: string;
    /**
     * 
     * @type {number}
     * @memberof UpcomingShowCreateGiveawayItemRequest
     */
    quantity?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpcomingShowCreateGiveawayItemRequest
     */
    prerequisites?: Array<UpcomingShowCreateGiveawayItemRequestPrerequisitesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpcomingShowCreateGiveawayItemRequest
     */
    criteria?: Array<UpcomingShowCreateGiveawayItemRequestCriteriaEnum>;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowCreateGiveawayItemRequest
     */
    title: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpcomingShowCreateGiveawayItemRequest
     */
    coverImages: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowCreateGiveawayItemRequest
     */
    description?: string;
}

/**
* @export
* @enum {string}
*/
export enum UpcomingShowCreateGiveawayItemRequestPrerequisitesEnum {
    CommentToEnter = 'CommentToEnter',
    ShareToEnter = 'ShareToEnter'
}/**
* @export
* @enum {string}
*/
export enum UpcomingShowCreateGiveawayItemRequestCriteriaEnum {
    CommentToEnter = 'CommentToEnter',
    ShareToEnter = 'ShareToEnter'
}

/**
 * 
 * @export
 * @interface UpcomingShowCreateGiveawayItemResponse
 */
export interface UpcomingShowCreateGiveawayItemResponse {
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowCreateGiveawayItemResponse
     */
    id: string;
}

/**
 * 
 * @export
 * @interface UpcomingShowCreateGiveawayWinnerRequest
 */
export interface UpcomingShowCreateGiveawayWinnerRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpcomingShowCreateGiveawayWinnerRequest
     */
    winnerIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpcomingShowCreateGiveawayWinnerRequest
     */
    needShippingFee: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpcomingShowCreateGiveawayWinnerRequest
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof UpcomingShowCreateGiveawayWinnerRequest
     */
    price?: number;
}

/**
 * 
 * @export
 * @interface UpcomingShowFeedItem
 */
export interface UpcomingShowFeedItem {
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowFeedItem
     */
    upcomingShowId: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowFeedItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowFeedItem
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowFeedItem
     */
    originalCoverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowFeedItem
     */
    previewVideoURL: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowFeedItem
     */
    startsAt: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowFeedItem
     */
    permission?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpcomingShowFeedItem
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowFeedItem
     */
    liveStreamId?: string;
}

/**
 * 
 * @export
 * @interface UpcomingShowGenerateTokenRequest
 */
export interface UpcomingShowGenerateTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowGenerateTokenRequest
     */
    deviceId: string;
}

/**
 * 
 * @export
 * @interface UpcomingShowItem
 */
export interface UpcomingShowItem {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpcomingShowItem
     */
    badges: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowItem
     */
    title: string;
    /**
     * 
     * @type {BaseProfileItem}
     * @memberof UpcomingShowItem
     */
    user: BaseProfileItem;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowItem
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowItem
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowItem
     */
    originalCoverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowItem
     */
    previewVideoURL: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowItem
     */
    shareVideo?: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowItem
     */
    startsAt: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowItem
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowItem
     */
    createdAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpcomingShowItem
     */
    available: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowItem
     */
    visibility?: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowItem
     */
    permission?: UpcomingShowItemPermissionEnum;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowItem
     */
    eventId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpcomingShowItem
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowItem
     */
    eventTemplateId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpcomingShowItem
     */
    disableComments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpcomingShowItem
     */
    notificationSent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowItem
     */
    liveStreamId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpcomingShowItem
     */
    historyLiveStreamIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowItem
     */
    transcodeStatus?: UpcomingShowItemTranscodeStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowItem
     */
    accessLevel?: UpcomingShowItemAccessLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowItem
     */
    id: string;
}

/**
* @export
* @enum {string}
*/
export enum UpcomingShowItemPermissionEnum {
    All = 'all',
    Follower = 'follower',
    Subscriber = 'subscriber',
    NoOne = 'no-one'
}/**
* @export
* @enum {string}
*/
export enum UpcomingShowItemTranscodeStatusEnum {
    Initial = 'initial',
    Processing = 'processing',
    TranscodeOriginal = 'transcode-original',
    TranscodeOriginalShare = 'transcode-original-share',
    RequestRetranscode = 'request-retranscode'
}/**
* @export
* @enum {string}
*/
export enum UpcomingShowItemAccessLevelEnum {
    All = 'all',
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface UpcomingShowPageRows
 */
export interface UpcomingShowPageRows {
    /**
     * 
     * @type {Array<SearchUpcomingShowItem>}
     * @memberof UpcomingShowPageRows
     */
    rows: Array<SearchUpcomingShowItem>;
}

/**
 * 
 * @export
 * @interface UpcomingShowResponse
 */
export interface UpcomingShowResponse {
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpcomingShowResponse
     */
    badges: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    title: string;
    /**
     * 
     * @type {object}
     * @memberof UpcomingShowResponse
     */
    user: object;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    originalCoverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    previewVideoURL: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    shareVideo?: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    startsAt: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    createdAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpcomingShowResponse
     */
    available: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    visibility?: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    permission?: UpcomingShowResponsePermissionEnum;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    eventId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpcomingShowResponse
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    eventTemplateId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpcomingShowResponse
     */
    disableComments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpcomingShowResponse
     */
    notificationSent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    liveStreamId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpcomingShowResponse
     */
    historyLiveStreamIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    transcodeStatus?: UpcomingShowResponseTranscodeStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowResponse
     */
    accessLevel?: UpcomingShowResponseAccessLevelEnum;
}

/**
* @export
* @enum {string}
*/
export enum UpcomingShowResponsePermissionEnum {
    All = 'all',
    Follower = 'follower',
    Subscriber = 'subscriber',
    NoOne = 'no-one'
}/**
* @export
* @enum {string}
*/
export enum UpcomingShowResponseTranscodeStatusEnum {
    Initial = 'initial',
    Processing = 'processing',
    TranscodeOriginal = 'transcode-original',
    TranscodeOriginalShare = 'transcode-original-share',
    RequestRetranscode = 'request-retranscode'
}/**
* @export
* @enum {string}
*/
export enum UpcomingShowResponseAccessLevelEnum {
    All = 'all',
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface UpcomingShowSearchResponse
 */
export interface UpcomingShowSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof UpcomingShowSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof UpcomingShowSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {UpcomingShowPageRows}
     * @memberof UpcomingShowSearchResponse
     */
    data: UpcomingShowPageRows;
}

/**
 * 
 * @export
 * @interface UpcomingShowSendItemSourceSource
 */
export interface UpcomingShowSendItemSourceSource {
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowSendItemSourceSource
     */
    type: UpcomingShowSendItemSourceSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowSendItemSourceSource
     */
    upcomingShowId: string;
}

/**
* @export
* @enum {string}
*/
export enum UpcomingShowSendItemSourceSourceTypeEnum {
    UpcomingShow = 'upcomingShow'
}

/**
 * 
 * @export
 * @interface UpcomingShowSource
 */
export interface UpcomingShowSource {
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowSource
     */
    type: UpcomingShowSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowSource
     */
    upcomingShowId: string;
}

/**
* @export
* @enum {string}
*/
export enum UpcomingShowSourceTypeEnum {
    UpcomingShow = 'UPCOMING_SHOW'
}

/**
 * 
 * @export
 * @interface UpcomingShowTokenResponse
 */
export interface UpcomingShowTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowTokenResponse
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowTokenResponse
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowTokenResponse
     */
    channel: string;
}

/**
 * 
 * @export
 * @interface UpcomingShowTokensResponse
 */
export interface UpcomingShowTokensResponse {
    /**
     * 
     * @type {UpcomingShowTokenResponse}
     * @memberof UpcomingShowTokensResponse
     */
    rtmComments: UpcomingShowTokenResponse;
    /**
     * 
     * @type {UpcomingShowTokenResponse}
     * @memberof UpcomingShowTokensResponse
     */
    rtmCommentUpvotes: UpcomingShowTokenResponse;
    /**
     * 
     * @type {UpcomingShowTokenResponse}
     * @memberof UpcomingShowTokensResponse
     */
    rtmLightningBolts: UpcomingShowTokenResponse;
}

/**
 * 
 * @export
 * @interface UpcomingShowsWatcherItem
 */
export interface UpcomingShowsWatcherItem {
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowsWatcherItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingShowsWatcherItem
     */
    createdAt?: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof UpcomingShowsWatcherItem
     */
    user: ProfileItem;
    /**
     * 
     * @type {Metadata}
     * @memberof UpcomingShowsWatcherItem
     */
    metadata: Metadata;
}

/**
 * 
 * @export
 * @interface UpcomingShowsWatcherPageRows
 */
export interface UpcomingShowsWatcherPageRows {
    /**
     * 
     * @type {Array<UpcomingShowsWatcherItem>}
     * @memberof UpcomingShowsWatcherPageRows
     */
    rows: Array<UpcomingShowsWatcherItem>;
}

/**
 * 
 * @export
 * @interface UpcomingShowsWatchersSearchResponse
 */
export interface UpcomingShowsWatchersSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof UpcomingShowsWatchersSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof UpcomingShowsWatchersSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {UpcomingShowsWatcherPageRows}
     * @memberof UpcomingShowsWatchersSearchResponse
     */
    data: UpcomingShowsWatcherPageRows;
}

/**
 * 
 * @export
 * @interface UpdateAddressResponse
 */
export interface UpdateAddressResponse {
    /**
     * 
     * @type {AddressItem}
     * @memberof UpdateAddressResponse
     */
    address?: AddressItem;
}

/**
 * 
 * @export
 * @interface UpdateAgencyDto
 */
export interface UpdateAgencyDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateAgencyDto
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgencyDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgencyDto
     */
    email: string;
    /**
     * 
     * @type {AgencyAddressDto}
     * @memberof UpdateAgencyDto
     */
    address: AgencyAddressDto;
}

/**
 * 
 * @export
 * @interface UpdateAgencyUserDto
 */
export interface UpdateAgencyUserDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateAgencyUserDto
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgencyUserDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgencyUserDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgencyUserDto
     */
    role: UpdateAgencyUserDtoRoleEnum;
}

/**
* @export
* @enum {string}
*/
export enum UpdateAgencyUserDtoRoleEnum {
    Admin = 'agency-admin',
    User = 'agency-user'
}

/**
 * 
 * @export
 * @interface UpdateAgencyUserPasswordRequest
 */
export interface UpdateAgencyUserPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAgencyUserPasswordRequest
     */
    password: string;
}

/**
 * 
 * @export
 * @interface UpdateAppSellerApplicationStatusBody
 */
export interface UpdateAppSellerApplicationStatusBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateAppSellerApplicationStatusBody
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAppSellerApplicationStatusBody
     */
    rejectedReason?: string;
}

/**
 * 
 * @export
 * @interface UpdateBlockUserCommentRequest
 */
export interface UpdateBlockUserCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateBlockUserCommentRequest
     */
    reason: UpdateBlockUserCommentRequestReasonEnum;
}

/**
* @export
* @enum {string}
*/
export enum UpdateBlockUserCommentRequestReasonEnum {
    Spam = 'spam',
    Inappropriate = 'inappropriate',
    Aggressive = 'aggressive'
}

/**
 * 
 * @export
 * @interface UpdateBuyerAddressRequest
 */
export interface UpdateBuyerAddressRequest {
    /**
     * 
     * @type {AddressRequest}
     * @memberof UpdateBuyerAddressRequest
     */
    address?: AddressRequest;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBuyerAddressRequest
     */
    deleteThis?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateBuyerAddressRequest
     */
    pos?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBuyerAddressRequest
     */
    asDefault?: boolean;
}

/**
 * 
 * @export
 * @interface UpdateCategoryRequest
 */
export interface UpdateCategoryRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateCategoryRequest
     */
    categoryIds: Array<string>;
}

/**
 * 
 * @export
 * @interface UpdateConfigResponse
 */
export interface UpdateConfigResponse {
    /**
     * 
     * @type {object}
     * @memberof UpdateConfigResponse
     */
    config: object;
}

/**
 * 
 * @export
 * @interface UpdateFeaturesRequest
 */
export interface UpdateFeaturesRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    storeReelPopupOnProfile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    storeReplayPopupOnProfile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    enableThemeCreator?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    commentchat?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    modelMe?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    pickup?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    unlimitedStoreFavorites?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    shopifyOrderSync?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    nftGatedShows?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateFeaturesRequest
     */
    nftContracts?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    patreonGatedShows?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateFeaturesRequest
     */
    patreonIdentifier?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    customersTab?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    shopifyOrderSyncWithPSPrefix?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    shopifyListingSyncWithoutSKU?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    streaming?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    voidLabel?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    customBadge?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateFeaturesRequest
     */
    customBadgeLimit?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    shippoPlatform?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    tipping?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    captureGroup?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    commentSoldTax?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    stripeConnect?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    dropshipUI?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    cloudRecording?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    preferReplaysHiddenInApp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    commentchatOtherLinkType?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    isCommentchatOnboardingOptional?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    orders?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    storefrontUI?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesRequest
     */
    onBehalfOfChargeModeEnabled?: boolean;
}

/**
 * 
 * @export
 * @interface UpdateMyFeaturesRequest
 */
export interface UpdateMyFeaturesRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMyFeaturesRequest
     */
    storeReelPopupOnProfile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMyFeaturesRequest
     */
    storeReplayPopupOnProfile?: boolean;
}

/**
 * 
 * @export
 * @interface UpdateNftFakerRequest
 */
export interface UpdateNftFakerRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateNftFakerRequest
     */
    asAddress: string;
}

/**
 * 
 * @export
 * @interface UpdateOnboardingPushRequest
 */
export interface UpdateOnboardingPushRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingPushRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingPushRequest
     */
    summary: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingPushRequest
     */
    subtitle: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingPushRequest
     */
    subjectLine: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingPushRequest
     */
    editor: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingPushRequest
     */
    embedCode: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingPushRequest
     */
    contentType: UpdateOnboardingPushRequestContentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingPushRequest
     */
    cover?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingPushRequest
     */
    videoUrl?: string;
    /**
     * 
     * @type {VideoSizeRequest}
     * @memberof UpdateOnboardingPushRequest
     */
    videoSize?: VideoSizeRequest;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOnboardingPushRequest
     */
    appearOnAllScreens?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateOnboardingPushRequest
     */
    appearOnSpecificPages?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateOnboardingPushRequest
     */
    visibleTo: Array<UpdateOnboardingPushRequestVisibleToEnum>;
    /**
     * 
     * @type {number}
     * @memberof UpdateOnboardingPushRequest
     */
    buttonDelayInSeconds: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingPushRequest
     */
    startTime: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOnboardingPushRequest
     */
    disabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOnboardingPushRequest
     */
    published: boolean;
    /**
     * 
     * @type {OnboardingPushCtaRequest}
     * @memberof UpdateOnboardingPushRequest
     */
    cta?: OnboardingPushCtaRequest;
    /**
     * 
     * @type {OnboardingPushNotificationRequest}
     * @memberof UpdateOnboardingPushRequest
     */
    notification?: OnboardingPushNotificationRequest;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateOnboardingPushRequest
     */
    sellerIds?: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum UpdateOnboardingPushRequestContentTypeEnum {
    Video = 'video',
    RichText = 'richText'
}/**
* @export
* @enum {string}
*/
export enum UpdateOnboardingPushRequestVisibleToEnum {
    Business = 'Business',
    Creator = 'Creator',
    CommentChat = 'CommentChat',
    Vfs = 'VFS'
}

/**
 * 
 * @export
 * @interface UpdateOrderByCommissionFeeRateRequest
 */
export interface UpdateOrderByCommissionFeeRateRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateOrderByCommissionFeeRateRequest
     */
    commissionFeeRate: number;
}

/**
 * 
 * @export
 * @interface UpdateOrderDenyRequest
 */
export interface UpdateOrderDenyRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateOrderDenyRequest
     */
    sellerIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDenyRequest
     */
    reason: UpdateOrderDenyRequestReasonEnum;
}

/**
* @export
* @enum {string}
*/
export enum UpdateOrderDenyRequestReasonEnum {
    Fraud = 'fraud',
    Chargebacks = 'chargebacks',
    MultipleAccounts = 'multipleAccounts',
    InappropriateBehavior = 'inappropriateBehavior'
}

/**
 * 
 * @export
 * @interface UpdateOrderPackedStatusDto
 */
export interface UpdateOrderPackedStatusDto {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrderPackedStatusDto
     */
    packed: boolean;
}

/**
 * 
 * @export
 * @interface UpdateOrderPickupStatusDto
 */
export interface UpdateOrderPickupStatusDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderPickupStatusDto
     */
    pickupStatus: UpdateOrderPickupStatusDtoPickupStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateOrderPickupStatusDto
     */
    cancelingOrderIds?: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum UpdateOrderPickupStatusDtoPickupStatusEnum {
    New = 'new',
    Processing = 'processing',
    Packed = 'packed',
    Pending = 'pending',
    Completed = 'completed'
}

/**
 * 
 * @export
 * @interface UpdateOrderTrackingInfoDto
 */
export interface UpdateOrderTrackingInfoDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderTrackingInfoDto
     */
    trackingInfo: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderTrackingInfoDto
     */
    trackingURL?: string;
}

/**
 * 
 * @export
 * @interface UpdatePackageTemplateRequest
 */
export interface UpdatePackageTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePackageTemplateRequest
     */
    packageTemplateId: string;
}

/**
 * 
 * @export
 * @interface UpdatePaymentMethodProviderRequest
 */
export interface UpdatePaymentMethodProviderRequest {
    /**
     * 
     * @type {BillingAddressDto}
     * @memberof UpdatePaymentMethodProviderRequest
     */
    billingAddress: BillingAddressDto;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentMethodProviderRequest
     */
    stripeToken?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentMethodProviderRequest
     */
    nonce?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentMethodProviderRequest
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentMethodProviderRequest
     */
    isSubscriptionPayment?: boolean;
}

/**
 * 
 * @export
 * @interface UpdatePopStoreThemeTemplateRequest
 */
export interface UpdatePopStoreThemeTemplateRequest {
    /**
     * Theme name
     * @type {string}
     * @memberof UpdatePopStoreThemeTemplateRequest
     */
    name: string;
    /**
     * 
     * @type {PopStoreThemeTemplateStyleEnumItem}
     * @memberof UpdatePopStoreThemeTemplateRequest
     */
    style: PopStoreThemeTemplateStyleEnumItem;
    /**
     * Theme type
     * @type {PopStoreThemeTemplateTypeRequestDto}
     * @memberof UpdatePopStoreThemeTemplateRequest
     */
    type: PopStoreThemeTemplateTypeRequestDto;
    /**
     * Thumbnail URL of the theme
     * @type {string}
     * @memberof UpdatePopStoreThemeTemplateRequest
     */
    thumbnailUrl?: string;
    /**
     * Theme settings (complex JSON)
     * @type {string}
     * @memberof UpdatePopStoreThemeTemplateRequest
     */
    theme: string;
}

/**
 * 
 * @export
 * @interface UpdatePostCommentRequest
 */
export interface UpdatePostCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePostCommentRequest
     */
    text: string;
}

/**
 * 
 * @export
 * @interface UpdatePostRequest
 */
export interface UpdatePostRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePostRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePostRequest
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdatePostRequest
     */
    tags?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePostRequest
     */
    allowComments: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePostRequest
     */
    saveAsDraft?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdatePostRequest
     */
    scheduledReleaseTime?: string;
    /**
     * 
     * @type {PayToViewOnlyModeDto}
     * @memberof UpdatePostRequest
     */
    payToViewOnlyMode?: PayToViewOnlyModeDto;
    /**
     * 
     * @type {SubscribeToViewDto}
     * @memberof UpdatePostRequest
     */
    subscribeToView?: SubscribeToViewDto;
    /**
     * 
     * @type {PayToViewDto}
     * @memberof UpdatePostRequest
     */
    payToView?: PayToViewDto;
    /**
     * 
     * @type {CrowdTippingToViewDto}
     * @memberof UpdatePostRequest
     */
    crowdTippingToView?: CrowdTippingToViewDto;
    /**
     * 
     * @type {TipToViewDto}
     * @memberof UpdatePostRequest
     */
    tipToView?: TipToViewDto;
    /**
     * 
     * @type {Array<TippingAmountDto>}
     * @memberof UpdatePostRequest
     */
    tippingAmounts?: Array<TippingAmountDto>;
    /**
     * 
     * @type {DmOnlyDto}
     * @memberof UpdatePostRequest
     */
    dmOnly?: DmOnlyDto;
    /**
     * 
     * @type {PostContentTypeEnumItem}
     * @memberof UpdatePostRequest
     */
    postType: PostContentTypeEnumItem;
    /**
     * 
     * @type {string}
     * @memberof UpdatePostRequest
     */
    textContent?: string;
    /**
     * 
     * @type {Array<PostMediaDto>}
     * @memberof UpdatePostRequest
     */
    medias?: Array<PostMediaDto>;
    /**
     * 
     * @type {number}
     * @memberof UpdatePostRequest
     */
    unrestrictedLeadingMediaCount?: number;
}

/**
 * 
 * @export
 * @interface UpdateRequest
 */
export interface UpdateRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRequest
     */
    access: boolean;
}

/**
 * 
 * @export
 * @interface UpdateShipmentConfigRequest
 */
export interface UpdateShipmentConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateShipmentConfigRequest
     */
    templateId?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateShipmentConfigRequest
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateShipmentConfigRequest
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateShipmentConfigRequest
     */
    depth?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateShipmentConfigRequest
     */
    distanceUnit?: UpdateShipmentConfigRequestDistanceUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateShipmentConfigRequest
     */
    weight: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateShipmentConfigRequest
     */
    massUnit: UpdateShipmentConfigRequestMassUnitEnum;
}

/**
* @export
* @enum {string}
*/
export enum UpdateShipmentConfigRequestDistanceUnitEnum {
    Cm = 'cm',
    In = 'in',
    Ft = 'ft',
    M = 'm',
    Mm = 'mm',
    Yd = 'yd'
}/**
* @export
* @enum {string}
*/
export enum UpdateShipmentConfigRequestMassUnitEnum {
    G = 'g',
    Kg = 'kg',
    Lb = 'lb',
    Oz = 'oz'
}

/**
 * 
 * @export
 * @interface UpdateShipmentExtraRequest
 */
export interface UpdateShipmentExtraRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateShipmentExtraRequest
     */
    signatureConfirmation?: UpdateShipmentExtraRequestSignatureConfirmationEnum;
}

/**
* @export
* @enum {string}
*/
export enum UpdateShipmentExtraRequestSignatureConfirmationEnum {
    Standard = 'STANDARD',
    Adult = 'ADULT',
    Certified = 'CERTIFIED'
}

/**
 * 
 * @export
 * @interface UpdateShipmentExtraResponse
 */
export interface UpdateShipmentExtraResponse {
    /**
     * 
     * @type {ShippingCostItem}
     * @memberof UpdateShipmentExtraResponse
     */
    data?: ShippingCostItem;
}

/**
 * 
 * @export
 * @interface UpdateShippingAddressBySellerRequest
 */
export interface UpdateShippingAddressBySellerRequest {
    /**
     * 
     * @type {SellerUpdateAddressDto}
     * @memberof UpdateShippingAddressBySellerRequest
     */
    shippingAddress: SellerUpdateAddressDto;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateShippingAddressBySellerRequest
     */
    generateShippingLabel?: boolean;
}

/**
 * 
 * @export
 * @interface UpdateShippingAddressRequest
 */
export interface UpdateShippingAddressRequest {
    /**
     * 
     * @type {AddressDto}
     * @memberof UpdateShippingAddressRequest
     */
    shippingAddress: AddressDto;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateShippingAddressRequest
     */
    generateShippingLabel?: boolean;
}

/**
 * 
 * @export
 * @interface UpdateShippingModeRequest
 */
export interface UpdateShippingModeRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateShippingModeRequest
     */
    shippingMode: Array<UpdateShippingModeRequestShippingModeEnum>;
}

/**
* @export
* @enum {string}
*/
export enum UpdateShippingModeRequestShippingModeEnum {
    Shipping = 'shipping',
    Pickup = 'pickup'
}

/**
 * 
 * @export
 * @interface UpdateStoreIsDormanRequest
 */
export interface UpdateStoreIsDormanRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateStoreIsDormanRequest
     */
    isDormant: boolean;
}

/**
 * 
 * @export
 * @interface UpdateStoreReelRequest
 */
export interface UpdateStoreReelRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateStoreReelRequest
     */
    originalURL: string;
}

/**
 * 
 * @export
 * @interface UpdateSubscriptionRequest
 */
export interface UpdateSubscriptionRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSubscriptionRequest
     */
    priceIds: Array<string>;
}

/**
 * 
 * @export
 * @interface UpdateTipRequest
 */
export interface UpdateTipRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTipRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTipRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTipRequest
     */
    minimumAmount: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTipRequest
     */
    stepAmount: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateTipRequest
     */
    defaultImage: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTipRequest
     */
    extraImages?: Array<string>;
}

/**
 * 
 * @export
 * @interface UpdateUpcomingShowDto
 */
export interface UpdateUpcomingShowDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUpcomingShowDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpcomingShowDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpcomingShowDto
     */
    startsAt: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpcomingShowDto
     */
    permission?: UpdateUpcomingShowDtoPermissionEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpcomingShowDto
     */
    eventId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUpcomingShowDto
     */
    userGroupIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUpcomingShowDto
     */
    available: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpcomingShowDto
     */
    shareVideo?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpcomingShowDto
     */
    previewVideoURL: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpcomingShowDto
     */
    coverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpcomingShowDto
     */
    originalCoverImage?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpcomingShowDto
     */
    transcodeStatus?: UpdateUpcomingShowDtoTranscodeStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpcomingShowDto
     */
    accessLevel?: UpdateUpcomingShowDtoAccessLevelEnum;
}

/**
* @export
* @enum {string}
*/
export enum UpdateUpcomingShowDtoPermissionEnum {
    All = 'all',
    Follower = 'follower',
    Subscriber = 'subscriber',
    NoOne = 'no-one'
}/**
* @export
* @enum {string}
*/
export enum UpdateUpcomingShowDtoTranscodeStatusEnum {
    Initial = 'initial',
    Processing = 'processing',
    TranscodeOriginal = 'transcode-original',
    TranscodeOriginalShare = 'transcode-original-share',
    RequestRetranscode = 'request-retranscode'
}/**
* @export
* @enum {string}
*/
export enum UpdateUpcomingShowDtoAccessLevelEnum {
    All = 'all',
    Subscriber = 'subscriber',
    Fan = 'fan',
    Vip = 'vip'
}

/**
 * 
 * @export
 * @interface UpdateUserGroupDto
 */
export interface UpdateUserGroupDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserGroupDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserGroupDto
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserGroupDto
     */
    active: boolean;
}

/**
 * 
 * @export
 * @interface UpdateUserParams
 */
export interface UpdateUserParams {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserParams
     */
    phoneNumber?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserParams
     */
    updateMask: Array<UpdateUserParamsUpdateMaskEnum>;
}

/**
* @export
* @enum {string}
*/
export enum UpdateUserParamsUpdateMaskEnum {
    PhoneNumber = 'phoneNumber'
}

/**
 * 
 * @export
 * @interface UpdateUserParamsV2
 */
export interface UpdateUserParamsV2 {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserParamsV2
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserParamsV2
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserParamsV2
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserParamsV2
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserParamsV2
     */
    bio?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserParamsV2
     */
    avatar?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserParamsV2
     */
    hideBadgeInProfile?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserParamsV2
     */
    popStoreDomain?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserParamsV2
     */
    updateMask: Array<UpdateUserParamsV2UpdateMaskEnum>;
}

/**
* @export
* @enum {string}
*/
export enum UpdateUserParamsV2UpdateMaskEnum {
    FirstName = 'firstName',
    LastName = 'lastName',
    Username = 'username',
    Email = 'email',
    Bio = 'bio',
    Avatar = 'avatar',
    HideBadgeInProfile = 'hideBadgeInProfile',
    PopStoreDomain = 'popStoreDomain'
}

/**
 * 
 * @export
 * @interface UpdateUserPhoneNumber
 */
export interface UpdateUserPhoneNumber {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserPhoneNumber
     */
    phoneNumber: string;
}

/**
 * 
 * @export
 * @interface UpdateWithdrawableBalanceByAdminRequest
 */
export interface UpdateWithdrawableBalanceByAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateWithdrawableBalanceByAdminRequest
     */
    note: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateWithdrawableBalanceByAdminRequest
     */
    amount: number;
}

/**
 * 
 * @export
 * @interface UploadCFImageResponse
 */
export interface UploadCFImageResponse {
    /**
     * 
     * @type {UploadCFImageResult}
     * @memberof UploadCFImageResponse
     */
    result: UploadCFImageResult;
}

/**
 * 
 * @export
 * @interface UploadCFImageResult
 */
export interface UploadCFImageResult {
    /**
     * 
     * @type {string}
     * @memberof UploadCFImageResult
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UploadCFImageResult
     */
    filename: string;
    /**
     * 
     * @type {string}
     * @memberof UploadCFImageResult
     */
    uploaded: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadCFImageResult
     */
    variants: Array<string>;
}

/**
 * 
 * @export
 * @interface UploadCFVideoResponse
 */
export interface UploadCFVideoResponse {
    /**
     * 
     * @type {UploadCFVideoResult}
     * @memberof UploadCFVideoResponse
     */
    result: UploadCFVideoResult;
}

/**
 * 
 * @export
 * @interface UploadCFVideoResult
 */
export interface UploadCFVideoResult {
    /**
     * 
     * @type {string}
     * @memberof UploadCFVideoResult
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof UploadCFVideoResult
     */
    preview: string;
    /**
     * 
     * @type {string}
     * @memberof UploadCFVideoResult
     */
    thumbnail: string;
    /**
     * 
     * @type {string}
     * @memberof UploadCFVideoResult
     */
    created: string;
    /**
     * 
     * @type {number}
     * @memberof UploadCFVideoResult
     */
    size: number;
    /**
     * 
     * @type {Playback}
     * @memberof UploadCFVideoResult
     */
    playback: Playback;
}

/**
 * 
 * @export
 * @interface UploadModelMeImageResponse
 */
export interface UploadModelMeImageResponse {
    /**
     * 
     * @type {string}
     * @memberof UploadModelMeImageResponse
     */
    awsS3Url: string;
}

/**
 * 
 * @export
 * @interface UploadPersonalDataRequest
 */
export interface UploadPersonalDataRequest {
    /**
     * at least default 3 face image aws s3 urls
     * @type {Array<string>}
     * @memberof UploadPersonalDataRequest
     */
    faceImageAwsS3Urls: Array<string>;
    /**
     * at least default 5 body image aws s3 urls
     * @type {Array<string>}
     * @memberof UploadPersonalDataRequest
     */
    bodyImageAwsS3Urls: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof UploadPersonalDataRequest
     */
    height: number;
    /**
     * 
     * @type {string}
     * @memberof UploadPersonalDataRequest
     */
    heightUnit: UploadPersonalDataRequestHeightUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadPersonalDataRequest
     */
    dressSize: UploadPersonalDataRequestDressSizeEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadPersonalDataRequest
     */
    ethnicity: UploadPersonalDataRequestEthnicityEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadPersonalDataRequest
     */
    hairColor: UploadPersonalDataRequestHairColorEnum;
}

/**
* @export
* @enum {string}
*/
export enum UploadPersonalDataRequestHeightUnitEnum {
    Cm = 'cm',
    In = 'in',
    Ft = 'ft',
    M = 'm'
}/**
* @export
* @enum {string}
*/
export enum UploadPersonalDataRequestDressSizeEnum {
    Xs = 'XS',
    S = 'S',
    M = 'M',
    L = 'L',
    Xl = 'XL',
    Xxl = 'XXL+'
}/**
* @export
* @enum {string}
*/
export enum UploadPersonalDataRequestEthnicityEnum {
    Asian = 'Asian',
    European = 'European',
    MiddleEastern = 'Middle Eastern',
    Indian = 'Indian',
    Hispanic = 'Hispanic',
    African = 'African',
    Latino = 'Latino'
}/**
* @export
* @enum {string}
*/
export enum UploadPersonalDataRequestHairColorEnum {
    Blonde = 'Blonde',
    Brunette = 'Brunette',
    RedHead = 'Red Head',
    BlackHair = 'Black hair',
    WhiteHair = 'White hair'
}

/**
 * 
 * @export
 * @interface UploadedFileDto
 */
export interface UploadedFileDto {
    /**
     * 
     * @type {number}
     * @memberof UploadedFileDto
     */
    sizeInBytes: number;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileDto
     */
    mimeType: string;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileDto
     */
    filename: string;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileDto
     */
    fileHandle: string;
}

/**
 * 
 * @export
 * @interface UploadedFileItem
 */
export interface UploadedFileItem {
    /**
     * 
     * @type {number}
     * @memberof UploadedFileItem
     */
    sizeInBytes: number;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileItem
     */
    mimeType: string;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileItem
     */
    fileHandle: string;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileItem
     */
    filename: string;
}

/**
 * 
 * @export
 * @interface UpvoteFeedRequest
 */
export interface UpvoteFeedRequest {
    /**
     * 
     * @type {string}
     * @memberof UpvoteFeedRequest
     */
    type: UpvoteFeedRequestTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum UpvoteFeedRequestTypeEnum {
    Live = 'LIVE',
    Replay = 'REPLAY',
    Preview = 'PREVIEW',
    Review = 'REVIEW',
    PopClip = 'POP_CLIP'
}

/**
 * 
 * @export
 * @interface UpvoteFeedResponse
 */
export interface UpvoteFeedResponse {
    /**
     * 
     * @type {number}
     * @memberof UpvoteFeedResponse
     */
    upvoteCount: number;
}

/**
 * 
 * @export
 * @interface UpvoteReviewMessageResponse
 */
export interface UpvoteReviewMessageResponse {
    /**
     * 
     * @type {number}
     * @memberof UpvoteReviewMessageResponse
     */
    upvoteCount: number;
}

/**
 * 
 * @export
 * @interface UserBadgeItem
 */
export interface UserBadgeItem {
    /**
     * 
     * @type {string}
     * @memberof UserBadgeItem
     */
    earnedAt: string;
    /**
     * 
     * @type {string}
     * @memberof UserBadgeItem
     */
    editionNo: string;
    /**
     * 
     * @type {string}
     * @memberof UserBadgeItem
     */
    storeId: string;
    /**
     * 
     * @type {string}
     * @memberof UserBadgeItem
     */
    badgeId: string;
    /**
     * 
     * @type {BadgeItem}
     * @memberof UserBadgeItem
     */
    badge: BadgeItem;
    /**
     * 
     * @type {string}
     * @memberof UserBadgeItem
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof UserBadgeItem
     */
    updatedAt: string;
}

/**
 * 
 * @export
 * @interface UserDetailItem
 */
export interface UserDetailItem {
    /**
     * 
     * @type {string}
     * @memberof UserDetailItem
     */
    id: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof UserDetailItem
     */
    profile: ProfileItem;
    /**
     * 
     * @type {PrivateProfileItem}
     * @memberof UserDetailItem
     */
    privateProfile?: PrivateProfileItem;
    /**
     * 
     * @type {ReadonlyProfileItem}
     * @memberof UserDetailItem
     */
    readonlyProfile?: ReadonlyProfileItem;
    /**
     * 
     * @type {StoreFrontItem}
     * @memberof UserDetailItem
     */
    store?: StoreFrontItem;
    /**
     * 
     * @type {ExposureSellerStatsItem}
     * @memberof UserDetailItem
     */
    sellerStats?: ExposureSellerStatsItem;
    /**
     * 
     * @type {ZendeskInfoItem}
     * @memberof UserDetailItem
     */
    zendeskInfo?: ZendeskInfoItem;
    /**
     * 
     * @type {Metadata}
     * @memberof UserDetailItem
     */
    metadata: Metadata;
}

/**
 * 
 * @export
 * @interface UserDetailPageRows
 */
export interface UserDetailPageRows {
    /**
     * 
     * @type {Array<UserDetailItem>}
     * @memberof UserDetailPageRows
     */
    rows: Array<UserDetailItem>;
}

/**
 * 
 * @export
 * @interface UserDetailSearchResponse
 */
export interface UserDetailSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof UserDetailSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof UserDetailSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {UserDetailPageRows}
     * @memberof UserDetailSearchResponse
     */
    data: UserDetailPageRows;
}

/**
 * 
 * @export
 * @interface UserGroupItem
 */
export interface UserGroupItem {
    /**
     * 
     * @type {string}
     * @memberof UserGroupItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupItem
     */
    createdAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserGroupItem
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserGroupItem
     */
    sendGridListId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupItem
     */
    userType?: string;
    /**
     * 
     * @type {Metadata}
     * @memberof UserGroupItem
     */
    metadata: Metadata;
}

/**
 * 
 * @export
 * @interface UserGroupPageRows
 */
export interface UserGroupPageRows {
    /**
     * 
     * @type {Array<UserGroupItem>}
     * @memberof UserGroupPageRows
     */
    rows: Array<UserGroupItem>;
}

/**
 * 
 * @export
 * @interface UserGroupResponse
 */
export interface UserGroupResponse {
    /**
     * 
     * @type {string}
     * @memberof UserGroupResponse
     */
    id: string;
}

/**
 * 
 * @export
 * @interface UserGroupsSearchResponse
 */
export interface UserGroupsSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof UserGroupsSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof UserGroupsSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {UserGroupPageRows}
     * @memberof UserGroupsSearchResponse
     */
    data: UserGroupPageRows;
}

/**
 * 
 * @export
 * @interface UserItem
 */
export interface UserItem {
    /**
     * 
     * @type {string}
     * @memberof UserItem
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof UserItem
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserItem
     */
    emailVerified: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserItem
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserItem
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UserItem
     */
    photoURL?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserItem
     */
    disabled: boolean;
    /**
     * 
     * @type {Array<ProviderUser>}
     * @memberof UserItem
     */
    providerData?: Array<ProviderUser>;
    /**
     * 
     * @type {CustomUserClaim}
     * @memberof UserItem
     */
    customClaims?: CustomUserClaim;
    /**
     * 
     * @type {UserMetadata}
     * @memberof UserItem
     */
    metadata: UserMetadata;
    /**
     * 
     * @type {string}
     * @memberof UserItem
     */
    id: string;
}

/**
 * 
 * @export
 * @interface UserMetadata
 */
export interface UserMetadata {
    /**
     * 
     * @type {string}
     * @memberof UserMetadata
     */
    lastSignInTime: string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadata
     */
    creationTime: string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadata
     */
    lastRefreshTime?: string;
}

/**
 * 
 * @export
 * @interface UserPageRows
 */
export interface UserPageRows {
    /**
     * 
     * @type {Array<UserItem>}
     * @memberof UserPageRows
     */
    rows: Array<UserItem>;
}

/**
 * 
 * @export
 * @interface UserReferralItem
 */
export interface UserReferralItem {
    /**
     * 
     * @type {string}
     * @memberof UserReferralItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserReferralItem
     */
    type: UserReferralItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UserReferralItem
     */
    presenteeUserId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof UserReferralItem
     */
    presenteeUserProfile: ProfileItem;
    /**
     * 
     * @type {string}
     * @memberof UserReferralItem
     */
    referrerUserId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof UserReferralItem
     */
    referrerUserProfile: ProfileItem;
    /**
     * 
     * @type {LinkHistoryItem}
     * @memberof UserReferralItem
     */
    share?: LinkHistoryItem;
    /**
     * 
     * @type {string}
     * @memberof UserReferralItem
     */
    createdAt: string;
}

/**
* @export
* @enum {string}
*/
export enum UserReferralItemTypeEnum {
    Share = 'SHARE',
    Passcode = 'PASSCODE'
}

/**
 * 
 * @export
 * @interface UserReferralsRows
 */
export interface UserReferralsRows {
    /**
     * 
     * @type {Array<UserReferralItem>}
     * @memberof UserReferralsRows
     */
    rows: Array<UserReferralItem>;
}

/**
 * 
 * @export
 * @interface UserReferralsSearchResponse
 */
export interface UserReferralsSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof UserReferralsSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof UserReferralsSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {UserReferralsRows}
     * @memberof UserReferralsSearchResponse
     */
    data: UserReferralsRows;
}

/**
 * 
 * @export
 * @interface ValidateFeedbackIDRequest
 */
export interface ValidateFeedbackIDRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidateFeedbackIDRequest
     */
    feedbackId: string;
}

/**
 * 
 * @export
 * @interface ValidateFeedbackIDResponse
 */
export interface ValidateFeedbackIDResponse {
    /**
     * 
     * @type {string}
     * @memberof ValidateFeedbackIDResponse
     */
    customToken: string;
    /**
     * 
     * @type {ValidateFeedbackIDTopic}
     * @memberof ValidateFeedbackIDResponse
     */
    topic?: ValidateFeedbackIDTopic;
}

/**
 * 
 * @export
 * @interface ValidateFeedbackIDTopic
 */
export interface ValidateFeedbackIDTopic {
    /**
     * 
     * @type {string}
     * @memberof ValidateFeedbackIDTopic
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateFeedbackIDTopic
     */
    topic: string;
}

/**
 * 
 * @export
 * @interface ValidateSellerCodeResponse
 */
export interface ValidateSellerCodeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateSellerCodeResponse
     */
    unique: boolean;
}

/**
 * 
 * @export
 * @interface ValidateUsername
 */
export interface ValidateUsername {
    /**
     * 
     * @type {string}
     * @memberof ValidateUsername
     */
    username: string;
}

/**
 * 
 * @export
 * @interface ValidateUsernameResponse
 */
export interface ValidateUsernameResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateUsernameResponse
     */
    valid: boolean;
}

/**
 * 
 * @export
 * @interface ValidationStoreDto
 */
export interface ValidationStoreDto {
    /**
     * 
     * @type {string}
     * @memberof ValidationStoreDto
     */
    locationId: string;
}

/**
 * 
 * @export
 * @interface VideoResolution
 */
export interface VideoResolution {
    /**
     * 
     * @type {number}
     * @memberof VideoResolution
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof VideoResolution
     */
    height: number;
}

/**
 * 
 * @export
 * @interface VideoSizeItem
 */
export interface VideoSizeItem {
    /**
     * 
     * @type {number}
     * @memberof VideoSizeItem
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof VideoSizeItem
     */
    height: number;
}

/**
 * 
 * @export
 * @interface VideoSizeRequest
 */
export interface VideoSizeRequest {
    /**
     * 
     * @type {number}
     * @memberof VideoSizeRequest
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof VideoSizeRequest
     */
    height: number;
}

/**
 * 
 * @export
 * @interface VoidShippingLabelRequest
 */
export interface VoidShippingLabelRequest {
    /**
     * 
     * @type {string}
     * @memberof VoidShippingLabelRequest
     */
    shipmentTrackingRecordId: string;
}

/**
 * 
 * @export
 * @interface WatchSellerRequest
 */
export interface WatchSellerRequest {
    /**
     * 
     * @type {string}
     * @memberof WatchSellerRequest
     */
    sellerId: string;
}

/**
 * 
 * @export
 * @interface WaveFollowersToWatchRequest
 */
export interface WaveFollowersToWatchRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof WaveFollowersToWatchRequest
     */
    followerIds: Array<string>;
}

/**
 * 
 * @export
 * @interface WavedToUserEnterRequest
 */
export interface WavedToUserEnterRequest {
    /**
     * 
     * @type {string}
     * @memberof WavedToUserEnterRequest
     */
    waverId: string;
}

/**
 * 
 * @export
 * @interface WithdrawTransactionExportOptions
 */
export interface WithdrawTransactionExportOptions {
    /**
     * default to pending.
     * @type {Array<string>}
     * @memberof WithdrawTransactionExportOptions
     */
    status?: Array<WithdrawTransactionExportOptionsStatusEnum>;
}

/**
* @export
* @enum {string}
*/
export enum WithdrawTransactionExportOptionsStatusEnum {
    Approved = 'approved',
    Rejected = 'rejected',
    Pending = 'pending'
}

/**
 * 
 * @export
 * @interface WithdrawTransactionItemWithId
 */
export interface WithdrawTransactionItemWithId {
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionItemWithId
     */
    userId: string;
    /**
     * 
     * @type {ProfileItem}
     * @memberof WithdrawTransactionItemWithId
     */
    profile: ProfileItem;
    /**
     * 
     * @type {number}
     * @memberof WithdrawTransactionItemWithId
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof WithdrawTransactionItemWithId
     */
    balance: number;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionItemWithId
     */
    status: WithdrawTransactionItemWithIdStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionItemWithId
     */
    note?: string;
    /**
     * 
     * @type {PayoutBankItem}
     * @memberof WithdrawTransactionItemWithId
     */
    payoutMethodBank?: PayoutBankItem;
    /**
     * 
     * @type {PayoutVenmoItem}
     * @memberof WithdrawTransactionItemWithId
     */
    payoutMethodVenmo?: PayoutVenmoItem;
    /**
     * 
     * @type {PayoutPaypalItem}
     * @memberof WithdrawTransactionItemWithId
     */
    payoutMethodPaypal?: PayoutPaypalItem;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionItemWithId
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionItemWithId
     */
    updatedAt: string;
    /**
     * 
     * @type {number}
     * @memberof WithdrawTransactionItemWithId
     */
    withdrawableAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WithdrawTransactionItemWithId
     */
    withdrawableBalance?: number;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionItemWithId
     */
    userAgent?: string;
    /**
     * 
     * @type {number}
     * @memberof WithdrawTransactionItemWithId
     */
    idNumber?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WithdrawTransactionItemWithId
     */
    isPslPayPayment?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionItemWithId
     */
    withdrawType?: WithdrawTransactionItemWithIdWithdrawTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionItemWithId
     */
    id: string;
}

/**
* @export
* @enum {string}
*/
export enum WithdrawTransactionItemWithIdStatusEnum {
    Approved = 'approved',
    Rejected = 'rejected',
    Pending = 'pending'
}/**
* @export
* @enum {string}
*/
export enum WithdrawTransactionItemWithIdWithdrawTypeEnum {
    PslPay = 'pslPay',
    Creator = 'creator'
}

/**
 * 
 * @export
 * @interface WithdrawTransactionResponse
 */
export interface WithdrawTransactionResponse {
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionResponse
     */
    userId: string;
    /**
     * 
     * @type {object}
     * @memberof WithdrawTransactionResponse
     */
    profile: object;
    /**
     * 
     * @type {number}
     * @memberof WithdrawTransactionResponse
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof WithdrawTransactionResponse
     */
    balance: number;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionResponse
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionResponse
     */
    note?: string;
    /**
     * 
     * @type {object}
     * @memberof WithdrawTransactionResponse
     */
    payoutMethodBank?: object;
    /**
     * 
     * @type {object}
     * @memberof WithdrawTransactionResponse
     */
    payoutMethodVenmo?: object;
    /**
     * 
     * @type {object}
     * @memberof WithdrawTransactionResponse
     */
    payoutMethodPaypal?: object;
    /**
     * 
     * @type {object}
     * @memberof WithdrawTransactionResponse
     */
    createdAt: object;
    /**
     * 
     * @type {object}
     * @memberof WithdrawTransactionResponse
     */
    updatedAt: object;
    /**
     * 
     * @type {number}
     * @memberof WithdrawTransactionResponse
     */
    withdrawableAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WithdrawTransactionResponse
     */
    withdrawableBalance?: number;
    /**
     * 
     * @type {string}
     * @memberof WithdrawTransactionResponse
     */
    userAgent?: string;
}

/**
 * 
 * @export
 * @interface WithdrawTransactionsPageRows
 */
export interface WithdrawTransactionsPageRows {
    /**
     * 
     * @type {Array<WithdrawTransactionItemWithId>}
     * @memberof WithdrawTransactionsPageRows
     */
    rows: Array<WithdrawTransactionItemWithId>;
}

/**
 * 
 * @export
 * @interface WithdrawTransactionsSearchResponse
 */
export interface WithdrawTransactionsSearchResponse {
    /**
     * total number of rows if exact is true.
     * @type {number}
     * @memberof WithdrawTransactionsSearchResponse
     */
    total: number;
    /**
     * if false there are more than total number of rows.
     * @type {boolean}
     * @memberof WithdrawTransactionsSearchResponse
     */
    exact: boolean;
    /**
     * 
     * @type {WithdrawTransactionsPageRows}
     * @memberof WithdrawTransactionsSearchResponse
     */
    data: WithdrawTransactionsPageRows;
}

/**
 * 
 * @export
 * @interface ZendeskContactItem
 */
export interface ZendeskContactItem {
    /**
     * 
     * @type {number}
     * @memberof ZendeskContactItem
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ZendeskContactItem
     */
    ownerId?: number;
    /**
     * 
     * @type {string}
     * @memberof ZendeskContactItem
     */
    ownerName?: string;
    /**
     * 
     * @type {string}
     * @memberof ZendeskContactItem
     */
    leadType?: string;
    /**
     * 
     * @type {string}
     * @memberof ZendeskContactItem
     */
    managedStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof ZendeskContactItem
     */
    community?: string;
    /**
     * 
     * @type {string}
     * @memberof ZendeskContactItem
     */
    primaryProduct?: string;
}

/**
 * 
 * @export
 * @interface ZendeskDealItem
 */
export interface ZendeskDealItem {
    /**
     * 
     * @type {number}
     * @memberof ZendeskDealItem
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ZendeskDealItem
     */
    ownerId?: number;
    /**
     * 
     * @type {string}
     * @memberof ZendeskDealItem
     */
    ownerName?: string;
    /**
     * 
     * @type {string}
     * @memberof ZendeskDealItem
     */
    leadType?: string;
}

/**
 * 
 * @export
 * @interface ZendeskInfoItem
 */
export interface ZendeskInfoItem {
    /**
     * 
     * @type {ZendeskContactItem}
     * @memberof ZendeskInfoItem
     */
    contact?: ZendeskContactItem;
    /**
     * 
     * @type {ZendeskDealItem}
     * @memberof ZendeskInfoItem
     */
    deal?: ZendeskDealItem;
    /**
     * 
     * @type {string}
     * @memberof ZendeskInfoItem
     */
    community?: string;
    /**
     * 
     * @type {string}
     * @memberof ZendeskInfoItem
     */
    primaryProduct?: string;
}

/**
 * 
 * @export
 * @interface ZendeskUserInfo
 */
export interface ZendeskUserInfo {
    /**
     * empty means user has not been created yet
     * @type {string}
     * @memberof ZendeskUserInfo
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ZendeskUserInfo
     */
    email: string;
    /**
     * 
     * @type {Array<CustomFieldOptionItem>}
     * @memberof ZendeskUserInfo
     */
    ticketIssueOptions: Array<CustomFieldOptionItem>;
}
